<template>
  <div id="Seating">
    <b-container class="seatingMain">
      <b-row>
        <b-col lg="7" md="12" class="map">
          <svg
            version="1.1"
            id="pricingMapSvg"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 736.9 646.1"
            style="enable-background: new 0 0 736.9 646.1"
            xml:space="preserve"
          >
            <g id="grey">
              <path
                class="st0"
                d="M383.9,349.1c-1.7,0.7-3.8,1.4-5.6,1.8c2.8,13.4,9.6,44.2,11.2,51.9l0,0c5.2-1,10.2-2.5,15.2-4.4
            C399.8,386.8,389.5,362.4,383.9,349.1"
              />
              <path
                class="st0"
                d="M388,403.1L388,403.1l-10.9-52c-1.7,0.3-3.4,0.5-5.2,0.6c0.2,14.4,0.6,45.3,0.7,52.9v0.1
            C377.8,404.5,382.9,404,388,403.1"
              />
              <path
                class="st0"
                d="M444.5,369.7l-35.9-34.8c-2.3,0-6,0.1-8.2,0.1c-1.1,1.8-2.3,3.5-3.6,5l39.4,38.2
            C437.4,376.9,440.3,373.9,444.5,369.7"
              />
              <path
                class="st0"
                d="M395.7,341.2c-1.4,1.4-2.8,2.6-4.3,3.7l31.6,47c4.7-3,7.8-8.7,12-12.7L395.7,341.2z"
              />
              <path
                class="st0"
                d="M390.1,345.8c-1.5,1-3.1,1.9-4.7,2.6l20.8,49.3l0.8,2.2c4.8-2,9.6-5.3,14.1-8L390.1,345.8z"
              />
              <path
                class="st0"
                d="M310.2,315.9l-9-8.8l-33.1,33.8c3.1,3,6.1,6,9.1,8.8L310.2,315.9z"
              />
              <path
                class="st0"
                d="M330.8,335.9l-9.3-9l-33,33.8c3.5,3.4,6.6,6.4,9.3,9L330.8,335.9z"
              />
              <path
                class="st0"
                d="M285.8,280c-2.6-2.5-5.8-5.6-9.1-8.8l-39.2,40.1c3,2.9,6,5.8,9.1,8.8L285.8,280z"
              />
              <path
                class="st0"
                d="M291.1,294.8c0.5-6.5,0.5-6.7,0.6-9c-0.7-0.7-2.5-2.4-4.8-4.7l-39.2,40.1c3,2.9,6.1,5.9,9,8.8L291.1,294.8z"
              />
              <path
                class="st0"
                d="M300,306l-9.1-8.8l0,0l-33,33.8c3.1,3,6.1,5.9,9.1,8.8L300,306z"
              />
              <path
                class="st0"
                d="M320.4,325.8l-9.1-8.8l-33.1,33.8c3.2,3.1,6.2,6,9.1,8.8L320.4,325.8z"
              />
              <path
                class="st0"
                d="M345.2,341c-1.5-1.6-2.8-3.3-4-5.2c-2.2,0-5.8,0.1-8.2,0.1l-34.1,34.9c4.5,4.3,7.6,7.4,8.8,8.5L345.2,341z"
              />
              <path
                class="st0"
                d="M353,402.9l9.5-52.1c-1.8-0.4-3.5-1-5.2-1.7c-5,12.7-15.1,38.7-19.3,49.5l0,0
            C342.9,400.5,347.9,401.9,353,402.9L353,402.9z"
              />
              <path
                class="st0"
                d="M336.5,398l19.3-49.5c-1.8-0.8-3.5-1.8-5.2-2.9l-28.5,45.1C326.7,393.6,331.5,396,336.5,398L336.5,398z"
              />
              <path
                class="st0"
                d="M346.3,342.1l-37.5,38.4c0.6,0.6,1.5,1.4,1.5,1.4c3.3,3,6.8,5.6,10.4,8l28.6-45.2
            C348.3,343.8,347.3,343,346.3,342.1"
              />
              <path
                class="st0"
                d="M362.3,404.2c0.5,0,1,0.1,1.6,0.1v0.1c2.4,0.2,4.7,0.3,7.1,0.3l0,0l-0.7-52.9c-2.1,0-4.2-0.2-6.3-0.6l-9.4,52
            v0.1C357.1,403.7,359.7,404,362.3,404.2L362.3,404.2z"
              />
              <path
                class="st0"
                d="M454.3,359.6l-34.8-33.7l-7,7.2l-1.7,1.8l34.8,33.7C448.1,365.9,451,362.9,454.3,359.6"
              />
              <path
                class="st0"
                d="M504.5,308.2l-41.8-40.5c-3.3,3.4-6.4,6.6-9,9.2l41.8,40.5C498.6,314.3,501.6,311.2,504.5,308.2"
              />
              <path
                class="st0"
                d="M484.4,328.8l-34.8-33.7l-8.9,9.1l34.8,33.7C478.4,334.9,481.4,331.9,484.4,328.8"
              />
              <path
                class="st0"
                d="M474.4,339.1l-34.8-33.7l-9,9.2l34.8,33.7C468.3,345.3,471.3,342.2,474.4,339.1"
              />
              <path
                class="st0"
                d="M464.3,349.3l-34.8-33.7l-8.9,9.1l34.8,33.7C458.2,355.6,461.2,352.6,464.3,349.3"
              />
              <path
                class="st0"
                d="M486.5,328.7c3-3.1,6.1-6.3,9.2-9.4l-42.8-41.5c-2.9,3-4.8,4.9-4.8,4.9c0.3,2.4,1,7.1,1.3,10.1L486.5,328.7z"
              />
              <polygon
                class="st0"
                points="180,288.9 200,308.3 212.2,295.8 192.2,276.4 	"
              />
              <polygon
                class="st0"
                points="542.7,303.8 559.8,286.3 547.4,274.3 530.3,291.7 	"
              />
              <path
                class="st0"
                d="M265.4,260.2c-5.2-5-9-8.7-9-8.7l0,0l-39.2,40.1c2.9,2.8,5.9,5.8,9.1,8.8L265.4,260.2z"
              />
              <polygon
                class="st0"
                points="200.4,308.7 209.5,317.4 221.7,304.9 212.6,296.2 	"
              />
              <path
                class="st0"
                d="M256.3,250.9c-3.1-4.9-13.5-21-14.1-21.9c-0.2-0.2-0.8-0.8-1.8-1.7l-43.6,44.6c5.3,5.1,12.2,11.8,20,19.4
            L256.3,250.9z"
              />
              <path
                class="st0"
                d="M482.8,247.1c-1.9,2-5.2,5.3-9,9.2l41.8,40.5c3.1-3.2,6.1-6.2,9-9.2L482.8,247.1z"
              />
              <path
                class="st0"
                d="M494.8,223c-2.2,5-10.1,22.5-10.1,22.5s-0.3,0.3-0.8,0.8l41.8,40.2c6.6-6.7,12.4-12.6,17.1-17.3L494.8,223z"
              />
              <polygon
                class="st0"
                points="272.7,354.3 263.6,345.5 251.4,358.1 260.4,366.8 	"
              />
              <polygon
                class="st0"
                points="293.3,374.3 284,365.3 271.7,377.8 281,386.8 	"
              />
              <polygon
                class="st0"
                points="242.1,324.7 233,315.9 220.8,328.4 229.8,337.2 	"
              />
              <polygon
                class="st0"
                points="252.2,334.5 243.2,325.8 231,338.3 240,347 	"
              />
              <polygon
                class="st0"
                points="262.5,344.4 253.4,335.6 241.1,348.1 250.2,357 	"
              />
              <polygon
                class="st0"
                points="282.8,364.2 273.8,355.4 261.6,367.9 270.6,376.7 	"
              />
              <polygon
                class="st0"
                points="303.2,383.9 294.4,375.4 282.2,387.9 291,396.5 	"
              />
              <path
                class="st0"
                d="M275.6,270.1c-3.1-3-6.2-6-9.1-8.8l-39.2,40.1c3,2.9,6,5.8,9.1,8.8L275.6,270.1z"
              />
              <polygon
                class="st0"
                points="231.9,314.8 222.8,306 210.6,318.5 219.7,327.3 	"
              />
              <path
                class="st0"
                d="M300.6,405.7c2.2,1.9,4.4,3.7,6.6,5.5l10.1-15.9c-3.9-2.6-7.7-5.5-11.3-8.7c0,0-1-0.9-1.7-1.5L292,397.6
            l8.4,8.1H300.6z"
              />
              <path
                class="st0"
                d="M472.7,257.4c-2.8,2.9-5.9,6.1-8.9,9.1l41.8,40.5c3-3.1,6-6.1,8.9-9.1L472.7,257.4z"
              />
              <path
                class="st0"
                d="M241.1,366.3c-7-6.8-14.2-13.8-21.4-20.7l-11.9,12.1c7.2,6.9,14.4,13.9,21.4,20.7L241.1,366.3z"
              />
              <path
                class="st0"
                d="M141.8,270.1l-11.9,12.2c0.1,0.1,3.2,3.1,8.5,8.2l11.9-12.1C145.2,273.3,142.1,270.3,141.8,270.1"
              />
              <path
                class="st0"
                d="M297.9,444.9l10.5-13.3c-0.3-0.3-0.6-0.5-0.7-0.7c-0.1-0.1-7.9-7.7-20.1-19.4l-11.9,12.1
            c11.8,11.4,19.5,18.9,20.3,19.7C296.3,443.5,297.6,444.6,297.9,444.9z"
              />
              <path
                class="st0"
                d="M245.6,394.3c2.1,2.1,4.2,4.1,6.3,6.1l11.9-12.1c-6.8-6.6-14-13.6-21.4-20.7l-11.9,12.1
            c4.7,4.6,9.4,9.1,13.9,13.4"
              />
              <path
                class="st0"
                d="M218.4,344.3c-7.3-7.1-14.5-14.1-21.5-20.8L185,335.6c6.9,6.7,14.2,13.7,21.5,20.8L218.4,344.3z"
              />
              <path
                class="st0"
                d="M161.1,312.4l11.9-12.1c-8.6-8.4-16-15.5-21.4-20.7l-11.9,12.1C145.1,296.9,152.5,304.1,161.1,312.4"
              />
              <path
                class="st0"
                d="M260.7,408.9c5,4.9,9.7,9.4,13.9,13.4l11.9-12.1c-6.2-6-13.5-13.1-21.4-20.7l-11.9,12.1
            c2.1,2.1,4.2,4.1,6.3,6.1"
              />
              <path
                class="st0"
                d="M195.7,322.3c-7.6-7.4-14.8-14.4-21.4-20.7l-11.9,12.1c6.6,6.4,13.8,13.4,21.4,20.7L195.7,322.3z"
              />
              <path
                class="st0"
                d="M326,444.3l-7.5,15.2c2.6,1.4,5.1,2.7,7.8,3.9l6.1-15.8C330.2,446.6,328.1,445.5,326,444.3z"
              />
              <path
                class="st0"
                d="M308.9,453.5L308.9,453.5c2.6,1.9,5.3,3.5,8.1,5.1l7.5-15.2c-5.1-3-10-6.6-14.6-10.6l-10.5,13.3
            c2.9,2.5,5.8,4.8,8.9,7L308.9,453.5z"
              />
              <polygon
                class="st1"
                points="121.5,250.4 141.9,270.2 130,282.5 109.5,262.5 	"
              />
              <path
                class="st0"
                d="M488.4,403.5c2-2,4-4.1,6.1-6.2l-12.2-11.8c-7.7,7.9-14.8,15.1-20.8,21.3l12.2,11.8c1.9-2,4-4.1,6.1-6.2l0,0
            l1.2-1.3l0,0c2-2,4-4.1,6.2-6.3"
              />
              <path
                class="st0"
                d="M531.3,359.6L531.3,359.6l1.2-1.3l0,0c2-2.1,4.1-4.2,6.1-6.2l-12.2-11.8c-7,7.1-14,14.3-20.8,21.3l12.2,11.8
            C522.3,368.8,526.8,364.2,531.3,359.6z"
              />
              <path
                class="st0"
                d="M503.1,388.5c2-2.1,4.1-4.2,6.2-6.3l0,0l1.2-1.3l0,0c2-2.1,4-4.1,6.1-6.2l-12.2-11.9
            c-7.2,7.4-14.2,14.6-20.8,21.3l12.2,11.8c2-2,4-4.1,6.1-6.2"
              />
              <path
                class="st0"
                d="M575.5,314.4L575.5,314.4l1.2-1.3l0,0c2.1-2.2,4.2-4.3,6.2-6.3L570.7,295c-6.4,6.5-13.4,13.7-20.8,21.3
            l12.2,11.8C566.7,323.4,571.2,318.8,575.5,314.4z"
              />
              <path
                class="st0"
                d="M546.1,344.5L546.1,344.5l1.2-1.3l0,0c2.1-2.1,4.1-4.2,6.1-6.2l0,0l1.2-1.3l0,0c2.1-2.1,4.1-4.2,6.2-6.3
            l-12.2-11.8c-6.8,6.9-13.8,14.1-20.9,21.4l12.2,11.8C542,348.7,544,346.6,546.1,344.5z"
              />
              <path
                class="st0"
                d="M590.2,299.4L590.2,299.4l1.2-1.3l0,0c4.9-5,9.2-9.4,12.8-13.1c0.2-0.3,0.5-0.5,0.7-0.8l-12.2-11.8
            c-5.3,5.4-12.5,12.8-20.8,21.3l12.2,11.8C586.2,303.5,588.2,301.4,590.2,299.4"
              />
              <path
                class="st0"
                d="M602.7,262.3c-0.4,0.4-3.5,3.6-8.7,8.9l12.2,11.8c5.4-5.5,8.5-8.7,8.7-8.9L602.7,262.3z"
              />
              <path
                class="st0"
                d="M423,442.2c-3,1.9-6.1,3.6-9.3,5.1l6.7,15.6c3.6-1.7,7.2-3.6,10.6-5.7L423,442.2z"
              />
              <path
                class="st0"
                d="M441.8,449.7c2.7-2.1,5.3-4.4,7.9-6.8l-10.9-13.1c-4.4,4.3-9.2,8.1-14.2,11.3l8,15c2.7-1.7,5.3-3.5,7.9-5.5"
              />
              <path
                class="st0"
                d="M452.1,440.6c0,0,0.1-0.1,0.3-0.3c0.1-0.1,0.3-0.3,0.5-0.5s0.4-0.4,0.7-0.7c0.2-0.2,0.4-0.4,0.6-0.6
            c0.1-0.2,0.3-0.3,0.5-0.5c0.6-0.6,1.3-1.3,2-2.1c0.3-0.3,0.6-0.7,1-1l0,0l1.2-1.3l0,0c0.7-0.7,1.3-1.4,2.1-2.1
            c0.3-0.3,0.6-0.6,0.9-0.9c1-1,2-2.1,3.1-3.2l0,0l1.2-1.3l0,0c1.6-1.7,3.4-3.5,5.3-5.4c0.3-0.3,0.6-0.6,0.9-0.9L460.3,408
            c-12.3,12.5-20.1,20.6-20.2,20.7l0,0l10.9,13.1C451.3,441.3,451.7,441,452.1,440.6z"
              />
              <polygon
                class="st1"
                points="634.1,253.3 614.9,274.2 602.5,262.6 621.6,241.6 	"
              />
              <path
                class="st0"
                d="M253.6,64.5l-20,17.9l25.7,25.2c6.4-6.6,12.8-13.1,18.5-19L253.6,64.5z"
              />
              <path
                class="st0"
                d="M232.4,83.3l-10.6,8.4l-8.1,10.9l26,25.1c5.9-6,12.2-12.5,18.5-19L232.4,83.3z"
              />
              <path
                class="st0"
                d="M176.7,145.4l37.5,22.5l-2.4-11.6c0,0,2.7-2.8,7.2-7.4L193.9,125c-4.6,4.7-9,9.2-9.2,9.4
            c-0.1,0.2-3.3,4.7-7.2,10.2"
              />
              <path
                class="st0"
                d="M220.1,147.8c4.8-4.9,11.3-11.6,18.5-19l-27-26l-15.9,21.5"
              />
              <polyline
                class="st0"
                points="460.4,37.4 433.8,64.6 453.1,83.2 481.2,54.4 	"
              />
              <polyline
                class="st0"
                points="503.8,74.2 474.6,104.1 493.8,122.8 522.2,93.2 	"
              />
              <polyline
                class="st0"
                points="524.3,94.9 495,123.9 514.2,142.5 543.9,112.8 	"
              />
              <polygon
                class="st0"
                points="483,55 454.2,84.3 473.5,103 502.6,73.1 	"
              />
              <path
                class="st0"
                d="M305.3,54.3L285.4,35l-10.1,9.5l23.4,22.8c1.6-1.6,2.5-2.6,2.7-2.7C301.6,63.7,303.4,59.2,305.3,54.3"
              />
              <path
                class="st0"
                d="M273.7,45.2l-6.8,7.7l-12.1,10.6l24.2,24c7.9-8.1,14.6-15,18.5-19L273.7,45.2z"
              />
              <polygon
                class="st0"
                points="449.3,28.2 423.4,54.4 432.7,63.5 458.6,36.6 	"
              />
              <path
                class="st0"
                d="M541.1,117.2l-25.8,26.5l11.5,5.2l5.9,6.2l25.6-16.9c-4.3-5.3-8.3-10.4-8.5-10.5c-0.1-0.1-3.8-5.5-8.6-10.2"
              />
              <polygon
                class="st0"
                points="205.7,165 192,154.2 299.6,47.3 305.7,54.5 301.8,66.5 	"
              />
              <polygon
                class="st0"
                points="437.9,40.2 425,52.7 532.9,157.4 548,147.1 	"
              />
              <polygon
                class="st0"
                points="548.5,273.2 560.9,285.2 570,275.8 581,256.9 580.6,257.5 567.2,249.1 558.9,262.5 	"
              />
              <polygon
                class="st0"
                points="171.6,254 158.2,263 171.3,280.5 179.6,288.3 191.8,275.9 181.1,265.7 	"
              />
              <polygon
                class="st0"
                points="158.6,231 140.1,236.7 140.4,239.1 157.3,261.7 170.6,252.8 161.7,241.9 	"
              />
              <polygon
                class="st0"
                points="578.7,224.7 595.8,231.3 595.5,231.8 597,229.4 597.1,228.2 591.7,192.9 591.7,192.9 582.3,192.9
            581,210.5 	"
              />
              <polygon
                class="st0"
                points="574.6,237.2 568.1,247.8 581.4,256.2 595.9,231.2 578.8,224.6 	"
              />
              <polyline
                class="st0"
                points="140.1,236.8 158.7,231.2 154.7,213.5 155.1,197.4 144.7,197.8 	"
              />
              <path
                class="st0"
                d="M195.2,270.1l43.6-44.6c-2.8-2.7-7.6-7.1-10.9-10.3l-51.7,34.5c4.5,5.5,8.8,10.8,8.9,10.9
            c0.5,0.4,3.9,3.8,9.4,9.1"
              />
              <path
                class="st0"
                d="M561.8,244.9l-55.5-34.8c-3,3-9.5,9.7-10.7,11L544,268c6.1-6.2,9.9-10.1,9.9-10.2
            C554,257.5,558,251,561.8,244.9"
              />
              <path
                class="st0"
                d="M160.2,212.9c0.1,0.4,2.2,7,4.2,13.3l56.9-24.4l-0.9-4.4l-60.4,0.8c0.1,7.2,0.4,14.3,0.4,14.8"
              />
              <path
                class="st0"
                d="M175.2,248.4l51.6-34.3c-2.2-2.1-3.7-3.6-3.7-3.6l-1.5-7.1l-57.2,24c1.6,5.2,2.5,10.1,2.6,10.5
            C167.4,238.3,171.1,243.3,175.2,248.4"
              />
              <path
                class="st0"
                d="M160.6,197.4l59.5-1.6l-0.9-4.5l-54.8-21.2c-1.9,6.4-3.8,12.5-3.9,12.9c0,0.4-0.3,6.3-0.2,13.4"
              />
              <path
                class="st0"
                d="M164.9,169l53.8,20.4l-4-19.3l-38.4-24.3c-3.7,5.1-7.2,9.9-7.4,10.3c-0.1,0.5-2,6.2-3.9,12.5"
              />
              <path
                class="st0"
                d="M576.8,192.2l-54.3,0.7l-8.8,0.1c0,1.8,0.2,3.8-0.1,5.6l59.2,23c2-6.2,4.1-12.6,4.3-13.1
            C577.1,207.9,577,199.8,576.8,192.2"
              />
              <path
                class="st0"
                d="M533.8,173l36.5-15.2c-1.3-4.1-2.2-7.3-2.3-7.6c-0.4-0.4-4.4-5.5-8.6-10.7"
              />
              <path
                class="st0"
                d="M570.8,159.3l-45.5,19v-0.1l-13.1,5.4c0.5,2.2,0.9,4.9,1,7.7l63.6-0.9c-0.1-6.3-0.2-11.9-0.2-12.3
            C576.5,177.8,573.3,167.3,570.8,159.3"
              />
              <path
                class="st0"
                d="M562.7,243.5c3.1-5,5.9-9.6,6.1-9.8c0.1-0.3,1.7-5.2,3.5-10.6l-48.6-18.8v-0.1l-11.2-4.3
            c-0.8,3.1-2.3,6.1-4.7,8.6c0,0-0.1,0.1-0.3,0.3l6.9,4.3l0,0L562.7,243.5z"
              />
              <polyline
                class="st0"
                points="559.4,139.4 530.6,158.5 533.8,173 	"
              />
              <polygon
                class="st0"
                points="204.9,164 197.4,159.2 195.3,162.3 190.3,173.3 187.3,182.5 185.5,191.8 186.3,201.5 188.7,211.3
            190.3,215 208.7,207.2 207.7,203.8 207.6,192.2 201.6,167.4 	"
              />
              <polygon
                class="st0"
                points="144.3,84.2 158.6,93.1 169,78.6 156,68 	"
              />
              <polygon
                class="st0"
                points="189.3,33.9 200.8,46.1 215.3,34.1 205.3,20.5 	"
              />
              <polygon
                class="st0"
                points="160.6,69.5 170.3,77.3 199.5,47.4 191,38.4 	"
              />
              <polygon
                class="st0"
                points="109.5,192.7 121.5,195.6 131.4,150.9 119.7,147 	"
              />
              <polygon
                class="st0"
                points="127.5,125.8 138.7,131.1 157.7,94.6 147.2,88 	"
              />
              <polygon
                class="st0"
                points="115.1,143.7 131.1,148.9 137.9,132.7 122.7,125.6 	"
              />
              <polygon
                class="st0"
                points="209.4,23.1 216.7,33 240.4,18.6 233.7,8.2 	"
              />
              <polygon
                class="st0"
                points="247.2,0 235.3,7.2 241.9,17.6 253.7,10.4 	"
              />
              <path
                class="st0"
                d="M324.5,344.7l-3.3,3.4c3.4,3.3,6.4,6.2,8.8,8.5l3.3-3.4C330.9,350.9,327.9,348,324.5,344.7"
              />
              <path
                class="st0"
                d="M314,334.6l-3.6,3.6c3.3,3.2,6.5,6.3,9.3,9l3.6-3.6C320.5,340.9,317.4,337.8,314,334.6"
              />
              <path
                class="st0"
                d="M341.1,360.5C341.1,360.5,341,360.5,341.1,360.5l-3,4.2c2.9,2.5,6.1,4.5,9.5,6.1l2.2-4.6
            C346.6,364.7,343.7,362.8,341.1,360.5"
              />
              <path
                class="st0"
                d="M334.4,354.4l-3.5,3.6c3.3,3.2,5.5,5.3,6.1,5.9c0,0,0.1,0.1,0.2,0.1l2.9-4.1
            C339.2,359,337.3,357.1,334.4,354.4"
              />
              <path
                class="st0"
                d="M312.9,333.5c-2.9-2.8-5.9-5.7-9.1-8.8l-3.6,3.7c3.1,3,6.2,6,9.1,8.8L312.9,333.5z"
              />
              <path
                class="st0"
                d="M283.4,304.9l-3.6,3.6c3.1,3,6.1,5.9,9.1,8.8l3.6-3.6C289.5,310.8,286.5,307.9,283.4,304.9"
              />
              <path
                class="st0"
                d="M302.7,323.6c-2.9-2.9-6-5.8-9.1-8.8l-3.5,3.6c3.1,3,6.1,5.9,9.1,8.8L302.7,323.6z"
              />
              <path
                class="st0"
                d="M381.8,370.3c0.4,1.7,0.8,3.4,1.1,5.2c4.6-1.1,9-2.7,13.3-4.8c-0.7-1.6-1.4-3.3-2.1-4.9
            C390.2,367.8,386,369.3,381.8,370.3"
              />
              <path
                class="st0"
                d="M403.5,359L403.5,359c-0.6,0.5-1.1,1-1.7,1.5l2.9,3.9c0.8-0.7,1.5-1.3,2.2-2l-0.4,0.4c0,0,2-2.1,5.6-5.7
            l-3.5-3.4C405.4,357,403.6,358.9,403.5,359"
              />
              <path
                class="st0"
                d="M409.7,352.6l3.6,3.5c2.3-2.4,5.1-5.2,8.3-8.5l-3.6-3.5C414.8,347.4,412,350.3,409.7,352.6"
              />
              <path
                class="st0"
                d="M427.9,334c-3.1,3.2-6.1,6.2-8.7,9l3.6,3.5c2.7-2.7,5.6-5.7,8.8-8.9L427.9,334z"
              />
              <path
                class="st0"
                d="M359.2,370.6l-1.2,4.5c4.1,0.6,8.3,0.7,12.6,0.3l0.4-4.4C366.9,371.3,363,371.2,359.2,370.6"
              />
              <path
                class="st0"
                d="M273.2,295.1l-3.6,3.7c3,2.9,6,5.9,9,8.8l3.6-3.7C279.3,300.9,276.3,298,273.2,295.1"
              />
              <path
                class="st0"
                d="M349.7,366.8c-0.6,1.4-1.2,2.9-1.8,4.4c3.6,1.8,7.4,3.2,11.2,4.1l0.9-4.6C356.5,369.8,353,368.5,349.7,366.8"
              />
              <path
                class="st0"
                d="M371.7,371.8c0.1,1.4,0.2,2.8,0.3,4.2c3.6,0.2,7.3,0,10.8-0.6l-1.1-4.1C378.5,371.8,375.1,371.9,371.7,371.8"
              />
              <path
                class="st0"
                d="M391.9,366.7l2.4,4.8c3.7-1.7,7.1-3.9,10.3-6.4l-3.2-4.5C398.5,363,395.3,365.1,391.9,366.7"
              />
              <path
                class="st0"
                d="M459.1,302.1l3.6,3.5c3-3.1,6-6.1,9-9.2l-3.7-3.5C465.1,296,462.1,299,459.1,302.1"
              />
              <path
                class="st0"
                d="M451.6,317l-3.7-3.5c-3.1,3.1-6.1,6.2-9,9.2l3.7,3.5C445.6,323.2,448.6,320.2,451.6,317"
              />
              <path
                class="st0"
                d="M441.5,327.3l-3.6-3.5c-3.1,3.2-6.1,6.2-8.9,9.1l3.6,3.5C435.4,333.5,438.4,330.4,441.5,327.3"
              />
              <path
                class="st0"
                d="M461.7,306.8l-3.7-3.5c-3,3.1-6,6.1-8.9,9.1l3.7,3.5C455.7,312.9,458.7,309.9,461.7,306.8"
              />
              <path
                class="st0"
                d="M437.8,323.7l-9.5-9.2c-3.1,3.2-6.1,6.2-8.9,9.1l9.5,9.2C431.8,329.9,434.8,326.9,437.8,323.7"
              />
              <path
                class="st0"
                d="M391.5,334.9l18.2,17.6c2.3-2.3,5.1-5.2,8.3-8.5l-18.2-17.6C396.6,329.7,393.8,332.6,391.5,334.9"
              />
              <path
                class="st0"
                d="M341.7,327.1l-17.1,17.5c3.4,3.3,6.4,6.2,8.8,8.5l17.1-17.5C348,333.3,345.1,330.4,341.7,327.1"
              />
              <path
                class="st0"
                d="M322.2,323.9c-2.9-2.8-5.9-5.7-9.1-8.8l-9.3,9.5c3.1,3,6.2,6,9.1,8.8L322.2,323.9z"
              />
              <path
                class="st0"
                d="M323.3,325l-9.3,9.5c3.3,3.2,6.5,6.3,9.3,9l9.3-9.5C329.8,331.3,326.7,328.2,323.3,325"
              />
              <path
                class="st0"
                d="M292.8,295.4l-9.3,9.5c3.1,3,6.1,5.9,9.1,8.8l9.3-9.5C298.9,301.3,295.8,298.3,292.8,295.4"
              />
              <path
                class="st0"
                d="M291.1,276.8L273.3,295c3,2.9,6,5.8,9,8.8l17.8-18.2C297.1,282.6,294.1,279.7,291.1,276.8"
              />
              <path
                class="st0"
                d="M303,305.3l-9.3,9.5c3.1,3,6.1,5.9,9,8.8l9.3-9.5C309.1,311.2,306.1,308.3,303,305.3"
              />
              <path
                class="st0"
                d="M447.9,313.4l-9.5-9.2c-3,3.1-6,6.2-8.9,9.2l9.5,9.2C441.9,319.6,444.8,316.5,447.9,313.4"
              />
              <path
                class="st0"
                d="M418.3,324.7c-3.1,3.2-6.1,6.2-8.7,8.9l9.5,9.2c2.7-2.7,5.6-5.7,8.7-8.9L418.3,324.7z"
              />
              <path
                class="st0"
                d="M394.3,349.3l7.5,11.2c0.6-0.5,1.1-1,1.6-1.6l0,0c0.1-0.1,2-2,5.1-5.2l-9.5-9.2
            C396.6,346.9,395,348.6,394.3,349.3"
              />
              <path
                class="st0"
                d="M449.5,272.6l9.5,9.2c3-3.1,6-6.2,9-9.2l-9.5-9.2C455.5,266.5,452.5,269.5,449.5,272.6"
              />
              <path
                class="st0"
                d="M440.9,284.4l18.2,17.6c3-3.1,6-6.1,9-9.2l-18.2-17.6C446.9,278.3,443.9,281.3,440.9,284.4"
              />
              <path
                class="st0"
                d="M459.6,262.5l8.3,8.2c3-3.1,6-6.2,8.9-9.1l-8.3-8.2C465.7,256.3,462.7,259.4,459.6,262.5"
              />
              <path
                class="st0"
                d="M469.7,252.3l8.3,8.2c3.1-3.2,6.1-6.3,9-9.2l-8.3-8.2C475.8,246,472.8,249.1,469.7,252.3"
              />
              <path
                class="st0"
                d="M439.5,303l9.5,9.2c2.9-3,5.9-6,8.9-9.1l-9.5-9.2C445.4,297,442.4,300,439.5,303"
              />
              <path
                class="st0"
                d="M372,358.9c0.1,4,0.1,8.6,0.2,13.2c3.1-0.1,6.1-0.4,9.1-1.1l-2.7-13C376.4,358.6,374.2,358.9,372,358.9"
              />
              <path
                class="st0"
                d="M343.7,344.8l-9.3,9.5c2.8,2.7,4.7,4.6,5.5,5.3l7.2-11.4C346.3,347.2,345.1,346.1,343.7,344.8"
              />
              <path
                class="st0"
                d="M380.1,357.7c0.8,3.9,1.8,8.4,2.7,13c3-0.8,6-1.9,8.8-3.3c-1.8-4.3-3.6-8.5-5.2-12.2
            C384.4,356.3,382.3,357.1,380.1,357.7"
              />
              <path
                class="st0"
                d="M355.1,354.6c-1.5,3.7-3.1,8-4.9,12.5c2.8,1.5,5.7,2.6,8.6,3.4l2.4-13.1C359.2,356.6,357.1,355.7,355.1,354.6"
              />
              <path
                class="st0"
                d="M281.1,266.8l-9.3,9.5c3,2.9,6,5.8,9.1,8.8l9.3-9.5C287.1,272.6,284,269.7,281.1,266.8"
              />
              <path
                class="st0"
                d="M270.9,256.9l-8.2,8.7c2.9,2.8,6,5.8,9,8.8l8.2-8.7C276.8,262.7,273.8,259.7,270.9,256.9"
              />
              <path
                class="st0"
                d="M260.7,247l-8.2,8.5c2.9,2.8,5.9,5.7,9.1,8.8l8.2-8.5C266.6,252.7,263.6,249.8,260.7,247"
              />
              <path
                class="st0"
                d="M387.9,354.4l5.2,12.3c2.6-1.4,5.2-3.2,7.5-5.2l-7.5-11.1C391.5,351.9,389.7,353.2,387.9,354.4"
              />
              <path
                class="st0"
                d="M350,350.8c0,0-0.4-0.4-0.7-0.6c0,0-0.4-0.4-1.1-1l-7.2,11.4h0.1c2.4,2.2,5,4,7.7,5.6l4.9-12.5
            C352.5,352.9,351.2,351.9,350,350.8"
              />
              <path
                class="st0"
                d="M362.8,357.8l-2.4,13.1c3.3,0.8,6.7,1.3,10.2,1.3l-0.2-13.2C367.9,358.9,365.3,358.5,362.8,357.8"
              />
              <path
                class="st0"
                d="M446.5,401.5L446.5,401.5l5.6-5.7l-12.4-12.1c-4.5,4.3-9.4,8.1-14.5,11.4l10.6,15.8
            C439.4,408.1,443.1,404.9,446.5,401.5"
              />
              <polygon
                class="st0"
                points="423.7,396 413.4,401.8 424.7,418.4 434.4,411.9 	"
              />
              <polygon
                class="st0"
                points="532.7,313.3 541.6,304.2 529.2,292.1 520.3,301.3 	"
              />
              <polygon
                class="st0"
                points="531.5,314.5 519,302.4 440.5,382.7 453.1,394.8 	"
              />
              <g id="hotSauce">
                <!-- <polygon class="st2" points="268.9,41.2 190.2,118.9 174.3,103 252.6,25 	"/> -->
                <polygon points="268.9,41.2 190.2,118.9 174.3,103 252.6,25 	" />
              </g>
              <path
                class="st3"
                d="M121.3,248.2l-13.9,14.5l74.9,72.3l109.3,105.8c0,0,18.8,18,35.3,24.3l6.9-17.7c0,0-9.2-3.8-25.2-16.9
            L121.3,248.2z"
              />
              <path
                class="st3"
                d="M621,240.1l14.6,13.8l-185.2,190c0,0-12.3,11.6-29.9,20.4l-1.2,0.5l-7.7-18.1c0,0,11.9-4.6,26.5-18.7
            C452.8,413.9,621,240.1,621,240.1"
              />
            </g>
            <g id="party-deck">
              <polygon
                class="st7"
                points="144.3,84.2 158.5,93.1 168.9,78.6 155.9,68 	"
              />
              <polygon
                class="st7"
                points="189.2,33.9 200.7,46.1 215.1,34.1 205.2,20.5 	"
              />
              <polygon
                class="st7"
                points="160.5,69.5 170.2,77.3 199.4,47.4 190.9,38.4 	"
              />
              <polygon
                class="st7"
                points="109.5,192.7 121.4,195.6 131.4,150.9 119.6,147 	"
              />
              <polygon
                class="st7"
                points="127.5,125.8 138.7,131.1 157.6,94.6 147.1,88 	"
              />
              <polygon
                class="st7"
                points="115.1,143.7 131.1,148.9 137.9,132.7 122.7,125.6 	"
              />
              <polygon
                class="st7"
                points="209.3,23.1 216.6,33 240.2,18.6 233.6,8.2 	"
              />
              <polygon
                class="st7"
                points="247,0 235.1,7.2 241.7,17.6 253.6,10.4 	"
              />
            </g>
            <g id="press-level">
              <path
                class="st8"
                d="M240.9,366.3c-7-6.8-14.2-13.8-21.4-20.7l-11.9,12.1c7.1,6.9,14.3,13.9,21.4,20.7L240.9,366.3z"
              />
              <path
                class="st8"
                d="M141.8,270.1L130,282.3c0.1,0.1,3.2,3.1,8.5,8.2l11.9-12.1C145.1,273.3,142,270.3,141.8,270.1"
              />
              <path
                class="st8"
                d="M297.7,444.9l10.5-13.3c-0.3-0.3-0.6-0.5-0.7-0.7c-0.1-0.1-7.9-7.7-20-19.4l-11.9,12.1
            c11.7,11.4,19.5,18.9,20.3,19.7C296.1,443.5,297.4,444.6,297.7,444.9"
              />
              <path
                class="st8"
                d="M245.4,394.3c2.1,2.1,4.2,4.1,6.3,6.1l11.8-12.1c-6.8-6.6-14-13.6-21.4-20.7l-11.9,12.1
            c4.7,4.6,9.4,9.1,13.9,13.4"
              />
              <path
                class="st8"
                d="M218.3,344.3c-7.3-7.1-14.5-14.1-21.4-20.8l-11.8,12.1c6.9,6.7,14.1,13.7,21.4,20.8L218.3,344.3z"
              />
              <path
                class="st8"
                d="M161.1,312.4l11.8-12.1c-8.6-8.4-16-15.5-21.4-20.7l-11.9,12.1C145.1,296.9,152.5,304.1,161.1,312.4"
              />
              <path
                class="st8"
                d="M260.5,408.9c5,4.9,9.7,9.4,13.9,13.4l11.9-12.1c-6.2-6-13.5-13.1-21.4-20.7L253,401.6
            c2.1,2.1,4.2,4.1,6.3,6.1"
              />
              <path
                class="st8"
                d="M195.6,322.3c-7.6-7.4-14.8-14.4-21.4-20.7l-11.9,12.1c6.5,6.4,13.8,13.4,21.4,20.7L195.6,322.3z"
              />
              <polygon
                class="st9"
                points="121.5,250.4 141.9,270.2 130,282.5 109.5,262.5 	"
              />
              <path
                class="st8"
                d="M488,403.5c2-2,4-4.1,6.1-6.2l-12.2-11.8c-7.7,7.9-14.7,15.1-20.8,21.3l12.2,11.8c1.9-2,4-4.1,6.1-6.2l0,0
            l1.2-1.3l0,0c2-2,4-4.1,6.2-6.3"
              />
              <path
                class="st8"
                d="M530.8,359.6L530.8,359.6l1.2-1.3l0,0c2-2.1,4.1-4.2,6.1-6.2l-12.2-11.8c-7,7.1-14,14.3-20.8,21.3l12.2,11.8
            C521.8,368.8,526.3,364.2,530.8,359.6"
              />
              <path
                class="st8"
                d="M502.6,388.5c2-2.1,4.1-4.2,6.2-6.3l0,0l1.2-1.3l0,0c2-2.1,4-4.1,6.1-6.2l-12.2-11.8
            c-7.2,7.4-14.2,14.6-20.8,21.3l12.2,11.8c2-2,4-4.1,6.1-6.2"
              />
              <path
                class="st8"
                d="M574.9,314.4L574.9,314.4l1.2-1.3l0,0c2.1-2.2,4.2-4.3,6.2-6.3L570.1,295c-6.4,6.5-13.4,13.7-20.8,21.3
            l12.2,11.8C566.1,323.4,570.6,318.8,574.9,314.4"
              />
              <path
                class="st8"
                d="M545.5,344.5L545.5,344.5l1.2-1.3l0,0c2-2.1,4.1-4.2,6.1-6.2l0,0l1.2-1.3l0,0c2.1-2.1,4.1-4.2,6.2-6.3
            L548,317.6c-6.7,6.9-13.8,14.1-20.9,21.4l12.2,11.8C541.4,348.7,543.5,346.6,545.5,344.5"
              />
              <path
                class="st8"
                d="M589.6,299.4L589.6,299.4l1.2-1.3l0,0c4.9-5,9.2-9.4,12.8-13.1c0.2-0.3,0.5-0.5,0.7-0.8l-12.2-11.8
            c-5.3,5.4-12.5,12.8-20.8,21.3l12.2,11.8C585.6,303.5,587.7,301.4,589.6,299.4"
              />
              <path
                class="st8"
                d="M602.1,262.3c-0.4,0.4-3.5,3.6-8.7,8.9l12.2,11.8c5.3-5.5,8.5-8.7,8.7-8.9L602.1,262.3z"
              />
              <path
                class="st8"
                d="M451.7,440.6c0,0,0.1-0.1,0.3-0.3c0.1-0.1,0.3-0.3,0.5-0.5s0.4-0.4,0.7-0.7c0.2-0.2,0.4-0.4,0.6-0.6
            c0.1-0.2,0.3-0.3,0.5-0.5c0.6-0.6,1.3-1.3,2-2.1c0.3-0.3,0.6-0.7,1-1l0,0l1.2-1.3l0,0c0.7-0.7,1.3-1.4,2.1-2.1
            c0.3-0.3,0.6-0.6,0.9-0.9c1-1,2-2.1,3.1-3.2l0,0l1.2-1.3l0,0c1.6-1.7,3.4-3.5,5.2-5.4c0.3-0.3,0.6-0.6,0.9-0.9L459.8,408
            c-12.2,12.5-20.1,20.6-20.2,20.7l0,0l10.9,13.1C450.9,441.3,451.3,441,451.7,440.6"
              />
              <polygon
                class="st9"
                points="633.5,253.3 614.2,274.2 601.9,262.6 621,241.6 	"
              />
            </g>
            <g id="preferred-level">
              <path
                class="st8"
                d="M325.7,444.3l-7.5,15.2c2.6,1.4,5.1,2.7,7.8,3.9l6.1-15.8C330,446.6,327.8,445.5,325.7,444.3"
              />
              <path
                class="st8"
                d="M308.6,453.5L308.6,453.5c2.6,1.9,5.3,3.5,8.1,5.1l7.5-15.2c-5.1-3-10-6.6-14.6-10.6l-10.5,13.3
            c2.9,2.5,5.8,4.8,8.8,7L308.6,453.5z"
              />
              <path
                class="st8"
                d="M422.6,442.2c-3,1.9-6.1,3.6-9.3,5.1l6.6,15.6c3.6-1.7,7.2-3.6,10.6-5.7L422.6,442.2z"
              />
              <path
                class="st8"
                d="M441.4,449.7c2.7-2.1,5.3-4.4,7.9-6.8l-10.9-13.1c-4.4,4.3-9.2,8.1-14.2,11.3l7.9,15c2.7-1.7,5.3-3.5,7.9-5.5"
              />
            </g>
            <g id="lower-reserved">
              <polygon
                class="st4"
                points="548,273.2 560.3,285.2 569.5,275.8 580.4,256.9 580.1,257.5 566.7,249.1 558.4,262.5 	"
              />
              <polygon
                class="st4"
                points="171.5,254 158.2,263 171.2,280.5 179.5,288.3 191.7,275.9 181,265.7 	"
              />
              <polygon
                class="st4"
                points="158.5,231 140.1,236.7 140.3,239.1 157.2,261.7 170.5,252.8 161.7,241.9 	"
              />
              <polygon
                class="st4"
                points="578.1,224.7 595.2,231.3 594.9,231.8 596.4,229.4 596.5,228.2 591.1,192.9 581.7,192.9 580.4,210.5
            "
              />
              <polygon
                class="st4"
                points="574,237.3 567.5,247.8 580.9,256.2 595.3,231.2 578.2,224.6 	"
              />
              <polyline
                class="st4"
                points="140.1,236.8 158.6,231.2 154.7,213.5 155,197.4 144.6,197.8 	"
              />
              <path
                class="st4"
                d="M195.1,270.1l43.6-44.6c-2.8-2.7-7.6-7.1-10.9-10.3l-51.7,34.5c4.4,5.5,8.8,10.8,8.9,10.9
            c0.5,0.4,3.9,3.8,9.4,9.1"
              />
              <path
                class="st4"
                d="M561.3,244.9l-55.5-34.8c-3,3-9.5,9.7-10.7,11l48.3,46.9c6.1-6.2,9.8-10.1,9.9-10.2
            C553.5,257.5,557.5,251,561.3,244.9"
              />
              <path
                class="st4"
                d="M160.1,212.9c0.1,0.4,2.2,7,4.2,13.3l56.8-24.4l-0.9-4.4l-60.3,0.8c0.1,7.2,0.4,14.3,0.4,14.8"
              />
              <path
                class="st4"
                d="M253.4,64.5l-19.9,17.9l25.7,25.2c6.4-6.6,12.8-13.1,18.5-19L253.4,64.5z"
              />
              <path
                class="st4"
                d="M175.2,248.4l51.5-34.3c-2.2-2.1-3.7-3.6-3.7-3.6l-1.5-7.1l-57.1,24c1.6,5.2,2.5,10.1,2.6,10.5
            C167.3,238.3,171,243.3,175.2,248.4"
              />
              <path
                class="st4"
                d="M232.2,83.3l-10.5,8.4l-8.1,10.9l26,25.1c5.9-6,12.2-12.5,18.5-19L232.2,83.3z"
              />
              <path
                class="st4"
                d="M160.5,197.4l59.4-1.6l-0.9-4.5l-54.7-21.2c-1.9,6.4-3.8,12.5-3.9,12.9c0,0.4-0.3,6.3-0.2,13.4"
              />
              <path
                class="st4"
                d="M164.9,169l53.7,20.4l-4-19.3l-38.4-24.3c-3.7,5.1-7.2,9.9-7.4,10.3c-0.1,0.5-2,6.2-3.9,12.5"
              />
              <path
                class="st4"
                d="M176.6,145.4l37.5,22.5l-2.4-11.6c0,0,2.7-2.8,7.2-7.4L193.8,125c-4.6,4.7-9,9.2-9.2,9.4
            c-0.1,0.2-3.3,4.7-7.2,10.2"
              />
              <path
                class="st4"
                d="M193.1,121.8l26.8,26.1c4.8-4.9,11.3-11.6,18.5-19l-26.9-26l-15.9,21.5l-7.1-7.1"
              />
              <polyline
                class="st4"
                points="460,37.4 433.5,64.6 452.7,83.2 480.8,54.4 	"
              />
              <polyline
                class="st4"
                points="503.4,74.2 474.1,104.1 493.4,122.8 521.7,93.2 	"
              />
              <polyline
                class="st4"
                points="523.7,94.9 494.5,123.9 513.7,142.5 543.4,112.8 	"
              />
              <polygon
                class="st4"
                points="482.5,55 453.8,84.3 473,103 502.1,73.1 	"
              />
              <path
                class="st4"
                d="M305.1,54.3l-20-19.3L275,44.5l23.4,22.8c1.6-1.6,2.5-2.6,2.7-2.7C301.4,63.7,303.1,59.2,305.1,54.3"
              />
              <path
                class="st4"
                d="M273.5,45.2l-6.8,7.7l-12.1,10.6l24.1,24c7.9-8.1,14.6-15,18.5-19L273.5,45.2z"
              />
              <polygon
                class="st4"
                points="448.8,28.2 423,54.4 432.3,63.5 458.2,36.6 	"
              />
              <path
                class="st4"
                d="M576.3,192.2l-54.2,0.7l-8.8,0.1c0,1.8,0.2,3.8-0.1,5.6l59.1,23c2-6.2,4.1-12.6,4.3-13.1
            C576.5,207.9,576.4,199.8,576.3,192.2"
              />
              <path
                class="st4"
                d="M540.6,117.2l-25.7,26.5l11.5,5.2l5.9,6.2l25.6-16.9c-4.2-5.3-8.3-10.4-8.4-10.5c-0.1-0.1-3.8-5.5-8.6-10.2"
              />
              <path
                class="st4"
                d="M533.3,173l36.5-15.2c-1.3-4.1-2.2-7.3-2.3-7.6c-0.4-0.4-4.4-5.5-8.6-10.7"
              />
              <path
                class="st4"
                d="M570.3,159.3l-45.4,19v-0.1l-13.1,5.4c0.5,2.2,0.9,4.9,1,7.7l63.5-0.9c-0.1-6.3-0.2-11.9-0.2-12.3
            C575.9,177.8,572.7,167.3,570.3,159.3"
              />
              <path
                class="st4"
                d="M562.1,243.5c3.1-5,5.9-9.6,6.1-9.8c0.1-0.3,1.7-5.2,3.5-10.6l-48.6-18.8v-0.1l-11.2-4.3
            c-0.8,3.1-2.3,6.1-4.7,8.6c0,0-0.1,0.1-0.3,0.3l6.9,4.3l0,0L562.1,243.5z"
              />
              <polyline
                class="st4"
                points="558.9,139.4 530.1,158.5 533.3,173 	"
              />
              <polygon
                class="st4"
                points="205.6,165 191.9,154.2 299.4,47.3 305.5,54.5 301.5,66.5 	"
              />
              <polygon
                class="st4"
                points="437.5,40.2 424.7,52.7 532.4,157.4 547.4,147.1 	"
              />
              <polygon
                class="st4"
                points="204.8,164 197.2,159.2 195.1,162.3 190.2,173.3 187.2,182.5 185.4,191.8 186.2,201.5 188.6,211.3
            190.2,215 208.6,207.2 207.5,203.8 207.4,192.2 201.5,167.4 	"
              />
            </g>
            <g id="lower-box">
              <polygon
                class="st2"
                points="179.9,288.9 199.9,308.3 212.1,295.8 192.1,276.4 	"
              />
              <polygon
                class="st2"
                points="542.2,303.8 559.2,286.3 546.9,274.3 529.8,291.7 	"
              />
              <path
                class="st2"
                d="M265.2,260.2c-5.2-5-9-8.7-9-8.7l0,0L217,291.6c2.9,2.8,5.9,5.8,9,8.8L265.2,260.2z"
              />
              <polygon
                class="st2"
                points="200.3,308.7 209.3,317.4 221.6,304.9 212.5,296.2 	"
              />
              <path
                class="st2"
                d="M256.2,250.9c-3.1-4.9-13.5-21-14.1-21.9c-0.2-0.2-0.8-0.8-1.8-1.7l-43.6,44.6c5.3,5.1,12.2,11.8,20,19.4
            L256.2,250.9z"
              />
              <path
                class="st2"
                d="M482.3,247.1c-1.9,2-5.2,5.3-8.9,9.2l41.8,40.5c3.1-3.2,6.1-6.2,8.9-9.2L482.3,247.1z"
              />
              <path
                class="st2"
                d="M494.3,223c-2.2,5-10.1,22.5-10.1,22.5s-0.3,0.3-0.8,0.8l41.8,40.2c6.6-6.7,12.4-12.6,17.1-17.3L494.3,223z"
              />
              <polygon
                class="st2"
                points="272.5,354.3 263.4,345.5 251.2,358.1 260.2,366.8 	"
              />
              <polygon
                class="st2"
                points="293,374.3 283.8,365.3 271.5,377.8 280.8,386.8 	"
              />
              <polygon
                class="st2"
                points="241.9,324.7 232.9,315.9 220.6,328.4 229.7,337.2 	"
              />
              <path
                class="st2"
                d="M285.5,280c-2.6-2.5-5.8-5.6-9-8.8l-39.2,40.1c3,2.9,6,5.8,9,8.8L285.5,280z"
              />
              <polygon
                class="st2"
                points="252.1,334.5 243,325.8 230.8,338.3 239.8,347 	"
              />
              <polygon
                class="st2"
                points="262.3,344.4 253.2,335.6 241,348.1 250.1,357 	"
              />
              <polygon
                class="st2"
                points="282.6,364.2 273.6,355.4 261.4,367.9 270.4,376.7 	"
              />
              <polygon
                class="st2"
                points="303,383.9 294.2,375.4 282,387.9 290.7,396.5 	"
              />
              <path
                class="st2"
                d="M275.4,270.1c-3.1-3-6.2-6-9-8.8l-39.2,40.1c3,2.9,6,5.8,9,8.8L275.4,270.1z"
              />
              <polygon
                class="st2"
                points="231.7,314.8 222.7,306 210.5,318.5 219.5,327.3 	"
              />
              <path
                class="st2"
                d="M300.4,405.7c2.2,1.9,4.4,3.7,6.6,5.5l10.1-15.9c-3.9-2.6-7.7-5.5-11.3-8.7c0,0-1-0.9-1.7-1.5l-12.2,12.5
            L300.4,405.7L300.4,405.7z"
              />
              <path
                class="st2"
                d="M472.3,257.4c-2.8,2.9-5.9,6.1-8.9,9.1l41.8,40.5c3-3.1,6-6.1,8.9-9.1L472.3,257.4z"
              />
              <path
                class="st2"
                d="M504,308.2l-41.8-40.5c-3.3,3.4-6.4,6.6-8.9,9.2l41.8,40.5C498.1,314.3,501.1,311.2,504,308.2"
              />
              <g>
                <!--109-->
                <path
                  class="st2"
                  d="M320.8,348.1l-22.2,22.7c4.5,4.3,7.6,7.4,8.8,8.5l22.2-22.7C327.2,354.3,324.1,351.3,320.8,348.1z"
                />
              </g>
              <g>
                <!--111-->
                <path
                  class="st2"
                  d="M310.2,338.2l-22,22.5c3.5,3.4,6.6,6.4,9.3,9l21.9-22.5C316.7,344.5,313.5,341.4,310.2,338.2z"
                />
              </g>
              <g>
                <!--107-->
                <path
                  class="st2"
                  d="M336.9,363.9c-0.1-0.1-0.1-0.1-0.2-0.1c-0.6-0.5-2.9-2.8-6.1-5.9l-22,22.5c0.6,0.6,1.5,1.4,1.5,1.4
              c3.3,3,6.8,5.6,10.4,8L336.9,363.9L336.9,363.9z"
                />
              </g>
              <g>
                <!--113-->
                <path
                  class="st2"
                  d="M300,328.4l-21.9,22.4c3.2,3.1,6.2,6,9,8.8l21.9-22.4C306.2,334.4,303,331.4,300,328.4z"
                />
              </g>
              <g>
                <!--117-->
                <path
                  class="st2"
                  d="M279.6,308.5l-22,22.5c3.1,3,6.1,5.9,9.1,8.8l22-22.5C285.8,314.5,282.6,311.5,279.6,308.5z"
                />
              </g>
              <g>
                <!--115-->
                <path
                  class="st2"
                  d="M289.9,318.4l-22,22.6c3.1,3,6.1,6,9,8.8l22-22.6C296.1,324.4,292.9,321.3,289.9,318.4z"
                />
              </g>
              <g>
                <!--108-->
                <path
                  class="st2"
                  d="M411.8,357.1c-3.4,3.5-5.6,5.7-5.6,5.7l0.4-0.4c-0.7,0.7-1.6,1.5-2.4,2.2l18.4,27.4c4.7-3,7.8-8.7,12-12.7
              L411.8,357.1z"
                />
              </g>
              <g>
                <!--110-->
                <path
                  class="st2"
                  d="M421.3,347.6c-3.1,3.2-6.1,6.2-8.3,8.5l22.8,22.1c1.2-1.3,4.2-4.3,8.3-8.5L421.3,347.6z"
                />
              </g>
              <g>
                <!--112-->
                <path
                  class="st2"
                  d="M431.1,337.5c-3.1,3.1-6.1,6.3-8.7,8.9l22.8,22.1c2.5-2.6,5.5-5.6,8.7-9L431.1,337.5z"
                />
              </g>
              <g>
                <!--119-->
                <path
                  class="st2"
                  d="M269.4,298.8l-21.9,22.4c3,2.9,6,5.9,9,8.8l21.9-22.4C275.5,304.7,272.4,301.6,269.4,298.8z"
                />
              </g>
              <g>
                <!--120-->
                <path
                  class="st2"
                  d="M471.5,296.2c-3,3-6.2,6.4-9.2,9.4l23.7,23c3-3.1,6.1-6.3,9.2-9.4L471.5,296.2z"
                />
              </g>
              <g>
                <!--116-->
                <path
                  class="st2"
                  d="M451.2,317L451.2,317c-3.1,3.1-6,6.2-8.9,9.2l22.7,22c2.9-2.9,5.9-6,8.9-9.2L451.2,317z"
                />
              </g>
              <g>
                <!--114-->
                <path
                  class="st2"
                  d="M441.1,327.2L441.1,327.2c-3.1,3.2-6.1,6.2-8.9,9.1l22.8,22.1c2.8-2.8,5.8-5.9,8.9-9.1L441.1,327.2z"
                />
              </g>
              <g>
                <!--118-->
                <path
                  class="st2"
                  d="M461.2,306.8L461.2,306.8c-3,3.1-6,6.1-8.9,9.1l22.7,22c2.9-3,5.9-6,8.9-9.1L461.2,306.8z"
                />
              </g>
            </g>
            <g id="lower-box-preferred">
              <g>
                <!--105-->
                <path
                  class="st2"
                  d="M338.1,365l-16.2,25.7c4.6,2.9,9.4,5.4,14.4,7.4l0,0l10.7-27.4C343.8,369.1,340.8,367.2,338.1,365z"
                />
              </g>
              <g>
                <path
                  class="st2"
                  d="M393.2,371.9c-3.2,1.4-6.6,2.5-10,3.4c2.5,11.6,5,23.1,5.9,27.4l0,0c5.1-1,10.2-2.5,15.2-4.4
              C401.7,392,397.4,381.9,393.2,371.9z"
                />
              </g>
              <g>
                <path
                  class="st2"
                  d="M370.3,375.4c-3.6,0.3-7.4,0.2-11-0.2l-5.1,27.9v0.1c2.6,0.5,5.2,0.8,7.8,1v-0.1c0.5,0,1,0.1,1.6,0.1v0.1
              c2.4,0.2,4.7,0.3,7.1,0.3l0,0L370.3,375.4z"
                />
              </g>
              <g>
                <path
                  class="st2"
                  d="M348.3,371.5c-4.1,10.5-8.2,21.1-10.6,27.1l0,0c4.9,1.9,9.9,3.3,15,4.3v-0.1l5-27.8
              C354.5,374.1,351.3,373,348.3,371.5z"
                />
              </g>
              <g>
                <!--102-->
                <path
                  class="st2"
                  d="M387.6,403.1L387.6,403.1l-5.8-27.6c-3.3,0.5-6.6,0.6-9.9,0.5c0.2,12.2,0.3,24.3,0.4,28.6v0.1
              C377.4,404.5,382.5,404,387.6,403.1z"
                />
              </g>
              <g>
                <!--106-->
                <path
                  class="st2"
                  d="M403.2,365.9c-2.7,2.1-5.6,3.8-8.6,5.3l11.2,26.6l0.8,2.2c4.8-2,9.6-5.3,14.1-8L403.2,365.9z"
                />
              </g>
            </g>
            <g id="lower-infield-box">
              <path
                class="st10"
                d="M324.2,344.7l-3.3,3.4c3.4,3.3,6.4,6.2,8.8,8.5l3.3-3.4C330.6,350.9,327.6,348,324.2,344.7"
              />
              <path
                class="st10"
                d="M313.8,334.6l-3.6,3.6c3.3,3.2,6.4,6.3,9.3,9l3.6-3.6C320.2,340.9,317.1,337.8,313.8,334.6"
              />
              <path
                class="st10"
                d="M340.8,360.5L340.8,360.5l-3,4.2c2.9,2.5,6.1,4.5,9.5,6.1l2.2-4.6C346.3,364.7,343.4,362.8,340.8,360.5"
              />
              <path
                class="st10"
                d="M334.1,354.4l-3.5,3.6c3.3,3.2,5.5,5.3,6,5.9c0,0,0.1,0.1,0.2,0.1l2.9-4.1C339,359,337,357.1,334.1,354.4"
              />
              <path
                class="st10"
                d="M312.7,333.5c-2.9-2.8-5.9-5.7-9.1-8.8l-3.6,3.7c3.1,3,6.2,6,9.1,8.8L312.7,333.5z"
              />
              <path
                class="st10"
                d="M283.2,304.9l-3.6,3.6c3.1,3,6.1,5.9,9.1,8.8l3.5-3.6C289.3,310.8,286.3,307.9,283.2,304.9"
              />
              <path
                class="st10"
                d="M302.5,323.6c-2.9-2.9-6-5.8-9-8.8l-3.5,3.6c3.1,3,6.1,5.9,9,8.8L302.5,323.6z"
              />
              <path
                class="st10"
                d="M381.5,370.3c0.4,1.7,0.8,3.4,1.1,5.2c4.6-1.1,9-2.7,13.2-4.8c-0.7-1.6-1.4-3.3-2.1-4.9
            C389.8,367.8,385.7,369.3,381.5,370.3"
              />
              <path
                class="st10"
                d="M403.1,359L403.1,359c-0.6,0.5-1.1,1-1.7,1.5l2.9,3.9c0.8-0.7,1.5-1.3,2.2-2l-0.4,0.4c0,0,2-2.1,5.5-5.7
            l-3.5-3.4C405.1,357,403.2,358.9,403.1,359"
              />
              <path
                class="st10"
                d="M409.3,352.6l3.6,3.5c2.3-2.4,5.1-5.2,8.3-8.5l-3.6-3.5C414.4,347.4,411.6,350.3,409.3,352.6"
              />
              <path
                class="st10"
                d="M427.5,334c-3.1,3.2-6.1,6.2-8.7,9l3.6,3.5c2.7-2.7,5.6-5.7,8.7-8.9L427.5,334z"
              />
              <path
                class="st10"
                d="M358.9,370.6l-1.2,4.5c4.1,0.6,8.3,0.7,12.6,0.3l0.4-4.4C366.6,371.3,362.7,371.2,358.9,370.6"
              />
              <path
                class="st10"
                d="M273,295.1l-3.6,3.7c3,2.9,6,5.9,9,8.8l3.6-3.7C279.1,300.9,276,298,273,295.1"
              />
              <path
                class="st10"
                d="M349.4,366.8c-0.6,1.4-1.2,2.9-1.8,4.4c3.6,1.8,7.4,3.2,11.2,4.1l0.9-4.6
            C356.2,369.8,352.7,368.5,349.4,366.8"
              />
              <path
                class="st10"
                d="M371.4,371.8c0.1,1.4,0.2,2.8,0.3,4.2c3.6,0.2,7.2,0,10.8-0.6l-1.1-4.1C378.1,371.8,374.8,371.9,371.4,371.8"
              />
              <path
                class="st10"
                d="M391.6,366.7l2.4,4.8c3.7-1.7,7.1-3.9,10.3-6.4l-3.2-4.5C398.1,363,394.9,365.1,391.6,366.7"
              />
              <path
                class="st10"
                d="M458.7,302.1l3.6,3.5c3-3.1,6-6.1,9-9.2l-3.6-3.5C464.7,296,461.7,299,458.7,302.1"
              />
              <path
                class="st10"
                d="M451.2,317l-3.7-3.5c-3.1,3.1-6,6.2-9,9.2l3.7,3.5C445.2,323.2,448.2,320.2,451.2,317"
              />
              <path
                class="st10"
                d="M441.1,327.3l-3.6-3.5c-3.1,3.2-6.1,6.2-8.9,9.1l3.6,3.5C435,333.5,438,330.4,441.1,327.3"
              />
              <path
                class="st10"
                d="M461.2,306.8l-3.7-3.5c-3,3.1-6,6.1-8.9,9.1l3.7,3.5C455.2,312.9,458.2,309.9,461.2,306.8"
              />
            </g>
            <g id="chalk-box">
              <path
                class="st11"
                d="M449,272.6l9.5,9.2c3-3.1,6-6.2,8.9-9.2l-9.5-9.2C455,266.5,452.1,269.5,449,272.6"
              />
              <path
                class="st11"
                d="M460.2,263.5l8.3,8.2c3-3.1,6-6.2,8.9-9.1l-8.3-8.2C466.2,257.3,463.3,260.4,460.2,263.5"
              />
              <path
                class="st11"
                d="M470.1,253.2l8.3,8.2c3.1-3.2,6.1-6.3,8.9-9.2L479,244C476.2,246.9,473.2,249.9,470.1,253.2"
              />
            </g>

            <g id="rays-club">
              <path
                class="st12"
                d="M446.1,401.5L446.1,401.5l5.6-5.7l-12.4-12.1c-4.5,4.3-9.4,8.1-14.5,11.4l10.6,15.8
            C439,408.1,442.6,404.9,446.1,401.5"
              />
              <polygon
                class="st12"
                points="423.4,396 413,401.8 424.3,418.4 434,411.9 	"
              />
              <polygon
                class="st12"
                points="532.2,313.3 541.1,304.2 528.7,292.1 519.8,301.3 	"
              />
              <polygon
                class="st12"
                points="531,314.5 518.5,302.4 440.1,382.7 452.7,394.8 	"
              />
            </g>
            <g id="dex-home-plate">
              <path
                class="st16"
                d="M405.9,350.7c0,0-36.2,37-69.4-0.4l8.9-9c0,0,26.5,17,49.6-0.9L405.9,350.7z"
              />
            </g>
            <g id="BG">
              <!--CHALK BOX-->
              <path
                class="st0"
                d="M450.6,274.2l18.1,17.6c3-3.1,6-6.1,29.3-29.5l-18.2-17.6C456.5,268.1,453.6,271.1,450.6,274.2"
              />
              <text
                transform="matrix(0.6893 -0.7248 0.7225 0.6913 465.8401 281.4472)"
                class="st13 st14 st15"
              >
                CHALK BOX
              </text>

              <polygon
                class="st3"
                points="178.2,107.2 166.5,122.1 146.8,165.2 143.9,197.1 156.4,196.6 162.3,167.4 171.4,143.3 192.9,120.4
            "
              />
              <path
                class="st3"
                d="M193.2,121.8l-4.6-4.5l-1.1,1.1l4.6,4.5C192.5,122.5,192.9,122.1,193.2,121.8"
              />
              <g>
                <path
                  class="st17"
                  d="M566.6,33.2c0,13.4-10.9,24.2-24.3,24.2c-13.4,0-24.3-10.8-24.3-24.2S528.9,9,542.3,9
              C555.8,9.1,566.6,19.9,566.6,33.2"
                />
                <path
                  class="st18"
                  d="M537.5,20.1c-0.4,0.1-1.2,0.3-2.1,0.3c-1.1,0-1.9-0.3-2.5-0.8s-0.9-1.3-0.9-2.2c0-2,1.5-3.2,3.5-3.2
              c0.8,0,1.4,0.2,1.7,0.3l-0.3,1.1c-0.3-0.2-0.8-0.3-1.4-0.3c-1.2,0-2.1,0.6-2.1,2c0,1.3,0.8,2,1.9,2c0.3,0,0.6,0,0.7-0.1v-1.3h-1
              v-1.1h2.3L537.5,20.1z"
                />
                <path
                  class="st18"
                  d="M540,18.8l-0.4,1.6h-1.5l1.9-6.1h1.8l1.9,6.2h-1.5l-0.5-1.6L540,18.8z M541.6,17.7l-0.4-1.3
              c-0.1-0.4-0.2-0.8-0.3-1.2l0,0c-0.1,0.4-0.2,0.8-0.3,1.2l-0.4,1.3H541.6z"
                />
                <polygon
                  class="st18"
                  points="545,15.4 543.3,15.4 543.3,14.2 548,14.2 548,15.4 546.3,15.4 546.3,20.4 544.9,20.4 		"
                />
                <polygon
                  class="st18"
                  points="552.4,17.8 550.2,17.8 550.2,19.2 552.7,19.3 552.7,20.4 548.8,20.4 548.8,14.2 552.6,14.2
              552.6,15.4 550.2,15.4 550.2,16.7 552.4,16.7 		"
                />
                <polygon
                  class="st18"
                  points="541.3,26.5 541.3,26.5 538.2,27.9 537.6,25.2 541.9,23.2 544.9,23.2 544.9,39.1 541.3,39 		"
                />
                <path
                  class="st18"
                  d="M527,43.8c0.3-0.1,0.7-0.1,1.2-0.1c0.6,0,1,0.1,1.3,0.3s0.4,0.5,0.4,0.9c0,0.5-0.4,0.9-0.7,1l0,0
              c0.3,0.1,0.4,0.4,0.5,0.8c0.1,0.5,0.2,1,0.3,1.2h-1c-0.1-0.1-0.2-0.5-0.3-1s-0.3-0.7-0.7-0.7h-0.3v1.6h-0.9L527,43.8z M527.9,45.5
              h0.4c0.5,0,0.7-0.2,0.7-0.6c0-0.4-0.3-0.6-0.7-0.6c-0.2,0-0.4,0-0.4,0V45.5z"
                />
                <path
                  class="st18"
                  d="M532.9,47.9c-1.2,0-1.9-0.9-1.9-2.1c0-1.2,0.8-2.1,2-2.1c1.3,0,1.9,0.9,1.9,2.1
              C534.9,47.1,534.1,47.9,532.9,47.9L532.9,47.9z M532.9,47.2c0.6,0,1-0.6,1-1.4c0-0.7-0.3-1.4-1-1.4c-0.6,0-1,0.6-1,1.4
              C531.9,46.6,532.3,47.2,532.9,47.2L532.9,47.2z"
                />
                <polygon
                  class="st18"
                  points="536.8,44.5 535.6,44.5 535.7,43.7 538.8,43.8 538.8,44.5 537.7,44.5 537.7,47.9 536.7,47.9 		"
                />
                <path
                  class="st18"
                  d="M540.8,43.8v2.4c0,0.7,0.3,1.1,0.7,1.1c0.5,0,0.8-0.3,0.8-1.1v-2.4h0.9v2.3c0,1.3-0.6,1.9-1.7,1.9
              c-1,0-1.6-0.6-1.6-1.9v-2.3H540.8z"
                />
                <path
                  class="st18"
                  d="M544.7,47.9v-4.1h1.1l0.9,1.5c0.2,0.4,0.5,0.9,0.7,1.4l0,0c-0.1-0.5-0.1-1.1-0.1-1.7v-1.2h0.9v4.1h-1
              l-0.9-1.6c-0.2-0.4-0.5-1-0.7-1.4l0,0c0,0.5,0,1.1,0,1.8v1.2H544.7z"
                />
                <path
                  class="st18"
                  d="M549.5,43.9c0.3-0.1,0.8-0.1,1.3-0.1c0.8,0,1.3,0.1,1.7,0.4c0.4,0.3,0.7,0.8,0.7,1.6s-0.3,1.3-0.7,1.7
              s-1.1,0.5-1.9,0.5c-0.5,0-0.8,0-1.1-0.1V43.9z M550.4,47.2c0.1,0,0.2,0,0.3,0c0.8,0,1.4-0.5,1.4-1.4s-0.5-1.3-1.3-1.3
              c-0.2,0-0.3,0-0.4,0V47.2z"
                />
                <path
                  class="st18"
                  d="M555.3,46.9L555,48h-1l1.3-4.1h1.2l1.3,4.1h-1l-0.3-1.1H555.3z M556.4,46.2l-0.3-0.9
              c-0.1-0.2-0.1-0.6-0.2-0.8l0,0c-0.1,0.2-0.1,0.6-0.2,0.8l-0.3,0.9H556.4z"
                />
              </g>

              <polygon
                class="st3"
                points="530,158.7 563.1,136.5 559.7,131 524.3,152.7 	"
              />
              <polygon
                class="st3"
                points="189.9,274.3 192.4,276.6 247.4,220.2 245.4,217.6 	"
              />
              <polygon
                class="st3"
                points="542.3,303.7 541.1,304.9 528.6,292.9 529.9,291.7 	"
              />
              <polygon
                class="st19"
                points="558.1,282.8 556.9,284 546.8,274.3 548.1,273.1 	"
              />
              <polygon
                class="st3"
                points="158.1,263 157.2,261.6 170.5,252.8 171.5,254.1 	"
              />
              <polygon
                class="st3"
                points="180.5,289.4 179.4,288.3 191.6,276 192.8,277.1 	"
              />
              <polygon
                class="st20"
                points="203.4,306.9 202.3,305.7 212.1,295.7 213.2,296.8 	"
              />
              <path
                class="st21"
                d="M256.2,250.9c-3.1-4.9-13.5-21-14.1-21.9c-0.2-0.2-0.8-0.8-1.8-1.7l-43.6,44.6c5.3,5.1,12.2,11.8,20,19.4
            L256.2,250.9z"
              />
              <path
                class="st22"
                d="M256.2,250.9c-3.1-4.9-13.5-21-14.1-21.9c-0.2-0.2-0.8-0.8-1.8-1.7l-43.6,44.6c5.3,5.1,12.2,11.8,20,19.4
            L256.2,250.9z"
              />
              <path
                class="st23"
                d="M525.2,287l-0.2-0.2l-42-40.4l0.2-0.2c0.4-0.4,0.7-0.7,0.8-0.8c0.5-1,7.9-17.6,10-22.5l0.2-0.4l48.5,46.7
            l-0.2,0.2c-4.6,4.7-10.5,10.7-17.1,17.3L525.2,287z M483.9,246.3l41.3,39.8c6.4-6.5,12.1-12.3,16.6-16.9l-47.4-45.7
            c-2.5,5.5-9.9,22.1-9.9,22.1l-0.1,0.1C484.5,245.7,484.3,245.9,483.9,246.3"
              />
              <path
                class="st22"
                d="M494.3,222.5c-2.2,5.1-10.1,22.7-10.1,22.7s-0.3,0.3-0.8,0.8l41.8,40.5c6.6-6.7,12.4-12.7,17.1-17.5
            L494.3,222.5z"
              />
              <polygon
                class="st3"
                points="316.8,417.9 318.2,418.8 328.6,401.4 326.8,400.5 	"
              />
              <polygon
                class="st24"
                points="364.5,17.5 307.6,17.9 295.2,24.8 311.7,41.7 408.1,40.7 417.4,17.9 	"
              />
              <polygon
                class="st25"
                points="114.8,144.5 119,145.9 118.8,146.8 130.5,150.6 130.7,149.8 131.1,148.9 115.1,143.7 	"
              />
              <polygon
                class="st25"
                points="126.9,127 122.9,125.1 122.7,125.6 137.9,132.7 138,132.4 138.7,131.1 127.5,125.8 	"
              />
              <polygon
                class="st25"
                points="143.8,84.9 147.5,87.2 147.1,88 157.6,94.6 158.1,93.7 158.5,93.1 144.3,84.2 	"
              />
              <polygon
                class="st25"
                points="188.5,34.5 191.5,37.7 190.9,38.4 199.4,47.4 200,46.8 200.7,46.1 189.2,33.9 	"
              />
              <polygon
                class="st25"
                points="205.8,20 208.4,23.6 209.6,22.9 216.6,33 215.7,33.7 214.9,34.3 205.1,20.6 	"
              />
              <polygon
                class="st25"
                points="156.4,67.3 160,70.2 160.8,69.2 170.1,77.1 169.4,78 168.8,78.7 155.8,68.1 	"
              />
              <polygon
                class="st25"
                points="233.6,8.2 240.2,18.6 241.7,17.6 235.1,7.2 	"
              />
              <path
                class="st25"
                d="M500.7,392.4L500.7,392.4c0.4-0.4,0.8-0.8,1.2-1.3C501.5,391.6,501.1,392,500.7,392.4"
              />
              <path
                class="st25"
                d="M508.1,384.8L508.1,384.8c0.4-0.4,0.8-0.8,1.2-1.3C508.9,384,508.5,384.4,508.1,384.8"
              />
              <path
                class="st25"
                d="M509.3,383.6L509.3,383.6l-1.2,1.3l0,0C508.5,384.4,508.9,384,509.3,383.6"
              />
              <path
                class="st25"
                d="M538.8,353.4c-0.4,0.4-0.8,0.8-1.2,1.3C538,354.3,538.4,353.8,538.8,353.4L538.8,353.4z"
              />
              <path
                class="st25"
                d="M552.3,339.6L552.3,339.6c0.4-0.4,0.8-0.8,1.2-1.3C553.1,338.7,552.7,339.2,552.3,339.6"
              />
              <path
                class="st25"
                d="M553.5,338.3L553.5,338.3l-1.2,1.3l0,0C552.7,339.2,553.1,338.7,553.5,338.3"
              />
              <path
                class="st25"
                d="M559.7,332L559.7,332c0.4-0.4,0.8-0.8,1.2-1.3C560.5,331.1,560.1,331.6,559.7,332"
              />
              <path
                class="st25"
                d="M581.8,309.4L581.8,309.4c0.4-0.4,0.8-0.8,1.2-1.3C582.6,308.5,582.2,308.9,581.8,309.4"
              />
              <polygon
                class="st3"
                points="553.5,338.3 552.3,339.6 552.3,339.6 	"
              />
              <polygon
                class="st26"
                points="327.1,401 318.2,395.9 307.5,411.4 316.8,417.9 	"
              />
              <path
                class="st25"
                d="M307,411.1L307,411.1c0.1,0.1,0.2,0.1,0.3,0.2C307.2,411.3,307.1,411.2,307,411.1"
              />
              <path
                class="st3"
                d="M247.5,321.2c-0.4-0.4-0.8-0.7-1.1-1.1l-4.5,4.6l1.1,1.1L247.5,321.2z"
              />
              <path
                class="st3"
                d="M226,300.4l-4.5,4.6l1.1,1.1l4.5-4.6C226.8,301.1,226.4,300.7,226,300.4"
              />
              <path
                class="st3"
                d="M236.2,310.2l-4.5,4.6l1.1,1.1l4.5-4.6C237,310.9,236.6,310.6,236.2,310.2"
              />
              <path
                class="st3"
                d="M193.1,121.8l-4.6-4.5l-1.1,1.1l4.6,4.5C192.4,122.5,192.8,122.1,193.1,121.8"
              />
              <path
                class="st3"
                d="M215.9,290.5l-4.5,4.6l1.1,1.1l4.5-4.6C216.6,291.2,216.2,290.8,215.9,290.5"
              />
              <path
                class="st3"
                d="M158.5,196.6l-6.4,0.1v1.6l6.4-0.1C158.5,197.6,158.5,197.1,158.5,196.6"
              />
              <path
                class="st3"
                d="M194.5,269.7l-4.5,4.6l1.4,1.3l4.5-4.6C195.4,270.6,194.9,270.2,194.5,269.7"
              />
              <path
                class="st3"
                d="M175.2,248.4l-5.4,3.6l1,1.2l5.4-3.6C175.8,249.2,175.5,248.8,175.2,248.4"
              />
              <path
                class="st3"
                d="M449.8,373l-4.6-4.5c-0.4,0.4-0.7,0.8-1.1,1.1l4.6,4.5L449.8,373z"
              />
              <path
                class="st3"
                d="M439.6,383.4l0.8-0.8l-4.6-4.5c-0.4,0.4-0.7,0.7-0.7,0.7c-0.1,0.1-0.3,0.3-0.5,0.4l4.6,4.5
            C439.3,383.7,439.5,383.5,439.6,383.4"
              />
              <path
                class="st3"
                d="M337.7,398.6c-0.5-0.2-1-0.4-1.5-0.6l-2.2,5.8c0,0,0.2,0.2,0.4,0.4c1.2,0.5,2.3,0.9,3.5,1.3
            c-0.9-0.9-1.8-1.8-2.1-2.1C335.9,403.2,336.6,401.5,337.7,398.6"
              />
              <path
                class="st3"
                d="M570.3,159.3l6-2.5l-0.5-1.5l-6,2.5C569.9,158.3,570.1,158.8,570.3,159.3"
              />
              <path
                class="st3"
                d="M321.8,390.6c-0.4-0.3-0.9-0.5-1.3-0.8l-3.4,5.4c0.4,0.3,0.9,0.6,1.3,0.8L321.8,390.6z"
              />
              <path
                class="st3"
                d="M563.2,134.6l-5.4,3.6c0.3,0.4,0.7,0.8,1,1.2l5.4-3.6L563.2,134.6z"
              />
              <path
                class="st3"
                d="M304.1,385l4.5-4.6c-0.3-0.3-0.6-0.5-0.6-0.5s-0.2-0.2-0.6-0.6l-4.5,4.6l0.6,0.6
            C303.6,384.6,303.8,384.8,304.1,385"
              />
              <path
                class="st3"
                d="M459.6,362.9l-4.6-4.5c-0.4,0.4-0.7,0.8-1.1,1.1l4.6,4.5L459.6,362.9z"
              />
              <path
                class="st3"
                d="M514,298l4.6,4.5l1.1-1.1l-4.6-4.5C514.8,297.2,514.4,297.6,514,298"
              />
              <path
                class="st3"
                d="M372.3,404.6c-0.5,0-1.1,0-1.6,0v2c0,0,1.3,2.8,2,4.4c0.6,0,1.1,0,1.7-0.1c-0.7-1.5-2-4.5-2.1-4.7
            C372.3,406.2,372.3,405.6,372.3,404.6"
              />
              <path
                class="st3"
                d="M576.3,192.2l5-0.1v-1.6l-5,0.1C576.3,191.1,576.3,191.6,576.3,192.2"
              />
              <path
                class="st3"
                d="M404.3,398.4L404.3,398.4c1.2,2.9,2.1,5,2.5,5.9c0.5-0.2,1-0.4,1.5-0.6l-2.5-5.9
            C405.3,398,404.8,398.2,404.3,398.4"
              />
              <path
                class="st3"
                d="M539.7,118.2l4.5-4.6l-1.1-1.1l-4.5,4.6C538.9,117.5,539.3,117.8,539.7,118.2"
              />
              <path
                class="st3"
                d="M419.8,390.7l3.6,5.3c0.4-0.3,0.9-0.5,1.3-0.8l-3.6-5.3C420.7,390.1,420.2,390.4,419.8,390.7"
              />
              <path
                class="st3"
                d="M352.7,402.9l-1.1,6.3c0.5,0.1,1,0.2,1.6,0.3l1.1-6.3C353.7,403.1,353.2,403,352.7,402.9"
              />
              <path
                class="st3"
                d="M362,404.2l-0.3,6.4c0.5,0,1,0.1,1.6,0.1l0.3-6.4C363.1,404.3,362.5,404.3,362,404.2"
              />
              <path
                class="st3"
                d="M257.7,331c-0.4-0.4-0.8-0.7-1.1-1.1l-4.5,4.6l1.1,1.1L257.7,331z"
              />
              <path
                class="st3"
                d="M267.9,340.9c-0.4-0.4-0.8-0.7-1.1-1.1l-4.5,4.6l1.1,1.1L267.9,340.9z"
              />
              <path
                class="st3"
                d="M278.1,350.8c-0.4-0.4-0.8-0.7-1.1-1.1l-4.5,4.6l1.1,1.1L278.1,350.8z"
              />
              <path
                class="st3"
                d="M542.3,269.1l4.6,4.5l1.1-1.1l-4.6-4.5C543,268.3,542.6,268.7,542.3,269.1"
              />
              <path
                class="st3"
                d="M499.7,321.8l-4.6-4.5c-0.4,0.4-0.7,0.8-1.1,1.1l4.6,4.5L499.7,321.8z"
              />
              <path
                class="st3"
                d="M524.1,287.7l4.6,4.5l1.1-1.1l-4.6-4.5C524.8,286.9,524.5,287.3,524.1,287.7"
              />
              <path
                class="st3"
                d="M389.2,402.8c-0.5,0.1-1,0.2-1.6,0.3l0.4,2.1c0,0,1.5,2.2,2.5,3.9c0.6-0.1,1.1-0.2,1.6-0.4
            c-1.1-1.6-2.6-3.9-2.7-4.1C389.5,404.5,389.4,403.9,389.2,402.8"
              />
              <path
                class="st3"
                d="M504,308.2l4.6,4.5l1.1-1.1l-4.6-4.5C504.8,307.4,504.4,307.8,504,308.2"
              />
              <path
                class="st3"
                d="M561.3,244.9l5.4,3.4l0.8-1.3l-5.4-3.4C561.8,244,561.6,244.4,561.3,244.9"
              />
              <path
                class="st3"
                d="M571.7,223.1l6,2.3l0.5-1.5l-6-2.3C572,222.1,571.9,222.6,571.7,223.1"
              />
              <path
                class="st3"
                d="M288.2,360.7c-0.4-0.4-0.7-0.7-1.1-1.1l-4.5,4.6l1.1,1.1L288.2,360.7z"
              />
              <path
                class="st3"
                d="M298.7,370.8c-0.4-0.4-0.7-0.7-1.1-1.1l-4.5,4.6l1.1,1.1L298.7,370.8z"
              />
              <path
                class="st3"
                d="M479.6,342.4l-4.6-4.5c-0.4,0.4-0.7,0.7-1.1,1.1l4.6,4.5L479.6,342.4z"
              />
              <path
                class="st3"
                d="M469.6,352.7l-4.6-4.5c-0.4,0.4-0.7,0.8-1.1,1.1l4.6,4.5L469.6,352.7z"
              />
              <path
                class="st3"
                d="M489.6,332.1l-4.6-4.5c-0.4,0.4-0.7,0.8-1.1,1.1l4.6,4.5L489.6,332.1z"
              />
              <path
                class="st3"
                d="M404.3,398.4c-4.9,1.9-10,3.4-15.2,4.4c0.2,1.1,0.4,1.7,0.4,1.8c0.1,0.2,1.7,2.5,2.7,4.1
            c4.9-1.1,9.8-2.6,14.6-4.4C406.4,403.3,405.5,401.2,404.3,398.4L404.3,398.4"
              />
              <path
                class="st3"
                d="M387.6,403.1c-5.1,0.9-10.2,1.5-15.3,1.6c0,1,0,1.6,0,1.6c0.1,0.2,1.5,3.2,2.1,4.7c5.4-0.2,10.8-0.8,16.2-1.9
            c-1.1-1.7-2.5-3.9-2.5-3.9L387.6,403.1z"
              />
              <path
                class="st3"
                d="M337.7,398.6c-1.1,2.9-1.8,4.7-1.9,4.8c0.3,0.3,1.2,1.2,2.1,2.1c4.5,1.6,9,2.8,13.7,3.7l1.1-6.3
            C347.6,401.9,342.6,400.5,337.7,398.6"
              />
              <path
                class="st3"
                d="M370.7,404.6c-2.4,0-4.8-0.1-7.1-0.3l-0.3,6.4c3.1,0.2,6.3,0.3,9.5,0.3c-0.7-1.6-2-4.4-2-4.4L370.7,404.6z"
              />
              <path
                class="st3"
                d="M354.3,403.2l-1.1,6.3c2.8,0.5,5.7,0.9,8.6,1.1l0.3-6.4C359.4,404,356.8,403.7,354.3,403.2"
              />
              <path
                class="st3"
                d="M570.3,159.3l6-2.5l0,0L570.3,159.3L570.3,159.3"
              />
              <path
                class="st3"
                d="M571.7,223.1l6,2.3l0,0L571.7,223.1L571.7,223.1"
              />
              <path
                class="st3"
                d="M564.2,135.8L564.2,135.8l-5.4,3.6l0,0L564.2,135.8z"
              />
              <path
                class="st3"
                d="M562.1,243.5L562.1,243.5l5.4,3.4l0,0L562.1,243.5z"
              />
              <path
                class="st22"
                d="M437.4,323.7l-9.5-9.2c-3.1,3.2-6.1,6.2-8.9,9.1l9.5,9.2C431.4,329.9,434.4,326.9,437.4,323.7z"
              />
              <path
                class="st22"
                d="M391.1,334.9l18.1,17.6c2.3-2.3,5.1-5.2,8.3-8.5l-18.1-17.6C396.2,329.7,393.4,332.6,391.1,334.9"
              />
              <path
                class="st22"
                d="M341.4,327.1l-17.1,17.5c3.4,3.3,6.4,6.2,8.8,8.5l17.1-17.5C347.7,333.3,344.8,330.4,341.4,327.1"
              />
              <path
                class="st22"
                d="M322,323.9c-2.9-2.8-5.9-5.7-9-8.8l-9.2,9.5c3.1,3,6.2,6,9,8.8L322,323.9z"
              />
              <path
                class="st22"
                d="M323.1,325l-9.3,9.5c3.3,3.2,6.4,6.3,9.3,9l9.3-9.5C329.5,331.3,326.4,328.2,323.1,325z"
              />
              <path
                class="st22"
                d="M292.5,295.4l-9.3,9.5c3.1,3,6.1,5.9,9.1,8.8l9.3-9.5C298.6,301.3,295.6,298.3,292.5,295.4"
              />
              <path
                class="st22"
                d="M290.9,276.8L273.1,295c3,2.9,6,5.8,9,8.8l17.7-18.2C296.9,282.6,293.9,279.7,290.9,276.8"
              />
              <path
                class="st22"
                d="M302.7,305.3l-9.3,9.5c3.1,3,6.1,5.9,9,8.8l9.3-9.5C308.8,311.2,305.8,308.3,302.7,305.3"
              />
              <path
                class="st22"
                d="M447.5,313.4l-9.5-9.2c-3,3.1-6,6.2-8.9,9.2l9.5,9.2C441.4,319.6,444.4,316.5,447.5,313.4z"
              />
              <path
                class="st22"
                d="M417.9,324.7c-3.1,3.2-6.1,6.2-8.7,8.9l9.5,9.2c2.7-2.7,5.6-5.7,8.7-8.9L417.9,324.7z"
              />
              <path
                class="st22"
                d="M393.9,349.3l7.5,11.2c0.6-0.5,1.1-1,1.6-1.6l0,0c0.1-0.1,2-2,5.1-5.2l-9.5-9.2
            C396.3,346.9,394.6,348.6,393.9,349.3"
              />
              <path
                class="st22"
                d="M440.5,284.4l18.1,17.6c3-3.1,6-6.1,9-9.2l-18.2-17.6C446.4,278.3,443.5,281.3,440.5,284.4"
              />
              <path
                class="st27"
                d="M459.2,262.5l7,6.8c3-3.1,6-6.2,8.9-9.1l-7-6.8C465.2,256.3,462.3,259.4,459.2,262.5"
              />
              <path
                class="st27"
                d="M469.2,252.3l7,6.8c3.1-3.2,6.1-6.3,8.9-9.2l-7-6.8C475.3,246,472.3,249.1,469.2,252.3"
              />
              <path
                class="st22"
                d="M439.1,303l9.5,9.2c2.9-3,5.9-6,8.9-9.1l-9.5-9.2C445,297,442,300,439.1,303"
              />
              <path
                class="st22"
                d="M371.7,358.9c0.1,4,0.1,8.6,0.2,13.2c3-0.1,6.1-0.4,9.1-1.1l-2.7-13C376.1,358.6,373.9,358.9,371.7,358.9"
              />
              <path
                class="st22"
                d="M343.4,344.8l-9.3,9.5c2.8,2.7,4.7,4.6,5.5,5.3l7.2-11.4C346,347.2,344.8,346.1,343.4,344.8"
              />
              <path
                class="st22"
                d="M379.8,357.7c0.8,3.9,1.8,8.4,2.7,13c3-0.8,6-1.9,8.8-3.3c-1.8-4.3-3.6-8.5-5.1-12.2
            C384.1,356.3,382,357.1,379.8,357.7"
              />
              <path
                class="st22"
                d="M354.8,354.6c-1.5,3.7-3.1,8-4.8,12.5c2.8,1.5,5.6,2.6,8.6,3.4l2.4-13.1C358.9,356.6,356.8,355.7,354.8,354.6
            "
              />
              <path
                class="st0"
                d="M280.8,266.8l-9.2,9.5c3,2.9,6,5.8,9,8.8l9.2-9.5C286.8,272.6,283.8,269.7,280.8,266.8"
              />
              <path
                class="st0"
                d="M269.7,256.9l-7,7.1c2.9,6.2,6,8.8,9,10.8l7.2-7.9C256.6,262.7,273.6,259.7,270.7,266.9"
              />
              <path
                class="st28"
                d="M271.6,275.2l-10-9.7l9-9.6l10,9.7L271.6,275.2z M263.4,265.5l8.1,7.9l7.3-7.7l-8.1-7.9L263.4,265.5z"
              />
              <path
                class="st0"
                d="M260.5,247l-8.2,8.7c2.9,2.8,5.9,5.7,9,8.8l8.2-8.7C266.4,252.7,263.4,249.8,260.5,247"
              />
              <path
                class="st22"
                d="M387.5,354.4l5.2,12.3c2.6-1.4,5.2-3.2,7.5-5.2l-7.4-11.1C391.1,351.9,389.4,353.2,387.5,354.4"
              />
              <path
                class="st22"
                d="M349.7,350.8c0,0-0.4-0.4-0.7-0.6c0,0-0.4-0.4-1.1-1l-7.2,11.4h0.1c2.4,2.2,5,4,7.7,5.6l4.9-12.5
            C352.2,352.9,350.9,351.9,349.7,350.8"
              />
              <path
                class="st22"
                d="M362.5,357.8l-2.4,13.1c3.3,0.8,6.7,1.3,10.2,1.3l-0.2-13.2C367.5,358.9,365,358.5,362.5,357.8"
              />
              <path
                class="st22"
                d="M405.9,350.7c0,0-36.2,37-69.4-0.4l8.9-9c0,0,26.5,17,49.6-0.9L405.9,350.7z"
              />
              <path
                class="st29"
                d="M558.4,261.7l15.7-25.3l5.3-27.4l0.1-32l-6.2-30l-19.1-23.8L451.7,30.5l-4-1.3c0,0,102.9,95.2,103.2,95.5
            c0.2,0.3,15.9,24.5,16.6,25.5c0.3,1.1,8.4,27.3,8.6,28.2c0,0.9,0.4,29.2,0.4,30.2c-0.3,1-8.1,24.5-8.3,25.2
            c-0.4,0.6-14.6,23.5-14.9,24.1C552.8,258.4,435.1,379,435.1,379c-35.9,40.2-89.6,34.5-124.9,2.9l-2.1-1.9
            c0,0-120.1-116.5-123-119.3c-0.2-0.3-17-21.9-17.7-22.8c-0.3-1.1-6.8-24-7.1-24.9c0-0.9,0.4-28.8,0.4-29.8c0.3-0.9,7.7-25.7,8-26.7
            c0.6-0.8,15.7-21.1,15.9-21.5c0.3-0.3,9.9-11.1,9.9-11.1l-4.9-4.6l-8.7,11.5L167,155.1l-8.8,27.8l-3,30.7l5.7,27.4l19.4,23.9
            l123.3,119.6c0.1,0.1,2.2,2,2.2,2c37.8,33.8,96.6,32.4,133.8-3.1L558.4,261.7z"
              />
              <polygon
                class="st3"
                points="427.8,67.9 429,69 460.2,37.4 458.8,36 	"
              />
              <polygon
                class="st3"
                points="490.2,128.3 523.1,95.5 521.2,93.6 489,127.2 	"
              />
              <polygon
                class="st3"
                points="469.8,108.6 503.4,74.3 502.2,73 468.7,107.5 	"
              />
              <polygon
                class="st3"
                points="449.4,88.8 482.6,55.1 481.4,53.6 448.3,87.7 	"
              />
              <polygon
                class="st3"
                points="510.5,148.1 544,113.8 543.1,112.6 509.4,147 	"
              />
              <polygon
                class="st3"
                points="511.7,200 577.5,225.3 578.1,223.6 512.3,198.6 	"
              />
              <polygon
                class="st3"
                points="522,192.9 581.3,192 581.1,190.4 522,191.3 	"
              />
              <polygon
                class="st3"
                points="524.8,178.3 574.9,157.4 574.3,156 524.2,176.9 	"
              />
              <polygon
                class="st3"
                points="505.5,209.8 566.4,248.2 567.2,246.8 506.3,208.5 	"
              />
              <polygon
                class="st3"
                points="452.7,394.7 388.5,332.4 387.4,333.5 451.6,395.8 	"
              />
              <polygon
                class="st3"
                points="476.9,241.9 541.1,304.2 542.2,303.1 478,240.7 	"
              />
              <polygon
                class="st3"
                points="492.8,221.1 546.5,273 547.6,271.9 493.9,219.9 	"
              />
              <path
                class="st3"
                d="M435.3,410.9L385.8,337l-1.3,0.9l49.6,73.9C434.5,411.6,434.9,411.3,435.3,410.9"
              />
              <path
                class="st3"
                d="M354.1,339.6l-1.3-0.8l-45.7,72.4c0.4,0.3,0.8,0.6,1.3,1L354.1,339.6z"
              />
              <polygon
                class="st3"
                points="266.7,238.4 199.2,307.6 200.3,308.7 267.9,239.5 	"
              />
              <polygon
                class="st3"
                points="239.9,195.5 143.8,196.8 143.7,198.4 239.9,197.1 	"
              />
              <polygon
                class="st3"
                points="230.7,194.1 160.8,167.1 160.3,168.6 230.1,195.6 	"
              />
              <polygon
                class="st3"
                points="226.9,176 173.5,142.5 173,143.9 226.1,177.4 	"
              />
              <polygon
                class="st3"
                points="229.8,198.2 158,228.1 158.2,229.7 230.4,199.6 	"
              />
              <polygon
                class="st3"
                points="227.2,213.7 170,251.8 171,253.1 228.1,215 	"
              />
              <polygon
                class="st3"
                points="349.5,318.7 348.4,317.6 280.8,386.8 282,387.9 	"
              />

              <rect
                x="256.4"
                y="341.9"
                transform="matrix(0.6989 -0.7152 0.7152 0.6989 -153.3411 321.1412)"
                class="st3"
                width="96.7"
                height="1.6"
              />
              <polygon
                class="st3"
                points="328.9,298.7 327.8,297.6 260.2,366.8 261.4,367.9 	"
              />
              <polygon
                class="st3"
                points="318.7,288.9 317.6,287.8 250.1,357 251.2,358.1 	"
              />
              <polygon
                class="st3"
                points="308.5,279 307.4,277.9 239.8,347.1 241,348.1 	"
              />
              <polygon
                class="st3"
                points="298.4,269.1 297.2,268 229.7,337.2 230.8,338.3 	"
              />
              <polygon
                class="st3"
                points="288.2,259.2 287.1,258.1 219.5,327.3 220.6,328.4 	"
              />
              <polygon
                class="st3"
                points="276.9,248.3 209.3,317.4 210.5,318.5 278,249.4 	"
              />
              <polygon
                class="st3"
                points="359.4,328.4 358.3,327.3 290.7,396.5 291.9,397.6 	"
              />
              <polygon
                class="st3"
                points="286,94.4 254.7,63.5 253.4,64.5 284.9,95.5 	"
              />
              <polygon
                class="st3"
                points="266.3,114.5 233.5,82.3 232.2,83.3 265.2,115.6 	"
              />
              <polygon
                class="st3"
                points="246.7,134.6 213.6,102.6 212.7,103.9 245.6,135.7 	"
              />
              <polygon
                class="st3"
                points="305.6,74.3 275,44.5 273.5,45.2 304.5,75.4 	"
              />
              <path
                class="st3"
                d="M372.7,407.3c0,0-0.4-0.2-0.4-1.3c-0.1-9.9-0.8-60.3-0.8-60.3h-1.6l0.8,60.3v0.5"
              />
              <path
                class="st3"
                d="M389.5,404.6c0,0-0.1-0.7-0.4-1.8c-2.1-10-12.2-56.8-12.2-56.8l-1.5,0.3l12.2,56.8l0.4,2.1"
              />
              <path
                class="st3"
                d="M404.4,405.2c0.8-0.4,3.9-1.6,3.9-1.6l-2.3-5.5l-24.2-57.3l-2,0.7c0,0,18,41.3,24.9,57.7
            c1.6,3.8,1.2,4.4,1.3,4.6c-0.8,0.4-0.7,0.4-0.7,0.4"
              />
              <polyline
                class="st3"
                points="354.1,404.6 364.7,347.4 362.9,347.1 352.5,404.4 	"
              />
              <path
                class="st3"
                d="M336,403.4c0.1-0.2,0.2-0.9,1.3-3.8c5.6-14.5,22.5-56.2,22.5-56.2l-2-0.7l-22,56.5l-1.8,4.5"
              />
              <polygon
                class="st30"
                points="194.6,161.7 181.6,153.7 186.4,146.2 199.3,154.2 	"
              />
              <polygon
                class="st3"
                points="186.6,181.8 172,177.2 174.7,168.8 189.2,173.3 	"
              />
              <polygon
                class="st30"
                points="186.6,181.8 172,177.2 174.7,168.8 189.2,173.3 	"
              />

              <rect
                x="169.8"
                y="192.4"
                transform="matrix(0.9977 -6.843094e-02 6.843094e-02 0.9977 -13.0554 12.6016)"
                class="st3"
                width="15.2"
                height="8.9"
              />

              <rect
                x="169.8"
                y="192.4"
                transform="matrix(0.9977 -6.843094e-02 6.843094e-02 0.9977 -13.0554 12.6016)"
                class="st31"
                width="15.2"
                height="8.9"
              />
              <polygon
                class="st3"
                points="191.2,219.9 177.1,225.4 173.8,217.2 188,211.6 	"
              />
              <polygon
                class="st30"
                points="191.2,219.9 177.1,225.4 173.8,217.2 188,211.6 	"
              />
              <polygon
                class="st3"
                points="545.8,163.8 559.8,157.7 563.3,165.8 549.4,171.9 	"
              />
              <polygon
                class="st30"
                points="545.8,163.8 559.8,157.7 563.3,165.8 549.4,171.9 	"
              />

              <rect
                x="551.9"
                y="187"
                transform="matrix(0.9997 -2.442161e-02 2.442161e-02 0.9997 -4.5086 13.721)"
                class="st3"
                width="15.2"
                height="8.9"
              />

              <rect
                x="551.9"
                y="187"
                transform="matrix(0.9997 -2.442161e-02 2.442161e-02 0.9997 -4.5086 13.721)"
                class="st32"
                width="15.2"
                height="8.9"
              />
              <polygon
                class="st3"
                points="549.3,208.9 563.8,213.9 560.9,222.3 546.5,217.3 	"
              />
              <polygon
                class="st30"
                points="549.3,208.9 563.8,213.9 560.9,222.3 546.5,217.3 	"
              />
              <path
                class="st3"
                d="M362.2,350.8l-1.1,6.4h1.6l-0.1,0.7c1.4,0.4,2.8,0.7,4.2,0.9l-0.2,13.3v3.8c1.3,0.1,2.5,0.2,3.8,0.2h1.6
            c1.2,0,2.4,0.2,3.6,0l-0.1-4.1l-0.5-13.2c1.1-0.1,2.2-0.3,3.3-0.6l-0.2-1.2h1.6l-1.3-6.2C373,352,367.5,352,362.2,350.8"
              />
              <path
                class="st33"
                d="M370,347.7h1.6c0-2.2,0-3.5,0-3.5H370V347.7z"
              />
              <path
                class="st27"
                d="M447.6,282.7l36.7-37.5c0,0,9.8-22.1,10.6-23.9l12.4-12.7c10.2-10.4,3.3-29.7,2.9-30.6l0,0l13-26.3L407.1,39
            l-96.4,0.8c0,0-8.9,22.8-9.7,24.8c-1.7,1.7-89.4,91.8-89.4,91.8l11.3,54.1c0,0,17.3,16.8,18.2,17.7c0.7,1.1,15,23.3,15,23.3
            s31.7,30.8,35.3,34.3c-0.2,2.5-0.2,2.5-0.8,11.5l39.8,38.7l10.2,9.4c0,0,2.6-2.7,4.2-4.1c13.9,13.5,38.5,12.6,52-1.2
            c1.3,1.1,4.2,3.7,4.2,3.7l9.4-8.8l1.8-1.8l37-37.9C449.2,295.1,448,286.2,447.6,282.7"
              />
              <path
                class="st27"
                d="M370.2,354.3c-9.9,0-19.2-3.8-26.2-10.6c-1.5-1.5-3-3.2-4.4-5.3l-10.1,0.1l-41.4-40.2l0.8-11.4
            c-6.2-6-34.5-33.5-34.5-33.5l-0.2-0.2L254,253c0,0-13.1-20.4-14.8-23.1c-2.2-2.1-18-17.5-18-17.5l-0.6-0.5l-11.8-56.2l0.9-1
            c0,0,82.7-84.9,89-91.4c1.5-3.9,9.5-24.3,9.5-24.3l0.6-1.6l99.1-0.8L526,151.4l-13.3,27c1.5,4.6,6.1,22-3.9,32.2L496.7,223
            l-10.3,23.6l-31.3,32c-2.4,2.4-3.9,4-4.9,4.9l1.7,12.4l-40.4,41.4l-10,0.1c-1.4,2.1-2.8,3.9-4.3,5.4c-7,7.2-16.4,11.2-26.5,11.3
            C370.6,354.3,370.4,354.3,370.2,354.3 M342.3,333.2l0.8,1.2c1.5,2.3,2.9,4.1,4.5,5.6c6.2,6,14.4,9.2,23.1,9.2
            c8.7-0.1,16.8-3.6,22.9-9.8c1.5-1.6,2.9-3.4,4.3-5.7l0.7-1.2l10.7-0.2l1-1l36.2-37l-1.9-14h1.8c4.9-5,32.3-33.1,35.6-36.4
            l10.6-23.9l12.7-13c9.1-9.3,2.4-27.7,2.4-27.9l-0.4-1l0.5-1l12.2-24.6L406,41.8l-93.6,0.7c-2,5.2-8.4,21.5-9.1,23.2l-0.2,0.5
            l-0.4,0.4c-1.6,1.6-79,81.1-88.4,90.8l10.9,52c3,2.9,16.8,16.3,17.7,17.1l0.2,0.2l0.2,0.2c0.7,1,13.3,20.7,14.8,23.1
            c2.8,2.7,31.7,30.7,35.1,34.1l0.9,0.8l-0.8,11.4l38.2,37.1L342.3,333.2z"
              />
              <path
                class="st34"
                d="M431,257.1c0,0-11.8-45.9-62.7-45.2c-50.8,0.7-60.5,47.8-60.5,47.8l53.9,52.3c-2,3.7-1.5,8.4,1.7,11.5
            c3.8,3.7,9.9,3.6,13.7-0.2c3.3-3.3,3.6-8.5,1-12.2L431,257.1z M375,308.3c-3.2-1.8-7.3-1.7-10.3,0.5l-30.9-30l0,0
            c2.5-2.5,2.4-6.6-0.1-9.1l30.5-31.2c2.6,2.5,6.6,2.4,9.1-0.1l0,0l31.3,30.4l0,0c-2.5,2.5-2.4,6.6,0.1,9.1L375,308.3z"
              />
              <polygon
                class="st18"
                points="449.2,295.1 410.4,334.8 416,340.3 454.8,300.5 	"
              />
              <polygon
                class="st18"
                points="290.7,297.2 285.2,302.8 325.1,341.5 330.5,335.9 	"
              />
              <path
                class="st34"
                d="M374.3,281.6c-2.5,2.5-6.6,2.6-9.1,0.1s-2.6-6.5-0.1-9.1c2.5-2.5,6.6-2.6,9.1-0.1S376.8,279.1,374.3,281.6"
              />
              <polygon
                class="st29"
                points="330.2,273.3 327.8,275.7 325.4,273.3 327.8,270.9 	"
              />
              <polygon
                class="st29"
                points="371,231.5 368.6,233.9 366.2,231.6 368.5,229.2 	"
              />
              <polygon
                class="st29"
                points="413.4,272.7 411,275.1 408.6,272.7 410.9,270.3 	"
              />
              <polygon
                class="st29"
                points="372.2,276.4 367.2,276.4 367.2,275.3 372.2,275.3 	"
              />
              <polygon
                class="st29"
                points="371.9,315.1 370.2,316.8 368.5,315.1 368.5,313.1 371.9,313.1 	"
              />
              <path
                class="st34"
                d="M240.9,198.4c1.5,1.5,1.5,3.9,0.1,5.3l-7.6,7.8c-1.5,1.5-3.9,1.5-5.4,0.1l-1.1-1.1c-1.5-1.4-1.5-3.9-0.1-5.3
            l7.6-7.8c1.5-1.5,3.9-1.5,5.4-0.1L240.9,198.4z"
              />
              <polygon
                class="st29"
                points="232.7,204.6 229.2,208.2 228.4,207.4 231.9,203.8 	"
              />
              <polygon
                class="st29"
                points="259.9,232.1 259.9,234.5 257.5,234.6 256.1,233.2 258.5,230.8 	"
              />

              <rect
                x="232.7"
                y="200.6"
                transform="matrix(0.6983 -0.7158 0.7158 0.6983 -73.0216 229.0372)"
                class="st29"
                width="5"
                height="1.1"
              />
              <polygon
                class="st29"
                points="264.6,227.3 264.7,229.7 262.3,229.7 260.8,228.3 263.2,225.9 	"
              />
              <path
                class="st34"
                d="M502.8,210.6c-1.5,1.5-3.9,1.5-5.4,0.1l-7.8-7.6c-1.5-1.5-1.5-3.9-0.1-5.3l1.1-1.1c1.5-1.5,3.9-1.5,5.4-0.1
            l7.8,7.6c1.5,1.4,1.5,3.9,0.1,5.3L502.8,210.6z"
              />

              <rect
                x="494.7"
                y="197.8"
                transform="matrix(0.6967 -0.7174 0.7174 0.6967 6.5335 416.0498)"
                class="st29"
                width="1.1"
                height="5"
              />
              <polygon
                class="st29"
                points="469,229.6 466.6,229.6 466.5,227.2 467.9,225.8 470.4,228.2 	"
              />

              <rect
                x="499.5"
                y="202.5"
                transform="matrix(0.6968 -0.7173 0.7173 0.6968 4.5872 420.8458)"
                class="st29"
                width="1.1"
                height="5"
              />
              <polygon
                class="st29"
                points="473.8,234.3 471.4,234.3 471.4,231.9 472.8,230.5 475.2,232.9 	"
              />
              <polygon
                class="st29"
                points="370.2,317.1 370,317 208.9,160.9 209.3,160.6 370.2,316.4 515.7,166.9 516,167.3 	"
              />
              <path
                class="st29"
                d="M224.3,170.8c0.2-0.1,0.5-0.2,0.7-0.4c0.4-0.4,0.4-0.9,0-1.3c-0.5-0.5-1-0.4-1.4,0.1l-0.1,0.1l-0.5-0.5
            l0.1-0.1c0.3-0.3,0.5-0.8,0.1-1.3c-0.3-0.3-0.7-0.3-1,0c-0.2,0.2-0.3,0.4-0.3,0.6l-0.6-0.4c0-0.3,0.2-0.7,0.5-1
            c0.6-0.6,1.4-0.6,1.9-0.1c0.4,0.4,0.5,0.9,0.3,1.4l0,0c0.5-0.3,1.1-0.2,1.7,0.3c0.6,0.6,0.7,1.6,0,2.4c-0.3,0.3-0.6,0.5-0.9,0.6
            L224.3,170.8z"
              />
              <polygon
                class="st29"
                points="224.9,164.9 224.9,165 224.6,166 224,165.6 224.3,164.3 224.9,163.7 228.8,167.5 228.2,168.1 	"
              />
              <path
                class="st29"
                d="M228.2,161.4l-1,1l0.7,1l0.1-0.1c0.2-0.2,0.6-0.4,1-0.5c0.4,0,0.8,0.2,1.2,0.5c0.8,0.8,0.9,1.8,0.1,2.6
            c-0.3,0.3-0.6,0.5-0.9,0.5l-0.4-0.6c0.2-0.1,0.5-0.2,0.7-0.4c0.4-0.4,0.4-0.9-0.1-1.4c-0.6-0.6-1.2-0.4-1.6,0.1
            c-0.1,0.1-0.2,0.2-0.3,0.3l-1.7-2.1l1.5-1.5L228.2,161.4z"
              />
              <path
                class="st29"
                d="M228.8,159.3c0.4,0.7,0.7,1.5,0.9,2l-0.3,0.4c-0.3-0.6-0.7-1.3-1.1-1.8L228.8,159.3z"
              />
              <path
                class="st29"
                d="M258.3,127.2c0.2-0.1,0.5-0.2,0.7-0.4c0.4-0.4,0.4-0.9,0-1.3c-0.5-0.5-1-0.4-1.4,0.1l-0.1,0.1l-0.5-0.5
            l0.1-0.1c0.3-0.3,0.5-0.8,0.1-1.3c-0.3-0.3-0.7-0.3-1,0c-0.2,0.2-0.3,0.4-0.3,0.6l-0.6-0.4c0-0.3,0.2-0.7,0.5-1
            c0.6-0.6,1.4-0.6,1.9-0.1c0.4,0.4,0.5,0.9,0.3,1.4l0,0c0.5-0.3,1.1-0.2,1.7,0.3c0.6,0.6,0.7,1.6,0,2.4c-0.3,0.3-0.6,0.5-0.9,0.6
            L258.3,127.2z"
              />
              <polygon
                class="st29"
                points="259.3,119.5 259.7,119.9 262,124.6 261.4,125.2 259.3,120.7 259.3,120.7 257.9,122.1 257.4,121.5
            "
              />
              <path
                class="st29"
                d="M264.7,122c-0.7,0.7-1.9,0.2-3-0.9c-1.2-1.2-1.7-2.3-0.9-3.1c0.8-0.8,1.9-0.2,3,0.9
            C265.2,120.3,265.3,121.4,264.7,122L264.7,122z M264.2,121.4c0.3-0.3-0.1-0.9-1.1-1.8c-0.9-0.9-1.6-1.3-1.9-1s0.1,1,1,1.9
            C263.2,121.3,263.9,121.7,264.2,121.4L264.2,121.4z"
              />
              <path
                class="st29"
                d="M262.7,115.6c0.4,0.7,0.7,1.5,0.9,2l-0.3,0.4c-0.3-0.6-0.7-1.3-1.1-1.8L262.7,115.6z"
              />
              <path
                class="st29"
                d="M463.7,112.2c0.1,0.2,0.2,0.5,0.4,0.7c0.4,0.4,0.9,0.4,1.3,0c0.5-0.5,0.4-1-0.1-1.4l-0.1-0.1l0.5-0.5l0.1,0.1
            c0.3,0.3,0.8,0.5,1.3,0.1c0.3-0.3,0.3-0.7,0-1c-0.2-0.2-0.4-0.3-0.7-0.3l0.4-0.6c0.3,0,0.7,0.2,1,0.5c0.6,0.6,0.6,1.4,0.1,1.9
            c-0.4,0.4-0.9,0.5-1.5,0.3l0,0c0.3,0.5,0.2,1.1-0.3,1.7c-0.6,0.6-1.6,0.7-2.4,0c-0.3-0.3-0.5-0.6-0.6-0.9L463.7,112.2z"
              />
              <polygon
                class="st29"
                points="471.3,113.3 470.9,113.7 466.3,116 465.6,115.3 470.1,113.2 470.1,113.2 468.8,111.9 469.3,111.3
            "
              />
              <path
                class="st29"
                d="M468.9,118.6c-0.7-0.7-0.2-1.9,0.9-3c1.2-1.2,2.3-1.7,3.1-0.9c0.8,0.8,0.2,1.9-0.9,3
            C470.6,119.1,469.5,119.2,468.9,118.6L468.9,118.6z M469.5,118.1c0.3,0.3,0.9-0.1,1.8-1.1c0.9-0.9,1.3-1.6,1-1.9s-1,0.1-1.9,1
            C469.5,117.1,469.1,117.8,469.5,118.1L469.5,118.1z"
              />
              <path
                class="st29"
                d="M475.2,116.6c-0.7,0.4-1.5,0.7-2,0.9l-0.4-0.3c0.6-0.3,1.3-0.7,1.8-1.1L475.2,116.6z"
              />
              <path
                class="st29"
                d="M494.1,159.2c0.1,0.2,0.2,0.5,0.4,0.7c0.4,0.4,0.9,0.4,1.3,0c0.5-0.5,0.4-1-0.1-1.4l-0.1-0.1l0.5-0.5l0.1,0.1
            c0.3,0.3,0.8,0.5,1.3,0.1c0.3-0.3,0.3-0.7,0-1c-0.2-0.2-0.4-0.3-0.7-0.3l0.4-0.6c0.3,0,0.7,0.2,1,0.5c0.6,0.6,0.6,1.4,0.1,1.9
            c-0.4,0.4-0.9,0.5-1.4,0.3l0,0c0.3,0.5,0.2,1.1-0.3,1.7c-0.6,0.6-1.6,0.7-2.4,0c-0.3-0.3-0.5-0.6-0.5-0.9L494.1,159.2z"
              />
              <path
                class="st29"
                d="M495.9,162.2l0.4-0.4l0.8-0.1c1.1-0.2,2.2-0.3,2.8-1c0.4-0.4,0.4-0.8,0.1-1.1s-0.6-0.3-0.8-0.4l0.4-0.6
            c0.3,0,0.7,0.2,1.1,0.5c0.8,0.7,0.5,1.5,0,2.1c-0.7,0.7-1.8,0.9-2.8,1.1l-0.6,0.1l0,0l1.2,1.2l-0.6,0.6L495.9,162.2z"
              />
              <path
                class="st29"
                d="M498.4,164.6l0.4-0.4l0.8-0.1c1.1-0.2,2.2-0.3,2.8-1c0.4-0.4,0.4-0.8,0.1-1.1s-0.6-0.3-0.8-0.4l0.4-0.6
            c0.3,0,0.7,0.2,1.1,0.5c0.8,0.7,0.5,1.5,0,2.1c-0.7,0.7-1.8,0.9-2.8,1.1l-0.6,0.1l0,0l1.2,1.2l-0.5,0.6L498.4,164.6z"
              />
              <path
                class="st29"
                d="M505.7,163.7c-0.7,0.4-1.5,0.7-2,0.9l-0.4-0.3c0.6-0.3,1.3-0.7,1.8-1.1L505.7,163.7z"
              />
              <path
                class="st29"
                d="M360.1,52.5v-1.4h-1.9v-0.6l1.7-3.5h0.9v3.3h0.6V51h-0.6v1.4L360.1,52.5z M360,50.4v-1.3c0-0.3,0-0.7,0-1l0,0
            c-0.1,0.4-0.3,0.6-0.4,0.9l-0.6,1.3l0,0L360,50.4z"
              />
              <path
                class="st29"
                d="M363.2,52.6c-1,0-1.5-1.2-1.5-2.8c0-1.7,0.5-2.8,1.5-2.8c1.1,0,1.5,1.3,1.5,2.8
            C364.7,51.7,364.1,52.6,363.2,52.6L363.2,52.6z M363.3,51.8c0.4,0,0.6-0.8,0.6-2s-0.2-2-0.6-2s-0.6,0.7-0.6,2
            C362.6,51.1,362.8,51.8,363.3,51.8L363.3,51.8z"
              />
              <path
                class="st29"
                d="M366.9,52.5v-1.4H365v-0.6l1.7-3.5h0.9v3.3h0.6V51h-0.6v1.4L366.9,52.5z M366.9,50.3V49c0-0.3,0-0.7,0-1l0,0
            c-0.1,0.4-0.3,0.6-0.4,0.9l-0.6,1.3l0,0L366.9,50.3z"
              />
              <path
                class="st29"
                d="M369.8,46.7c-0.2,0.7-0.5,1.5-0.8,2l-0.5,0.1c0.2-0.6,0.4-1.4,0.5-2L369.8,46.7z"
              />
              <path
                class="st35"
                d="M318.8,159.3C318.8,159.3,318.8,159.4,318.8,159.3C318.8,159.4,318.8,159.3,318.8,159.3"
              />
              <polygon
                class="st29"
                points="452.7,331.2 457,326.8 456.1,325.9 454.6,325.4 453.9,326.4 455,326.8 455.1,326.8 451.7,330.2 	"
              />
              <polygon
                class="st29"
                points="456.1,334.5 460.4,330.1 459.5,329.2 457.9,328.7 457.3,329.7 458.4,330 458.4,330 455.1,333.5 	"
              />
              <path
                class="st29"
                d="M461.6,336.9c0.8-0.8,0.9-1.8,0.3-2.4c-0.3-0.3-0.6-0.4-1-0.3l0,0c0.6-0.4,1.3-0.5,1.9-0.1
            c0.2,0.1,0.3,0.2,0.4,0.3l0.8-0.8c-0.1-0.1-0.3-0.2-0.5-0.4c-0.4-0.3-1-0.5-1.6-0.5c-0.8,0-1.8,0.3-2.8,1.3
            c-1.1,1.1-1.2,2.4-0.4,3.2C459.7,338,460.9,337.6,461.6,336.9 M459.9,335.2c0.2-0.2,0.4-0.4,0.5-0.4c0.2-0.1,0.4-0.1,0.5,0
            c0.3,0.2,0,0.7-0.3,0.9c-0.4,0.4-0.9,0.8-1.1,0.6l0,0C459.2,336.2,459.5,335.7,459.9,335.2"
              />
              <polygon
                class="st29"
                points="442.6,342 446.9,337.5 445.9,336.6 444.4,336.2 443.8,337.1 444.9,337.5 444.9,337.5 441.5,340.9
            "
              />
              <polygon
                class="st29"
                points="445.9,345.2 450.2,340.8 449.3,339.9 447.7,339.4 447.1,340.4 448.2,340.8 448.2,340.8 444.9,344.2
            "
              />
              <path
                class="st29"
                d="M448.6,347.8l0.9,0.9l1-1l0.4,0.4l0.8-0.8l-0.4-0.4l2.5-2.6l-1-1l-4.1,1.3l-0.7,0.7l1.5,1.5L448.6,347.8z
            M449.8,345.4l1.2-0.4c0.3-0.1,0.6-0.2,0.9-0.3l0,0c-0.2,0.2-0.5,0.4-0.7,0.6l-0.8,0.7L449.8,345.4L449.8,345.4z"
              />
              <polygon
                class="st29"
                points="433.4,352.2 437.7,347.8 436.8,346.9 435.2,346.4 434.6,347.4 435.7,347.7 435.7,347.7 432.4,351.2
            "
              />
              <polygon
                class="st29"
                points="436.8,355.4 441.1,351 440.1,350.1 438.6,349.6 438,350.6 439.1,351 439.1,351 435.7,354.4 	"
              />
              <path
                class="st29"
                d="M441.5,358.2l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L441.5,358.2z"
              />
              <polygon
                class="st29"
                points="309.2,366.8 309.3,366.8 312.7,370.2 313.7,369.1 309.3,364.8 308.4,365.8 307.9,367.3 308.9,367.9
            "
              />
              <path
                class="st29"
                d="M316.3,366.5L316.3,366.5c0.7-0.7,0.6-2-1-3.6c-0.9-0.9-2.4-2-3.5-0.8c-1,1-0.2,2.5,0.9,3.6
            C313.8,366.7,315.3,367.6,316.3,366.5 M312.7,363c0.2-0.2,0.7,0.2,1.6,1.1c1,1,1.3,1.4,1.1,1.6l0,0c-0.2,0.2-0.7,0-1.7-1
            C312.8,363.7,312.5,363.2,312.7,363"
              />
              <path
                class="st29"
                d="M317.7,361.9c0.3-0.3,0.3-0.5,0.3-0.8l0,0c0.2,0.4,0.4,0.8,0.4,1.1c0,0.3-0.1,0.5-0.2,0.7s-0.2,0.3-0.4,0.5
            l0.9,0.8c0.1-0.2,0.3-0.3,0.4-0.4c0.4-0.5,0.6-1.1,0.6-1.6c0-0.8-0.3-1.9-1.4-2.9c-1.1-1.1-2.3-1.3-3.1-0.5
            c-0.9,0.9-0.5,2.2,0.2,2.9C316.1,362.5,317.1,362.5,317.7,361.9 M315.8,359.5L315.8,359.5c0.2-0.2,0.6,0,1,0.4
            c0.4,0.3,0.5,0.5,0.5,0.6s0,0.3-0.1,0.4c-0.2,0.2-0.7,0-1-0.3C315.8,360.2,315.6,359.8,315.8,359.5"
              />
              <polygon
                class="st29"
                points="287.5,388.9 287.5,388.9 290.9,392.3 291.9,391.2 287.5,387 286.6,387.9 286.1,389.4 287.1,390.1
            "
              />
              <path
                class="st29"
                d="M294.6,388.7L294.6,388.7c0.7-0.7,0.6-2-1-3.6c-0.9-0.9-2.4-2-3.5-0.8c-1,1-0.2,2.5,0.9,3.6
            C292,388.8,293.5,389.7,294.6,388.7 M291,385.1c0.2-0.2,0.7,0.2,1.6,1c1,1,1.3,1.4,1.1,1.6l0,0c-0.2,0.2-0.7,0-1.7-1
            C291,385.8,290.7,385.3,291,385.1"
              />
              <path
                class="st29"
                d="M295.9,384c0.3-0.3,0.3-0.5,0.3-0.8l0,0c0.2,0.4,0.4,0.8,0.4,1.1c0,0.3-0.1,0.5-0.2,0.7s-0.2,0.3-0.4,0.5
            l0.9,0.8c0.1-0.1,0.3-0.3,0.4-0.5c0.4-0.5,0.6-1.1,0.6-1.6c0-0.8-0.3-1.9-1.4-2.9c-1.1-1.1-2.3-1.3-3.1-0.5
            c-0.9,0.9-0.5,2.2,0.2,2.9C294.4,384.6,295.3,384.6,295.9,384 M294,381.7L294,381.7c0.2-0.2,0.6,0,1,0.4c0.4,0.3,0.5,0.5,0.5,0.6
            s0,0.3-0.1,0.4c-0.2,0.2-0.7,0-1-0.4C294,382.3,293.8,381.9,294,381.7"
              />
              <polygon
                class="st29"
                points="300,400.8 300,400.8 303.4,404.2 304.4,403.1 300,398.8 299.1,399.8 298.6,401.3 299.6,401.9 	"
              />
              <path
                class="st29"
                d="M307,400.5L307,400.5c0.7-0.7,0.6-2-1-3.6c-0.9-0.9-2.4-2-3.5-0.8c-1,1-0.2,2.5,0.9,3.6
            C304.5,400.7,306,401.6,307,400.5 M303.4,397c0.2-0.2,0.7,0.2,1.6,1c1,1,1.3,1.4,1.1,1.6l0,0c-0.2,0.2-0.7,0-1.7-1
            C303.5,397.7,303.2,397.2,303.4,397"
              />
              <polygon
                class="st29"
                points="307,393.5 307,393.5 309.2,398.2 310.2,397.2 307.8,392.3 307.1,391.6 304.6,394.1 305.6,395 	"
              />
              <polygon
                class="st29"
                points="299.6,356.3 299.6,356.3 303,359.6 304,358.6 299.6,354.3 298.7,355.2 298.2,356.8 299.2,357.4 	"
              />
              <polygon
                class="st29"
                points="302.8,353 302.8,352.9 306.3,356.3 307.3,355.3 302.9,351 302,351.9 301.5,353.4 302.4,354.1 	"
              />
              <polygon
                class="st29"
                points="306.1,349.6 306.1,349.6 309.5,352.9 310.5,351.9 306.1,347.6 305.2,348.5 304.7,350.1 305.7,350.7
            "
              />
              <polygon
                class="st29"
                points="276.9,379.1 276.9,379.1 280.3,382.4 281.3,381.4 276.9,377.1 276,378 275.5,379.5 276.5,380.2 	"
              />
              <polygon
                class="st29"
                points="280.1,375.7 280.1,375.7 283.6,379.1 284.6,378 280.2,373.7 279.3,374.7 278.8,376.2 279.8,376.8
            "
              />
              <polygon
                class="st29"
                points="283.4,372.4 283.4,372.4 286.8,375.7 287.9,374.7 283.4,370.4 282.5,371.3 282,372.9 283,373.5 	"
              />
              <polygon
                class="st29"
                points="289.2,345.5 289.3,345.4 292.7,348.8 293.7,347.8 289.3,343.5 288.4,344.4 287.9,345.9 288.9,346.6
            "
              />
              <polygon
                class="st29"
                points="292.5,342.1 292.5,342.1 296,345.4 297,344.4 292.6,340.1 291.7,341.1 291.2,342.6 292.1,343.2 	"
              />
              <path
                class="st29"
                d="M295.4,338.8c0.3-0.3,0.6-0.3,0.9-0.1c0.4,0.4,0.1,0.8-0.2,1.2L296,340l0.8,0.7l0.1-0.1
            c0.4-0.4,0.9-0.6,1.4-0.2c0.3,0.3,0.3,0.7-0.1,1.2c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,0.9c0.3-0.1,0.7-0.3,1.1-0.7c1-1,0.8-2.2,0.2-2.9
            c-0.6-0.5-1.2-0.6-1.8-0.3l0,0c0.2-0.5,0.1-1.1-0.4-1.6c-0.6-0.5-1.5-0.6-2.3,0.2c-0.4,0.4-0.6,0.9-0.7,1.2l0.9,0.6
            C295.1,339.2,295.2,339,295.4,338.8"
              />
              <polygon
                class="st29"
                points="266.6,369 266.6,368.9 270.1,372.3 271.1,371.3 266.7,367 265.8,367.9 265.3,369.4 266.2,370.1 	"
              />
              <polygon
                class="st29"
                points="269.9,365.6 269.9,365.6 273.3,368.9 274.3,367.9 269.9,363.6 269,364.6 268.5,366.1 269.5,366.7
            "
              />
              <path
                class="st29"
                d="M272.8,362.3c0.3-0.3,0.6-0.3,0.9-0.1c0.4,0.4,0.1,0.8-0.2,1.2l-0.1,0.1l0.8,0.7l0.1-0.1
            c0.4-0.4,0.9-0.6,1.4-0.2c0.3,0.3,0.3,0.7-0.1,1.2c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,0.9c0.3-0.1,0.7-0.3,1.1-0.7c1-1,0.8-2.2,0.2-2.9
            c-0.6-0.5-1.2-0.6-1.8-0.3l0,0c0.2-0.5,0.1-1.1-0.4-1.6c-0.6-0.5-1.5-0.6-2.3,0.2c-0.4,0.4-0.6,0.9-0.7,1.2l0.9,0.6
            C272.5,362.7,272.6,362.5,272.8,362.3"
              />
              <polygon
                class="st29"
                points="278.8,336.2 278.8,336.2 282.3,339.6 283.3,338.5 278.9,334.3 278,335.2 277.5,336.7 278.4,337.4
            "
              />
              <polygon
                class="st29"
                points="282.1,332.9 282.1,332.9 285.5,336.2 286.5,335.2 282.1,330.9 281.2,331.8 280.7,333.4 281.7,334
            "
              />
              <path
                class="st29"
                d="M286.2,331.3c0.5-0.5,1.1-0.8,1.6-0.2c0.4,0.4,0.4,0.8,0,1.3c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,0.9
            c0.3-0.1,0.7-0.4,1-0.7c1-1,0.8-2.3,0-3.2c-0.4-0.4-0.9-0.6-1.4-0.6s-1,0.3-1.1,0.5l-0.1,0.1l-0.6-0.7l1.1-1.2l-0.9-0.9l-1.9,1.9
            l2.1,2.4C286,331.5,286.1,331.4,286.2,331.3"
              />
              <polygon
                class="st29"
                points="256.6,358.8 256.6,358.8 260,362.1 261,361.1 256.6,356.8 255.7,357.7 255.2,359.3 256.2,359.9 	"
              />
              <polygon
                class="st29"
                points="259.8,355.5 259.8,355.5 263.3,358.8 264.3,357.8 259.9,353.5 259,354.4 258.5,355.9 259.5,356.6
            "
              />
              <path
                class="st29"
                d="M264,353.8c0.5-0.5,1.1-0.8,1.6-0.2c0.4,0.4,0.4,0.9,0,1.3c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,1
            c0.3-0.1,0.7-0.4,1-0.7c1-1,0.8-2.3,0-3.2c-0.4-0.4-0.9-0.6-1.4-0.6s-1,0.3-1.1,0.5l-0.1,0.1l-0.6-0.7l1.1-1.2l-0.9-0.9l-1.9,1.9
            l2.1,2.5C263.7,354.1,263.8,354,264,353.8"
              />
              <polygon
                class="st29"
                points="269.6,325.2 269.6,325.2 273,328.5 274,327.5 269.6,323.2 268.7,324.1 268.2,325.7 269.2,326.3 	"
              />
              <polygon
                class="st29"
                points="272.8,321.8 272.8,321.8 276.3,325.2 277.3,324.1 272.9,319.9 272,320.8 271.5,322.3 272.5,323 	"
              />
              <polygon
                class="st29"
                points="276.7,315.9 277.4,316.6 279.8,321.6 278.8,322.6 276.6,317.9 276.6,317.9 275.2,319.4 274.2,318.5
            "
              />
              <polygon
                class="st29"
                points="246.7,349.4 246.7,349.4 250.2,352.7 251.2,351.7 246.8,347.4 245.9,348.3 245.4,349.9 246.4,350.5
            "
              />
              <polygon
                class="st29"
                points="250,346.1 250,346 253.4,349.4 254.5,348.4 250,344.1 249.1,345 248.6,346.5 249.6,347.2 	"
              />
              <polygon
                class="st29"
                points="253.7,342.1 253.8,342.1 255.9,346.8 256.9,345.8 254.6,340.8 253.9,340.2 251.4,342.7 252.3,343.6
            "
              />
              <polygon
                class="st29"
                points="259.3,315.5 259.3,315.5 258.9,316.6 258,316 258.5,314.4 259.4,313.5 263.8,317.8 262.8,318.8 	"
              />
              <polygon
                class="st29"
                points="262.6,312.1 262.6,312.1 262.2,313.3 261.2,312.6 261.7,311.1 262.6,310.2 267,314.4 266,315.5 	"
              />
              <path
                class="st29"
                d="M267.8,312c0.2-0.2,0.3-0.3,0.4-0.5s0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0c0,0.3-0.1,0.5-0.3,0.8
            c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.8,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9c0,0.5-0.2,1.1-0.6,1.6
            c-0.1,0.2-0.3,0.3-0.4,0.4L267.8,312z M265.9,308.2c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3c0.1-0.1,0.1-0.3,0.1-0.4
            c-0.1-0.1-0.2-0.2-0.5-0.6C266.5,308.2,266,308,265.9,308.2L265.9,308.2z"
              />
              <polygon
                class="st29"
                points="236.3,339.6 236.3,339.6 239.8,343 240.8,341.9 236.4,337.6 235.5,338.6 235,340.1 236,340.7 	"
              />
              <polygon
                class="st29"
                points="239.6,336.3 239.6,336.3 243,339.6 244,338.6 239.6,334.3 238.7,335.2 238.2,336.8 239.2,337.4 	"
              />
              <path
                class="st29"
                d="M244.8,334.7c0.3-0.3,0.3-0.5,0.3-0.8l0,0c0.2,0.4,0.4,0.8,0.4,1.1c0,0.3-0.1,0.5-0.2,0.7
            c-0.1,0.2-0.2,0.3-0.4,0.5l0.9,0.8c0.1-0.2,0.3-0.3,0.4-0.4c0.4-0.5,0.6-1.1,0.6-1.6c0-0.8-0.3-1.9-1.4-2.9
            c-1.1-1.1-2.3-1.3-3.1-0.5c-0.9,0.9-0.5,2.2,0.2,2.9C243.2,335.3,244.2,335.3,244.8,334.7 M242.9,332.4L242.9,332.4
            c0.2-0.2,0.6,0,1,0.4c0.4,0.3,0.5,0.5,0.5,0.6s0,0.3-0.1,0.4c-0.2,0.2-0.7,0-1-0.3C242.9,333,242.7,332.6,242.9,332.4"
              />
              <polygon
                class="st29"
                points="249.8,304.7 249.7,304.7 249.4,305.8 248.4,305.2 248.9,303.7 249.8,302.7 254.2,307 253.2,308 	"
              />
              <path
                class="st29"
                d="M255.4,305.7l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L255.4,305.7z"
              />
              <polygon
                class="st29"
                points="256.3,298 256.3,298 255.9,299.1 254.9,298.5 255.4,297 256.3,296 260.7,300.3 259.7,301.4 	"
              />
              <polygon
                class="st29"
                points="226.4,330 226.4,330 229.9,333.3 230.9,332.3 226.5,328 225.6,328.9 225.1,330.5 226,331.1 	"
              />
              <path
                class="st29"
                d="M229.4,326.6c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0v-0.5
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.7,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C229,327.2,229.2,326.9,229.4,326.6"
              />
              <polygon
                class="st29"
                points="232.9,323.3 233,323.3 236.4,326.6 237.4,325.6 233,321.3 232.1,322.2 231.6,323.8 232.6,324.4 	"
              />
              <polygon
                class="st29"
                points="239.9,295.1 239.9,295.1 239.5,296.2 238.6,295.6 239.1,294.1 240,293.1 244.4,297.4 243.4,298.4
            "
              />
              <path
                class="st29"
                d="M245.6,296.1l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L245.6,296.1z"
              />
              <path
                class="st29"
                d="M248.1,291.7c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L248.1,291.7z"
              />
              <polygon
                class="st29"
                points="216.1,319.8 216.1,319.8 215.7,320.9 214.7,320.3 215.2,318.8 216.1,317.8 220.5,322.1 219.5,323.1
            "
              />
              <path
                class="st29"
                d="M221.8,320.8l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L221.8,320.8z"
              />
              <path
                class="st29"
                d="M224.2,316.4c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L224.2,316.4z"
              />
              <polygon
                class="st29"
                points="230.3,284.3 230.3,284.3 229.9,285.4 228.9,284.8 229.5,283.3 230.4,282.3 234.8,286.6 233.8,287.6
            "
              />
              <path
                class="st29"
                d="M236,285.3l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L236,285.3z"
              />
              <path
                class="st29"
                d="M238.1,276.2l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.9,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.7,0.6-1,0.7l-0.7-0.9c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.5-0.5-1.1-0.2-1.6,0.2
            c-0.1,0.1-0.2,0.2-0.3,0.3l-2.1-2.5l1.9-1.9L238.1,276.2z"
              />
              <polygon
                class="st29"
                points="205.9,309.9 205.8,309.9 205.5,311 204.5,310.4 205,308.8 205.9,307.9 210.3,312.2 209.3,313.2 	"
              />
              <path
                class="st29"
                d="M211.5,310.9l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L211.5,310.9z"
              />
              <path
                class="st29"
                d="M213.7,301.7l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.8,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.8,0.6-1,0.7l-0.7-0.9c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.6-0.5-1.1-0.2-1.6,0.3
            c-0.1,0.1-0.2,0.2-0.3,0.3l-2.1-2.4l1.9-1.9L213.7,301.7z"
              />
              <polygon
                class="st29"
                points="216.1,269.6 216.1,269.6 215.8,270.7 214.8,270.1 215.3,268.5 216.2,267.6 220.6,271.9 219.6,272.9
            "
              />
              <path
                class="st29"
                d="M221.8,270.6l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L221.8,270.6z"
              />
              <polygon
                class="st29"
                points="223.3,260.3 224,261 226.3,266 225.4,267 223.2,262.3 223.2,262.3 221.7,263.8 220.8,262.9 	"
              />
              <polygon
                class="st29"
                points="190,295.7 190,295.7 189.6,296.8 188.6,296.2 189.1,294.7 190,293.7 194.4,298 193.4,299.1 	"
              />
              <path
                class="st29"
                d="M195.7,296.8l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L195.7,296.8z"
              />
              <polygon
                class="st29"
                points="197.1,286.5 197.8,287.2 200.2,292.1 199.2,293.2 197,288.5 197,288.4 195.6,289.9 194.6,289 	"
              />
              <polygon
                class="st29"
                points="195.6,249.3 195.6,249.3 195.2,250.4 194.2,249.8 194.7,248.3 195.6,247.3 200,251.6 199,252.7 	"
              />
              <path
                class="st29"
                d="M201.3,250.4l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L201.3,250.4z"
              />
              <path
                class="st29"
                d="M204.1,245.8c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7s-0.1-0.7-0.4-1.1l0,0c0,0.3-0.1,0.5-0.3,0.8
            c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.8,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9c0,0.5-0.2,1.1-0.6,1.6
            c-0.1,0.2-0.3,0.3-0.4,0.4L204.1,245.8z M202.1,242.1c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3c0.1-0.1,0.1-0.3,0.1-0.4
            c-0.1-0.1-0.2-0.2-0.5-0.6C202.7,242,202.3,241.9,202.1,242.1L202.1,242.1z"
              />
              <polygon
                class="st29"
                points="169,274.3 168.9,274.3 168.6,275.4 167.6,274.8 168.1,273.3 169,272.3 173.4,276.6 172.4,277.6 	"
              />
              <path
                class="st29"
                d="M174.6,275.3l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L174.6,275.3z"
              />
              <path
                class="st29"
                d="M177.5,270.8c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0
            c0,0.3-0.1,0.5-0.3,0.8c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.8,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9
            c0,0.5-0.2,1.1-0.6,1.6c-0.1,0.2-0.3,0.3-0.4,0.4L177.5,270.8z M175.5,267c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3
            c0.1-0.1,0.1-0.3,0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.6C176.1,267,175.7,266.8,175.5,267L175.5,267z"
              />
              <polygon
                class="st29"
                points="428.2,357.4 426.6,356.9 426,357.9 427.1,358.2 427.1,358.3 423.8,361.7 424.8,362.7 429.1,358.3
            "
              />
              <polygon
                class="st29"
                points="428.2,366 432.5,361.6 431.5,360.7 430,360.1 429.4,361.1 430.5,361.5 430.5,361.5 427.1,364.9 	"
              />
              <path
                class="st29"
                d="M430.8,368.6c0.7,0.7,2,0.6,3.6-1c0.9-0.9,2-2.4,0.8-3.5c-1-1-2.5-0.2-3.6,0.9
            C430.6,366,429.7,367.5,430.8,368.6L430.8,368.6z M432.6,366c1-1,1.4-1.3,1.7-1c0.2,0.2-0.2,0.7-1.1,1.6c-1,1-1.4,1.3-1.6,1.1l0,0
            C431.4,367.5,431.6,367,432.6,366"
              />
              <polygon
                class="st29"
                points="417.1,367.9 417,367.9 416,367.4 416.7,366.5 418.2,367.2 419,368.2 414.2,372 413.3,370.9 	"
              />
              <path
                class="st29"
                d="M416.4,374.9c-0.9-1.2,0.2-2.5,1.3-3.4c1.3-1,2.8-1.6,3.7-0.5c1,1.3-0.3,2.6-1.3,3.4
            C418.4,375.8,417.1,375.8,416.4,374.9L416.4,374.9z M417.4,374.2c0.2,0.2,0.6,0,1.7-0.9c1-0.8,1.4-1.2,1.2-1.5
            c-0.2-0.2-0.7-0.1-1.8,0.8C417.5,373.5,417.2,373.9,417.4,374.2L417.4,374.2z"
              />
              <path
                class="st29"
                d="M424.3,374.7c0.5,0.7,0.6,1.7-0.2,2.3c-0.3,0.2-0.8,0.5-1.5,0.2l0,0c0.1,0.6-0.1,1.3-0.6,1.7
            c-1,0.8-2,0.4-2.7-0.4s-0.7-1.9,0.2-2.6c0.6-0.4,1.2-0.5,1.8-0.3l0,0c-0.1-0.6,0.2-1.1,0.6-1.4
            C422.7,373.7,423.7,373.9,424.3,374.7L424.3,374.7z M420.1,378c0.2,0.3,0.6,0.1,1-0.1c0.4-0.3,0.5-0.8,0.4-1.1
            c-0.3-0.1-0.6,0-1,0.3C420.1,377.3,419.9,377.7,420.1,378L420.1,378z M423.6,375.3c-0.2-0.3-0.6-0.1-0.8,0.1
            c-0.3,0.2-0.4,0.5-0.3,0.9c0.2,0.1,0.6,0,0.8-0.2C423.5,375.9,423.8,375.6,423.6,375.3L423.6,375.3z"
              />
              <polygon
                class="st29"
                points="434.8,394.3 439.6,390.5 438.8,389.5 437.3,388.8 436.6,389.7 437.6,390.2 437.6,390.2 433.9,393.2
            "
              />
              <path
                class="st29"
                d="M437,397.2c0.6,0.8,1.9,0.8,3.7-0.5c1-0.8,2.3-2.1,1.3-3.4c-0.9-1.1-2.4-0.5-3.7,0.5
            C437.2,394.7,436.1,396,437,397.2L437,397.2z M439.2,394.9c1.1-0.9,1.6-1.1,1.8-0.8c0.2,0.2-0.3,0.7-1.2,1.5
            c-1.1,0.9-1.5,1.1-1.7,0.9l0,0C437.8,396.2,438.1,395.8,439.2,394.9"
              />
              <path
                class="st29"
                d="M442.6,401.2c0.6-0.4,0.8-1.1,0.6-1.7l0,0c0.7,0.3,1.3,0,1.5-0.2c0.8-0.6,0.7-1.6,0.2-2.3l0,0
            c-0.6-0.8-1.7-1.1-2.5-0.4c-0.4,0.3-0.7,0.8-0.6,1.4l0,0c-0.6-0.2-1.2-0.2-1.8,0.3c-0.9,0.7-0.8,1.7-0.2,2.6
            C440.6,401.7,441.6,402,442.6,401.2 M443.3,397.6c0.2-0.2,0.6-0.3,0.8-0.1l0,0c0.2,0.3,0,0.6-0.3,0.8c-0.2,0.2-0.6,0.3-0.8,0.2
            C442.9,398.2,443.1,397.9,443.3,397.6 M441.1,399.3c0.3-0.3,0.7-0.3,1-0.3c0.1,0.3,0,0.8-0.4,1.1c-0.3,0.3-0.7,0.4-1,0.1l0,0
            C440.5,400,440.7,399.6,441.1,399.3"
              />
              <polygon
                class="st29"
                points="462.6,320.7 466.9,316.3 466,315.4 464.4,314.9 463.8,315.9 464.9,316.2 464.9,316.3 461.6,319.7
            "
              />
              <polygon
                class="st29"
                points="466,324 470.3,319.6 469.3,318.7 467.8,318.2 467.2,319.1 468.3,319.5 468.3,319.5 464.9,322.9 	"
              />
              <path
                class="st29"
                d="M471.2,326.6c0.5-0.5,0.6-1.2,0.4-1.8l0,0c0.8,0.2,1.2-0.1,1.5-0.4c0.7-0.7,0.5-1.7-0.1-2.3l0,0
            c-0.7-0.7-1.8-0.9-2.5-0.1c-0.3,0.3-0.5,0.8-0.4,1.5l0,0c-0.6-0.1-1.2,0-1.7,0.5c-0.8,0.8-0.6,1.8,0.2,2.6
            C469.3,327.3,470.4,327.5,471.2,326.6 M471.5,322.9c0.2-0.2,0.6-0.4,0.8-0.2l0,0c0.2,0.2,0,0.6-0.2,0.8c-0.2,0.2-0.6,0.4-0.8,0.3
            C471.2,323.5,471.3,323.2,471.5,322.9 M469.5,324.9c0.3-0.3,0.7-0.4,0.9-0.4c0.1,0.3,0.1,0.8-0.2,1.2c-0.3,0.3-0.7,0.5-0.9,0.2l0,0
            C469,325.6,469.2,325.2,469.5,324.9"
              />
              <polygon
                class="st29"
                points="474.6,305.3 474.6,305.3 473.5,305 474.1,304 475.7,304.5 476.6,305.4 472.3,309.8 471.3,308.8 	"
              />
              <path
                class="st29"
                d="M473.6,311l0.7-0.7l1-0.1c1.3-0.1,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L473.6,311z"
              />
              <path
                class="st29"
                d="M478.2,315.7c0.7,0.7,2,0.6,3.6-1c0.9-0.9,2-2.4,0.8-3.5c-1-1-2.5-0.2-3.6,0.9
            C478.1,313.1,477.2,314.6,478.2,315.7L478.2,315.7z M480.1,313.1c1-1,1.4-1.2,1.7-1c0.2,0.2-0.2,0.7-1,1.6c-1,1-1.4,1.3-1.6,1.1
            l0,0C478.9,314.5,479.1,314.1,480.1,313.1"
              />
              <polygon
                class="st29"
                points="484.2,294.2 484.2,294.2 483,293.8 483.7,292.8 485.2,293.3 486.2,294.2 481.9,298.6 480.8,297.6
            "
              />
              <path
                class="st29"
                d="M483.1,299.8l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L483.1,299.8z"
              />
              <path
                class="st29"
                d="M486.5,303.1l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L486.5,303.1z"
              />
              <polygon
                class="st29"
                points="492.7,283.5 492.7,283.4 491.6,283.1 492.2,282.1 493.8,282.6 494.7,283.5 490.4,287.9 489.4,286.9
            "
              />
              <path
                class="st29"
                d="M491.7,289.1l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L491.7,289.1z"
              />
              <path
                class="st29"
                d="M496.5,293.8l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L496.5,293.8z
            M498.3,292l0.7-0.7c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L498.3,292z"
              />
              <polygon
                class="st29"
                points="502,272.4 502,272.4 500.9,272 501.5,271 503.1,271.5 504,272.4 499.7,276.8 498.7,275.8 	"
              />
              <path
                class="st29"
                d="M501,278l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L501,278z"
              />
              <path
                class="st29"
                d="M510.2,280c-0.1-0.1-0.3-0.2-0.4-0.3c-0.6-0.4-1.3-0.3-1.9,0.1l0,0c0.3,0,0.7,0,1,0.3
            c0.6,0.6,0.5,1.5-0.3,2.4c-0.7,0.7-2,1.2-2.9,0.3c-0.9-0.8-0.7-2.1,0.4-3.2c1-1,2-1.3,2.8-1.3c0.6,0,1.2,0.2,1.6,0.5
            c0.3,0.2,0.4,0.3,0.5,0.4L510.2,280z M506.4,282c0.3,0.3,0.7-0.1,1.1-0.6c0.2-0.3,0.5-0.7,0.3-0.9c-0.1-0.1-0.3-0.1-0.5,0
            c-0.1,0-0.2,0.2-0.5,0.4C506.4,281.3,506.2,281.7,506.4,282L506.4,282z"
              />
              <polygon
                class="st29"
                points="514.4,256 514.3,256 513.2,255.6 513.9,254.7 515.4,255.2 516.3,256.1 512,260.5 511,259.5 	"
              />
              <path
                class="st29"
                d="M513.3,261.7l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L513.3,261.7z"
              />
              <path
                class="st29"
                d="M522.5,261.9c0.6,0.6,0.8,1.6,0.1,2.3c-0.2,0.2-0.7,0.6-1.5,0.4l0,0c0.2,0.6,0.1,1.3-0.4,1.8
            c-0.9,0.9-1.9,0.7-2.7,0s-0.9-1.8-0.2-2.6c0.5-0.5,1.2-0.6,1.7-0.5l0,0c-0.1-0.6,0.1-1.1,0.4-1.5
            C520.7,261,521.7,261.2,522.5,261.9L522.5,261.9z M518.7,265.6c0.3,0.3,0.6,0.1,0.9-0.2c0.4-0.4,0.4-0.9,0.3-1.2
            c-0.3,0-0.6,0.1-1,0.4C518.6,265,518.4,265.4,518.7,265.6L518.7,265.6z M521.7,262.5c-0.2-0.2-0.6-0.1-0.8,0.2
            c-0.2,0.3-0.3,0.6-0.2,1c0.2,0.1,0.6-0.1,0.8-0.3C521.8,263.1,522,262.8,521.7,262.5L521.7,262.5z"
              />
              <polygon
                class="st29"
                points="542.1,283.5 542,283.5 540.9,283.1 541.6,282.1 543.1,282.6 544,283.5 539.7,287.9 538.7,286.9 	"
              />
              <path
                class="st29"
                d="M541,289.2l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L541,289.2z"
              />
              <path
                class="st29"
                d="M550.1,289.4c0.6,0.6,0.8,1.6,0.1,2.3c-0.2,0.2-0.7,0.6-1.5,0.4l0,0c0.2,0.6,0.1,1.3-0.4,1.8
            c-0.9,0.9-1.9,0.7-2.7,0s-0.9-1.8-0.2-2.6c0.5-0.5,1.2-0.6,1.7-0.5l0,0c-0.1-0.6,0.1-1.1,0.4-1.5
            C548.4,288.5,549.4,288.6,550.1,289.4L550.1,289.4z M546.4,293.1c0.3,0.3,0.6,0.1,0.9-0.2c0.4-0.4,0.4-0.9,0.3-1.2
            c-0.3,0-0.6,0.1-1,0.4C546.3,292.4,546.1,292.9,546.4,293.1L546.4,293.1z M549.4,290c-0.2-0.2-0.6-0.1-0.8,0.2
            c-0.2,0.3-0.3,0.6-0.2,1c0.2,0.1,0.6-0.1,0.8-0.3C549.5,290.6,549.7,290.2,549.4,290L549.4,290z"
              />
              <polygon
                class="st29"
                points="530.5,237.1 530.5,237.1 529.4,236.7 530,235.7 531.6,236.2 532.5,237.1 528.2,241.6 527.2,240.5
            "
              />
              <path
                class="st29"
                d="M530.6,242c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.4,0.9,0.4,1.2,0.1c0.4-0.5,0.2-1-0.2-1.4l-0.1-0.1l0.7-0.8l0.1,0.1
            c0.3,0.3,0.8,0.6,1.2,0.2c0.3-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.4-0.3-0.7-0.4l0.6-0.9c0.3,0.1,0.8,0.3,1.2,0.7
            c0.8,0.8,0.7,1.7,0.2,2.3c-0.4,0.4-1,0.5-1.6,0.4l0,0c0.3,0.6,0.2,1.3-0.3,1.8c-0.6,0.7-1.8,0.8-2.9-0.2c-0.4-0.4-0.6-0.8-0.7-1.1
            L530.6,242z"
              />
              <path
                class="st29"
                d="M534.1,247.4c-1.1-1-0.2-2.5,0.8-3.6c1.1-1.2,2.6-1.9,3.6-0.9c1.2,1.1,0,2.6-0.8,3.5
            C536.2,248,534.9,248.1,534.1,247.4L534.1,247.4z M535,246.5c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.3-1.4,1-1.6c-0.2-0.2-0.7,0-1.7,1
            C535,245.9,534.8,246.3,535,246.5L535,246.5z"
              />
              <polygon
                class="st29"
                points="563,262.3 563,262.3 561.9,262 562.5,261 564,261.5 565,262.4 560.7,266.8 559.6,265.8 	"
              />
              <path
                class="st29"
                d="M563,267.2c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.4,0.9,0.4,1.2,0.1c0.4-0.5,0.2-1-0.2-1.4l-0.1-0.1l0.7-0.8l0.1,0.1
            c0.3,0.3,0.8,0.6,1.2,0.2c0.3-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.4-0.3-0.7-0.4l0.6-0.9c0.3,0.1,0.8,0.3,1.2,0.7
            c0.8,0.8,0.7,1.7,0.2,2.3c-0.4,0.4-1,0.5-1.6,0.4l0,0c0.3,0.6,0.2,1.3-0.3,1.8c-0.6,0.7-1.8,0.8-2.9-0.2c-0.4-0.4-0.6-0.8-0.7-1.1
            L563,267.2z"
              />
              <path
                class="st29"
                d="M566.6,272.6c-1.1-1-0.2-2.5,0.8-3.6c1.1-1.2,2.6-1.9,3.6-0.9c1.2,1.1,0,2.6-0.8,3.5
            C568.7,273.2,567.4,273.4,566.6,272.6L566.6,272.6z M567.5,271.8c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.3-1.4,1-1.6
            c-0.2-0.2-0.7,0-1.7,1C567.5,271.1,567.3,271.5,567.5,271.8L567.5,271.8z"
              />
              <polygon
                class="st29"
                points="528.6,297.4 528.6,297.4 527.5,297 528.2,296 529.7,296.5 530.6,297.4 526.3,301.8 525.3,300.8 	"
              />
              <path
                class="st29"
                d="M527.6,303.1l0.7-0.7l1-0.1c1.3-0.1,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L527.6,303.1z"
              />
              <path
                class="st29"
                d="M536.9,305c-0.1-0.1-0.3-0.2-0.4-0.3c-0.6-0.4-1.3-0.3-1.9,0.1l0,0c0.3,0,0.7,0,1,0.3
            c0.6,0.6,0.5,1.5-0.3,2.4c-0.7,0.7-1.9,1.2-2.9,0.3c-0.9-0.8-0.7-2.1,0.4-3.2c1-1,2-1.3,2.8-1.3c0.6,0,1.2,0.2,1.6,0.5
            c0.3,0.2,0.4,0.3,0.5,0.4L536.9,305z M533,307c0.3,0.3,0.7-0.1,1.1-0.6c0.2-0.3,0.5-0.7,0.3-0.9c-0.1-0.1-0.3-0.1-0.5,0
            c-0.1,0-0.2,0.2-0.5,0.4C533.1,306.3,532.8,306.8,533,307L533,307z"
              />
              <polygon
                class="st29"
                points="542.2,220.9 542.2,220.9 541.1,220.8 541.4,219.7 543.1,219.8 544.2,220.4 541,225.7 539.8,225 	"
              />
              <path
                class="st29"
                d="M543.4,225.6c0.2,0.3,0.4,0.5,0.7,0.7c0.5,0.3,0.9,0.2,1.1-0.2c0.3-0.5,0-1-0.5-1.3l-0.1-0.1l0.5-0.9l0.1,0.1
            c0.4,0.2,0.9,0.4,1.2-0.1c0.2-0.3,0.1-0.7-0.3-0.9c-0.2-0.1-0.5-0.2-0.8-0.2l0.4-1c0.3,0,0.9,0.1,1.3,0.4c1,0.6,1.1,1.5,0.7,2.2
            c-0.3,0.5-0.9,0.8-1.4,0.7l0,0c0.4,0.5,0.5,1.2,0.1,1.9c-0.5,0.8-1.6,1.2-2.8,0.5c-0.5-0.3-0.8-0.6-1-0.9L543.4,225.6z"
              />
              <path
                class="st29"
                d="M546.6,229l0.5-0.9l1-0.4c1.2-0.5,2.1-0.8,2.5-1.4c0.2-0.4,0.1-0.8-0.3-1c-0.3-0.2-0.7-0.2-1-0.2l0.4-1.1
            c0.4,0,0.9,0.1,1.4,0.4c1.3,0.8,1.2,1.8,0.7,2.5c-0.6,1-1.6,1.3-2.6,1.6l-0.5,0.1l0,0l1.6,0.9l-0.7,1.1L546.6,229z"
              />
              <polygon
                class="st29"
                points="581.9,225.7 581.9,225.7 580.8,225.6 581.1,224.5 582.8,224.6 583.9,225.3 580.7,230.6 579.5,229.8
            "
              />
              <path
                class="st29"
                d="M583.1,230.4c0.2,0.3,0.4,0.5,0.7,0.7c0.5,0.3,0.9,0.2,1.1-0.2c0.3-0.5,0-1-0.5-1.3l-0.1-0.1l0.5-0.9l0.1,0.1
            c0.4,0.2,0.9,0.4,1.2-0.1c0.2-0.3,0.1-0.7-0.3-0.9c-0.2-0.1-0.5-0.2-0.8-0.2l0.4-1c0.3,0,0.9,0.1,1.3,0.4c1,0.6,1.1,1.5,0.7,2.2
            c-0.3,0.5-0.9,0.8-1.4,0.7l0,0c0.4,0.5,0.5,1.2,0.1,1.9c-0.5,0.8-1.6,1.2-2.8,0.5c-0.5-0.3-0.8-0.6-1-0.9L583.1,230.4z"
              />
              <path
                class="st29"
                d="M586.3,233.8l0.5-0.9l1-0.4c1.2-0.5,2.1-0.8,2.5-1.4c0.2-0.4,0.1-0.8-0.3-1c-0.3-0.2-0.7-0.2-1-0.2l0.4-1.1
            c0.4,0,0.9,0.1,1.4,0.4c1.3,0.8,1.2,1.8,0.7,2.5c-0.6,1-1.6,1.3-2.6,1.6l-0.5,0.1l0,0l1.6,0.9l-0.7,1.1L586.3,233.8z"
              />
              <polygon
                class="st29"
                points="554.1,200.5 554.1,200.4 552.9,200.6 553.1,199.4 554.7,199.2 555.9,199.7 553.9,205.5 552.5,205
            "
              />
              <path
                class="st29"
                d="M556.2,204.8c0.2,0.2,0.5,0.4,0.8,0.5c0.6,0.2,0.9,0,1.1-0.4c0.2-0.6-0.2-1-0.8-1.2l-0.2-0.1l0.4-1h0.1
            c0.4,0.1,1,0.2,1.2-0.3c0.1-0.3,0-0.7-0.4-0.8c-0.2-0.1-0.5-0.1-0.8-0.1l0.2-1.1c0.3-0.1,0.9,0,1.4,0.1c1.1,0.4,1.4,1.3,1.1,2
            c-0.2,0.6-0.7,0.9-1.3,1l0,0c0.5,0.4,0.7,1.1,0.5,1.8c-0.3,0.9-1.3,1.5-2.7,1c-0.5-0.2-0.9-0.4-1.1-0.7L556.2,204.8z"
              />
              <path
                class="st29"
                d="M561.9,208.2l0.5-1.3l-2-0.7l0.3-0.9l3.2-2.9l1.3,0.5l-1.2,3.4l0.6,0.2l-0.4,1.1l-0.6-0.2l-0.5,1.3
            L561.9,208.2z M562.7,205.8l0.3-1c0.1-0.3,0.2-0.6,0.4-0.9l0,0c-0.2,0.2-0.4,0.4-0.7,0.7l-0.9,0.8l0,0L562.7,205.8z"
              />
              <polygon
                class="st29"
                points="552.9,177.9 552.8,177.9 551.9,178.6 551.5,177.5 552.8,176.6 554.1,176.4 554.9,182.5 553.5,182.7
            "
              />
              <path
                class="st29"
                d="M556.7,180.9c0.3,0.1,0.7,0.2,1,0.1c0.6-0.1,0.8-0.5,0.8-0.9c-0.1-0.6-0.6-0.8-1.2-0.7h-0.2l-0.1-1.1h0.1
            c0.5-0.1,1-0.3,0.9-0.8c0-0.4-0.3-0.6-0.7-0.5c-0.3,0-0.5,0.1-0.7,0.3l-0.3-1.1c0.2-0.2,0.8-0.4,1.3-0.5c1.2-0.2,1.8,0.5,1.9,1.3
            c0.1,0.6-0.2,1.1-0.7,1.5l0,0c0.6,0.1,1.1,0.6,1.2,1.4c0.1,0.9-0.5,2-1.9,2.1c-0.5,0.1-1,0-1.3-0.1L556.7,180.9z"
              />
              <path
                class="st29"
                d="M563.9,176.2c-0.2,0-0.3,0.1-0.5,0.1c-0.7,0.2-1,0.8-1.1,1.5l0,0c0.2-0.3,0.5-0.5,0.8-0.6
            c0.8-0.1,1.5,0.6,1.7,1.7c0.1,1-0.3,2.3-1.6,2.4c-1.2,0.2-2.1-0.7-2.3-2.3c-0.2-1.4,0.2-2.4,0.7-3c0.4-0.5,0.9-0.8,1.4-1
            c0.3-0.1,0.5-0.1,0.7-0.2L563.9,176.2z M563.1,180.4c0.4-0.1,0.3-0.7,0.3-1.2c-0.1-0.3-0.2-0.8-0.6-0.8c-0.1,0-0.3,0.1-0.3,0.3
            c0,0.1,0,0.3,0,0.6C562.6,180,562.8,180.5,563.1,180.4L563.1,180.4z"
              />
              <polygon
                class="st29"
                points="404.9,375.7 404.9,375.7 403.9,375 404.8,374.3 406.1,375.2 406.7,376.4 401.3,379.2 400.6,377.9
            "
              />
              <path
                class="st29"
                d="M402.9,382.5c-0.7-1.3,0.6-2.5,1.9-3.1c1.5-0.8,3.1-1,3.7,0.2c0.8,1.4-0.8,2.5-1.9,3.1
            C404.7,383.7,403.4,383.4,402.9,382.5L402.9,382.5z M404.1,382c0.1,0.3,0.6,0.1,1.9-0.5c1.1-0.6,1.6-0.9,1.5-1.2
            c-0.1-0.3-0.7-0.2-1.9,0.5C404.3,381.3,403.9,381.7,404.1,382L404.1,382z"
              />
              <path
                class="st29"
                d="M410.3,385.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.5-0.6-1.1-0.7-1.8-0.5l0,0c0.3,0.1,0.6,0.3,0.8,0.6
            c0.4,0.7,0,1.6-1,2.1c-0.9,0.5-2.2,0.5-2.8-0.6c-0.6-1.1-0.1-2.2,1.3-2.9c1.3-0.7,2.3-0.6,3.1-0.4c0.6,0.2,1.1,0.6,1.4,1
            c0.2,0.3,0.3,0.5,0.4,0.6L410.3,385.5z M406.1,386.2c0.2,0.4,0.7,0.1,1.3-0.2c0.3-0.2,0.7-0.5,0.5-0.8c-0.1-0.1-0.2-0.2-0.4-0.2
            c-0.1,0-0.3,0.1-0.6,0.2C406.3,385.5,405.9,385.9,406.1,386.2L406.1,386.2z"
              />
              <polygon
                class="st29"
                points="392.2,380.9 392.2,380.9 391.4,380.1 392.5,379.5 393.6,380.7 393.9,382 388,383.6 387.6,382.3 	"
              />
              <path
                class="st29"
                d="M388.9,387.2c-0.4-1.4,1.1-2.3,2.5-2.7c1.6-0.4,3.2-0.4,3.6,1c0.4,1.6-1.3,2.3-2.5,2.6
            C390.4,388.7,389.2,388.2,388.9,387.2L388.9,387.2z M390.2,386.9c0.1,0.3,0.6,0.2,1.9-0.1c1.2-0.3,1.8-0.6,1.7-0.9
            c-0.1-0.3-0.6-0.3-2,0.1C390.5,386.3,390.1,386.6,390.2,386.9L390.2,386.9z"
              />
              <path
                class="st29"
                d="M390.3,391.8l1.3-0.4l-0.6-2.1l1-0.3l4.2,0.9l0.4,1.4l-3.5,1l0.2,0.6l-1.1,0.3l-0.2-0.6l-1.3,0.4L390.3,391.8
            z M392.8,391.1l1-0.3c0.3-0.1,0.6-0.1,0.9-0.2l0,0c-0.3,0-0.6-0.1-0.9-0.1l-1.2-0.2l0,0L392.8,391.1z"
              />
              <polygon
                class="st29"
                points="379.2,383.9 379.2,383.8 378.6,382.9 379.7,382.5 380.6,383.8 380.7,385.1 374.6,385.9 374.4,384.5
            "
              />
              <path
                class="st29"
                d="M375,389.6c-0.2-1.5,1.5-2.1,2.8-2.3c1.6-0.2,3.2,0.1,3.4,1.5c0.2,1.6-1.6,2.1-2.8,2.2
            C376.3,391.3,375.2,390.6,375,389.6L375,389.6z M376.3,389.4c0,0.3,0.6,0.3,1.9,0.1c1.3-0.2,1.9-0.3,1.8-0.6c0-0.3-0.6-0.4-1.9-0.2
            C376.7,388.9,376.2,389.1,376.3,389.4L376.3,389.4z"
              />
              <path
                class="st29"
                d="M375.5,392.3l1-0.1l0.9,0.5c1.1,0.7,1.9,1.1,2.6,1.1c0.4-0.1,0.7-0.4,0.6-0.8c0-0.4-0.2-0.6-0.4-0.9l1.1-0.4
            c0.2,0.3,0.5,0.8,0.6,1.4c0.2,1.5-0.7,2-1.6,2.1c-1.1,0.1-2.1-0.4-2.9-1l-0.4-0.3l0,0l0.2,1.8l-1.3,0.2L375.5,392.3z"
              />
              <polygon
                class="st29"
                points="361.6,394.8 361.6,394.8 362,395.9 360.8,396 360.2,394.5 360.4,393.2 366.5,393.9 366.3,395.3 	"
              />
              <path
                class="st29"
                d="M367,390.3c-0.2,1.5-1.9,1.7-3.3,1.5c-1.6-0.2-3.1-0.9-3-2.3c0.2-1.6,2.1-1.6,3.3-1.5
            C366.2,388.3,367.1,389.2,367,390.3L367,390.3z M365.8,390.1c0-0.3-0.5-0.4-1.8-0.6c-1.3-0.1-1.9-0.1-1.9,0.2
            c0,0.3,0.4,0.5,1.8,0.7C365.2,390.5,365.7,390.4,365.8,390.1L365.8,390.1z"
              />
              <polygon
                class="st29"
                points="362.6,385.5 362.6,385.5 363,386.6 361.8,386.8 361.3,385.2 361.4,383.9 367.6,384.6 367.4,386.1
            "
              />
              <polygon
                class="st29"
                points="346.1,391.9 346.1,391.9 346.3,393 345.1,392.9 344.9,391.3 345.2,390.1 351.1,391.9 350.7,393.3
            "
              />
              <path
                class="st29"
                d="M352.3,388.4c-0.4,1.4-2.2,1.3-3.5,0.9c-1.6-0.5-2.9-1.4-2.5-2.8c0.5-1.5,2.3-1.2,3.5-0.9
            C351.9,386.3,352.6,387.4,352.3,388.4L352.3,388.4z M351.1,388c0.1-0.3-0.4-0.5-1.7-0.9c-1.2-0.4-1.8-0.5-1.9-0.2s0.3,0.6,1.7,1
            C350.5,388.3,351,388.3,351.1,388L351.1,388z"
              />
              <path
                class="st29"
                d="M351.8,385.1c0.2-0.2,0.4-0.5,0.5-0.8c0.2-0.6-0.1-0.9-0.5-1.1c-0.6-0.2-1,0.3-1.1,0.8v0.2l-1-0.3v-0.1
            c0.1-0.4,0.2-1-0.3-1.2c-0.4-0.1-0.7,0.1-0.8,0.5c-0.1,0.3-0.1,0.5,0,0.8l-1.1-0.2c-0.1-0.3-0.1-0.9,0.1-1.4c0.3-1.1,1.2-1.4,2-1.2
            c0.6,0.2,1,0.7,1,1.2l0,0c0.4-0.5,1-0.8,1.8-0.5c0.9,0.3,1.6,1.3,1.2,2.6c-0.2,0.5-0.4,0.9-0.6,1.1L351.8,385.1z"
              />
              <polygon
                class="st29"
                points="332.5,384.3 332.5,384.4 332.5,385.5 331.3,385.2 331.4,383.6 331.9,382.4 337.4,385.2 336.8,386.5
            "
              />
              <path
                class="st29"
                d="M339.2,382c-0.7,1.3-2.4,0.9-3.6,0.3c-1.5-0.7-2.6-1.9-2-3.2c0.7-1.4,2.5-0.8,3.6-0.2
            C339.1,379.8,339.6,381,339.2,382L339.2,382z M338.1,381.4c0.1-0.3-0.3-0.6-1.5-1.2c-1.1-0.6-1.7-0.8-1.9-0.5
            c-0.1,0.3,0.2,0.6,1.5,1.3C337.4,381.6,337.9,381.7,338.1,381.4L338.1,381.4z"
              />
              <path
                class="st29"
                d="M337.5,374.3l-0.7,1.4l0.7,0.5l0.1-0.1c0.1-0.2,0.5-0.6,0.9-0.8c0.5-0.2,1-0.1,1.5,0.2c1.1,0.5,1.6,1.7,0.9,3
            c-0.2,0.4-0.5,0.8-0.8,1l-0.9-0.7c0.2-0.2,0.4-0.4,0.6-0.7c0.3-0.5,0.1-1-0.4-1.2c-0.7-0.3-1.2,0.1-1.5,0.7
            c-0.1,0.1-0.1,0.3-0.2,0.4l-2.7-1.7l1.2-2.4L337.5,374.3z"
              />
              <polygon
                class="st29"
                points="319.3,373.7 318.4,374.7 318,376.2 319.1,376.8 319.4,375.7 319.4,375.7 323.1,378.7 324,377.6 	"
              />
              <path
                class="st29"
                d="M326.4,374.9c-1,1.2-2.5,0.4-3.6-0.5c-1.3-1-2.1-2.5-1.2-3.5c1-1.2,2.6-0.2,3.6,0.6
            C326.9,372.8,327.1,374.1,326.4,374.9L326.4,374.9z M325.5,374c0.2-0.2-0.2-0.6-1.2-1.5c-1-0.8-1.5-1.2-1.7-0.9
            c-0.2,0.2,0.1,0.7,1.2,1.6C324.8,374.1,325.3,374.3,325.5,374L325.5,374z"
              />
              <polygon
                class="st29"
                points="325.8,365.9 326.5,366.5 329.3,371.3 328.4,372.4 325.8,367.9 325.8,367.9 324.5,369.4 323.5,368.6
            "
              />
              <polygon
                class="st29"
                points="178.8,160.3 178.8,160.3 177.6,160.6 177.7,159.4 179.2,159.1 180.5,159.4 179,165.3 177.6,165 	"
              />
              <path
                class="st29"
                d="M181.3,164.5c0.2,0.2,0.6,0.4,0.8,0.4c0.6,0.1,0.9-0.1,1-0.5c0.1-0.6-0.3-0.9-0.9-1.1H182l0.3-1h0.1
            c0.5,0.1,1,0.1,1.1-0.4c0.1-0.4-0.1-0.6-0.5-0.7c-0.3-0.1-0.5-0.1-0.8,0l0.1-1.1c0.3-0.1,0.9-0.1,1.4,0c1.1,0.3,1.5,1.1,1.3,1.9
            c-0.1,0.6-0.6,1-1.2,1.1l0,0c0.5,0.4,0.8,1,0.6,1.7c-0.2,0.9-1.2,1.6-2.6,1.3c-0.5-0.1-0.9-0.4-1.2-0.6L181.3,164.5z"
              />
              <polygon
                class="st29"
                points="190.4,161.8 190.1,162.7 187,167.3 185.7,167 188.6,162.7 188.6,162.7 186.6,162.2 186.9,160.9 	"
              />
              <polygon
                class="st29"
                points="173.6,182.6 173.6,182.6 172.4,182.8 172.5,181.7 174.1,181.3 175.3,181.6 173.9,187.6 172.5,187.2
            "
              />
              <path
                class="st29"
                d="M176.1,186.7c0.2,0.2,0.6,0.4,0.8,0.5c0.6,0.1,0.9-0.1,1-0.5c0.2-0.6-0.3-0.9-0.9-1.1h-0.2l0.3-1h0.1
            c0.5,0.1,1,0.1,1.1-0.4c0.1-0.4-0.1-0.6-0.5-0.7c-0.3-0.1-0.5-0.1-0.8,0l0.1-1.1c0.3-0.1,0.9-0.1,1.4,0c1.1,0.3,1.5,1.1,1.3,1.9
            c-0.1,0.6-0.6,1-1.2,1.1l0,0c0.5,0.4,0.8,1,0.6,1.7c-0.2,0.9-1.2,1.6-2.6,1.3c-0.5-0.1-0.9-0.4-1.2-0.6L176.1,186.7z"
              />
              <path
                class="st29"
                d="M184.6,185.2l-1.6-0.4l-0.3,0.8c0.1,0,0.1,0,0.2,0c0.2,0.1,0.7,0.3,1,0.7s0.3,0.9,0.2,1.5
            c-0.3,1.1-1.3,1.9-2.7,1.6c-0.5-0.1-0.9-0.3-1.1-0.5l0.5-1.1c0.2,0.2,0.5,0.3,0.8,0.4c0.6,0.1,1-0.1,1.1-0.6c0.2-0.7-0.4-1.1-1-1.3
            c-0.1,0-0.3-0.1-0.4-0.1l1.1-3l2.6,0.6L184.6,185.2z"
              />
              <polygon
                class="st29"
                points="172.8,205.9 172.8,205.9 171.8,206.5 171.5,205.4 172.9,204.5 174.2,204.5 174.6,210.6 173.2,210.7
            "
              />
              <path
                class="st29"
                d="M176.5,209.1c0.3,0.1,0.6,0.2,0.9,0.2c0.6,0,0.9-0.4,0.8-0.8c0-0.6-0.6-0.8-1.2-0.8h-0.2l-0.1-1.1h0.1
            c0.5,0,1-0.2,1-0.7c0-0.4-0.3-0.6-0.7-0.6c-0.3,0-0.5,0.1-0.8,0.3l-0.3-1.1c0.3-0.2,0.8-0.4,1.3-0.4c1.2-0.1,1.8,0.6,1.9,1.4
            c0,0.6-0.3,1.1-0.8,1.4l0,0c0.6,0.2,1.1,0.7,1.2,1.5c0.1,0.9-0.6,1.9-2,2c-0.5,0-1,0-1.3-0.2L176.5,209.1z"
              />
              <path
                class="st29"
                d="M181.2,208.7c0.3,0.1,0.6,0.2,0.9,0.2c0.6,0,0.9-0.4,0.8-0.8c0-0.6-0.6-0.8-1.2-0.8h-0.2l-0.1-1.1h0.1
            c0.5,0,1-0.2,1-0.7c0-0.4-0.3-0.6-0.7-0.6c-0.3,0-0.5,0.1-0.8,0.3l-0.3-1.1c0.3-0.2,0.8-0.4,1.3-0.4c1.2-0.1,1.8,0.6,1.9,1.4
            c0,0.6-0.3,1.1-0.8,1.4l0,0c0.6,0.2,1.1,0.7,1.2,1.5c0.1,0.9-0.6,1.9-2,2c-0.5,0-1,0-1.3-0.2L181.2,208.7z"
              />
              <polygon
                class="st29"
                points="183.5,231.6 183.4,231.6 182.6,232.4 182,231.4 183.2,230.3 184.4,229.9 186.3,235.7 184.9,236.1
            "
              />
              <path
                class="st29"
                d="M187.8,233.8c0.3,0.1,0.7,0,1-0.1c0.6-0.2,0.7-0.6,0.6-1c-0.2-0.6-0.8-0.6-1.3-0.5l-0.2,0.1l-0.3-1h0.1
            c0.4-0.2,0.9-0.4,0.7-0.9c-0.1-0.4-0.4-0.5-0.8-0.4c-0.3,0.1-0.5,0.2-0.7,0.4l-0.5-1c0.2-0.2,0.7-0.5,1.2-0.7
            c1.1-0.4,1.9,0.2,2.1,0.9c0.2,0.6,0,1.2-0.4,1.6l0,0c0.7,0,1.2,0.4,1.5,1.1c0.3,0.9-0.1,2-1.5,2.5c-0.5,0.2-1,0.2-1.3,0.1
            L187.8,233.8z"
              />
              <polygon
                class="st29"
                points="192.4,228.7 192.3,228.7 191.5,229.5 190.9,228.5 192.1,227.4 193.3,227 195.2,232.8 193.8,233.3
            "
              />
              <polygon
                class="st29"
                points="146.1,240.3 146.1,240.3 145.2,241.1 144.7,240.1 145.8,239 147.1,238.6 149,244.4 147.6,244.9 	"
              />
              <path
                class="st29"
                d="M150.4,242.5c0.3,0.1,0.7,0,1-0.1c0.6-0.2,0.7-0.6,0.6-1c-0.2-0.6-0.8-0.6-1.3-0.5l-0.2,0.1l-0.3-1h0.1
            c0.4-0.2,0.9-0.4,0.7-0.9c-0.1-0.4-0.4-0.5-0.8-0.4c-0.3,0.1-0.5,0.2-0.7,0.4l-0.5-1c0.2-0.2,0.7-0.5,1.2-0.7
            c1.1-0.4,1.9,0.2,2.1,0.9c0.2,0.6,0,1.2-0.4,1.6l0,0c0.7,0,1.2,0.4,1.5,1.1c0.3,0.9-0.1,2-1.5,2.5c-0.5,0.2-1,0.2-1.3,0.1
            L150.4,242.5z"
              />
              <polygon
                class="st29"
                points="155,237.4 155,237.4 154.1,238.3 153.6,237.2 154.7,236.1 156,235.7 157.9,241.5 156.5,242 	"
              />
              <path
                class="st36"
                d="M160.8,284.2l0.4-0.4l0.9-0.1c1.2-0.2,2.3-0.3,3-1c0.4-0.4,0.4-0.8,0.1-1.2c-0.3-0.3-0.6-0.3-0.8-0.4l0.4-0.6
            c0.3,0,0.7,0.2,1.1,0.6c0.8,0.8,0.6,1.6,0,2.2c-0.8,0.8-1.9,1-3,1.1l-0.6,0.1l0,0l1.3,1.3l-0.6,0.6L160.8,284.2z"
              />
              <path
                class="st36"
                d="M164.7,288.1c-0.8-0.8-0.2-2,0.9-3.2c1.2-1.3,2.5-1.7,3.2-1c0.8,0.8,0.2,2-0.9,3.1
            C166.5,288.6,165.3,288.7,164.7,288.1L164.7,288.1z M165.3,287.6c0.3,0.3,1-0.1,1.9-1.1c0.9-0.9,1.4-1.6,1-2c-0.3-0.3-1,0.1-2,1.1
            C165.4,286.6,165,287.3,165.3,287.6L165.3,287.6z"
              />
              <path
                class="st36"
                d="M167.6,290.9c-0.8-0.8-0.2-2,0.9-3.2c1.2-1.3,2.5-1.7,3.2-1c0.8,0.8,0.2,2-0.9,3.2
            C169.4,291.4,168.2,291.6,167.6,290.9L167.6,290.9z M168.2,290.4c0.3,0.3,1-0.1,1.9-1.1c0.9-0.9,1.4-1.6,1-2c-0.3-0.3-1,0.1-2,1.1
            C168.2,289.4,167.9,290.1,168.2,290.4L168.2,290.4z"
              />
              <polygon
                class="st36"
                points="175.1,289.8 175.8,290.5 172.2,294.2 173.3,295.3 172.8,295.8 171,294.1 	"
              />
              <polygon
                class="st36"
                points="177.1,296.3 176.1,295.3 174.8,296.7 176,297.8 175.4,298.4 173.6,296.6 177.7,292.4 179.5,294.1
            178.9,294.7 177.8,293.6 176.7,294.8 177.7,295.8 	"
              />
              <path
                class="st36"
                d="M177,299.9l3.2-5.2l0.7,0.7l-1.5,2.2c-0.4,0.5-0.8,1.2-1.3,1.8l0,0c0.6-0.5,1.2-0.9,1.8-1.3l2.2-1.6l0.7,0.7
            l-5.1,3.3L177,299.9z"
              />
              <polygon
                class="st36"
                points="183,302 182,301 180.6,302.4 181.8,303.5 181.2,304.1 179.4,302.3 183.5,298 185.3,299.7
            184.7,300.3 183.6,299.3 182.5,300.4 183.5,301.4 	"
              />
              <polygon
                class="st36"
                points="186.2,300.6 186.9,301.3 183.3,305 184.5,306.1 183.9,306.7 182.1,304.9 	"
              />

              <rect
                x="191.8"
                y="309.1"
                transform="matrix(0.6985 -0.7156 0.7156 0.6985 -163.9018 230.9575)"
                class="st36"
                width="0.7"
                height="1.8"
              />
              <path
                class="st36"
                d="M200.1,319l0.8,0.8l-0.9,1.3l0.7,0.6l3.3-5.1l-0.8-0.8l-5.1,3.3l0.7,0.6L200.1,319z M201.9,317.7
            c0.3-0.2,0.8-0.6,1.1-0.8l0,0c-0.2,0.3-0.6,0.8-0.8,1.1l-0.8,1.1l-0.7-0.7L201.9,317.7z"
              />
              <path
                class="st36"
                d="M203.9,321.5c0.1,0.1,0.1,0.1,0.2,0.2c0.4,0.4,0.9,0.6,1.5,0.6c0.4,0,0.8-0.2,1.2-0.6s0.6-0.8,0.5-1.2
            c0-0.5-0.3-0.9-0.8-1.4c-0.3-0.3-0.6-0.5-0.9-0.7l-4.1,4.2l0.7,0.7L203.9,321.5z M205.9,319.5c0.1,0,0.2,0.1,0.3,0.2
            c0.5,0.4,0.3,0.9-0.1,1.3c-0.5,0.5-1,0.5-1.5,0.1c-0.1-0.1-0.1-0.1-0.2-0.2L205.9,319.5z"
              />
              <path
                class="st36"
                d="M206.9,324.5c0.1,0.1,0.1,0.1,0.2,0.2c0.4,0.3,0.9,0.6,1.5,0.6c0.4,0,0.8-0.2,1.2-0.6s0.6-0.8,0.5-1.2
            c0-0.5-0.3-0.9-0.8-1.4c-0.3-0.3-0.6-0.5-0.9-0.7l-4.1,4.2l0.7,0.7L206.9,324.5z M208.9,322.5c0.1,0,0.2,0.1,0.3,0.2
            c0.5,0.4,0.3,0.9-0.1,1.3c-0.5,0.5-1,0.5-1.5,0.1c-0.1-0.1-0.1-0.1-0.2-0.2L208.9,322.5z"
              />
              <path
                class="st36"
                d="M210.1,327.3l0.2,0.1c0.3,0.3,0.3,0.7-0.1,1.3c-0.4,0.6-0.7,1.1-0.8,1.2l0.7,0.7c0.1-0.2,0.4-0.8,0.8-1.4
            c0.4-0.6,0.5-1,0.3-1.4l0,0c0.6,0.2,1.2,0.1,1.7-0.4c0.3-0.4,0.5-0.7,0.5-1.2s-0.3-0.9-0.8-1.3c-0.3-0.3-0.6-0.5-0.9-0.7l-4.1,4.2
            l0.7,0.6L210.1,327.3z M212,325.4c0.1,0,0.2,0.1,0.3,0.2c0.4,0.4,0.3,0.9-0.1,1.3c-0.4,0.4-1,0.5-1.4,0.1l-0.2-0.2L212,325.4z"
              />
              <path
                class="st36"
                d="M211.8,332.6c0.7,0.7,1.9,0.6,3.5-1c1.1-1.1,1.7-2.5,0.8-3.3s-2.2-0.4-3.5,0.9
            C211.4,330.4,211,331.7,211.8,332.6L211.8,332.6z M213.4,329.8c0.8-0.8,1.7-1.4,2.1-1c0.5,0.4-0.2,1.4-0.9,2.1
            c-0.8,0.8-1.7,1.5-2.2,1.1l0,0C212,331.6,212.6,330.7,213.4,329.8"
              />
              <path
                class="st36"
                d="M215.4,334.2c0.3-0.2,0.6-0.3,1-0.5l0,0c-0.2,0.4-0.3,0.7-0.5,1l-0.5,1.2l0.7,0.7l1.2-3l2.9-1.3l-0.7-0.7
            l-1.1,0.6c-0.3,0.2-0.5,0.3-0.9,0.5l0,0c0.2-0.3,0.3-0.6,0.4-0.9l0.6-1.2l-0.7-0.7l-1.2,2.9l-2.9,1.4l0.7,0.7L215.4,334.2z"
              />

              <rect
                x="216.2"
                y="335"
                transform="matrix(0.6979 -0.7162 0.7162 0.6979 -174.0397 258.2964)"
                class="st36"
                width="5.9"
                height="0.9"
              />
              <path
                class="st36"
                d="M220.6,337.8c0.5-0.5,1.1-1,1.6-1.5l0,0c-0.4,0.5-0.8,1.2-1.1,1.7l-1.2,2.1l0.5,0.4l2.1-1.3
            c0.5-0.3,1.1-0.7,1.6-1.1l0,0c-0.5,0.5-1,1.1-1.4,1.6l-1.5,1.7l0.6,0.6l3.9-4.5l-0.7-0.7l-2.1,1.3c-0.7,0.4-1.2,0.8-1.7,1.2l0,0
            c0.4-0.6,0.7-1.1,1.1-1.8l1.3-2.1l-0.7-0.7l-4.4,4l0.6,0.6L220.6,337.8z"
              />
              <path
                class="st36"
                d="M224.3,342.4l0.8,0.8l-0.8,1.3l0.7,0.6l3.3-5.1l-0.8-0.8l-5.1,3.3l0.7,0.6L224.3,342.4z M226,341.2
            c0.3-0.2,0.8-0.6,1.1-0.8l0,0c-0.2,0.3-0.6,0.8-0.8,1.1l-0.8,1.1l-0.7-0.7L226,341.2z"
              />
              <polygon
                class="st36"
                points="226.4,346.7 230,343 230.7,343.8 231.4,343.2 229.1,341 228.5,341.6 229.3,342.4 225.8,346 	"
              />
              <polygon
                class="st36"
                points="230.4,349.3 229.2,348.2 230.5,346.9 231.6,347.9 232.1,347.3 231.1,346.3 232.2,345.2 233.3,346.2
            233.9,345.6 232.1,343.9 228,348.2 229.8,349.9 	"
              />
              <path
                class="st36"
                d="M235,352.7c0.6-0.6,0.6-1.3,0.3-1.8l0,0c0.6,0.2,1.1,0.1,1.5-0.4c0.5-0.5,0.6-1.3-0.1-1.9
            c-0.3-0.3-0.7-0.5-1-0.5l-0.4,0.6c0.2,0,0.5,0.1,0.7,0.3c0.3,0.3,0.3,0.7,0,1c-0.4,0.4-1,0.2-1.3-0.1l-0.1-0.1l-0.5,0.5l0.1,0.1
            c0.4,0.4,0.6,1,0.1,1.5c-0.4,0.4-0.9,0.5-1.3,0c-0.2-0.2-0.4-0.5-0.4-0.7l-0.6,0.4c0.1,0.3,0.3,0.6,0.6,0.9
            C233.3,353.4,234.3,353.3,235,352.7"
              />
              <path
                class="st36"
                d="M237.3,353.7l0.2,0.1c0.3,0.3,0.3,0.7-0.1,1.3c-0.4,0.6-0.7,1.1-0.8,1.2l0.7,0.7c0.1-0.2,0.4-0.8,0.8-1.4
            c0.4-0.6,0.5-1,0.3-1.4l0,0c0.6,0.2,1.2,0.1,1.7-0.4c0.3-0.4,0.5-0.7,0.5-1.2s-0.3-0.9-0.8-1.3c-0.3-0.3-0.6-0.5-0.9-0.7l-4.1,4.2
            l0.7,0.6L237.3,353.7z M239.2,351.8c0.1,0,0.2,0.1,0.3,0.2c0.4,0.4,0.3,0.9-0.1,1.3c-0.4,0.4-1,0.5-1.4,0.1l-0.2-0.2L239.2,351.8z"
              />
              <path
                class="st36"
                d="M240.2,359.3c0.6,0,1.4-0.4,2.3-1.3c0.8-0.9,1.2-1.6,1.1-2.3c0-0.5-0.3-0.9-0.8-1.4c-0.3-0.3-0.6-0.5-0.8-0.7
            l-4.1,4.2c0.1,0.2,0.3,0.4,0.6,0.6C239.1,359,239.7,359.3,240.2,359.3 M242.3,354.8c0.1,0,0.1,0.1,0.2,0.2c0.6,0.6,0.3,1.4-0.6,2.4
            c-1.3,1.3-2.1,1.3-2.5,0.8c0,0-0.1-0.1-0.2-0.2L242.3,354.8z"
              />
              <path
                class="st36"
                d="M244.9,363.9c0.4,0,0.8-0.2,1.1-0.5c0.5-0.5,0.6-1.2,0.3-1.8l0,0c0.6,0.2,1.1,0.1,1.5-0.3
            c0.3-0.3,0.5-0.7,0.4-1.1c0-0.5-0.3-0.9-0.7-1.3c-0.3-0.3-0.6-0.6-0.9-0.7l-4.1,4.2c0.1,0.2,0.3,0.4,0.7,0.7
            C243.9,363.7,244.4,363.9,244.9,363.9 M246.9,359.3c0.1,0,0.2,0.1,0.3,0.2c0.4,0.4,0.3,0.8,0,1.2c-0.4,0.4-0.9,0.4-1.3,0.1
            l-0.2-0.2L246.9,359.3z M245.2,361l0.2,0.2c0.4,0.4,0.5,1,0,1.5s-1,0.4-1.4,0c-0.1-0.1-0.2-0.2-0.2-0.2L245.2,361z"
              />
              <path
                class="st36"
                d="M247.4,364.9l0.8,0.8l-0.8,1.3l0.7,0.6l3.3-5.1l-0.8-0.8l-5.1,3.3l0.7,0.6L247.4,364.9z M249.2,363.7
            c0.3-0.2,0.8-0.6,1.1-0.8l0,0c-0.2,0.3-0.6,0.8-0.8,1.1l-0.8,1.1l-0.7-0.7L249.2,363.7z"
              />
              <path
                class="st36"
                d="M252,369.1c0.4-0.5,0.6-1.1,0.4-1.9c-0.2-0.7-0.2-1,0.1-1.3s0.7-0.3,1.1,0c0.2,0.2,0.3,0.5,0.4,0.7l0.7-0.5
            c0-0.2-0.2-0.5-0.5-0.8c-0.8-0.8-1.8-0.7-2.4,0c-0.5,0.5-0.5,1.2-0.4,2c0.1,0.6,0.1,1-0.2,1.3c-0.3,0.4-0.8,0.4-1.2,0
            c-0.2-0.2-0.4-0.6-0.5-0.8l-0.7,0.5c0,0.2,0.3,0.6,0.6,0.9C250.2,369.8,251.2,369.8,252,369.1"
              />
              <polygon
                class="st36"
                points="254,372.3 252.9,371.2 254.2,369.8 255.2,370.8 255.7,370.2 254.7,369.3 255.9,368.1 256.9,369.1
            257.5,368.6 255.8,366.9 251.6,371.1 253.4,372.9 	"
              />
              <polygon
                class="st36"
                points="261.2,372.7 259.3,378.6 265.2,376.7 	"
              />
              <path
                class="st36"
                d="M492.2,361.4c0.3-0.3,0.8-0.3,1.1,0.1c0.6,0.6,0.8,1.7,1,2.9l0.1,0.8l0.4,0.4l2-2l-0.6-0.6l-1.2,1.3l0,0
            l-0.1-0.6c-0.1-1-0.3-2.2-1.1-2.9c-0.6-0.6-1.4-0.8-2.2,0c-0.4,0.4-0.5,0.8-0.6,1.1l0.6,0.4C491.9,362,491.9,361.7,492.2,361.4"
              />
              <path
                class="st36"
                d="M498.7,361.8L498.7,361.8c0.6-0.6,0.5-1.7-1-3.1c-1.1-1.1-2.3-1.7-3.1-0.9c-0.7,0.7-0.3,1.9,1,3.1
            C496.8,362,498,362.5,498.7,361.8 M495.2,358.3c0.3-0.3,1,0.1,1.9,1s1.4,1.6,1.1,1.9l0,0c-0.3,0.3-1-0.1-1.9-1
            C495.3,359.3,494.9,358.6,495.2,358.3"
              />
              <path
                class="st36"
                d="M501.4,359L501.4,359c0.6-0.6,0.5-1.7-1-3.1c-1.1-1.1-2.3-1.7-3.1-0.9c-0.7,0.7-0.3,1.9,1,3.1
            C499.5,359.2,500.7,359.7,501.4,359 M497.9,355.5c0.3-0.3,1,0.1,1.9,1s1.4,1.6,1.1,1.9l0,0c-0.3,0.3-1-0.1-1.9-1
            C498,356.5,497.6,355.8,497.9,355.5"
              />
              <polygon
                class="st36"
                points="506.2,354 505.7,353.5 504.6,354.5 501,351.1 500.4,351.7 504.5,355.7 	"
              />
              <polygon
                class="st36"
                points="508.7,351.4 508.1,350.9 507,352 505.7,350.7 506.7,349.8 506.1,349.2 505.2,350.2 504,349.1
            505.1,348.1 504.5,347.5 502.8,349.2 507,353.2 	"
              />
              <path
                class="st36"
                d="M510.8,349.2l-3.2-5l-0.7,0.7l1.5,2.1c0.4,0.5,0.8,1.2,1.3,1.7l0,0c-0.6-0.4-1.2-0.9-1.7-1.2l-2.2-1.5
            l-0.7,0.7l5,3.1L510.8,349.2z"
              />
              <polygon
                class="st36"
                points="514.2,345.8 513.6,345.3 512.5,346.4 511.2,345.1 512.2,344.1 511.6,343.6 510.7,344.6 509.5,343.5
            510.5,342.4 510,341.9 508.3,343.6 512.5,347.6 	"
              />
              <polygon
                class="st36"
                points="516.7,343.2 516.1,342.7 515.1,343.8 511.5,340.3 510.9,341 515,345 	"
              />
              <polygon
                class="st36"
                points="521.4,334.6 520.9,334.1 519.7,335.4 520.1,335.9 	"
              />
              <path
                class="st36"
                d="M529.9,329.7l-0.9-1.3l0.8-0.8l1.3,0.8l0.6-0.6l-5-3.2l-0.7,0.8l3.2,4.9L529.9,329.7z M527.8,326.8
            c-0.2-0.3-0.5-0.7-0.8-1.1l0,0c0.3,0.2,0.8,0.5,1.1,0.8l1.1,0.8l-0.7,0.7L527.8,326.8z"
              />
              <path
                class="st36"
                d="M533.1,326.4l-1.6-1.6c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.6-0.9,0.5-1.4c0-0.4-0.2-0.8-0.6-1.2
            c-0.4-0.3-0.8-0.5-1.2-0.5c-0.5,0-0.9,0.3-1.3,0.7c-0.3,0.3-0.5,0.6-0.7,0.8l4.1,3.9L533.1,326.4z M531.1,324.2
            c-0.1,0.1-0.1,0.1-0.2,0.1l-1.4-1.4c0-0.1,0.1-0.2,0.2-0.3c0.4-0.4,0.9-0.3,1.3,0.1C531.5,323.2,531.5,323.8,531.1,324.2"
              />
              <path
                class="st36"
                d="M536,323.5l-1.6-1.6c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.6-0.9,0.5-1.4c0-0.4-0.2-0.8-0.6-1.2
            c-0.4-0.3-0.8-0.5-1.2-0.5c-0.5,0-0.9,0.3-1.3,0.7c-0.3,0.3-0.5,0.6-0.7,0.8l4.1,3.9L536,323.5z M534,321.3
            c-0.1,0.1-0.1,0.1-0.2,0.1l-1.4-1.4c0-0.1,0.1-0.2,0.2-0.3c0.4-0.4,0.9-0.3,1.3,0.1C534.3,320.3,534.4,320.8,534,321.3"
              />
              <path
                class="st36"
                d="M538.8,320.6l-1.7-1.7l0.1-0.1c0.3-0.3,0.6-0.3,1.3,0.1c0.5,0.4,1,0.7,1.2,0.8l0.7-0.7
            c-0.2-0.1-0.7-0.4-1.3-0.8s-1-0.5-1.4-0.3l0,0c0.2-0.6,0.1-1.2-0.4-1.7c-0.3-0.3-0.7-0.5-1.1-0.5c-0.5,0-0.9,0.3-1.3,0.7
            c-0.3,0.3-0.5,0.6-0.7,0.9l4.1,3.9L538.8,320.6z M536.8,318.2l-0.2,0.2l-1.4-1.4c0-0.1,0.1-0.2,0.2-0.2c0.4-0.4,0.9-0.3,1.3,0.1
            C537.1,317.3,537.2,317.9,536.8,318.2"
              />
              <path
                class="st36"
                d="M542.2,317.2L542.2,317.2c0.7-0.7,0.6-1.9-0.9-3.4c-1.1-1.1-2.4-1.7-3.2-0.8c-0.8,0.8-0.4,2.1,0.8,3.3
            C540.1,317.6,541.4,318,542.2,317.2 M538.6,313.6c0.4-0.4,1.3,0.2,2.1,0.9c0.8,0.8,1.4,1.7,1,2.1l0,0c-0.4,0.4-1.3-0.1-2.1-0.9
            C538.8,314.9,538.2,314.1,538.6,313.6"
              />
              <path
                class="st36"
                d="M543.7,315.5l0.6-0.7l-0.6-1.1c-0.2-0.3-0.3-0.6-0.5-0.9l0,0c0.3,0.2,0.6,0.3,1,0.5l1.2,0.5l0.7-0.7l-2.9-1.2
            l-1.3-2.8l-0.6,0.6l0.6,1.1c0.2,0.3,0.3,0.5,0.5,0.8l0,0c-0.3-0.2-0.6-0.3-0.9-0.4l-1.1-0.5l-0.7,0.7l2.8,1.2L543.7,315.5z"
              />
              <polygon
                class="st36"
                points="543.2,307.8 547.4,311.8 546.7,312.5 542.6,308.5 	"
              />
              <path
                class="st36"
                d="M549.2,306.8c-0.5-0.4-1.1-1-1.5-1.4l0,0c0.4,0.5,0.8,1.1,1.1,1.6l1.3,2.1l-0.4,0.4l-2-1.2
            c-0.5-0.3-1.1-0.7-1.7-1.1l0,0c0.5,0.5,1,1,1.4,1.5l1.5,1.6l-0.6,0.6l-3.9-4.3l0.7-0.7l2.1,1.2c0.7,0.4,1.2,0.7,1.7,1.1l0,0
            c-0.4-0.5-0.7-1-1.2-1.7l-1.3-2l0.7-0.7l4.4,3.8l-0.6,0.6L549.2,306.8z"
              />
              <path
                class="st36"
                d="M551.8,305.2l0.9,1.3l-0.6,0.6l-3.2-4.9l0.7-0.8l5,3.2l-0.6,0.6l-1.3-0.8L551.8,305.2z M552,303.9l-1.1-0.8
            c-0.3-0.2-0.8-0.5-1.1-0.8l0,0c0.2,0.3,0.6,0.8,0.8,1.1l0.8,1.1L552,303.9z"
              />
              <polygon
                class="st36"
                points="551.7,300.3 551,301.1 550.4,300.5 552.5,298.4 553.1,298.9 552.4,299.7 555.9,303.1 555.2,303.8
            "
              />
              <polygon
                class="st36"
                points="557,298.2 556.1,299.1 557.4,300.4 558.5,299.3 559.1,299.8 557.3,301.6 553.2,297.6 554.9,295.9
            555.4,296.5 554.4,297.5 555.5,298.6 556.5,297.6 	"
              />
              <polygon
                class="st36"
                points="558.5,293.7 558.5,293.8 558.2,294.8 557.6,294.4 557.9,293.1 558.5,292.5 562.5,296.4 561.8,297
            "
              />
              <path
                class="st36"
                d="M563,294.4c0.2-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.8,0-1.2c-0.3-0.3-0.7-0.3-1.3-0.2
            c-0.7,0.2-1.5,0.1-1.9-0.3c-0.6-0.6-0.7-1.5,0-2.3c0.3-0.3,0.6-0.4,0.7-0.5l0.5,0.7c-0.2,0-0.4,0.2-0.6,0.4c-0.4,0.4-0.3,0.8,0,1
            c0.3,0.3,0.6,0.3,1.3,0.1c0.8-0.2,1.4,0,1.9,0.4c0.7,0.7,0.7,1.7,0,2.4c-0.3,0.3-0.7,0.5-0.9,0.6L563,294.4z"
              />
              <polygon
                class="st36"
                points="563.3,288.5 562.6,289.2 562,288.6 564.1,286.5 564.7,287.1 563.9,287.8 567.5,291.2 566.8,291.9
            "
              />
              <path
                class="st36"
                d="M566.1,284.5c0.2-0.3,0.4-0.6,0.7-0.9c0.4-0.4,0.8-0.7,1.2-0.7s0.7,0.1,1,0.4c0.4,0.4,0.5,0.9,0.3,1.5l0,0
            c0.6-0.3,1.2-0.2,1.7,0.2c0.3,0.3,0.5,0.7,0.5,1.1c0,0.5-0.2,1-0.8,1.6c-0.3,0.3-0.5,0.5-0.7,0.6L566.1,284.5z M568.4,285.5
            l0.2-0.2c0.3-0.3,0.3-0.9-0.1-1.2c-0.3-0.3-0.8-0.4-1.1,0c-0.1,0.1-0.2,0.2-0.2,0.3L568.4,285.5z M570.3,287.4
            c0.1,0,0.1-0.1,0.2-0.2c0.4-0.4,0.4-0.9,0-1.4c-0.5-0.5-1.1-0.4-1.4,0l-0.2,0.2L570.3,287.4z"
              />
              <path
                class="st36"
                d="M572.6,283.8l0.9,1.3l-0.6,0.6l-3.2-4.9l0.7-0.8l5,3.2l-0.6,0.6l-1.4-0.8L572.6,283.8z M572.9,282.6l-1.1-0.7
            c-0.3-0.2-0.8-0.5-1.1-0.8l0,0c0.2,0.3,0.6,0.8,0.8,1.1l0.8,1.1L572.9,282.6z"
              />
              <path
                class="st36"
                d="M575.3,281.8c0.2-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.8,0-1.2c-0.3-0.3-0.7-0.3-1.3-0.2
            c-0.7,0.2-1.5,0.1-1.9-0.3c-0.6-0.6-0.7-1.5,0-2.3c0.3-0.3,0.6-0.4,0.7-0.5l0.5,0.7c-0.2,0-0.4,0.2-0.6,0.4c-0.4,0.4-0.3,0.8,0,1
            c0.3,0.3,0.6,0.3,1.3,0.1c0.9-0.2,1.5,0,1.9,0.4c0.7,0.7,0.7,1.7,0,2.4c-0.3,0.3-0.7,0.5-0.9,0.6L575.3,281.8z"
              />
              <polygon
                class="st36"
                points="578.4,276.3 577.4,277.3 578.7,278.6 579.8,277.5 580.4,278 578.7,279.8 574.5,275.8 576.2,274.1
            576.8,274.6 575.7,275.7 576.9,276.8 577.8,275.8 	"
              />
              <polygon
                class="st36"
                points="487.9,364.6 484,368.5 489.8,370.2 	"
              />
              <path
                class="st29"
                d="M415.5,331.8c0.1-0.2,0.4-0.5,0.6-0.7c0.4-0.4,0.7-0.6,1.1-0.6s0.7,0.1,1,0.4c0.4,0.4,0.5,0.9,0.3,1.4l0,0
            c0.3-0.2,0.7-0.1,1.2,0.3c0.5,0.3,0.9,0.6,1.1,0.7l-0.6,0.6c-0.1-0.1-0.6-0.3-1-0.6c-0.5-0.4-0.8-0.4-1.1-0.1l-0.1,0.1l1.4,1.4
            l-0.5,0.5L415.5,331.8z M417.6,332.8l0.1-0.1c0.3-0.3,0.3-0.8-0.1-1.1c-0.3-0.3-0.7-0.4-1.1-0.1c-0.1,0.1-0.1,0.1-0.2,0.2
            L417.6,332.8z"
              />
              <path
                class="st29"
                d="M421,331.2l0.7,1.1l-0.5,0.5l-2.7-4.2l0.6-0.6l4.2,2.7l-0.5,0.5l-1.1-0.7L421,331.2z M421.2,330.1l-0.9-0.6
            c-0.3-0.2-0.6-0.4-0.9-0.6l0,0c0.2,0.3,0.5,0.6,0.7,0.9l0.6,0.9L421.2,330.1z"
              />
              <path
                class="st29"
                d="M424,330l-1.4-1.4l-2.8-1.3l0.6-0.6l1.1,0.6c0.3,0.1,0.7,0.3,1,0.5l0,0c-0.2-0.3-0.4-0.6-0.6-1l-0.6-1
            l0.6-0.6l1.3,2.8l1.4,1.4L424,330z"
              />
              <path
                class="st29"
                d="M425.1,327.7c0.2-0.1,0.5-0.2,0.7-0.4c0.3-0.3,0.3-0.7,0-1s-0.6-0.3-1.1-0.2c-0.6,0.1-1.2,0.1-1.6-0.3
            c-0.5-0.5-0.6-1.3,0-2c0.2-0.2,0.5-0.4,0.6-0.4l0.4,0.6c-0.2,0-0.4,0.1-0.5,0.3c-0.3,0.3-0.2,0.7,0,0.9c0.3,0.3,0.5,0.2,1.1,0.1
            c0.7-0.2,1.2,0,1.6,0.4c0.6,0.6,0.6,1.4,0,2.1c-0.3,0.3-0.6,0.5-0.8,0.5L425.1,327.7z"
              />
              <path
                class="st29"
                d="M429.5,324.4c0.4-0.4,0.7-0.9,0.6-1.4c0-0.5-0.3-1.2-1-1.9c-0.7-0.7-1.3-0.9-1.9-0.9c-0.4,0-0.8,0.2-1.2,0.6
            c-0.2,0.2-0.4,0.5-0.5,0.7l3.4,3.3C429.1,324.8,429.3,324.6,429.5,324.4 M426.6,321.2c0.5-0.5,1.1-0.3,1.9,0.5c1.1,1,1,1.7,0.7,2.1
            l-0.1,0.1l-2.6-2.5C426.5,321.3,426.5,321.3,426.6,321.2"
              />
              <path
                class="st29"
                d="M432.5,321.3c0.6-0.6,0.5-1.4-0.4-2.2l-2.2-2.1l-0.5,0.6l2.3,2.2c0.6,0.6,0.6,0.9,0.3,1.1
            c-0.2,0.2-0.6,0.2-1.1-0.3l-2.3-2.2l-0.5,0.6l2.2,2.2C431.2,321.8,431.9,322,432.5,321.3"
              />
              <path
                class="st29"
                d="M434.2,318.9c0.5,0,0.9-0.2,1.2-0.5c0.2-0.2,0.5-0.6,0.5-0.8l-1.8-1.8l-0.9,0.9l0.5,0.4l0.4-0.4l1,1
            c0,0-0.1,0.1-0.2,0.2c-0.4,0.4-1,0.4-2-0.5c-1-1-0.9-1.7-0.5-2.1c0.2-0.2,0.3-0.3,0.5-0.3l-0.4-0.6c-0.2,0-0.4,0.2-0.6,0.4
            c-0.7,0.7-0.9,1.9,0.4,3.2C433,318.6,433.7,318.9,434.2,318.9"
              />
              <path
                class="st29"
                d="M437.7,316L437.7,316c0.6-0.6,0.5-1.6-0.8-2.9c-0.9-0.9-2-1.4-2.7-0.7c-0.7,0.7-0.3,1.8,0.7,2.8
            C435.9,316.4,437,316.7,437.7,316 M434.6,313c0.4-0.4,1.1,0.2,1.7,0.8c0.7,0.7,1.2,1.4,0.9,1.8l0,0c-0.4,0.4-1.1-0.1-1.8-0.8
            C434.8,314.1,434.3,313.4,434.6,313"
              />
              <path
                class="st29"
                d="M436.4,310.3l2.3,2.2c0.6,0.5,0.9,0.5,1.1,0.3s0.2-0.6-0.4-1.1l-2.3-2.2l0.5-0.6l2.2,2.1
            c0.9,0.9,1,1.6,0.4,2.2s-1.4,0.5-2.2-0.3l-2.2-2.2L436.4,310.3z"
              />
              <polygon
                class="st29"
                points="439.5,308.2 438.9,308.8 438.3,308.3 440.1,306.5 440.6,307 440,307.6 443,310.5 442.4,311.1 	"
              />
              <path
                class="st29"
                d="M470.8,225.1c0.2-0.3,0.4-0.6,0.7-0.9c0.4-0.4,0.8-0.7,1.2-0.7c0.4,0,0.7,0.1,1,0.4c0.4,0.4,0.5,0.9,0.3,1.5
            l0,0c0.6-0.3,1.2-0.2,1.7,0.2c0.3,0.3,0.5,0.7,0.5,1.1c0,0.5-0.2,1-0.8,1.6c-0.3,0.3-0.5,0.5-0.7,0.6L470.8,225.1z M473.1,226.1
            l0.2-0.2c0.3-0.3,0.3-0.9-0.1-1.2c-0.3-0.3-0.7-0.4-1.1,0c-0.1,0.1-0.2,0.2-0.2,0.3L473.1,226.1z M474.9,227.9
            c0.1,0,0.1-0.1,0.2-0.2c0.4-0.4,0.4-0.9,0-1.4c-0.5-0.5-1-0.4-1.4,0l-0.2,0.2L474.9,227.9z"
              />
              <path
                class="st29"
                d="M474.3,221.4l2.7,2.6c0.7,0.6,1.1,0.6,1.3,0.4c0.3-0.3,0.2-0.7-0.4-1.3l-2.7-2.6l0.6-0.6l2.6,2.5
            c1.1,1,1.1,1.9,0.5,2.6c-0.7,0.7-1.6,0.6-2.6-0.4l-2.6-2.5L474.3,221.4z"
              />
              <polygon
                class="st29"
                points="476.8,218.9 477.4,218.2 481,221.6 482,220.6 482.6,221.1 480.9,222.8 	"
              />
              <polygon
                class="st29"
                points="479.3,216.4 479.9,215.7 483.4,219.1 484.5,218.1 485,218.6 483.3,220.3 	"
              />
              <path
                class="st29"
                d="M481.7,213.9c0.2-0.3,0.4-0.5,0.7-0.8c0.4-0.4,0.8-0.7,1.3-0.7c0.4,0,0.8,0.2,1.2,0.5
            c0.4,0.4,0.6,0.8,0.6,1.2c0.1,0.5-0.2,1-0.5,1.4c-0.1,0.1-0.1,0.1-0.2,0.2l1.6,1.5l-0.6,0.6L481.7,213.9z M484.3,215.1
            c0.1,0,0.1-0.1,0.2-0.1c0.4-0.4,0.4-0.9-0.1-1.4c-0.4-0.4-0.8-0.5-1.3-0.1c-0.1,0.1-0.2,0.2-0.2,0.3L484.3,215.1z"
              />
              <polygon
                class="st29"
                points="488.3,211.5 487.3,212.5 488.6,213.8 489.7,212.7 490.3,213.2 488.6,214.9 484.5,211 486.1,209.3
            486.7,209.9 485.7,210.9 486.8,212 487.7,211 	"
              />
              <path
                class="st29"
                d="M491.1,212.4l-4.1-3.9l0.6-0.6l2.4,1c0.5,0.2,1.2,0.5,1.7,0.8l0,0c-0.6-0.5-1.2-1-1.9-1.7l-1.2-1.1l0.6-0.6
            l4.1,3.9l-0.6,0.6l-2.4-1c-0.5-0.2-1.2-0.5-1.7-0.8l0,0c0.5,0.4,1.1,1,1.9,1.8l1.1,1.1L491.1,212.4z"
              />
              <path
                class="st29"
                d="M240.7,207.2c0.3,0.2,0.6,0.4,0.9,0.7c0.4,0.4,0.7,0.8,0.7,1.2s-0.1,0.7-0.4,1c-0.4,0.4-0.9,0.5-1.5,0.3l0,0
            c0.3,0.6,0.2,1.2-0.2,1.7c-0.3,0.3-0.7,0.5-1.1,0.5c-0.5,0-1-0.2-1.6-0.8c-0.3-0.3-0.5-0.5-0.6-0.7L240.7,207.2z M237.9,211.3
            c0,0.1,0.1,0.1,0.2,0.2c0.4,0.4,0.9,0.4,1.4,0c0.5-0.5,0.4-1,0-1.4l-0.2-0.2L237.9,211.3z M239.7,209.4l0.2,0.2
            c0.3,0.3,0.9,0.3,1.2-0.1c0.3-0.3,0.4-0.7,0-1.1c-0.1-0.1-0.2-0.2-0.3-0.2L239.7,209.4z"
              />
              <path
                class="st29"
                d="M244.4,210.7l-2.6,2.7c-0.6,0.7-0.6,1.1-0.4,1.3c0.3,0.3,0.7,0.3,1.3-0.4l2.6-2.7l0.6,0.6l-2.5,2.6
            c-1,1-1.9,1.1-2.6,0.5c-0.7-0.7-0.6-1.6,0.4-2.6l2.5-2.6L244.4,210.7z"
              />
              <polygon
                class="st29"
                points="247,213.2 247.6,213.8 244.2,217.3 245.3,218.3 244.7,218.9 243,217.2 	"
              />
              <polygon
                class="st29"
                points="249.5,215.6 250.1,216.2 246.7,219.7 247.8,220.8 247.2,221.3 245.5,219.6 	"
              />
              <path
                class="st29"
                d="M251.9,218.1c0.3,0.2,0.5,0.4,0.8,0.7c0.4,0.4,0.7,0.8,0.7,1.3c0,0.4-0.2,0.8-0.5,1.2
            c-0.4,0.4-0.8,0.6-1.2,0.6c-0.5,0-1-0.2-1.4-0.5c-0.1-0.1-0.1-0.1-0.2-0.2l-1.5,1.6l-0.6-0.6L251.9,218.1z M250.7,220.6
            c0,0.1,0.1,0.1,0.1,0.2c0.4,0.4,0.9,0.4,1.4-0.1c0.4-0.4,0.5-0.8,0.1-1.3c-0.1-0.1-0.2-0.2-0.3-0.2L250.7,220.6z"
              />
              <polygon
                class="st29"
                points="254.3,224.6 253.3,223.6 252.1,224.9 253.2,226 252.6,226.6 250.9,224.9 254.8,220.8 256.5,222.4
            256,223 254.9,222 253.9,223.1 254.8,224 	"
              />
              <path
                class="st29"
                d="M253.5,227.4l4-4.1l0.6,0.6l-1,2.4c-0.2,0.5-0.5,1.2-0.8,1.7l0,0c0.5-0.6,1-1.2,1.7-1.9l1.1-1.1l0.6,0.6
            l-4,4.1l-0.6-0.6l1-2.4c0.2-0.5,0.5-1.2,0.8-1.7l0,0c-0.4,0.5-1,1.1-1.8,1.9L254,228L253.5,227.4z"
              />

              <rect
                x="506.1"
                y="270"
                transform="matrix(0.6966 -0.7175 0.7175 0.6966 -68.4155 457.6764)"
                class="st3"
                width="1.6"
                height="79.4"
              />
              <polygon
                class="st3"
                points="512.1,333.9 455.2,278.6 454.1,279.7 511,335 	"
              />

              <rect
                x="467.6"
                y="300.5"
                transform="matrix(0.6965 -0.7176 0.7176 0.6965 -96.5365 437.0902)"
                class="st3"
                width="1.6"
                height="64.3"
              />
              <polygon
                class="st3"
                points="501,345.5 502.1,344.3 450.3,294 449.2,295.1 	"
              />
              <polygon
                class="st3"
                points="482,364.7 435.9,320 434.8,321.2 480.9,365.9 	"
              />

              <rect
                x="447.5"
                y="321"
                transform="matrix(0.6965 -0.7175 0.7175 0.6965 -117.3101 428.8009)"
                class="st3"
                width="1.6"
                height="64.2"
              />
              <polygon
                class="st3"
                points="462.1,384.9 410.4,334.7 409.3,335.8 461,386 	"
              />
              <path
                class="st37"
                d="M174.9,45.3c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C168.6,42.9,172.5,42.9,174.9,45.3"
              />
              <path
                class="st29"
                d="M170.6,56c-1.6,0-3.2-0.6-4.4-1.8s-1.9-2.8-1.9-4.4c0-1.7,0.6-3.3,1.8-4.5c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C173.9,55.4,172.3,56,170.6,56 M170.6,43.7c-1.6,0-3.1,0.6-4.3,1.8c-1.1,1.1-1.7,2.7-1.7,4.3
            s0.7,3.1,1.8,4.2c2.4,2.3,6.2,2.3,8.5-0.1c2.3-2.4,2.3-6.2-0.1-8.5l0,0C173.7,44.2,172.1,43.7,170.6,43.7"
              />
              <path
                class="st38"
                d="M174.9,45.3c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C168.6,42.9,172.5,42.9,174.9,45.3z"
              />
              <path
                class="st39"
                d="M170.4,51.3L170.4,51.3l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L170.4,51.3z"
              />
              <path
                class="st39"
                d="M167.6,47c0.4,0.4,0.4,0.9,0,1.3c-0.4,0.4-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3
            C166.6,46.6,167.2,46.6,167.6,47"
              />
              <path
                class="st39"
                d="M173.8,50.3l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C174.3,51.4,174.2,50.8,173.8,50.3C173.9,50.3,173.9,50.2,173.8,50.3
            "
              />
              <path
                class="st37"
                d="M222.9,5.2c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C216.5,2.8,220.4,2.8,222.9,5.2"
              />
              <path
                class="st29"
                d="M218.6,15.9c-1.6,0-3.2-0.6-4.4-1.8s-1.9-2.8-1.9-4.4c0-1.7,0.6-3.3,1.8-4.5c2.4-2.5,6.5-2.6,9-0.1
            c2.5,2.4,2.6,6.4,0.1,8.9C221.9,15.2,220.2,15.9,218.6,15.9 M218.6,3.6c-1.6,0-3.1,0.6-4.3,1.8c-1.1,1.1-1.7,2.7-1.7,4.3
            s0.7,3.1,1.8,4.2c2.4,2.3,6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5C221.6,4.1,220.1,3.6,218.6,3.6"
              />
              <path
                class="st38"
                d="M222.9,5.2c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C216.5,2.8,220.4,2.8,222.9,5.2z"
              />
              <path
                class="st39"
                d="M218.3,11.1h0.1l1.8-1.9h0.1l2.8,1h0.1l0.6-1.4V8.7l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9h-0.1
            l-1.8,1.8h-0.1l-0.3-0.2V10l1.3-1.3V8.6l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L218.3,11.1z"
              />
              <path
                class="st39"
                d="M215.5,6.9c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3C214.6,6.5,215.1,6.5,215.5,6.9"
              />
              <path
                class="st39"
                d="M221.8,10.1l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C222.2,11.3,222.1,10.7,221.8,10.1C221.9,10.2,221.9,10.1,221.8,10.1
            "
              />
              <path
                class="st37"
                d="M112.1,160.1c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C105.7,157.7,109.6,157.7,112.1,160.1"
              />
              <path
                class="st29"
                d="M107.8,170.8c-1.7,0-3.2-0.6-4.4-1.8c-1.2-1.2-1.9-2.8-1.9-4.4c0-1.7,0.6-3.3,1.8-4.5
            c1.2-1.2,2.8-1.9,4.5-1.9h0.1c1.7,0,3.2,0.6,4.4,1.8c1.2,1.2,1.9,2.8,1.9,4.4c0,1.7-0.6,3.3-1.8,4.5
            C111.1,170.1,109.6,170.8,107.8,170.8L107.8,170.8 M107.8,158.5C107.7,158.5,107.7,158.5,107.8,158.5c-1.7,0-3.2,0.7-4.3,1.8
            s-1.7,2.7-1.7,4.3s0.7,3.1,1.8,4.2c1.1,1.1,2.6,1.7,4.2,1.7h0.1c1.6,0,3.1-0.7,4.2-1.8s1.7-2.7,1.7-4.3s-0.7-3.1-1.8-4.2
            C110.8,159.1,109.4,158.5,107.8,158.5"
              />
              <path
                class="st38"
                d="M112.1,160.1c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C105.7,157.7,109.6,157.7,112.1,160.1z"
              />
              <path
                class="st39"
                d="M107.5,166.1L107.5,166.1l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9h-0.1l-1.8,1.8h-0.1l-0.3-0.2V165l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L107.5,166.1z"
              />
              <path
                class="st39"
                d="M104.7,161.8c0.4,0.4,0.4,0.9,0,1.3c-0.4,0.4-0.9,0.4-1.3,0s-0.4-0.9,0-1.3S104.4,161.4,104.7,161.8"
              />
              <path
                class="st39"
                d="M111,165l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1v-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C111.4,166.1,111.3,165.6,111,165C111.1,165.1,111.1,165,111,165"
              />
              <path
                class="st37"
                d="M135.1,100c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C128.7,97.7,132.7,97.6,135.1,100"
              />
              <path
                class="st29"
                d="M130.8,110.7c-1.6,0-3.2-0.6-4.4-1.8c-1.2-1.2-1.9-2.8-1.9-4.4c0-1.7,0.6-3.3,1.8-4.5c2.4-2.5,6.5-2.5,9-0.1
            l0,0c2.5,2.4,2.6,6.4,0.1,8.9C134.1,110.1,132.4,110.7,130.8,110.7 M130.8,98.4c-1.6,0-3.1,0.6-4.3,1.8c-1.1,1.1-1.7,2.7-1.7,4.3
            c0,1.6,0.7,3.1,1.8,4.2c2.4,2.3,6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5C133.8,99,132.3,98.4,130.8,98.4"
              />
              <path
                class="st38"
                d="M135.1,100c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C128.7,97.7,132.7,97.6,135.1,100z"
              />
              <path
                class="st39"
                d="M130.6,106L130.6,106l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.2c0,0-0.1,0-0.1,0.1l-0.3,0.8
            c0,0-0.1,0.1-0.1,0l-2.5-0.9h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4H131l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3
            v0.1L130.6,106z"
              />
              <path
                class="st39"
                d="M127.7,101.7c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0s-0.4-0.9,0-1.3C126.8,101.4,127.4,101.4,127.7,101.7"
              />
              <path
                class="st39"
                d="M134,105l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-1,0.7-1.6,0.7
            s-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1v-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9c0.6,0.5,1.2,0.8,2,0.8
            s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C134.4,106.1,134.3,105.6,134,105C134.1,105,134.1,105,134,105"
              />
              <path
                class="st36"
                d="M208.3,57.5c0.2,0,0.4-0.1,0.6-0.3c0.3-0.3,0.3-0.7,0-1c-0.4-0.4-0.8-0.4-1.2-0.1l-0.1,0.1l-0.4-0.4l0.1-0.1
            c0.2-0.2,0.4-0.6,0.1-1c-0.3-0.3-0.6-0.3-0.8-0.1c-0.2,0.1-0.2,0.3-0.3,0.5l-0.5-0.3c0-0.2,0.2-0.5,0.4-0.7
            c0.5-0.5,1.1-0.3,1.5,0.1c0.3,0.3,0.4,0.8,0.2,1.2l0,0c0.4-0.2,0.9-0.1,1.3,0.4c0.5,0.5,0.5,1.3-0.1,1.9c-0.2,0.2-0.5,0.3-0.7,0.4
            L208.3,57.5z"
              />
              <path
                class="st36"
                d="M212.1,55.2c-0.6,0.5-1.5,0-2.4-1c-0.9-1.1-1.2-2-0.6-2.5c0.6-0.6,1.6,0.1,2.4,1
            C212.5,53.9,212.6,54.8,212.1,55.2L212.1,55.2z M211.7,54.7c0.2-0.2-0.1-0.8-0.8-1.6s-1.2-1.2-1.4-1c-0.3,0.2,0,0.8,0.7,1.6
            C210.9,54.6,211.5,55,211.7,54.7L211.7,54.7z"
              />
              <path
                class="st36"
                d="M214.8,53c-0.6,0.5-1.5,0-2.4-1c-0.9-1.1-1.2-2-0.6-2.6c0.7-0.5,1.5,0.1,2.3,1
            C215.2,51.8,215.3,52.6,214.8,53L214.8,53z M214.4,52.5c0.2-0.2-0.1-0.8-0.7-1.6c-0.7-0.8-1.2-1.2-1.4-1c-0.3,0.2,0,0.8,0.7,1.6
            C213.6,52.4,214.1,52.8,214.4,52.5L214.4,52.5z"
              />
              <polygon
                class="st36"
                points="214.7,46.9 215.3,46.5 217.8,49.6 218.7,48.9 219.1,49.4 217.7,50.6 	"
              />
              <polygon
                class="st36"
                points="220.1,45.9 219.2,46.6 220.2,47.7 221.1,47 221.5,47.5 220,48.7 217.1,45 218.6,43.9 219,44.4
            218.1,45.1 218.9,46.1 219.7,45.4 	"
              />
              <path
                class="st36"
                d="M223.1,46.3l-3.6-3.2l0.6-0.5l1.6,1.5c0.4,0.4,0.8,0.8,1.2,1.2l0,0c-0.3-0.5-0.6-1-0.8-1.5l-1-1.9l0.6-0.5
            l2,4.3L223.1,46.3z"
              />
              <polygon
                class="st36"
                points="225.7,41.7 224.8,42.4 225.7,43.6 226.7,42.9 227,43.4 225.5,44.5 222.8,40.7 224.2,39.6 224.6,40.2
            223.7,40.8 224.5,41.9 225.3,41.2 	"
              />
              <polygon
                class="st36"
                points="225.4,38.7 226,38.3 228.3,41.7 229.3,41 229.6,41.5 228.1,42.6 	"
              />
              <line class="st40" x1="461.1" y1="386.2" x2="462.2" y2="385" />
              <polygon
                class="st29"
                points="516.6,308.1 516.6,308.1 515.5,307.7 516.1,306.7 517.7,307.2 518.6,308.1 514.3,312.5 513.3,311.5
            "
              />
              <path
                class="st29"
                d="M519,315.3l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L519,315.3z"
              />
              <path
                class="st29"
                d="M520.4,318.4l0.9,0.9l1-1l0.4,0.4l0.8-0.8l-0.4-0.4l2.5-2.6l-1-1l-4.1,1.3l-0.7,0.7l1.5,1.5L520.4,318.4z
            M521.5,315.9l1.2-0.4c0.3-0.1,0.6-0.2,0.9-0.3l0,0c-0.2,0.2-0.5,0.4-0.7,0.6l-0.7,0.8L521.5,315.9L521.5,315.9z"
              />
              <polygon
                class="st29"
                points="504.8,322.6 509.1,318.2 508.2,317.3 506.6,316.8 506,317.8 507.1,318.2 507.1,318.2 503.8,321.6
            "
              />
              <path
                class="st29"
                d="M509.5,325.4l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L509.5,325.4z"
              />
              <path
                class="st29"
                d="M512.9,328.7l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L512.9,328.7z"
              />
              <polygon
                class="st29"
                points="494.9,333.3 499.2,328.9 498.3,328 496.7,327.5 496.1,328.5 497.2,328.9 497.2,328.9 493.9,332.3
            "
              />
              <path
                class="st29"
                d="M499.6,336.1l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L499.6,336.1z"
              />
              <path
                class="st29"
                d="M500.8,339.2c0.7,0.7,2,0.6,3.6-1c0.9-0.9,2-2.4,0.8-3.5c-1-1-2.5-0.2-3.6,0.9
            C500.7,336.7,499.8,338.2,500.8,339.2L500.8,339.2z M502.7,336.7c1-1,1.4-1.2,1.7-1c0.2,0.2-0.2,0.7-1.1,1.6c-1,1-1.4,1.3-1.6,1.1
            l0,0C501.5,338.1,501.7,337.7,502.7,336.7"
              />
              <polygon
                class="st29"
                points="485.3,343.9 489.6,339.5 488.7,338.6 487.2,338.1 486.5,339 487.6,339.4 487.7,339.4 484.3,342.9
            "
              />
              <polygon
                class="st29"
                points="488.7,347.1 493,342.7 492.1,341.8 490.5,341.3 489.9,342.3 491,342.7 491,342.7 487.7,346.1 	"
              />
              <path
                class="st29"
                d="M494,349.7c0.5-0.5,0.6-1.2,0.4-1.8l0,0c0.8,0.2,1.3-0.1,1.5-0.4c0.7-0.7,0.5-1.7-0.1-2.3l0,0
            c-0.7-0.7-1.8-0.9-2.5-0.1c-0.3,0.3-0.5,0.8-0.4,1.5l0,0c-0.6-0.1-1.2,0-1.7,0.5c-0.8,0.8-0.6,1.8,0.2,2.6
            C492,350.4,493.1,350.6,494,349.7 M494.3,346.1c0.2-0.2,0.5-0.4,0.8-0.2l0,0c0.2,0.2,0,0.6-0.2,0.8c-0.2,0.2-0.6,0.4-0.8,0.3
            C493.9,346.7,494,346.3,494.3,346.1 M492.2,348c0.3-0.3,0.7-0.4,1-0.4c0.1,0.3,0.1,0.8-0.3,1.2c-0.3,0.3-0.7,0.5-0.9,0.2l0,0
            C491.7,348.8,491.9,348.4,492.2,348"
              />
              <polygon
                class="st29"
                points="475,354.1 479.3,349.7 478.4,348.8 476.9,348.3 476.2,349.2 477.3,349.6 477.4,349.6 474,353.1 	"
              />
              <polygon
                class="st29"
                points="478.4,357.3 482.7,352.9 481.8,352 480.2,351.5 479.6,352.5 480.7,352.9 480.7,352.9 477.4,356.3
            "
              />
              <path
                class="st29"
                d="M483.9,359.7c0.8-0.8,0.9-1.8,0.3-2.4c-0.3-0.3-0.6-0.4-1-0.3l0,0c0.6-0.4,1.3-0.5,1.9-0.1
            c0.2,0.1,0.3,0.2,0.4,0.3l0.8-0.8c-0.1-0.1-0.3-0.2-0.5-0.4c-0.4-0.3-1-0.5-1.6-0.5c-0.8,0-1.8,0.3-2.8,1.3
            c-1.1,1.1-1.2,2.4-0.4,3.2C482,360.9,483.2,360.4,483.9,359.7 M482.2,358.1c0.2-0.2,0.4-0.4,0.5-0.4c0.2-0.1,0.4-0.1,0.5,0
            c0.3,0.2,0,0.7-0.3,0.9c-0.4,0.4-0.9,0.8-1.1,0.6l0,0C481.5,359,481.8,358.5,482.2,358.1"
              />
              <polygon
                class="st29"
                points="464.9,364 469.2,359.6 468.3,358.7 466.8,358.2 466.1,359.2 467.2,359.6 467.3,359.6 463.9,363 	"
              />
              <polygon
                class="st29"
                points="468.3,367.3 472.6,362.9 471.7,362 470.1,361.5 469.5,362.5 470.6,362.8 470.6,362.9 467.3,366.3
            "
              />
              <path
                class="st29"
                d="M471,369.9l0.9,0.9l1-1l0.4,0.4l0.8-0.8l-0.4-0.4l2.5-2.6l-1-1l-4.1,1.3l-0.7,0.7l1.5,1.5L471,369.9z
            M472.1,367.5l1.2-0.4c0.3-0.1,0.6-0.2,0.9-0.3l0,0c-0.2,0.2-0.5,0.4-0.7,0.6l-0.7,0.7L472.1,367.5L472.1,367.5z"
              />
              <polygon
                class="st29"
                points="455.5,374.8 459.8,370.4 458.8,369.5 457.3,369 456.7,370 457.8,370.3 457.8,370.4 454.4,373.8 	"
              />
              <polygon
                class="st29"
                points="458.8,378 463.1,373.6 462.2,372.7 460.6,372.2 460,373.2 461.1,373.6 461.1,373.6 457.8,377 	"
              />
              <path
                class="st29"
                d="M463.5,380.8l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L463.5,380.8z"
              />
              <polygon
                class="st29"
                points="445.8,384.5 450,380.1 449.1,379.2 447.6,378.7 446.9,379.7 448.1,380 448.1,380.1 444.7,383.5 	"
              />
              <polygon
                class="st29"
                points="449.1,387.8 453.4,383.4 452.5,382.5 450.9,382 450.3,382.9 451.4,383.3 451.4,383.3 448.1,386.7
            "
              />
              <path
                class="st29"
                d="M451.7,390.4c0.7,0.7,2,0.6,3.6-1c0.9-0.9,2-2.4,0.8-3.5c-1-1-2.5-0.2-3.6,0.9
            C451.5,387.8,450.6,389.3,451.7,390.4L451.7,390.4z M453.6,387.8c1-1,1.4-1.2,1.7-1c0.2,0.2-0.2,0.7-1,1.6c-1,1-1.4,1.3-1.6,1.1
            l0,0C452.3,389.3,452.6,388.8,453.6,387.8"
              />
              <polygon class="st36" points="232.1,31.1 238.7,34.8 233,38.6 	" />
              <!-- <polygon class="st36" points="137.7,158 144.7,156 143.4,162.6 	" /> -->
              <path
                class="st29"
                d="M360,340.6L360,340.6L360,340.6L360,340.6z"
              />
              <polygon
                class="st29"
                points="545.2,156.3 545.2,156.3 544.4,157.2 543.7,156.3 544.8,155 545.9,154.5 548.5,160.1 547.2,160.7
            "
              />
              <path
                class="st29"
                d="M549.7,158c0.3,0,0.7,0,0.9-0.2c0.5-0.2,0.7-0.7,0.5-1c-0.3-0.6-0.8-0.5-1.4-0.3l-0.2,0.1l-0.4-1h0.1
            c0.4-0.2,0.9-0.5,0.6-1c-0.2-0.3-0.5-0.4-0.9-0.3c-0.2,0.1-0.5,0.3-0.6,0.5l-0.6-0.9c0.2-0.3,0.6-0.6,1.1-0.8
            c1.1-0.5,1.9-0.1,2.2,0.7c0.3,0.6,0.1,1.2-0.2,1.6l0,0c0.7,0,1.3,0.3,1.6,1c0.4,0.8,0.1,2-1.2,2.6c-0.5,0.2-0.9,0.3-1.3,0.3
            L549.7,158z"
              />
              <path
                class="st29"
                d="M553.6,150.9c0.8-0.4,1.8-0.2,2.2,0.7c0.1,0.3,0.3,0.9-0.2,1.5l0,0c0.6,0,1.2,0.4,1.5,1
            c0.5,1.1-0.1,2.1-1,2.5c-1,0.4-2,0.2-2.5-0.8c-0.3-0.7-0.2-1.3,0.2-1.8l0,0c-0.6-0.1-1-0.5-1.2-0.9
            C552.1,152.3,552.7,151.4,553.6,150.9L553.6,150.9z M553.9,151.8c-0.3,0.1-0.3,0.5-0.1,0.8c0.1,0.3,0.4,0.5,0.8,0.5
            c0.2-0.2,0.1-0.6,0-0.8C554.5,152,554.2,151.7,553.9,151.8L553.9,151.8z M555.7,155.8c0.3-0.2,0.3-0.6,0.1-1
            c-0.2-0.5-0.7-0.7-1-0.7c-0.1,0.3-0.2,0.6,0,1C555.1,155.6,555.4,156,555.7,155.8L555.7,155.8z"
              />
              <polygon
                class="st3"
                points="424.2,18.1 416.4,16.2 407.1,39 423,54.4 449.2,27.6 	"
              />
              <polygon
                class="st29"
                points="294.6,303.7 293,306.2 293,306.2 295.5,304.5 296.1,305.1 292.6,307.3 291.9,306.6 294,303.1 	"
              />
              <polygon
                class="st29"
                points="293.5,308.2 296.3,305.3 296.9,305.9 294.1,308.7 	"
              />
              <path
                class="st29"
                d="M295.9,308.7L295.9,308.7c-0.3,0.4-0.4,0.6-0.1,0.9c0.2,0.2,0.5,0.2,0.7,0c0.3-0.3,0.2-0.5,0-1
            c-0.3-0.7-0.4-1.1,0.1-1.6c0.5-0.6,1.2-0.5,1.7,0s0.7,1.1,0.1,1.6l-0.1,0.1l-0.6-0.5c0.3-0.3,0.3-0.5,0.1-0.7
            c-0.3-0.3-0.5-0.2-0.7,0s-0.2,0.3-0.1,0.7l0.3,0.6c0.2,0.6,0.1,0.9-0.2,1.3c-0.6,0.6-1.2,0.5-1.8-0.1c-0.7-0.6-0.6-1.2-0.1-1.7
            l0.1-0.1L295.9,308.7z"
              />
              <polygon
                class="st29"
                points="296.6,311.2 299.4,308.4 300,308.9 297.2,311.8 	"
              />
              <polygon
                class="st29"
                points="302.1,310.9 301.6,311.4 301,310.8 298.7,313.2 298.1,312.6 300.4,310.3 299.8,309.6 300.3,309.2
            "
              />
              <path
                class="st29"
                d="M303.3,312c0.9,0.8,0.4,1.6-0.5,2.4c-0.8,0.9-1.5,1.4-2.4,0.5c-0.9-0.8-0.4-1.6,0.5-2.4
            C301.7,311.7,302.4,311.2,303.3,312 M300.8,314.5c0.3,0.3,0.7,0.1,1.4-0.7c0.7-0.8,1-1.1,0.6-1.4c-0.3-0.3-0.7-0.1-1.4,0.7
            C300.7,313.9,300.5,314.2,300.8,314.5"
              />
              <path
                class="st29"
                d="M304.6,313.3l1.1,1c0.5,0.5,0.5,1,0,1.5c-0.4,0.4-0.8,0.5-1.2,0.2l0,0c0.3,0.4,0.2,0.7-0.4,1.3
            c-0.3,0.3-0.4,0.5-0.4,0.6l0,0l-0.6-0.6c0-0.1,0.1-0.3,0.2-0.4l0.5-0.6c0.2-0.2,0.2-0.5,0-0.7l-0.3-0.3l-1.2,1.2l-0.6-0.6
            L304.6,313.3z M303.9,315.1l0.2,0.2c0.3,0.3,0.5,0.3,0.8,0s0.2-0.5,0-0.8l-0.3-0.3L303.9,315.1z"
              />
              <path
                class="st29"
                d="M305.3,317.9L305.3,317.9c-0.3,0.3-0.4,0.6-0.1,0.9c0.2,0.2,0.5,0.2,0.7,0c0.3-0.3,0.2-0.5,0-1
            c-0.3-0.7-0.4-1.1,0.1-1.6c0.5-0.6,1.2-0.5,1.7,0s0.7,1.1,0.1,1.6l-0.1,0.1l-0.6-0.5c0.3-0.3,0.3-0.5,0.1-0.7
            c-0.3-0.3-0.5-0.2-0.7,0s-0.2,0.3-0.1,0.7l0.3,0.6c0.2,0.6,0.2,0.9-0.2,1.3c-0.6,0.6-1.2,0.5-1.8-0.1c-0.7-0.6-0.6-1.2-0.1-1.7
            l0.1-0.1L305.3,317.9z"
              />
              <path
                class="st29"
                d="M308.9,318.6c-0.4,0.4-0.8,0.6-1.3,0.3l0.3-0.3c0.2,0.1,0.4,0,0.5-0.1l0.1-0.1l-0.2-0.2l0.6-0.6l0.5,0.5
            L308.9,318.6z"
              />
              <path
                class="st29"
                d="M310.9,319.5l0.9,0.9c0.8,0.8,0.4,1.5-0.4,2.3c-1,1-1.6,1.3-2.4,0.5l-0.9-0.9L310.9,319.5z M309.1,322.4
            l0.3,0.2c0.4,0.4,0.7,0.2,1.5-0.6c0.6-0.6,0.9-1,0.5-1.5l-0.2-0.2L309.1,322.4z"
              />
              <path
                class="st29"
                d="M313.7,322.2l-1.9,2c-0.3,0.3-0.4,0.6-0.1,0.8c0.3,0.3,0.5,0.1,0.8-0.2l1.9-2l0.6,0.6l-1.9,2
            c-0.7,0.7-1.3,0.5-1.8,0s-0.8-1,0-1.8l1.9-2L313.7,322.2z"
              />
              <path
                class="st29"
                d="M315.7,325.8c0.2-0.2,0.4-0.6,0.1-0.8c-0.3-0.3-0.7-0.1-1.4,0.6c-0.7,0.7-1,1.2-0.7,1.5
            c0.1,0.1,0.5,0.2,0.8-0.1l0.3-0.3l-0.4-0.4l0.4-0.4l0.9,0.9l-1.5,1.5l-0.4-0.4l0.3-0.3l0,0c-0.4,0.1-0.6,0-0.9-0.3
            c-0.7-0.7-0.3-1.3,0.6-2.3s1.6-1.2,2.4-0.5c0.6,0.6,0.6,1.2,0,1.8L315.7,325.8z"
              />
              <path
                class="st29"
                d="M318.5,326.7c0.9,0.8,0.4,1.6-0.5,2.4c-0.8,0.9-1.5,1.4-2.4,0.5c-0.9-0.8-0.4-1.6,0.5-2.4
            C316.9,326.4,317.6,325.9,318.5,326.7 M316,329.3c0.3,0.3,0.7,0.1,1.4-0.7c0.7-0.8,1-1.1,0.6-1.4c-0.3-0.3-0.7-0.1-1.4,0.7
            C315.9,328.6,315.7,328.9,316,329.3"
              />
              <path
                class="st29"
                d="M320.3,328.6l-1.9,2c-0.3,0.3-0.4,0.6-0.1,0.8c0.3,0.3,0.5,0.1,0.8-0.2l1.9-2l0.6,0.6l-1.9,2
            c-0.7,0.7-1.3,0.5-1.8,0s-0.8-1,0-1.8l1.9-2L320.3,328.6z"
              />
              <polygon
                class="st29"
                points="323.6,331.8 323.1,332.2 322.5,331.6 320.2,334 319.6,333.4 321.9,331.1 321.3,330.5 321.7,330 	"
              />
              <path
                class="st24"
                d="M370,443.5c-8.6,0-16.3-1.1-22.8-2.6c-20.9-4.8-33.9-14.6-34.5-15l-3.3-2.5l13.9-21.9
            c-5.7-3.5-15.8-9.8-20.1-14.1c-5.5-5.5-137.9-137.6-139.2-139l-0.4-0.4l-0.3-0.5c-0.6-1-14.2-25.5-7.6-61.7
            c6.6-35.8,30.9-63.5,31.9-64.6l0.2-0.2L294.6,15.5h117.7l33,3.1l1.1,0.9c4.1,3.5,101.8,84.9,123,119.9c9.7,16,26,74.3-7.7,120.4
            l-0.4,0.5L428.8,395.9l-9.2,6.3l12.8,20.8l-3.7,2.4C407.2,439.2,386.9,443.5,370,443.5 M321.6,421c4.9,3,14.8,8.2,28.1,11.2
            c24.1,5.5,47.8,1.4,70.6-12.1l-12.6-20.6l15.5-10.6l131.7-134.7c30.4-41.9,15.6-96.2,7.1-110.3C542.5,112.2,452.6,36.3,441.7,27.2
            l-30-2.8H298.3l-104,102.8c-1.5,1.8-23.7,27.9-29.7,60.2c-5.6,30.2,4.5,51.7,6.3,55.2c8.8,8.7,133.4,133.1,138.7,138.5
            c4.2,4.2,17.5,12.3,22.3,15.1l4,2.3L321.6,421z"
              />
              <text
                transform="matrix(0.7092 -0.705 0.7071 0.7071 220.583 98.0226)"
                class="st13 st14 st41"
              >
                W
              </text>
              <text
                transform="matrix(0.7092 -0.705 0.7071 0.7071 223.3101 95.3117)"
                class="st13 st14 st41"
              >
                ALK
              </text>
              <text
                transform="matrix(0.7092 -0.705 0.7071 0.7071 229.0288 89.6276)"
                class="st13 st14 st41"
              >
                W
              </text>
              <text
                transform="matrix(0.7092 -0.705 0.7071 0.7071 231.7556 86.9171)"
                class="st13 st14 st41"
              >
                A
              </text>
              <text
                transform="matrix(0.7092 -0.705 0.7071 0.7071 233.5977 85.0876)"
                class="st13 st14 st41"
              >
                Y
              </text>
              <path
                class="st28"
                d="M364.1,108.8v-0.2l-3.4-6.2l-3.9-7.2l3.2,15.4l0.5,2.1l-0.7-0.5l-32.7-20.8l28.7,29.6l-20.8,8.9l16.1-1.4
            l4.8-0.4C355.7,123.5,356.9,115.5,364.1,108.8"
              />
              <polygon
                class="st28"
                points="405.1,119.2 375.3,114.5 384.3,89.5 366.3,108.3 366.3,108.3 365.7,113 373.1,108 369.7,116.8
            392.9,121.9 369.7,124.3 375.5,133.6 366.5,127.1 362,154.4 358.9,129.2 356.1,132.3 361.6,181.3 369.1,132.8 381.4,142.6
            386.4,146.6 391.7,150.8 388,145.6 384.5,140.8 374.8,127.2 401.8,124.7 409.2,124 418.2,123.2 425.5,122.5 418.8,121.4
            411.2,120.2 	"
              />
              <polygon
                class="st28"
                points="364.7,180.4 364.7,178.4 364,178.4 364,178.1 365.7,178.1 365.7,178.4 365,178.4 365,180.4 	"
              />
              <path
                class="st28"
                d="M366.3,180.4v-2.2h0.5l0.5,1.6c0.1,0.1,0.1,0.3,0.1,0.3c0-0.1,0.1-0.2,0.1-0.4l0.5-1.6h0.4v2.2h-0.3v-1.9
            l-0.7,1.9h-0.3l-0.7-1.9v1.9L366.3,180.4L366.3,180.4z"
              />
              <path
                class="st37"
                d="M197.5,118.9c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C191.2,116.6,195.1,116.5,197.5,118.9"
              />
              <path
                class="st29"
                d="M193.2,129.6c-1.6,0-3.2-0.6-4.4-1.8s-1.9-2.8-1.9-4.4c0-1.7,0.6-3.3,1.8-4.5s2.8-1.9,4.5-1.9h0.1
            c1.7,0,3.2,0.6,4.4,1.8l0,0c2.5,2.4,2.6,6.4,0.1,8.9C196.5,129,194.9,129.6,193.2,129.6 M193.2,117.3L193.2,117.3
            c-1.7,0-3.2,0.7-4.3,1.8c-1.1,1.1-1.7,2.7-1.7,4.3c0,1.6,0.7,3.1,1.8,4.2c2.4,2.3,6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5l0,0
            C196.3,117.9,194.8,117.3,193.2,117.3"
              />
              <path
                class="st39"
                d="M193,124.9L193,124.9l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9
            h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.4H192l-1.6-1.3h-0.1l-0.4,0.3v0.1L193,124.9z"
              />
              <path
                class="st39"
                d="M190.2,120.6c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3
            C189.2,120.3,189.8,120.3,190.2,120.6"
              />
              <path
                class="st39"
                d="M196.4,123.9l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C196.9,125,196.8,124.5,196.4,123.9
            C196.5,123.9,196.5,123.9,196.4,123.9"
              />
              <path
                class="st38"
                d="M197.5,118.9c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C191.2,116.6,195.1,116.5,197.5,118.9z"
              />
              <text
                transform="matrix(0.7177 0.6965 -0.6986 0.7155 490.4352 66.2588)"
                class="st13 st14 st42"
              >
                W
              </text>
              <text
                transform="matrix(0.7177 0.6965 -0.6986 0.7155 493.1992 68.9411)"
                class="st13 st14 st42"
              >
                ALK
              </text>
              <text
                transform="matrix(0.7177 0.6965 -0.6986 0.7155 498.9864 74.5561)"
                class="st13 st14 st42"
              >
                W
              </text>
              <text
                transform="matrix(0.7177 0.6965 -0.6986 0.7155 501.7441 77.2337)"
                class="st13 st14 st42"
              >
                A
              </text>
              <text
                transform="matrix(0.7177 0.6965 -0.6986 0.7155 503.6111 79.0455)"
                class="st13 st14 st42"
              >
                Y
              </text>
              <text
                transform="matrix(0.74 0.673 -0.6751 0.7377 464.1167 24.7196)"
                class="st13 st14 st43"
              >
                R
              </text>
              <text
                transform="matrix(0.74 0.673 -0.6751 0.7377 466.9293 27.2775)"
                class="st13 st14 st43"
              >
                A
              </text>
              <text
                transform="matrix(0.74 0.673 -0.6751 0.7377 469.8138 29.9015)"
                class="st13 st14 st43"
              >
                Y
              </text>
              <text
                transform="matrix(0.74 0.673 -0.6751 0.7377 472.4048 32.2573)"
                class="st13 st14 st43"
              >
                S
              </text>
              <text
                transform="matrix(0.74 0.673 -0.6751 0.7377 475.0689 34.6795)"
                class="st13 st14 st43"
              ></text>
              <text
                transform="matrix(0.74 0.673 -0.6751 0.7377 476.2534 35.7574)"
                class="st13 st14 st43"
              >
                S
              </text>
              <text
                transform="matrix(0.74 0.673 -0.6751 0.7377 478.8431 38.1119)"
                class="st13 st14 st43"
              >
                CORE
              </text>
              <text
                transform="matrix(0.74 0.673 -0.6751 0.7377 489.7212 48.0052)"
                class="st13 st14 st43"
              >
                B
              </text>
              <text
                transform="matrix(0.74 0.673 -0.6751 0.7377 492.5327 50.5628)"
                class="st13 st14 st43"
              >
                OAR
              </text>
              <text
                transform="matrix(0.74 0.673 -0.6751 0.7377 501.0415 58.3006)"
                class="st13 st14 st43"
              >
                D
              </text>
              <polygon
                class="st3"
                points="248.3,104.2 237.4,93.6 243.6,87.2 254.5,97.8 	"
              />
              <polygon
                class="st30"
                points="248.3,104.2 237.4,93.6 243.6,87.2 254.5,97.8 	"
              />
              <polygon
                class="st3"
                points="228.7,124.3 217.8,113.7 224,107.3 234.9,117.9 	"
              />
              <polygon
                class="st30"
                points="228.7,124.3 217.8,113.7 224,107.3 234.9,117.9 	"
              />
              <polygon
                class="st3"
                points="209,144.5 198.1,133.9 204.3,127.5 215.2,138.1 	"
              />
              <polygon
                class="st30"
                points="209,144.5 198.1,133.9 204.3,127.5 215.2,138.1 	"
              />
              <polygon
                class="st3"
                points="268,84.1 257,73.5 263.2,67.2 274.2,77.8 	"
              />
              <polygon
                class="st30"
                points="268,84.1 257,73.5 263.2,67.2 274.2,77.8 	"
              />
              <polygon
                class="st3"
                points="460.7,70.4 471.4,59.6 477.7,65.7 467.1,76.6 	"
              />
              <polygon
                class="st30"
                points="460.7,70.4 471.4,59.6 477.7,65.7 467.1,76.6 	"
              />
              <polygon
                class="st3"
                points="481.1,90.2 491.7,79.3 498.1,85.5 487.4,96.3 	"
              />
              <polygon
                class="st30"
                points="481.1,90.2 491.7,79.3 498.1,85.5 487.4,96.3 	"
              />
              <polygon
                class="st3"
                points="501.3,109.8 511.9,98.9 518.3,105.1 507.7,116 	"
              />
              <polygon
                class="st30"
                points="501.3,109.8 511.9,98.9 518.3,105.1 507.7,116 	"
              />
              <polygon
                class="st3"
                points="521.7,129.6 532.3,118.7 538.7,124.9 528,135.8 	"
              />
              <polygon
                class="st30"
                points="521.7,129.6 532.3,118.7 538.7,124.9 528,135.8 	"
              />
              <polygon
                class="st3"
                points="535.6,147.8 549.5,139.2 554.2,146.8 540.3,155.3 	"
              />
              <polygon
                class="st29"
                points="438.8,45.7 438.8,45.7 438.4,46.8 437.4,46.2 437.9,44.6 438.9,43.7 443.3,48 442.3,49 	"
              />
              <path
                class="st29"
                d="M443.4,40.9l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.8,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.7,0.6-1,0.7l-0.7-0.9c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.5-0.5-1.1-0.2-1.6,0.2
            c-0.1,0.1-0.2,0.2-0.3,0.3l-2.1-2.5l1.9-1.9L443.4,40.9z"
              />
              <path
                class="st29"
                d="M449.2,42.1c-1,1.1-2.6,0.2-3.6-0.8c-1.2-1.1-1.9-2.6-0.9-3.6c1.1-1.2,2.6,0,3.5,0.8
            C449.8,40,449.9,41.3,449.2,42.1L449.2,42.1z M448.3,41.2c0.2-0.2-0.1-0.6-1.1-1.6c-0.9-0.9-1.4-1.3-1.6-1c-0.2,0.2,0,0.7,1,1.7
            C447.6,41.2,448,41.4,448.3,41.2L448.3,41.2z"
              />
              <polygon
                class="st29"
                points="454.7,60.5 454.7,60.5 454.3,61.6 453.3,61 453.8,59.4 454.7,58.5 459.1,62.8 458.1,63.8 	"
              />
              <path
                class="st29"
                d="M461.8,60.1l-1-1l-1.5,1.5l-0.7-0.7l-1.3-4.1l1-1l2.6,2.5l0.4-0.4l0.8,0.8l-0.4,0.4l1,1L461.8,60.1z
            M460,58.3l-0.8-0.7c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.3,0.9l0.4,1.2l0,0L460,58.3z"
              />
              <path
                class="st29"
                d="M460.6,52.4c0.6-0.6,1.6-0.8,2.3-0.1c0.3,0.2,0.6,0.7,0.4,1.5l0,0c0.6-0.2,1.3-0.1,1.8,0.4
            c0.9,0.8,0.7,1.9,0,2.7s-1.8,0.9-2.6,0.2c-0.5-0.5-0.6-1.2-0.5-1.7l0,0c-0.6,0.1-1.1-0.1-1.5-0.4C459.7,54.2,459.8,53.2,460.6,52.4
            L460.6,52.4z M461.2,53.1c-0.2,0.2-0.1,0.6,0.2,0.8c0.2,0.2,0.6,0.3,1,0.2c0.1-0.2-0.1-0.6-0.3-0.8
            C461.8,53.1,461.4,52.9,461.2,53.1L461.2,53.1z M464.3,56.2c0.3-0.3,0.1-0.6-0.2-0.9c-0.4-0.4-0.9-0.4-1.2-0.3c0,0.3,0.1,0.6,0.4,1
            C463.6,56.3,464.1,56.5,464.3,56.2L464.3,56.2z"
              />
              <polygon
                class="st29"
                points="474.6,80.4 474.6,80.4 474.2,81.6 473.3,80.9 473.8,79.4 474.7,78.5 479.1,82.7 478.1,83.8 	"
              />
              <path
                class="st29"
                d="M481.7,80l-1-1l-1.5,1.5l-0.7-0.7l-1.3-4.1l1-1l2.6,2.5l0.4-0.4l0.8,0.8l-0.4,0.4l1,1L481.7,80z M479.9,78.3
            l-0.8-0.7c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.3,0.9l0.4,1.2l0,0L479.9,78.3z"
              />
              <path
                class="st29"
                d="M482.3,72.2c-0.1,0.1-0.2,0.3-0.3,0.4c-0.4,0.6-0.3,1.3,0.1,1.9l0,0c0-0.3,0-0.7,0.3-1
            c0.6-0.6,1.5-0.5,2.4,0.3c0.7,0.7,1.2,1.9,0.3,2.9c-0.8,0.9-2.1,0.7-3.2-0.4c-1-1-1.3-2-1.3-2.8c0-0.6,0.2-1.2,0.5-1.6
            c0.2-0.3,0.3-0.4,0.4-0.5L482.3,72.2z M484.3,76.1c0.3-0.3-0.1-0.7-0.6-1.1c-0.3-0.2-0.7-0.5-0.9-0.3c-0.1,0.1-0.1,0.3,0,0.5
            c0,0.1,0.2,0.2,0.4,0.5C483.5,76,484,76.3,484.3,76.1L484.3,76.1z"
              />
              <polygon
                class="st29"
                points="495.2,100 495.2,100 494.9,101.1 493.9,100.5 494.4,98.9 495.3,98 499.7,102.3 498.7,103.3 	"
              />
              <path
                class="st29"
                d="M502.3,99.6l-1-1l-1.5,1.5l-0.7-0.7l-1.3-4.1l1-1l2.6,2.5l0.4-0.4l0.8,0.8l-0.4,0.4l1,1L502.3,99.6z
            M500.5,97.8l-0.8-0.7c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.3,0.9l0.4,1.2l0,0L500.5,97.8z"
              />
              <path
                class="st29"
                d="M505.6,96.2l-1-1l-1.5,1.5l-0.7-0.7l-1.3-4.1l1-1l2.6,2.5l0.4-0.4l0.8,0.8l-0.4,0.4l1,1L505.6,96.2z
            M503.8,94.5l-0.8-0.7c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.3,0.9l0.4,1.2l0,0L503.8,94.5z"
              />
              <polygon
                class="st29"
                points="515.5,119 515.5,119 515.2,120.1 514.2,119.5 514.7,117.9 515.6,117 520,121.3 519,122.3 	"
              />
              <path
                class="st29"
                d="M522.6,118.6l-1-1l-1.5,1.5l-0.7-0.7l-1.3-4.1l1-1l2.6,2.5l0.4-0.4l0.8,0.8l-0.4,0.4l1,1L522.6,118.6z
            M520.8,116.8l-0.8-0.7c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.3,0.9l0.4,1.2l0,0L520.8,116.8z"
              />
              <path
                class="st29"
                d="M524.5,116.7l-0.7-0.7l-0.1-1c-0.1-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0c-0.2,0.3-0.4,0.6-0.4,0.9
            l-1-0.6c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L524.5,116.7z"
              />
              <polygon
                class="st29"
                points="534,137.8 533.9,137.8 533.6,138.9 532.6,138.3 533.1,136.7 534,135.8 538.4,140.1 537.4,141.1 	"
              />
              <path
                class="st29"
                d="M541.1,137.4l-1-1l-1.5,1.5l-0.7-0.7l-1.3-4.1l1-1l2.6,2.5l0.4-0.4l0.8,0.8l-0.4,0.4l1,1L541.1,137.4z
            M539.2,135.6l-0.8-0.7c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.3,0.9l0.4,1.2l0,0L539.2,135.6z"
              />
              <path
                class="st29"
                d="M544.3,134.2c-1.1,1.1-2.6,0.2-3.6-0.8c-1.2-1.1-1.9-2.6-0.9-3.6c1.1-1.2,2.6,0,3.5,0.8
            C544.9,132.1,545,133.4,544.3,134.2L544.3,134.2z M543.4,133.3c0.2-0.2-0.1-0.6-1.1-1.6c-0.9-0.9-1.4-1.3-1.6-1
            c-0.2,0.2,0,0.7,1,1.7C542.7,133.3,543.2,133.5,543.4,133.3L543.4,133.3z"
              />
              <polygon
                class="st29"
                points="289.5,45.7 289.5,45.7 288.4,45.3 289,44.4 290.6,44.9 291.5,45.8 287.2,50.2 286.2,49.2 	"
              />
              <path
                class="st29"
                d="M289.9,52.8l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L289.9,52.8z
            M291.7,51l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L291.7,51z"
              />
              <path
                class="st29"
                d="M293,54.2c0.2,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.2,0.7,0.2c0.3,0,0.7-0.1,1.1-0.4l0,0
            c-0.3,0-0.5-0.1-0.8-0.3c-0.6-0.6-0.6-1.5,0.2-2.4c0.7-0.7,2-1.1,2.9-0.2c0.8,0.8,0.6,2-0.5,3.1c-1,1-2.1,1.4-2.9,1.4
            c-0.5,0-1.1-0.2-1.6-0.6c-0.2-0.1-0.3-0.3-0.4-0.4L293,54.2z M296.8,52.2c-0.2-0.2-0.6,0-1,0.4c-0.3,0.3-0.6,0.8-0.3,1
            c0.1,0.1,0.3,0.1,0.4,0.1c0.1-0.1,0.2-0.2,0.6-0.5C296.8,52.9,297,52.4,296.8,52.2L296.8,52.2z"
              />
              <polygon
                class="st29"
                points="273.6,60.9 273.6,60.9 272.5,60.5 273.1,59.5 274.7,60 275.6,60.9 271.3,65.3 270.3,64.3 	"
              />
              <path
                class="st29"
                d="M274,68l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L274,68z M275.8,66.2
            l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L275.8,66.2z"
              />
              <polygon
                class="st29"
                points="282.9,68 282.2,68.7 277.2,71.1 276.2,70.1 280.9,67.9 280.9,67.9 279.5,66.5 280.4,65.5 	"
              />
              <polygon
                class="st29"
                points="253.7,81 253.7,81 252.6,80.6 253.2,79.6 254.8,80.1 255.7,81 251.4,85.4 250.4,84.4 	"
              />
              <path
                class="st29"
                d="M254.1,88.1l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L254.1,88.1z
            M255.9,86.2l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L255.9,86.2z"
              />
              <path
                class="st29"
                d="M261.9,88.8l-1.2-1.1l-0.7,0.6l0.1,0.1c0.2,0.2,0.5,0.6,0.5,1.1s-0.2,1-0.6,1.4c-0.8,0.8-2.1,1-3.2,0
            c-0.3-0.3-0.6-0.7-0.7-1l0.9-0.7c0.1,0.3,0.3,0.5,0.5,0.8c0.4,0.4,0.9,0.4,1.3,0c0.5-0.5,0.2-1.1-0.2-1.6c-0.1-0.1-0.2-0.2-0.3-0.3
            l2.5-2.1l1.9,1.9L261.9,88.8z"
              />
              <polygon
                class="st29"
                points="233.7,101.2 233.7,101.2 232.6,100.8 233.2,99.9 234.7,100.4 235.7,101.3 231.4,105.7 230.3,104.7
            "
              />
              <path
                class="st29"
                d="M234.1,108.3l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L234.1,108.3z
            M235.9,106.5l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L235.9,106.5z"
              />
              <path
                class="st29"
                d="M237.1,109.3c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.4,0.9,0.4,1.2,0.1c0.4-0.5,0.2-1-0.2-1.4l-0.1-0.1l0.7-0.8
            l0.1,0.1c0.3,0.3,0.8,0.6,1.2,0.2c0.3-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.4-0.3-0.7-0.4l0.6-0.9c0.3,0.1,0.8,0.3,1.2,0.7
            c0.8,0.8,0.7,1.7,0.2,2.3c-0.4,0.4-1,0.5-1.6,0.4l0,0c0.3,0.6,0.2,1.3-0.3,1.8c-0.6,0.7-1.8,0.8-2.9-0.2c-0.4-0.4-0.6-0.8-0.7-1.1
            L237.1,109.3z"
              />
              <polygon
                class="st29"
                points="214.3,121.1 214.3,121.1 213.1,120.7 213.8,119.7 215.3,120.2 216.3,121.1 212,125.5 210.9,124.5
            "
              />
              <path
                class="st29"
                d="M214.7,128.2l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L214.7,128.2z
            M216.4,126.4l0.7-0.7c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L216.4,126.4z"
              />
              <polygon
                class="st29"
                points="221,127.6 221,127.6 219.9,127.2 220.5,126.2 222,126.7 223,127.6 218.7,132 217.6,131 	"
              />
              <polygon
                class="st29"
                points="194.5,139.3 194.5,139.3 193.4,138.9 194,137.9 195.6,138.4 196.5,139.3 192.2,143.7 191.2,142.7
            "
              />
              <path
                class="st29"
                d="M194.5,144.1c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.4,0.9,0.4,1.2,0.1c0.4-0.5,0.2-1-0.2-1.4l-0.1-0.1l0.7-0.8
            l0.1,0.1c0.3,0.3,0.8,0.6,1.2,0.2c0.3-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.4-0.3-0.7-0.4l0.6-0.9c0.3,0.1,0.8,0.3,1.2,0.7
            c0.8,0.8,0.7,1.7,0.2,2.3c-0.4,0.4-1,0.5-1.6,0.4l0,0c0.3,0.6,0.2,1.3-0.3,1.8c-0.6,0.7-1.8,0.8-2.9-0.2c-0.4-0.4-0.6-0.8-0.7-1.1
            L194.5,144.1z"
              />
              <path
                class="st29"
                d="M198,147.8c0.2,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.2,0.7,0.2s0.7-0.1,1.1-0.4l0,0c-0.3,0-0.5-0.1-0.8-0.3
            c-0.6-0.6-0.6-1.5,0.2-2.4c0.7-0.7,2-1.1,2.9-0.2c0.8,0.8,0.6,2-0.5,3.1c-1,1-2.1,1.4-2.9,1.4c-0.5,0-1.1-0.2-1.6-0.6
            c-0.2-0.1-0.3-0.3-0.4-0.4L198,147.8z M201.8,145.8c-0.2-0.2-0.6,0-1,0.4c-0.3,0.3-0.6,0.8-0.3,1c0.1,0.1,0.3,0.1,0.4,0.1
            c0.1-0.1,0.2-0.2,0.6-0.5C201.8,146.4,202,146,201.8,145.8L201.8,145.8z"
              />
              <polygon
                class="st3"
                points="220.6,148.1 212.7,140.7 211.7,141.9 219.5,149.3 	"
              />
              <polygon
                class="st3"
                points="240.1,127.9 232.1,120.4 231.2,121.7 238.9,129 	"
              />
              <polygon
                class="st3"
                points="259.7,107.6 251.8,100.2 250.8,101.4 258.6,108.8 	"
              />
              <polygon
                class="st3"
                points="279.2,87.6 271.3,80.1 270.4,81.4 278.1,88.7 	"
              />
              <polygon
                class="st3"
                points="299.9,68.2 286,55.2 285.1,56.5 298.8,69.4 	"
              />
              <polygon
                class="st3"
                points="434,62 435.2,63.1 450.9,46.6 449.7,45.4 	"
              />
              <polygon
                class="st3"
                points="454.5,81.8 455.6,82.9 464.1,74.3 462.9,73.1 	"
              />
              <polygon
                class="st3"
                points="474.8,101.5 476,102.6 484.4,94 483.3,92.8 	"
              />
              <polygon
                class="st3"
                points="495.2,121.4 496.3,122.4 504.8,113.8 503.6,112.6 	"
              />
              <polygon
                class="st3"
                points="515.5,141.2 516.6,142.3 525.1,133.5 524,132.3 	"
              />
              <polygon
                class="st3"
                points="207.5,196.3 163.4,196.8 163.2,198.4 207.5,197.9 	"
              />
              <polygon
                class="st3"
                points="205.6,184.4 187.6,177.4 187,178.8 206,186.2 	"
              />
              <path
                class="st28"
                d="M550.2,184.2c-1.6-17.1-12.1-30.3-12.1-30.3l-5,3.1l3.1,15.3l2.1,35.8l8.3,4.4
            C546.5,212.5,552,203.7,550.2,184.2"
              />
              <polygon
                class="st3"
                points="522.5,193.1 573.1,192.4 573,190.6 522.4,191.5 	"
              />
              <polygon
                class="st3"
                points="525.3,178.5 568.4,160.5 567.9,158.9 524.7,177.1 	"
              />
              <path
                class="st38"
                d="M579.3,172c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C573,169.7,576.9,169.6,579.3,172z"
              />
              <path
                class="st37"
                d="M579.3,172c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C573,169.7,576.9,169.6,579.3,172"
              />
              <path
                class="st29"
                d="M575,182.7c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C578.3,182.1,576.7,182.7,575,182.7 M575,170.4c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            c2.4,2.3,6.2,2.3,8.5-0.1c2.3-2.4,2.3-6.2-0.1-8.5l0,0C578,171,576.5,170.4,575,170.4"
              />
              <path
                class="st39"
                d="M574.8,178L574.8,178l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9
            h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L574.8,178z"
              />
              <path
                class="st39"
                d="M572,173.7c0.4,0.4,0.4,0.9,0,1.3c-0.4,0.4-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3
            C571,173.4,571.6,173.4,572,173.7"
              />
              <path
                class="st39"
                d="M578.2,177l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3H573v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C578.6,178.1,578.6,177.5,578.2,177C578.3,177,578.3,177,578.2,177"
              />
              <path
                class="st38"
                d="M555.9,249.3c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C549.5,247,553.4,246.9,555.9,249.3z
            "
              />
              <path
                class="st37"
                d="M555.9,249.3c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C549.5,247,553.4,246.9,555.9,249.3"
              />
              <path
                class="st29"
                d="M551.6,260c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1s2.6,6.4,0.1,8.9
            C554.9,259.4,553.2,260,551.6,260 M551.6,247.7c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5c2.4,2.3,6.2,2.2,8.5-0.1
            c2.3-2.4,2.3-6.2-0.1-8.5C554.6,248.3,553.1,247.7,551.6,247.7"
              />
              <path
                class="st39"
                d="M551.3,255.3L551.3,255.3l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L551.3,255.3z"
              />
              <path
                class="st39"
                d="M548.5,251c0.4,0.4,0.4,0.9,0,1.3c-0.4,0.4-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3
            C547.6,250.7,548.2,250.7,548.5,251"
              />
              <path
                class="st39"
                d="M554.8,254.3l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C555.2,255.4,555.1,254.9,554.8,254.3
            C554.9,254.3,554.9,254.3,554.8,254.3"
              />
              <path
                class="st38"
                d="M493.2,319.4c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C486.8,317.1,490.7,317,493.2,319.4z"
              />
              <path
                class="st37"
                d="M493.2,319.4c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C486.8,317.1,490.7,317,493.2,319.4"
              />
              <path
                class="st29"
                d="M488.9,330.1c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C492.2,329.5,490.5,330.1,488.9,330.1 M488.9,317.8c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            s6.2,2.2,8.5-0.1c2.3-2.4,2.3-6.2-0.1-8.5l0,0C491.9,318.4,490.4,317.8,488.9,317.8"
              />
              <path
                class="st39"
                d="M488.6,325.4h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4V323l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9h-0.1
            l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4H489l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L488.6,325.4z"
              />
              <path
                class="st39"
                d="M485.8,321.1c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0s-0.4-0.9,0-1.3C484.9,320.8,485.4,320.7,485.8,321.1"
              />
              <path
                class="st39"
                d="M492.1,324.4l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C492.5,325.5,492.4,324.9,492.1,324.4
            C492.2,324.4,492.2,324.4,492.1,324.4"
              />
              <path
                class="st38"
                d="M418.6,390.4c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C412.2,388.1,416.2,388,418.6,390.4z"
              />
              <path
                class="st37"
                d="M418.6,390.4c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C412.2,388.1,416.2,388,418.6,390.4"
              />
              <path
                class="st29"
                d="M414.3,401.1c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C417.6,400.5,415.9,401.1,414.3,401.1 M414.3,388.8c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            s6.2,2.2,8.5-0.1c2.3-2.4,2.3-6.2-0.1-8.5l0,0C417.3,389.4,415.8,388.8,414.3,388.8"
              />
              <path
                class="st39"
                d="M414.1,396.4h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4V394l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9h-0.1
            l-1.8,1.8H414l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L414.1,396.4z"
              />
              <path
                class="st39"
                d="M411.2,392.1c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0s-0.4-0.9,0-1.3C410.3,391.8,410.9,391.8,411.2,392.1"
              />
              <path
                class="st39"
                d="M417.5,395.4l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C417.9,396.5,417.9,395.9,417.5,395.4
            C417.6,395.4,417.6,395.4,417.5,395.4"
              />
              <path
                class="st38"
                d="M332.2,390.6c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7S329.8,388.2,332.2,390.6z"
              />
              <path
                class="st37"
                d="M332.2,390.6c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7S329.8,388.2,332.2,390.6"
              />
              <path
                class="st29"
                d="M327.9,401.3c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C331.2,400.7,329.6,401.3,327.9,401.3 M327.9,389c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            s6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5l0,0C330.9,389.6,329.4,389,327.9,389"
              />
              <path
                class="st39"
                d="M327.7,396.6h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9
            h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3H325l-0.4,0.3v0.1L327.7,396.6z"
              />
              <path
                class="st39"
                d="M324.9,392.3c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0s-0.4-0.9,0-1.3C323.9,392,324.5,392,324.9,392.3"
              />
              <path
                class="st39"
                d="M331.1,395.6l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C331.5,396.7,331.5,396.1,331.1,395.6
            C331.2,395.6,331.2,395.6,331.1,395.6"
              />
              <path
                class="st38"
                d="M266.3,331.2c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C259.9,328.9,263.8,328.8,266.3,331.2z"
              />
              <path
                class="st37"
                d="M266.3,331.2c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C259.9,328.9,263.8,328.8,266.3,331.2"
              />
              <path
                class="st29"
                d="M261.9,341.9c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C265.2,341.3,263.6,341.9,261.9,341.9 M261.9,329.6c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            c2.4,2.3,6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5l0,0C265,330.2,263.5,329.6,261.9,329.6"
              />
              <path
                class="st39"
                d="M261.7,337.2h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9
            h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3H259l-0.4,0.3v0.1L261.7,337.2z"
              />
              <path
                class="st39"
                d="M258.9,332.9c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0s-0.4-0.9,0-1.3C257.9,332.6,258.5,332.6,258.9,332.9"
              />
              <path
                class="st39"
                d="M265.2,336.2l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3H260v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C265.6,337.3,265.5,336.7,265.2,336.2
            C265.3,336.2,265.2,336.2,265.2,336.2"
              />
              <path
                class="st38"
                d="M226.4,291.3c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C220.1,288.9,224,288.9,226.4,291.3z"
              />
              <path
                class="st37"
                d="M226.4,291.3c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C220.1,288.9,224,288.9,226.4,291.3"
              />
              <path
                class="st29"
                d="M222.1,302c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C225.4,301.3,223.8,302,222.1,302 M222.1,289.7c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            c2.4,2.3,6.2,2.2,8.5-0.1c2.3-2.4,2.3-6.2-0.1-8.5l0,0C225.1,290.2,223.6,289.7,222.1,289.7"
              />
              <path
                class="st39"
                d="M221.9,297.3h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9
            h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L221.9,297.3z"
              />
              <path
                class="st39"
                d="M219.1,293c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3C218.1,292.6,218.7,292.6,219.1,293"
              />
              <path
                class="st39"
                d="M225.3,296.3l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C225.7,297.3,225.7,296.8,225.3,296.3
            C225.4,296.3,225.4,296.2,225.3,296.3"
              />
              <path
                class="st38"
                d="M191.7,254.3c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C185.3,252,189.2,251.9,191.7,254.3z
            "
              />
              <path
                class="st37"
                d="M191.7,254.3c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C185.3,252,189.2,251.9,191.7,254.3"
              />
              <path
                class="st29"
                d="M187.4,265c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C190.7,264.4,189,265,187.4,265 M187.4,252.7c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            c2.4,2.3,6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5l0,0C190.4,253.3,188.9,252.7,187.4,252.7"
              />
              <path
                class="st39"
                d="M187.1,260.3L187.1,260.3l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9h-0.1l-1.8,1.8H187l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L187.1,260.3z"
              />
              <path
                class="st39"
                d="M184.3,256c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3C183.4,255.7,184,255.7,184.3,256"
              />
              <path
                class="st39"
                d="M190.6,259.3l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C191,260.4,190.9,259.8,190.6,259.3
            C190.7,259.3,190.7,259.3,190.6,259.3"
              />
              <path
                class="st38"
                d="M168,179.1c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C161.7,176.8,165.6,176.7,168,179.1z"
              />
              <path
                class="st37"
                d="M168,179.1c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C161.7,176.8,165.6,176.7,168,179.1"
              />
              <path
                class="st29"
                d="M163.7,189.8c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C167,189.2,165.4,189.8,163.7,189.8 M163.7,177.5c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            c2.4,2.3,6.2,2.2,8.5-0.1c2.3-2.4,2.3-6.2-0.1-8.5l0,0C166.8,178.1,165.2,177.5,163.7,177.5"
              />
              <path
                class="st39"
                d="M163.5,185.1L163.5,185.1l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9h-0.1l-1.8,1.8h-0.1l-0.3-0.2V184l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L163.5,185.1z"
              />
              <path
                class="st39"
                d="M160.7,180.8c0.4,0.4,0.4,0.9,0,1.3c-0.4,0.4-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3
            C159.7,180.5,160.3,180.5,160.7,180.8"
              />
              <path
                class="st39"
                d="M166.9,184.1l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C167.4,185.2,167.3,184.7,166.9,184.1
            C167,184.1,167,184.1,166.9,184.1"
              />
              <path
                class="st29"
                d="M605.2,285.4l0.7-0.7l1-0.1c1.3-0.1,2.2-0.2,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.5l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.8c1,1.1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,0.9h-0.5l0,0l1.3,1.3l-0.9,0.9L605.2,285.4z"
              />
              <text
                transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 528.8346 168.5998)"
                class="st13 st14 st44"
              >
                P
              </text>
              <text
                transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 528.2748 170.839)"
                class="st13 st14 st44"
              >
                A
              </text>
              <text
                transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 527.6017 173.5124)"
                class="st13 st14 st44"
              >
                P
              </text>
              <text
                transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 527.0386 175.7487)"
                class="st13 st14 st44"
              >
                A JOHN’S
              </text>
              <text
                transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 523.2092 166.4963)"
                class="st13 st14 st44"
              >
                BULLPEN BOX
              </text>
              <path
                class="st36"
                d="M239.5,317.1c0.2-0.1,0.4-0.3,0.6-0.5l0,0c-0.1,0.2-0.3,0.5-0.4,0.7l-1.2,2l0.6,0.5l3.6-2.5l-0.7-0.7
            l-1.7,1.3c-0.2,0.2-0.5,0.4-0.7,0.6l0,0l1.6-2.6l-0.5-0.5l-1.7,1.2c-0.3,0.2-0.5,0.4-0.7,0.6l0,0c0.2-0.2,0.4-0.5,0.6-0.7l1.1-1.8
            l-0.7-0.6l-2.3,3.8l0.6,0.5L239.5,317.1z"
              />
              <path
                class="st36"
                d="M241,321.2L241,321.2l-0.2,0.2l0.6,0.6l2-2.1l-0.6-0.6l-0.2,0.3l0,0c0.1-0.2,0.1-0.5-0.1-0.7
            c-0.5-0.5-1.3,0.2-1.6,0.5s-0.9,1.2-0.4,1.7C240.5,321.2,240.8,321.2,241,321.2 M241.4,319.9c0.1-0.1,0.5-0.6,0.8-0.4
            c0.2,0.2-0.2,0.7-0.3,0.8c-0.1,0.1-0.5,0.6-0.8,0.4C240.9,320.5,241.3,320.1,241.4,319.9"
              />
              <polygon
                class="st36"
                points="245.5,319.5 244.9,318.9 241.8,322.3 242.4,322.9 	"
              />
              <polygon
                class="st36"
                points="244.3,322.8 244.3,322.8 243.8,324.2 244.5,324.8 245,323 246.4,322.6 245.7,321.9 244.6,322.4
            244.6,322.4 246.5,320.3 245.9,319.8 242.7,323.2 243.3,323.7 	"
              />
              <polygon
                class="st36"
                points="246.6,325.6 247.4,325 247.4,325 247,325.7 246.5,326.7 247,327.1 249.6,325.6 249,325 247.8,325.8
            247.6,326 247.5,326 248.4,324.5 247.9,324 246.4,324.9 246.4,324.9 247.3,323.4 246.6,322.8 245.3,325.5 245.8,326 	"
              />
              <path
                class="st36"
                d="M249.1,328.6L249.1,328.6l-0.2,0.2l0.6,0.6l2-2.1l-0.6-0.6l-0.2,0.3l0,0c0.1-0.2,0.1-0.5-0.2-0.7
            c-0.5-0.5-1.3,0.2-1.6,0.5s-0.9,1.2-0.4,1.7C248.6,328.7,248.9,328.7,249.1,328.6 M249.5,327.4c0.1-0.1,0.5-0.6,0.8-0.4
            c0.2,0.2-0.2,0.7-0.3,0.8c-0.1,0.1-0.5,0.6-0.8,0.4C248.9,328,249.3,327.5,249.5,327.4"
              />
              <polygon
                class="st36"
                points="253.6,329.2 252.9,328.6 251.5,329.6 251.5,329.6 251.8,329.2 252.3,328.1 251.7,327.5 250.4,330.2
            249,330.9 249.7,331.5 	"
              />
              <path
                class="st36"
                d="M465.3,355.2l-1.4-1.9c-0.2-0.2-0.3-0.4-0.5-0.6l0,0c0.2,0.1,0.5,0.3,0.7,0.4l2,1.2l0.5-0.6l-2.6-3.6
            l-0.6,0.7l1.3,1.7c0.2,0.2,0.4,0.4,0.6,0.7l0,0l-2.6-1.5l-0.5,0.5l1.2,1.7c0.2,0.3,0.4,0.5,0.6,0.7l0,0c-0.2-0.2-0.5-0.4-0.8-0.5
            l-1.8-1.1l-0.6,0.7l3.9,2.2L465.3,355.2z"
              />
              <path
                class="st36"
                d="M466.3,352c0.3,0.3,1.2,0.9,1.7,0.4c0.2-0.2,0.2-0.5,0.1-0.7l0,0l0.2,0.2l0.6-0.7l-2.2-1.9l-0.6,0.6l0.3,0.2
            l0,0c-0.2-0.1-0.5-0.1-0.7,0.2C465.2,350.9,465.9,351.6,466.3,352 M466.5,350.6c0.2-0.2,0.7,0.2,0.8,0.3c0.1,0.1,0.6,0.5,0.4,0.7
            s-0.7-0.2-0.8-0.3C466.7,351.2,466.3,350.8,466.5,350.6"
              />

              <rect
                x="467.3"
                y="346.7"
                transform="matrix(0.6637 -0.748 0.748 0.6637 -103.7331 467.238)"
                class="st36"
                width="0.9"
                height="4.6"
              />
              <polygon
                class="st36"
                points="470.6,349.3 469.6,348.4 469.6,348.4 471,348.8 471.6,348.1 469.8,347.6 469.4,346.3 468.8,347
            469.2,348 469.2,348.1 467.1,346.2 466.6,346.9 470,349.9 	"
              />
              <polygon
                class="st36"
                points="472.9,346.8 472.3,346 471.8,345.2 471.8,345.2 472.5,345.6 473.5,346.1 473.9,345.6 472.3,343
            471.8,343.6 472.6,344.8 472.8,345.1 472.8,345.1 471.2,344.2 470.7,344.8 471.7,346.2 471.7,346.2 470.2,345.4 469.6,346
            472.4,347.3 	"
              />
              <path
                class="st36"
                d="M473.6,343.8c0.3,0.3,1.2,0.9,1.7,0.4c0.2-0.2,0.2-0.5,0.1-0.7l0,0l0.2,0.2l0.6-0.6l-2.2-1.9l-0.6,0.6
            l0.3,0.2l0,0c-0.2-0.1-0.5-0.1-0.7,0.2C472.5,342.7,473.2,343.5,473.6,343.8 M473.8,342.4c0.2-0.2,0.7,0.2,0.8,0.3
            c0.1,0.1,0.6,0.5,0.4,0.7s-0.7-0.2-0.8-0.3C474,343,473.6,342.6,473.8,342.4"
              />
              <polygon
                class="st36"
                points="477.7,343.5 478.3,342.8 475.9,339 475.3,339.6 476.3,341 476.3,341 475.9,340.8 474.8,340.3
            474.2,340.9 476.9,342.1 	"
              />
              <polygon
                class="st29"
                points="425.2,401.5 425.2,401.5 424.3,400.9 425.1,400.2 426.4,401 427,402 422.1,405 421.4,403.8 	"
              />
              <path
                class="st29"
                d="M428.9,405c-0.7-1.1-2.2-0.8-3.5,0c-1.1,0.7-2.3,1.8-1.6,3l0,0c0.5,0.8,1.7,1,3.5,0
            C428.2,407.4,429.6,406.3,428.9,405 M426.5,406.8c-1.1,0.7-1.6,0.8-1.7,0.6l0,0c-0.2-0.3,0.2-0.6,1.3-1.3c1.1-0.7,1.6-0.8,1.8-0.5
            C428,405.8,427.5,406.2,426.5,406.8"
              />
              <path
                class="st29"
                d="M429.6,410.1c-0.2-0.3-0.5-0.5-0.8-0.5l0,0c0.6-0.2,1.3-0.1,1.7,0.4c0.1,0.1,0.2,0.3,0.3,0.4l0.9-0.6
            c-0.1-0.1-0.2-0.3-0.4-0.5c-0.3-0.3-0.8-0.7-1.4-0.8c-0.8-0.2-1.7-0.2-2.9,0.5c-1.3,0.8-1.7,1.8-1.1,2.8s1.8,0.9,2.7,0.4
            C429.6,411.6,430,410.8,429.6,410.1 M428,411c-0.5,0.3-1,0.6-1.2,0.2l0,0c-0.1-0.2,0.2-0.6,0.7-0.9c0.3-0.2,0.4-0.2,0.5-0.2
            c0.2,0,0.4,0,0.4,0.2C428.7,410.5,428.3,410.9,428,411"
              />
              <path
                class="st27"
                d="M335.5,397.7l-14,23.4c0,0,17.5,10.1,30.6,12c10.1,1.5,18.1,1.7,23.3,1.4c10.4-0.6,11.4-1.2,19.3-3
            c9.4-2.2,25.5-11,25.5-11l-13.5-22.7c0,0-13.4,2.7-19.4,4.3c-6,1.6-11.8,2-16.4,2s-14.4-1-18.1-2
            C349.3,401,335.5,397.7,335.5,397.7"
              />
              <path
                class="st37"
                d="M547,109.7c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7S544.6,107.3,547,109.7"
              />
              <path
                class="st29"
                d="M542.7,120.4c-1.7,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c1.2-1.2,2.8-1.9,4.5-1.9s3.3,0.6,4.5,1.8
            c2.5,2.4,2.6,6.4,0.1,8.9C546.1,119.7,544.5,120.4,542.7,120.4C542.8,120.4,542.8,120.4,542.7,120.4 M542.7,108.1L542.7,108.1
            c-1.7,0-3.2,0.7-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5c1.1,1.1,2.6,1.7,4.2,1.7h0.1c1.6,0,3.1-0.7,4.2-1.8c2.3-2.4,2.3-6.2-0.1-8.5
            C545.8,108.7,544.3,108.1,542.7,108.1"
              />
              <path
                class="st39"
                d="M542.5,115.7L542.5,115.7l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.2h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9h-0.1l-1.7,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4H543l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L542.5,115.7z"
              />
              <path
                class="st39"
                d="M539.7,111.4c0.4,0.4,0.4,0.9,0,1.3s-1,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3
            C538.7,111.1,539.3,111.1,539.7,111.4"
              />
              <path
                class="st39"
                d="M545.9,114.7l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C546.4,115.8,546.3,115.3,545.9,114.7
            C546,114.7,546,114.7,545.9,114.7"
              />
              <path
                class="st38"
                d="M547,109.7c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7S544.6,107.3,547,109.7z"
              />
              <path
                class="st3"
                d="M291,41c0.5,0.6,11.6,10.8,12.2,11.4c0.3-0.8,12.5-16.1,12.6-16.3c-0.1-0.2-16.4-15.5-16.4-15.5
            s-11.8,14.3-13,15.6"
              />
              <polygon
                class="st3"
                points="441.2,406 440,406.9 429.8,394.9 430.9,393.9 	"
              />
              <polygon
                class="st3"
                points="462.3,385 461.2,386.2 449.4,374.9 450.6,373.7 	"
              />
              <polygon
                class="st3"
                points="428.2,415.8 426.8,416.6 418.6,402.9 420.1,402 	"
              />
              <polygon
                class="st3"
                points="482.2,364.7 481,365.9 469.3,354.6 470.4,353.4 	"
              />
              <polygon
                class="st3"
                points="502.1,344.2 500.9,345.4 489.2,334.1 490.3,332.9 	"
              />
              <polygon
                class="st3"
                points="522.3,323.6 521.1,324.8 509.4,313.5 510.5,312.3 	"
              />
              <polygon
                class="st3"
                points="542.1,302.9 540.9,304.1 529.3,292.9 530.4,291.7 	"
              />
              <polygon
                class="st3"
                points="557.9,282.6 556.8,283.8 547.4,274.7 548.5,273.5 	"
              />
              <polygon
                class="st3"
                points="160.5,261.2 159.7,260 169.3,253.6 170.1,254.8 	"
              />
              <polygon
                class="st3"
                points="184.1,285.7 183.1,284.7 191.5,276.1 192.5,277.1 	"
              />
              <polygon
                class="st3"
                points="203.6,305.2 202.6,304.2 211.1,295.5 212.1,296.5 	"
              />
              <polygon
                class="st3"
                points="223.7,325.2 222.6,324.2 231.1,315.5 232.2,316.5 	"
              />
              <polygon
                class="st3"
                points="243.8,345.2 242.8,344.2 251.3,335.5 252.3,336.5 	"
              />
              <polygon
                class="st3"
                points="263.8,365.4 262.8,364.4 271.2,355.7 272.3,356.6 	"
              />
              <polygon
                class="st3"
                points="284.1,385.6 283.1,384.7 291.6,375.9 292.6,376.9 	"
              />
              <polygon
                class="st3"
                points="310.7,408.1 309.5,407.3 316,397 317.2,397.8 	"
              />
              <polygon
                class="st3"
                points="314.5,416.6 313.3,415.8 322.3,401.3 323.5,402.1 	"
              />
              <polygon
                class="st3"
                points="194.6,161.7 181.6,153.7 186.4,146.2 199.3,154.2 	"
              />
              <path
                class="st3"
                d="M201.3,167.3c0,0.2,5.9,24.7,5.9,24.7l0.2,11.6l3.7,11.4l7.5,10.8c0,0,10.1,9.7,10.3,10
            c0.2-0.2,9.4-9.6,9.7-9.9c-0.2-0.2-15.7-15.2-15.7-15.2s-11.2-53.2-11.3-53.9C211.1,157.2,201.4,167.2,201.3,167.3"
              />
              <path
                class="st28"
                d="M228.9,236.2l-0.2-0.2c-0.2-0.2-10.3-10-10.3-10l-7.6-10.9l-3.7-11.5l-0.2-11.6c0,0-5.9-24.4-5.9-24.6v-0.2
            l0.1-0.1c0.1-0.1,4.9-5,7.9-8.1l2.8-2.8l0.1,0.6c0.1,0.6,10.7,51.3,11.3,53.8c1.1,1.1,15.4,14.9,15.6,15.1l0.2,0.2l-0.2,0.2
            c-0.2,0.2-9.4,9.6-9.7,9.9L228.9,236.2z M218.8,225.6c0,0,8.5,8.2,10.1,9.7c1.3-1.3,7.9-8.1,9.2-9.4c-1.9-1.9-15.5-15-15.5-15
            l-0.1-0.1v-0.1c0,0-9.9-47.4-11.2-53.3l-1.9,2c-2.8,2.8-7,7.2-7.8,8c0.5,2.2,5.9,24.5,5.9,24.5l0.2,11.6l3.7,11.3L218.8,225.6z"
              />
              <path
                class="st25"
                d="M308.6,457.8l-0.7-0.5C308.1,457.5,308.4,457.7,308.6,457.8L308.6,457.8z"
              />
              <path
                class="st25"
                d="M472,424.1L472,424.1c0.4-0.4,0.8-0.8,1.2-1.3C472.8,423.3,472.4,423.7,472,424.1"
              />
              <path
                class="st25"
                d="M479.3,416.6L479.3,416.6c0.4-0.4,0.8-0.8,1.2-1.3C480.1,415.8,479.7,416.2,479.3,416.6"
              />
              <path
                class="st25"
                d="M480.6,415.4L480.6,415.4l-1.2,1.3l0,0C479.7,416.2,480.1,415.8,480.6,415.4"
              />
              <path
                class="st25"
                d="M486.7,409.1L486.7,409.1c0.4-0.4,0.8-0.8,1.2-1.3C487.5,408.2,487.1,408.7,486.7,409.1"
              />
              <path
                class="st25"
                d="M495.3,400.3c-0.4,0.4-0.8,0.8-1.2,1.3l0,0C494.5,401.1,494.9,400.7,495.3,400.3"
              />
              <path
                class="st25"
                d="M501.4,394.1L501.4,394.1c0.4-0.4,0.8-0.8,1.2-1.3C502.2,393.2,501.8,393.7,501.4,394.1"
              />
              <path
                class="st25"
                d="M508.8,386.5L508.8,386.5c0.4-0.4,0.8-0.8,1.2-1.3C509.6,385.7,509.2,386.1,508.8,386.5"
              />
              <path
                class="st25"
                d="M510,385.2L510,385.2l-1.2,1.3l0,0C509.2,386.1,509.6,385.7,510,385.2"
              />
              <path
                class="st25"
                d="M516.1,379L516.1,379c0.4-0.4,0.8-0.8,1.2-1.3C516.9,378.2,516.5,378.6,516.1,379"
              />
              <path
                class="st25"
                d="M532,362.7L532,362.7c-0.4,0.4-0.8,0.8-1.2,1.3l0,0C531.2,363.5,531.6,363.1,532,362.7"
              />
              <path
                class="st25"
                d="M532,362.7L532,362.7l-1.2,1.3l0,0C531.2,363.5,531.6,363.1,532,362.7"
              />
              <path
                class="st25"
                d="M539.4,355.2c-0.4,0.4-0.8,0.8-1.2,1.3C538.5,356,539,355.6,539.4,355.2L539.4,355.2z"
              />
              <path
                class="st25"
                d="M545.5,348.9L545.5,348.9c0.4-0.4,0.8-0.8,1.2-1.3C546.4,348,545.9,348.4,545.5,348.9"
              />
              <path
                class="st25"
                d="M546.8,347.6L546.8,347.6l-1.2,1.3l0,0C545.9,348.4,546.4,348,546.8,347.6"
              />
              <path
                class="st25"
                d="M552.9,341.4L552.9,341.4c0.4-0.4,0.8-0.8,1.2-1.3C553.7,340.5,553.3,340.9,552.9,341.4"
              />
              <path
                class="st25"
                d="M554.1,340.1L554.1,340.1l-1.2,1.3l0,0C553.3,340.9,553.7,340.5,554.1,340.1"
              />
              <path
                class="st25"
                d="M560.2,333.8L560.2,333.8c0.4-0.4,0.8-0.8,1.2-1.3C561.1,332.9,560.7,333.4,560.2,333.8"
              />
              <path
                class="st25"
                d="M574.9,318.8L574.9,318.8c0.4-0.4,0.8-0.8,1.2-1.3C575.7,317.9,575.3,318.4,574.9,318.8"
              />
              <path
                class="st25"
                d="M576.1,317.5L576.1,317.5l-1.2,1.3l0,0C575.3,318.4,575.7,317.9,576.1,317.5"
              />
              <path
                class="st25"
                d="M582.3,311.2L582.3,311.2c0.4-0.4,0.8-0.8,1.2-1.3C583.1,310.4,582.7,310.8,582.3,311.2"
              />
              <path
                class="st25"
                d="M589.6,303.7L589.6,303.7c0.4-0.4,0.8-0.8,1.2-1.3C590.4,302.9,590,303.3,589.6,303.7"
              />
              <path
                class="st25"
                d="M458.5,438L458.5,438l-1.2,1.3l0,0l0.1-0.1C457.7,438.8,458.1,438.4,458.5,438"
              />
              <polygon
                class="st3"
                points="554.1,340.1 552.8,341.4 552.9,341.4 	"
              />
              <polygon
                class="st3"
                points="530.8,363.9 530.8,363.9 532,362.7 532,362.7 	"
              />
              <polygon
                class="st3"
                points="546.8,347.6 546.8,347.6 545.5,348.9 545.5,348.9 	"
              />
              <polygon
                class="st3"
                points="576.1,317.5 574.9,318.8 574.9,318.8 	"
              />
              <polygon
                class="st17"
                points="515.1,406.7 514.7,406.3 507.9,413.3 508.2,413.5 	"
              />
              <polygon
                class="st17"
                points="596,323.7 595.6,323.4 588.7,330.5 589.1,330.9 	"
              />
              <path
                class="st3"
                d="M144.5,298.1l-13.2,14l154.2,150.6c0,0,31.6,33.6,88.3,34.2c47,0.5,74.5-22.8,88.6-36.9l158.9-163.4L606.6,282
            L446.2,447c0,0-15.6,13.5-27,16.4c-11.5,2.9-30.3,6.2-44.1,6.2c-13.8,0-44.9,4.4-75.8-22L144.5,298.1z"
              />
              <path
                class="st3"
                d="M133,312.6c0.3,0.3,5.8,5.7,6.1,5.9c0.3-0.3,12.3-12.6,12.5-12.8c-2.8-2.7-3.3-3.2-6.1-5.9
            C145.4,299.8,133.2,312.3,133,312.6 M140.6,320c0.3,0.3,5.8,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-0.1-0.1-3.6-3.5-6-5.8
            C152.9,307.4,140.9,319.7,140.6,320"
              />
              <path
                class="st13"
                d="M146.6,326.1l-0.1-0.1c-0.1-0.1-1.1-1.1-2.3-2.2c-1.6-1.6-3.6-3.5-3.7-3.6l-0.1-0.2l0.1-0.1
            c0.1-0.1,3.5-3.6,6.7-6.9c2.9-3,5.7-5.8,5.8-5.9l0.1-0.1l0.1,0.1c2.4,2.4,5.9,5.8,6,5.8l0.1,0.1l-0.1,0.1
            c-0.3,0.3-12.3,12.6-12.5,12.8L146.6,326.1z M140.9,320c0.5,0.5,2.2,2.1,3.6,3.5c1,0.9,1.8,1.8,2.1,2.1c1.3-1.3,11-11.3,12.3-12.6
            c-0.7-0.6-3.6-3.5-5.7-5.6c-0.6,0.6-3.1,3.2-5.7,5.8C144.6,316.2,141.6,319.3,140.9,320 M139.1,318.8l-0.1-0.1
            c-0.2-0.2-2.4-2.4-4.2-4.1l-2.1-2l0.1-0.1c0.2-0.2,6.2-6.3,9.7-9.9c1.6-1.7,2.8-2.9,2.8-2.9l0.1-0.1l6.4,6.2l-0.1,0.1
            c-0.1,0.1-4,4.1-7.4,7.6C141.7,316.2,139.3,318.6,139.1,318.8L139.1,318.8z M133.2,312.6l1.8,1.7c1.5,1.5,3.5,3.4,4,3.9
            c0.5-0.6,2.7-2.7,5-5.1c3.1-3.2,6.6-6.7,7.3-7.5l-5.8-5.6c-0.4,0.4-1.4,1.4-2.7,2.8C139.5,306.1,134.2,311.6,133.2,312.6"
              />
              <path
                class="st3"
                d="M148.2,327.4c0.3,0.3,5.8,5.6,6.1,5.9c0.3-0.3,12.3-12.6,12.5-12.8c-3-2.9-5.9-5.8-6.1-5.9
            C160.5,314.8,148.5,327.1,148.2,327.4 M155.9,334.8c0.2,0.2,5.7,5.6,6,5.8c0.3-0.3,12.5-12.8,12.5-12.8c-1-1-4.6-4.5-6-5.8
            C168.1,322.2,156.1,334.5,155.9,334.8 M163.4,342.1c0.2,0.2,5.7,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-0.2-0.2-3.1-3-6-5.8
            C176,329.3,163.7,341.9,163.4,342.1"
              />
              <path
                class="st13"
                d="M169.5,348.2l-1.9-1.8c-1.7-1.7-4.1-4-4.3-4.1l-0.1-0.1l0.1-0.1c0.2-0.2,4.3-4.4,7.8-7.9
            c4.8-4.9,4.8-4.9,4.8-4.9l0.1-0.1l0.1,0.1c2.9,2.8,5.9,5.7,6,5.8l0.1,0.1l-0.1,0.1c-0.3,0.3-12.3,12.6-12.5,12.8L169.5,348.2z
            M163.7,342.1c0.6,0.5,2.6,2.5,4.1,4l1.6,1.6c1.3-1.3,11-11.3,12.3-12.6c-0.6-0.6-3.2-3.1-5.7-5.6c-0.5,0.5-2.5,2.5-4.6,4.8
            C168.2,337.6,164.5,341.4,163.7,342.1 M161.9,340.9l-0.1-0.1c-0.3-0.3-5.8-5.6-6-5.8l-0.1-0.1l4-4.1c3.6-3.7,8.5-8.7,8.6-8.9
            l0.1-0.1l6.2,6v0.1C174.6,328,174.6,328,161.9,340.9L161.9,340.9z M156.1,334.8c0.8,0.8,4.9,4.8,5.7,5.6c1.3-1.4,11-11.3,12.3-12.6
            l-5.7-5.6c-0.8,0.8-5.2,5.3-8.5,8.7L156.1,334.8z M154.3,333.5l-0.1-0.1c-0.3-0.3-5.8-5.6-6.1-5.9l-0.1-0.1l0.1-0.1
            c0.3-0.3,12.3-12.6,12.5-12.8l0.1-0.1l0.1,0.1c0.2,0.1,3,2.9,6.1,5.9l0.1,0.1l-0.1,0.1c-0.3,0.3-12.2,12.5-12.5,12.8L154.3,333.5z
            M148.5,327.4c0.8,0.8,5,4.8,5.8,5.6c1.3-1.3,11-11.3,12.3-12.6c-2.7-2.7-5.2-5-5.8-5.6C159.5,316.1,149.7,326,148.5,327.4"
              />
              <path
                class="st3"
                d="M171,349.5c0.3,0.3,5.9,5.7,6.1,5.9c0.3-0.3,12.3-12.6,12.5-12.8c-3-2.9-5.9-5.8-6.1-5.9
            C183.3,336.9,171.3,349.2,171,349.5 M178.7,356.9c0.3,0.3,5.8,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-0.8-0.8-4.4-4.3-6-5.8
            C191,344.3,178.9,356.6,178.7,356.9 M186.2,364.3c0.2,0.2,5.8,5.7,6.1,5.9c0.3-0.3,12.3-12.6,12.5-12.8c-0.2-0.2-3.2-3.1-6.1-5.9
            C198.5,351.7,186.5,364,186.2,364.3"
              />
              <path
                class="st13"
                d="M192.3,370.4l-0.1-0.1c-0.2-0.2-3.4-3.3-5.1-4.9l-1.2-1.1l0.1-0.1c0.3-0.3,12.3-12.6,12.5-12.8l0.1-0.1
            l6.4,6.2l-0.1,0.1C204.6,357.9,192.6,370.2,192.3,370.4L192.3,370.4z M186.5,364.3l0.9,0.9c1.5,1.5,4.3,4.1,4.9,4.8
            c1.3-1.3,11-11.3,12.3-12.6l-5.8-5.6C197.5,353,187.8,363,186.5,364.3 M184.7,363l-0.1-0.1c-0.1-0.1-1.5-1.5-3-2.9s-2.9-2.8-3.1-3
            l-0.1-0.1l0.1-0.1c0.3-0.3,12.5-12.7,12.5-12.8l0.1-0.1l0.1,0.1c0.9,0.9,2.6,2.5,4,3.8l2.2,2.1v0.1c-0.3,0.3-12.3,12.6-12.5,12.8
            L184.7,363z M178.9,356.9c0.4,0.4,1.7,1.6,2.9,2.8c1.2,1.2,2.4,2.3,2.8,2.7c1.3-1.3,11-11.3,12.3-12.6l-1.9-1.9
            c-1.3-1.3-2.9-2.8-3.8-3.7C190,345.6,180.2,355.6,178.9,356.9 M177.1,355.7l-0.1-0.1c-0.1-0.1-1.1-1-2.2-2.2
            c-1.7-1.6-3.7-3.6-3.9-3.8l-0.1-0.1l0.1-0.1c0.2-0.2,12.2-12.5,12.5-12.8l0.1-0.1l0.1,0.1c0.2,0.1,3.1,3,6.1,5.9l0.1,0.1l-0.1,0.1
            c-0.1,0.1-12.3,12.6-12.5,12.8L177.1,355.7z M171.3,349.5c0.5,0.5,2.3,2.2,3.7,3.6c0.9,0.9,1.8,1.7,2.1,2
            c1.3-1.3,11-11.3,12.3-12.6c-2.7-2.6-5.2-5-5.8-5.6C182.3,338.2,172.5,348.2,171.3,349.5"
              />
              <path
                class="st3"
                d="M262.3,438.1c0.2,0.2,5.8,5.7,6.1,5.9c0.3-0.3,12.3-12.6,12.5-12.8c-3-3-6-5.8-6.1-5.9
            C274.6,425.5,262.6,437.8,262.3,438.1 M270,445.5c0.3,0.3,5.8,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-0.9-0.9-4-3.9-6-5.8
            C282.3,432.9,270.2,445.2,270,445.5 M277.5,452.9c0.3,0.3,7.8,7.5,8.1,7.8c0.3-0.3,11-13.9,11.2-14.2c-0.2-0.2-1.7-1.5-1.7-1.5
            s-2.7-2.7-5.1-4.9C289.8,440.3,277.8,452.6,277.5,452.9"
              />
              <path
                class="st13"
                d="M285.6,461l-0.2-0.1c-0.1-0.1-2.1-2-4-3.9c-2-1.9-3.9-3.8-4-3.9l-0.1-0.1l0.1-0.1c0.1-0.1,2.3-2.3,12-12.3
            l0.7-0.7l4.8,4.7c0.2,0.2,0.4,0.3,0.4,0.3s1.4,1.3,1.7,1.5l0.1,0.1l-0.1,0.1c-0.1,0.1-2,2.6-4.3,5.4c-3.1,3.9-6.8,8.6-6.9,8.8
            L285.6,461z M277.8,452.9c0.5,0.5,2.2,2.1,3.9,3.8c1.7,1.6,3.3,3.2,3.9,3.7c0.7-0.9,4-5.1,6.8-8.6c2-2.5,3.7-4.7,4.2-5.3
            c-0.4-0.4-1.6-1.4-1.6-1.4l-4.9-4.8l-0.4,0.4C281.1,449.5,278.4,452.3,277.8,452.9 M276,451.6l-2.2-2.1c-1.7-1.6-3.8-3.7-4-3.9
            l-0.1-0.1l0.1-0.1c0.3-0.3,12.3-12.6,12.5-12.8l0.1-0.1l6.3,6.1l-0.1,0.1c-0.3,0.3-12.3,12.6-12.5,12.8L276,451.6z M270.2,445.5
            c0.5,0.5,2.4,2.3,3.8,3.7l1.9,1.8c1.3-1.3,11-11.3,12.3-12.6l-5.7-5.6C281.2,434.2,271.5,444.2,270.2,445.5 M268.4,444.3l-0.1-0.1
            c-0.2-0.2-3.3-3.2-5-4.9l-1.2-1.2l0.1-0.1c0.1-0.1,12.2-12.5,12.5-12.8l0.1-0.1l0.1,0.1c0.1,0.1,3,3,6.1,5.9l0.1,0.1l-0.1,0.1
            c-0.2,0.2-12.3,12.6-12.5,12.8L268.4,444.3z M262.6,438.1l0.9,0.9c1.5,1.5,4.2,4.1,4.9,4.7c1.3-1.3,11-11.3,12.3-12.6
            c-2.7-2.6-5.2-5-5.8-5.6C273.6,426.8,263.8,436.8,262.6,438.1"
              />
              <polygon
                class="st3"
                points="251.7,402.7 239,415.6 253.5,429.9 266.3,417.1 	"
              />
              <path
                class="st13"
                d="M253.5,430.2l-0.1-0.1l-14.7-14.5l0.1-0.1l12.9-13l0.1,0.1l14.7,14.5l-0.1,0.1L253.5,430.2z M239.2,415.6
            l14.3,14.1l12.5-12.6L251.7,403L239.2,415.6z"
              />
              <path
                class="st3"
                d="M231.9,408.6c0.3,0.2,5.8,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-0.3-0.3-5.8-5.6-6-5.8
            C244.2,396,232.2,408.3,231.9,408.6"
              />
              <path
                class="st13"
                d="M237.9,414.7l-0.6-0.6c-1.4-1.3-5.3-5.2-5.5-5.4l-0.1-0.1l0.1-0.1c0.2-0.2,6.5-6.6,10.1-10.3l2.6-2.7l0.1,0.1
            c0.3,0.2,5.8,5.6,6,5.8l0.1,0.1l-0.1,0.1c-0.3,0.3-12.3,12.6-12.5,12.8L237.9,414.7z M232.2,408.6c0.7,0.7,4.1,4,5.4,5.2l0.3,0.3
            c1.3-1.3,11-11.3,12.3-12.6c-0.8-0.8-4.9-4.8-5.7-5.6l-2.3,2.4C238.8,401.8,233.1,407.6,232.2,408.6"
              />
              <path
                class="st3"
                d="M254.7,430.7c0.3,0.3,5.8,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-0.3-0.2-5.3-5.1-6-5.8
            C267,418.2,255,430.5,254.7,430.7"
              />
              <path
                class="st13"
                d="M260.8,436.8l-0.1-0.1c-0.3-0.3-5.7-5.6-6-5.8l-0.1-0.1l0.1-0.1c0.1-0.1,12.3-12.6,12.5-12.8l0.1-0.1l1.3,1.3
            c1.7,1.7,4.6,4.5,4.8,4.7l0.1,0.1l-0.1,0.1c-0.1,0.1-2.5,2.6-5.2,5.3C264.8,432.8,261,436.7,260.8,436.8L260.8,436.8z M255,430.7
            c0.8,0.8,4.9,4.8,5.7,5.6c0.7-0.7,4.2-4.2,7.2-7.4c2.4-2.4,4.5-4.6,5.1-5.2c-0.6-0.6-3.1-3-4.7-4.5l-1.1-1
            C266,419.5,256.3,429.5,255,430.7"
              />
              <path
                class="st3"
                d="M298,471.2c3.1,2.3,6.2,4.4,9.4,6.4c0.2-0.4,8.4-17,8.5-17.3c-2.7-1.6-5.3-3.2-7.8-4.9
            C307.9,455.7,298.2,470.9,298,471.2"
              />
              <path
                class="st13"
                d="M307.5,477.9l-0.2-0.1c-3.2-2-6.4-4.1-9.4-6.4l-0.1-0.1l0.1-0.1c0.2-0.3,9.9-15.5,10.1-15.9l0.1-0.2l0.2,0.1
            c2.5,1.7,5.1,3.4,7.8,4.9l0.2,0.1l-0.1,0.2c-0.2,0.3-8.4,16.9-8.5,17.3L307.5,477.9z M298.3,471.2c2.9,2.2,6,4.3,9.1,6.1
            c0.9-1.8,7.6-15.3,8.4-17c-2.6-1.5-5.1-3.1-7.5-4.7C307.2,457.2,299.3,469.7,298.3,471.2"
              />
              <path
                class="st3"
                d="M287.2,462.2c0.1,0.1,0.1,0.1,0.1,0.1l2.1,1.9c2.2,2,4.5,3.9,6.9,5.7c0.2-0.4,10-15.6,10.1-15.8
            c-2.6-1.9-5.3-4-7.9-6.2C298.2,448.2,287.4,461.9,287.2,462.2"
              />
              <path
                class="st13"
                d="M296.3,470.2l-0.2-0.1c-2.5-1.9-4.8-3.8-6.9-5.7c0,0-1.5-1.3-2-1.7l0,0l-0.4-0.4l0.1-0.1
            c0.2-0.3,11.1-14.1,11.3-14.3l0.1-0.2l0.2,0.1c2.5,2.1,5.1,4.2,7.9,6.2l0.1,0.1l-0.1,0.2c-0.1,0.1-4.5,7-7.4,11.6
            C297.5,468.2,296.4,470,296.3,470.2L296.3,470.2z M287.4,462.2c0.2,0.2,0.8,0.7,2.1,1.8c2.1,1.9,4.3,3.7,6.7,5.6
            c0.3-0.5,1.3-2.1,2.6-4c2.7-4.2,6.6-10.4,7.3-11.5c-2.6-1.9-5.2-3.9-7.6-6C297.3,449.6,288.4,461,287.4,462.2"
              />
              <path
                class="st3"
                d="M309.3,478.7c3,1.8,6,3.4,8.9,4.8c0.2-0.4,7-18,7.1-18.4c-2.5-1.1-5-2.4-7.5-3.8
            C317.7,461.7,309.5,478.4,309.3,478.7"
              />
              <path
                class="st13"
                d="M318.3,483.8l-0.2-0.1c-2.9-1.4-6-3-9-4.8l-0.2-0.1l0.1-0.2c0.1-0.2,3.2-6.5,5.6-11.4
            c1.6-3.2,2.9-5.8,2.9-5.9l0.1-0.2l0.2,0.1c2.5,1.4,5,2.6,7.5,3.8l0.2,0.1l-0.1,0.2c-0.1,0.4-7.1,18.2-7.1,18.4V483.8z M309.5,478.7
            c2.9,1.7,5.8,3.2,8.6,4.6c0.7-1.8,6.3-16.3,7-18c-2.4-1.1-4.8-2.3-7.2-3.6c-0.3,0.7-1.5,3-2.8,5.7
            C312.9,471.9,310,477.6,309.5,478.7"
              />
              <path
                class="st3"
                d="M193.9,371.7c0.3,0.2,5.8,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-2.5-2.4-5.9-5.8-6-5.8
            C206.2,359.1,194.2,371.4,193.9,371.7 M201.5,379c0.3,0.3,5.8,5.6,6,5.8c0.3-0.3,12.5-12.8,12.5-12.8c-2.8-2.7-3.2-3.2-6-5.8
            C213.8,366.5,201.7,378.8,201.5,379 M209,386.4c0.3,0.3,5.8,5.6,6.1,5.9c0.3-0.3,12.3-12.6,12.5-12.8c-0.1-0.1-3.6-3.5-6.1-5.9
            C221.6,373.6,209.3,386.1,209,386.4"
              />
              <path
                class="st13"
                d="M215.1,392.6l-0.1-0.1c-0.3-0.3-5.8-5.6-6.1-5.9l-0.1-0.1l0.1-0.1c0.1-0.2,3.8-3.9,7.2-7.3
            c5.4-5.5,5.4-5.5,5.5-5.6h0.1l0.1,0.1c3.8,3.7,6,5.8,6.1,5.9l0.1,0.1l-0.1,0.1c-0.3,0.3-12.5,12.8-12.5,12.8L215.1,392.6z
            M209.3,386.4c0.8,0.8,5,4.8,5.8,5.6c1.3-1.3,11-11.3,12.3-12.6c-0.7-0.7-3.8-3.7-5.8-5.6c-0.6,0.6-2.8,2.9-5.2,5.4
            C213.3,382.3,210,385.7,209.3,386.4 M207.5,385.2l-0.1-0.2c-0.2-0.2-2.6-2.6-4.4-4.2l-1.8-1.7l0.1-0.1c0.2-0.2,4-4.1,7.4-7.6
            c2.7-2.7,5.1-5.2,5.2-5.3l0.1-0.1l6.3,6.1l-0.1,0.1c0,0-12.3,12.6-12.5,12.8L207.5,385.2z M201.7,379l1.5,1.5
            c1.5,1.5,3.7,3.5,4.2,4.1c1.3-1.3,11-11.3,12.3-12.6l-5.7-5.6c-0.5,0.6-2.7,2.7-5,5.1C205.9,374.8,202.5,378.3,201.7,379
            M199.9,377.8l-2.1-2.1c-1.7-1.6-3.9-3.7-4-3.9l-0.1-0.1l0.1-0.1c0.2-0.2,4.6-4.7,8.1-8.3c2.3-2.4,4.3-4.4,4.4-4.5l0.1-0.1l6.3,6.1
            l-0.1,0.1c-0.1,0.1-12.3,12.6-12.5,12.8L199.9,377.8z M194.2,371.7c0.5,0.5,2.4,2.3,3.9,3.8l1.9,1.8c1.3-1.3,11-11.3,12.3-12.6
            l-5.7-5.6c-0.5,0.5-2.3,2.3-4.3,4.4C198.9,366.8,194.9,370.9,194.2,371.7"
              />
              <path
                class="st3"
                d="M462.3,432.1L462.3,432.1c0,0-2.7,2.7-2.9,2.9c0.3,0.3,12.5,12.1,12.8,12.4c0.2-0.2,5.6-5.7,5.9-6
            c-0.3-0.3-12.5-12.2-12.8-12.4C465,429.3,462.3,432.1,462.3,432.1"
              />
              <path
                class="st13"
                d="M472.2,447.7l-0.1-0.1c-0.4-0.3-12.6-12.2-12.8-12.4l-0.1-0.1l0.1-0.1c0.2-0.2,2.9-2.9,2.9-2.9s2.7-2.8,3-3.1
            l0.1-0.1l0.1,0.1c0.1,0.1,3.4,3.3,6.5,6.3s6.1,5.9,6.3,6.1l0.1,0.1l-0.1,0.1c-0.2,0.2-2.6,2.7-4.3,4.4c-0.8,0.9-1.5,1.5-1.6,1.6
            L472.2,447.7z M459.7,435c1.3,1.3,11.2,10.9,12.5,12.2c0.2-0.2,0.8-0.8,1.4-1.5c1.5-1.5,3.6-3.7,4.2-4.3c-0.6-0.6-3.4-3.3-6.1-5.9
            c-2.8-2.8-5.7-5.6-6.4-6.2c-0.6,0.6-2.8,2.9-2.9,2.9C462.4,432.2,460.2,434.4,459.7,435"
              />
              <path
                class="st3"
                d="M442.1,451.3c0.2,0.3,10.2,15,10.4,15.4c2.9-2.4,5.6-4.9,8.1-7.4c0,0,0.4-0.5,0.7-0.7
            c-0.2-0.3-11.3-13.6-11.6-13.9C447.2,447.1,444.7,449.3,442.1,451.3"
              />
              <path
                class="st13"
                d="M452.5,467l-0.1-0.2c-0.1-0.2-2-3-4.2-6.1c-2.9-4.3-6.2-9.1-6.3-9.3l-0.1-0.1l0.1-0.1c2.6-2,5.1-4.2,7.6-6.6
            l0.1-0.1l0.1,0.2c0.1,0.1,11.3,13.6,11.6,13.9l0.1,0.1l-0.8,0.8c-2.4,2.4-5.2,4.9-8.1,7.4L452.5,467z M442.4,451.3
            c0.6,0.9,3.5,5.2,6.2,9.1c1.9,2.8,3.6,5.3,4,6c2.9-2.4,5.5-4.9,7.9-7.3l0.6-0.6c-1.1-1.4-10.1-12.1-11.3-13.6
            C447.3,447.3,444.8,449.4,442.4,451.3"
              />
              <path
                class="st3"
                d="M474.2,419.9c0.3,0.3,12.5,12.1,12.8,12.4c0.3-0.3,5.7-5.8,5.9-6c-0.3-0.3-12.5-12.2-12.8-12.4
            C479.8,414.1,474.5,419.6,474.2,419.9"
              />
              <path
                class="st13"
                d="M487,432.5l-0.1-0.1c-0.3-0.3-12.5-12.1-12.8-12.4l-0.1-0.1l0.1-0.1c0.2-0.2,5.6-5.7,5.9-6l0.1-0.1l0.1,0.1
            c0.3,0.3,12.5,12.2,12.8,12.4l0.1,0.1l-0.1,0.1c-0.1,0.1-2.2,2.3-3.9,4L487,432.5z M474.5,419.9c1.3,1.3,11.2,10.9,12.5,12.2
            l1.9-1.9c1.4-1.5,3.2-3.3,3.7-3.8c-1.3-1.3-11.2-10.9-12.5-12.2C479.3,415,475.3,419,474.5,419.9"
              />
              <path
                class="st3"
                d="M432.7,457.9c0.2,0.3,8.7,16.6,8.9,16.9c3-2,6.1-4.3,9.2-6.8c-0.2-0.3-10.2-15.1-10.5-15.5
            C437.9,454.5,435.3,456.3,432.7,457.9"
              />
              <path
                class="st13"
                d="M441.6,475.1l-1.7-3.2c-2.5-4.8-7.2-13.7-7.3-13.9l-0.1-0.2l0.1-0.1c2.6-1.6,5.1-3.4,7.6-5.3l0.2-0.1l0.1,0.2
            c0.1,0.2,2.9,4.3,5.7,8.4c2.4,3.6,4.7,6.9,4.8,7.1l0.1,0.1l-0.1,0.1c-3.1,2.5-6.1,4.8-9.2,6.8L441.6,475.1z M433,458
            c0.6,1.2,4.9,9.3,7.3,13.7l1.5,2.9c2.9-2,5.9-4.2,8.8-6.5c-0.5-0.7-2.5-3.8-4.7-6.9c-2.5-3.6-5-7.4-5.5-8.2
            C437.9,454.7,435.5,456.4,433,458"
              />
              <path
                class="st3"
                d="M457,437.5L457,437.5l-3.4,3.5l-0.4,0.4l-0.5,0.5l-0.3,0.3c0,0-0.9,0.9-1.1,1c0.2,0.3,11.2,13.5,11.5,13.8
            c0.3-0.3,7.6-7.7,7.8-8c-0.3-0.3-12.5-12.1-12.8-12.4C457.7,436.8,457,437.5,457,437.5"
              />
              <path
                class="st13"
                d="M462.8,457.3l-0.1-0.2c-0.3-0.3-11.4-13.7-11.5-13.8l-0.1-0.1l0.1-0.1c0.2-0.1,1-1,1.1-1l5.6-5.7l0.1,0.1
            c0.1,0.1,12.5,12.1,12.8,12.4l0.1,0.1l-0.1,0.1c-0.3,0.3-7.5,7.7-7.8,8L462.8,457.3z M451.6,443.2c1.1,1.3,10,12,11.3,13.5
            c1-1,6.6-6.7,7.5-7.7c-1.3-1.3-11.2-10.9-12.5-12.2l-4.6,4.7l0,0c-0.1,0.1-0.2,0.3-0.5,0.5l-0.3,0.3
            C452.5,442.3,451.9,443,451.6,443.2"
              />
              <path
                class="st3"
                d="M471.9,422.2L471.9,422.2c0,0-4.9,5-5.1,5.3c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.7-5.8,5.9-6.1
            c-0.3-0.3-12.5-12.2-12.8-12.4C472.6,421.6,471.9,422.2,471.9,422.2"
              />
              <path
                class="st13"
                d="M479.6,440.2l-0.2-0.2c-0.1-0.1-2.4-2.3-5-4.8c-3.5-3.4-7.7-7.5-7.8-7.6l-0.1-0.1l0.1-0.1
            c0.3-0.3,5-5.1,5.1-5.3l0,0l0.9-0.9l0.1,0.1c0.3,0.3,12.7,12.3,12.8,12.4l0.1,0.1l-0.1,0.1c-0.2,0.3-5.7,5.8-5.9,6.1V440.2z
            M467,427.5c0.8,0.7,4.5,4.4,7.7,7.5c2.3,2.2,4.3,4.2,4.8,4.7c0.8-0.8,4.9-5,5.7-5.8c-1.3-1.2-11.2-10.9-12.5-12.2l-0.6,0.7l0,0
            C472.1,422.3,467.9,426.6,467,427.5"
              />
              <path
                class="st3"
                d="M420.5,464.6c0.1,0.3,7.5,17.7,7.7,18.1c3.9-2,7.8-4.2,11.6-6.7c-0.2-0.3-8.8-16.6-9-17
            C427.4,461.2,423.9,463,420.5,464.6"
              />
              <path
                class="st13"
                d="M428.1,483l-0.1-0.2c-0.1-0.1-7.5-17.7-7.7-18.1l-0.1-0.2l0.2-0.1c3.4-1.6,6.9-3.5,10.3-5.6l0.2-0.1l0.1,0.2
            c0.1,0.3,4.8,9,7.3,13.8l1.8,3.4l-0.1,0.1c-3.8,2.4-7.7,4.7-11.6,6.7L428.1,483z M420.8,464.7c0.7,1.7,6.8,15.9,7.5,17.7
            c3.8-1.9,7.6-4.1,11.3-6.5l-1.6-3.1c-2.3-4.4-6.5-12.3-7.2-13.6C427.4,461.4,424.1,463.2,420.8,464.7"
              />
              <path
                class="st3"
                d="M481.6,412.3c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.7-5.8,5.9-6.1c-0.3-0.3-12.5-12.1-12.8-12.4
            C487.3,406.5,481.8,412,481.6,412.3"
              />
              <path
                class="st13"
                d="M494.4,425l-0.1-0.1c-0.1-0.1-1.3-1.3-3-3c-3.8-3.7-9.6-9.3-9.8-9.5l-0.1-0.1l0.1-0.1
            c0.2-0.3,5.7-5.8,5.9-6.1l0.1-0.1l0.1,0.1c0.1,0.1,12.5,12.1,12.8,12.4l0.1,0.1l-0.1,0.1c-0.2,0.2-5.7,5.8-5.9,6.1L494.4,425z
            M481.9,412.3c0.9,0.9,6.1,5.9,9.6,9.3c1.4,1.4,2.5,2.4,2.9,2.8c0.8-0.8,4.9-5,5.7-5.8c-1.3-1.3-11.2-10.9-12.5-12.2
            C486.7,407.3,482.7,411.5,481.9,412.3"
              />
              <path
                class="st3"
                d="M540.1,352.6c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,21.5-22.2,21.8-22.5c-0.3-0.3-12.5-12.2-12.8-12.4
            c-0.2,0.3-21.5,22-21.8,22.2"
              />
              <path
                class="st13"
                d="M552.9,365.3l-0.1-0.1c-0.4-0.4-12.6-12.2-12.8-12.4l0.3-0.3l-0.2-0.2c0.3-0.3,21.6-22.1,21.8-22.2l0.1-0.1
            l0.1,0.1c0.3,0.3,12.7,12.3,12.8,12.4l0.1,0.1l-0.1,0.1c-0.1,0.1-6.9,7.1-12.9,13.3c-4.6,4.8-8.8,9-8.9,9.2L552.9,365.3z
            M540.3,352.5c0.8,0.7,11.3,10.9,12.6,12.3c0.8-0.8,4.5-4.7,8.8-9c5.6-5.7,11.8-12.2,12.8-13.2c-1.3-1.2-11.2-10.9-12.5-12.2
            C560.1,332.3,540.8,351.9,540.3,352.5"
              />
              <path
                class="st3"
                d="M585.3,306.1c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.8-5.9,5.9-6c-0.3-0.3-12.5-12.2-12.8-12.4
            C590.9,300.4,585.6,305.8,585.3,306.1"
              />
              <path
                class="st13"
                d="M598.1,318.8l-0.1-0.1c-0.1-0.1-3.3-3.2-6.4-6.2c-3.1-3-6.3-6.1-6.4-6.2l-0.1-0.1l0.1-0.1
            c0.3-0.3,5.6-5.7,5.9-6l0.1-0.1l3,3c3.7,3.6,9.7,9.4,9.9,9.6l0.1,0.1l-0.1,0.1c0,0-0.7,0.7-1.5,1.6c-1.7,1.7-4.1,4.2-4.3,4.4
            L598.1,318.8z M585.6,306.1c0.7,0.6,3.5,3.4,6.3,6.1s5.6,5.4,6.3,6.1c0.6-0.6,2.7-2.7,4.2-4.3c0.6-0.7,1.2-1.2,1.4-1.4
            c-0.9-0.9-6.3-6.1-9.8-9.5l-2.8-2.7C590.4,301.2,586.4,305.3,585.6,306.1"
              />
              <path
                class="st3"
                d="M577.9,313.7c0.3,0.3,12.5,12.2,12.8,12.4c0.2-0.2,5.7-5.8,5.9-6.1c-0.3-0.3-12.5-12.2-12.8-12.4
            C583.6,307.9,578.1,313.5,577.9,313.7"
              />
              <path
                class="st13"
                d="M590.7,326.4l-0.1-0.1c-0.3-0.3-12.7-12.3-12.8-12.4l-0.1-0.1l0.1-0.1c0.2-0.2,3.1-3.1,4.8-4.9l1.3-1.3
            l0.1,0.1c0.1,0.1,12.5,12.1,12.8,12.4l0.1,0.1l-0.1,0.1c-0.1,0.1-1.9,2-3.5,3.6c-1.2,1.3-2.3,2.4-2.4,2.5L590.7,326.4z
            M578.1,313.7c1.3,1.2,11.2,10.9,12.5,12.2c0.3-0.4,1.3-1.3,2.3-2.4c1.4-1.4,2.9-3,3.3-3.4c-1.3-1.3-11.2-10.9-12.5-12.2l-1,1.1
            C581.2,310.5,578.7,313.1,578.1,313.7"
              />
              <path
                class="st3"
                d="M592.7,298.5c0.3,0.3,12.5,12.2,12.8,12.4c0.2-0.2,5.7-5.8,5.9-6.1c-0.3-0.3-12.6-12.3-12.8-12.4
            C595.8,295.3,592.9,298.4,592.7,298.5"
              />
              <path
                class="st3"
                d="M496.4,397.1c0.3,0.3,12.5,12.1,12.8,12.4c0.3-0.3,5.6-5.8,5.9-6c-0.3-0.3-12.5-12.1-12.8-12.4
            C502,391.4,496.7,396.9,496.4,397.1"
              />
              <path
                class="st13"
                d="M509.2,409.8l-0.1-0.1c-0.1-0.1-3.3-3.2-6.4-6.2s-6.3-6.1-6.4-6.2l-0.1-0.1l0.1-0.1c0.3-0.3,5.6-5.7,5.9-6
            l0.1-0.1l0.1,0.1c0.3,0.3,12.5,12.2,12.8,12.4l0.1,0.1l-0.1,0.1c-0.3,0.3-5.6,5.7-5.9,6L509.2,409.8z M496.7,397.1
            c0.7,0.6,3.5,3.4,6.3,6.1s5.6,5.4,6.3,6.1c0.8-0.8,4.8-4.9,5.6-5.7c-1.3-1.3-11.2-10.9-12.5-12.2
            C501.5,392.2,497.5,396.3,496.7,397.1"
              />
              <path
                class="st3"
                d="M503.8,389.6c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.7-5.8,5.9-6.1c-0.3-0.3-12.5-12.2-12.8-12.4
            C509.5,383.7,504.1,389.3,503.8,389.6"
              />
              <path
                class="st13"
                d="M516.6,402.3l-0.1-0.1c-0.3-0.3-12.5-12.2-12.8-12.4l-0.1-0.1l0.1-0.1c0.3-0.3,5.7-5.8,5.9-6.1l0.1-0.1l1,1
            c2.9,2.8,11.7,11.3,11.9,11.6l0.1,0.1l-0.1,0.1c-0.3,0.3-5.7,5.8-5.9,6.1H516.6z M504.1,389.6c1.3,1.3,11.2,10.9,12.5,12.2
            c0.8-0.8,4.9-5,5.7-5.8c-1.2-1.1-9.1-8.8-11.8-11.4l-0.7-0.7C508.9,384.6,504.9,388.7,504.1,389.6"
              />
              <path
                class="st3"
                d="M489,404.7c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.6-5.8,5.9-6c-0.3-0.3-12.5-12.1-12.8-12.4
            C494.6,398.9,489.2,404.5,489,404.7"
              />
              <path
                class="st13"
                d="M501.8,417.4l-5.2-5.1l-7.8-7.6l0.1-0.1c0.2-0.2,5.6-5.7,5.9-6l0.1-0.1l0.1,0.1c0.3,0.3,12.7,12.3,12.8,12.4
            l0.1,0.1l-0.1,0.1c-0.1,0.1-1.6,1.7-3.1,3.2c-1.3,1.4-2.6,2.7-2.7,2.8L501.8,417.4z M489.3,404.7l12.5,12.2
            c0.4-0.4,1.5-1.5,2.6-2.7c1.3-1.3,2.6-2.6,3-3.1c-1.3-1.2-11.2-10.9-12.5-12.2C494.1,399.8,490.1,403.9,489.3,404.7"
              />
              <path
                class="st3"
                d="M526.1,366.8c0,0,12.5,12.2,12.8,12.4c0.3-0.3,5.6-5.7,5.9-6c-0.3-0.3-12.5-12.2-12.8-12.4
            C531.8,360.9,529,363.8,526.1,366.8 M518.6,374.4c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.7-5.8,5.9-6.1
            c-0.3-0.3-12.8-12.4-12.8-12.4C522.9,370,518.9,374.1,518.6,374.4"
              />
              <path
                class="st13"
                d="M531.4,387.1l-0.1-0.1c-0.3-0.3-12.5-12.2-12.8-12.4l-0.1-0.1l0.1-0.1c0.1-0.1,1.2-1.2,2.4-2.5l3.7-3.8
            l0.1,0.1c0,0,12.4,12.1,12.8,12.4l0.1,0.1l-0.1,0.1c-0.2,0.2-3.2,3.3-4.9,5L531.4,387.1z M518.9,374.4c1.3,1.3,11.2,10.9,12.5,12.2
            l0.9-1c1.5-1.5,4.1-4.2,4.7-4.8c-1.3-1.3-11.2-10.9-12.5-12.2l-3.4,3.5C520.1,373.1,519.2,374,518.9,374.4 M538.9,379.4l-0.1-0.1
            c-0.1-0.1-2.1-2.1-4.6-4.4c-8.2-8-8.2-8-8.3-8l-0.1-0.1l0.8-0.8c2.7-2.7,5-5.2,5.2-5.3l0.1-0.1l0.1,0.1
            c0.1,0.1,12.5,12.1,12.8,12.4l0.1,0.1l-0.1,0.1C544.5,373.6,539.2,379,538.9,379.4L538.9,379.4z M526.3,366.7
            c0.8,0.8,4.8,4.7,8.1,7.9c2.1,2,3.9,3.8,4.4,4.3c0.8-0.8,4.8-4.9,5.6-5.7c-1.3-1.3-11.2-10.9-12.5-12.2c-0.6,0.6-2.7,2.8-5,5.2
            L526.3,366.7z"
              />
              <path
                class="st3"
                d="M511.2,381.9c0.3,0.3,12.5,12.2,12.8,12.4c0.2-0.2,5.6-5.7,5.9-6c-0.3-0.3-12.5-12.2-12.8-12.4
            C516.8,376.2,511.5,381.7,511.2,381.9"
              />
              <path
                class="st13"
                d="M524.1,394.6l-0.1-0.1c-0.2-0.2-5.9-5.7-9.6-9.3c-1.8-1.7-3.1-3-3.2-3.1l-0.1-0.1l6.1-6.3l13.1,12.7l-0.1,0.1
            c-0.1,0.1-1.4,1.5-2.8,2.9c-1.4,1.5-2.9,3-3,3.1L524.1,394.6z M511.5,381.9c0.4,0.4,1.6,1.5,3,3c3.5,3.4,8.6,8.3,9.5,9.2
            c0.4-0.4,1.7-1.7,2.9-3c1.2-1.2,2.3-2.3,2.7-2.7l-12.5-12.2L511.5,381.9z"
              />
              <path
                class="st3"
                d="M533.5,359.2c0.3,0.3,12.5,12.2,12.8,12.4c0.2-0.2,5.6-5.7,5.9-6c-0.3-0.3-12.5-12.1-12.8-12.4
            C539.1,353.5,533.7,358.9,533.5,359.2"
              />
              <path
                class="st13"
                d="M546.3,371.9l-0.1-0.1c-0.2-0.2-6.8-6.6-10.4-10.1l-2.6-2.5l0.1-0.1c0.2-0.2,2.5-2.6,4.2-4.3l1.8-1.9l0.1,0.1
            c0.2,0.2,12.4,12,12.8,12.4l0.1,0.1l-0.1,0.1c-0.3,0.3-5.6,5.8-5.9,6L546.3,371.9L546.3,371.9z M533.7,359.2l2.3,2.2
            c3.3,3.2,9.2,9,10.2,9.9c0.8-0.8,4.8-4.9,5.6-5.7c-1.3-1.2-11.2-10.9-12.5-12.2l-1.6,1.6C536.3,356.6,534.3,358.6,533.7,359.2"
              />
              <path
                class="st3"
                d="M570.5,321.3c0.3,0.3,12.5,12.1,12.8,12.4c0.3-0.3,5.6-5.7,5.9-6c-0.3-0.3-12.5-12.2-12.8-12.4
            C576.1,315.5,570.7,321,570.5,321.3"
              />
              <path
                class="st13"
                d="M583.3,334l-0.1-0.1c-0.1-0.1-2.2-2.2-4.7-4.6c-3.6-3.5-7.9-7.7-8.1-7.8l-0.1-0.1l0.1-0.1
            c0.3-0.3,5.6-5.7,5.9-6l0.1-0.1l0.1,0.1c0.2,0.1,4,3.9,7.5,7.3c2.7,2.7,5.2,5,5.3,5.2l0.1,0.1l-1.4,1.5c-1.7,1.7-4.4,4.5-4.6,4.7
            L583.3,334z M570.7,321.3c0.8,0.8,4.7,4.5,7.9,7.7c2.2,2.1,4.1,3.9,4.6,4.4c0.6-0.6,2.9-3,4.4-4.5l1.2-1.2c-0.6-0.6-2.8-2.7-5.2-5
            c-3.1-3-6.6-6.4-7.3-7.1C575.5,316.4,571.6,320.5,570.7,321.3"
              />
              <path
                class="st3"
                d="M563.1,328.8c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.6-5.7,5.9-6c-0.3-0.3-12.5-12.1-12.8-12.4
            C568.7,323.1,563.4,328.6,563.1,328.8"
              />
              <path
                class="st13"
                d="M575.9,341.5l-0.1-0.1c-0.1-0.1-2.6-2.6-5.4-5.3c-3.4-3.3-7.2-7-7.4-7.2l-0.1-0.1l0.5-0.5
            c1.3-1.3,5.2-5.4,5.5-5.6l0.1-0.1l0.1,0.1c0.1,0.1,3.3,3.2,6.4,6.2c3.1,3,6.3,6.1,6.4,6.2l0.1,0.1l-0.1,0.1c-0.3,0.3-5.6,5.7-5.9,6
            L575.9,341.5z M563.4,328.8c0.7,0.7,4.1,4,7.3,7c2.4,2.4,4.7,4.6,5.3,5.1c0.8-0.8,4.8-4.9,5.6-5.7c-0.7-0.6-3.5-3.4-6.3-6.1
            s-5.6-5.4-6.3-6.1c-0.7,0.8-4.1,4.2-5.3,5.5L563.4,328.8z"
              />
              <path
                class="st36"
                d="M582.6,317.4l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L582.6,317.4z
            M584.4,315.5l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.4l-1.2,0.4l0,0L584.4,315.5z"
              />
              <path
                class="st36"
                d="M590.2,309.5l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L590.2,309.5z
            M592,307.7l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.4l-1.1,0.3l0,0L592,307.7z"
              />
              <path
                class="st36"
                d="M593.6,312.7l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4L596,313l-0.4-0.4l-1,1L593.6,312.7z
            M595.4,310.9l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.4l-1.2,0.4l0,0L595.4,310.9z"
              />
              <path
                class="st36"
                d="M584.5,319.2l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L584.5,319.2z"
              />
              <path
                class="st36"
                d="M575.2,325l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L575.2,325z M577,323.2
            l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L577,323.2z"
              />
              <path
                class="st36"
                d="M578.4,328.2c-1.1-1.1-0.2-2.6,0.8-3.6c1.1-1.2,2.6-1.9,3.6-0.9c1.2,1.1,0,2.6-0.9,3.5
            C580.5,328.8,579.2,329,578.4,328.2L578.4,328.2z M579.3,327.4c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.3-1.4,1.1-1.6s-0.7,0-1.7,1
            C579.3,326.7,579.1,327.1,579.3,327.4L579.3,327.4z"
              />
              <path
                class="st36"
                d="M567.5,330.2c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.4,0.9,0.4,1.2,0.1c0.4-0.5,0.2-1-0.2-1.4l-0.1-0.1l0.7-0.8
            l0.1,0.1c0.3,0.3,0.8,0.6,1.2,0.2c0.3-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.4-0.3-0.7-0.4l0.7-0.9c0.3,0.1,0.8,0.3,1.2,0.7
            c0.8,0.8,0.7,1.7,0.2,2.3c-0.4,0.4-1,0.6-1.6,0.4l0,0c0.3,0.6,0.2,1.3-0.3,1.8c-0.6,0.7-1.9,0.8-2.9-0.2c-0.4-0.4-0.6-0.8-0.7-1.1
            L567.5,330.2z"
              />
              <path
                class="st36"
                d="M575.6,331.2c0.6,0.6,0.8,1.6,0.1,2.3c-0.2,0.3-0.7,0.6-1.5,0.4l0,0c0.2,0.6,0.1,1.3-0.4,1.8
            c-0.9,0.9-2,0.7-2.7,0c-0.8-0.7-1-1.8-0.2-2.6c0.5-0.5,1.2-0.6,1.8-0.5l0,0c-0.1-0.6,0.1-1.1,0.4-1.5
            C573.8,330.4,574.9,330.5,575.6,331.2L575.6,331.2z M571.8,335c0.3,0.3,0.7,0.1,0.9-0.2c0.4-0.4,0.4-0.9,0.3-1.2
            c-0.3,0-0.6,0.1-1,0.4C571.7,334.3,571.5,334.8,571.8,335L571.8,335z M574.9,331.9c-0.2-0.2-0.6-0.1-0.8,0.2
            c-0.2,0.3-0.3,0.6-0.2,1c0.2,0.1,0.6-0.1,0.8-0.3C574.9,332.5,575.1,332.1,574.9,331.9L574.9,331.9z"
              />
              <path
                class="st36"
                d="M551.8,354.7c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.4-0.5-1-0.2-1.4,0.1l-0.1,0.1l-0.7-0.8
            l0.1-0.1c0.3-0.3,0.6-0.8,0.3-1.2c-0.3-0.3-0.6-0.3-0.9,0c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.7c0.1-0.3,0.4-0.8,0.8-1.1
            c0.9-0.8,1.8-0.7,2.3-0.1c0.4,0.5,0.5,1.1,0.3,1.6l0,0c0.6-0.3,1.3-0.1,1.8,0.4c0.6,0.7,0.7,1.9-0.3,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L551.8,354.7z"
              />
              <path
                class="st36"
                d="M559.7,346.5c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.4-0.5-1-0.2-1.4,0.1l-0.1,0.1l-0.7-0.8
            l0.1-0.1c0.3-0.3,0.6-0.8,0.3-1.2c-0.3-0.3-0.6-0.3-0.9,0c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.7c0.1-0.3,0.4-0.8,0.8-1.1
            c0.9-0.8,1.8-0.7,2.3-0.1c0.4,0.4,0.5,1.1,0.3,1.6l0,0c0.6-0.3,1.3-0.1,1.8,0.4c0.6,0.7,0.7,1.9-0.3,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L559.7,346.5z"
              />
              <path
                class="st36"
                d="M537.8,360.7c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.4,0.9,0.4,1.2,0.1c0.4-0.5,0.2-1-0.2-1.4l-0.1-0.1l0.7-0.8
            l0.1,0.1c0.3,0.3,0.8,0.6,1.2,0.2c0.3-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.4-0.3-0.7-0.4l0.6-0.9c0.3,0.1,0.8,0.3,1.2,0.7
            c0.8,0.8,0.7,1.7,0.2,2.3c-0.4,0.4-1,0.6-1.6,0.4l0,0c0.3,0.6,0.2,1.3-0.3,1.8c-0.6,0.7-1.9,0.8-2.9-0.2c-0.4-0.4-0.6-0.8-0.7-1.1
            L537.8,360.7z"
              />
              <path
                class="st36"
                d="M541.4,366.1c-1.1-1.1-0.2-2.6,0.8-3.6c1.1-1.2,2.6-1.9,3.6-0.9c1.2,1.1,0,2.6-0.8,3.5
            C543.5,366.8,542.2,366.9,541.4,366.1L541.4,366.1z M542.3,365.3c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.3-1.4,1.1-1.6s-0.7,0-1.7,1
            C542.3,364.6,542.1,365,542.3,365.3L542.3,365.3z"
              />
              <path
                class="st36"
                d="M529.4,369l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L529.4,369z"
              />
              <path
                class="st36"
                d="M538.6,369.2c0.6,0.6,0.8,1.6,0.1,2.3c-0.2,0.3-0.7,0.6-1.5,0.4l0,0c0.2,0.6,0.1,1.3-0.4,1.8
            c-0.9,0.9-2,0.7-2.7,0c-0.8-0.7-1-1.8-0.2-2.6c0.5-0.5,1.2-0.6,1.8-0.5l0,0c-0.1-0.6,0.1-1.1,0.4-1.5
            C536.8,368.3,537.8,368.5,538.6,369.2L538.6,369.2z M534.7,373c0.3,0.3,0.7,0.1,0.9-0.2c0.4-0.4,0.4-0.9,0.3-1.2
            c-0.3,0-0.6,0.1-1,0.4C534.7,372.3,534.5,372.7,534.7,373L534.7,373z M537.8,369.8c-0.2-0.2-0.6-0.1-0.8,0.2
            c-0.2,0.3-0.3,0.6-0.2,1c0.2,0.1,0.6-0.1,0.8-0.3C537.9,370.4,538.1,370.1,537.8,369.8L537.8,369.8z"
              />
              <path
                class="st36"
                d="M521.9,376.7l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1H524l0,0l1.3,1.3l-0.9,0.9L521.9,376.7z"
              />
              <path
                class="st36"
                d="M531.2,378.6c-0.1-0.1-0.3-0.2-0.4-0.3c-0.6-0.4-1.3-0.3-1.9,0.1l0,0c0.3,0,0.7,0,1,0.3
            c0.6,0.6,0.5,1.5-0.3,2.4c-0.7,0.7-2,1.2-2.9,0.3c-0.9-0.8-0.7-2.1,0.4-3.2c1-1,2-1.3,2.8-1.3c0.6,0,1.2,0.2,1.6,0.5
            c0.3,0.2,0.4,0.3,0.5,0.4L531.2,378.6z M527.4,380.6c0.3,0.3,0.7-0.1,1.2-0.6c0.2-0.3,0.5-0.7,0.3-0.9c-0.1-0.1-0.3-0.1-0.5,0
            c-0.1,0-0.2,0.2-0.5,0.4C527.4,379.9,527.1,380.4,527.4,380.6L527.4,380.6z"
              />
              <path
                class="st36"
                d="M514.6,384.2l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L514.6,384.2z"
              />
              <path
                class="st36"
                d="M519.4,388.8l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L519.4,388.8z
            M521.2,387l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L521.2,387z"
              />
              <path
                class="st36"
                d="M507.1,391.8l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L507.1,391.8z"
              />
              <path
                class="st36"
                d="M510.5,395l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L510.5,395z"
              />
              <path
                class="st36"
                d="M499.7,399.3l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L499.7,399.3z"
              />
              <path
                class="st36"
                d="M504.4,404c-1.1-1.1-0.2-2.6,0.8-3.6c1.1-1.2,2.6-1.9,3.6-0.9c1.2,1.1,0,2.6-0.9,3.5
            C506.5,404.6,505.2,404.7,504.4,404L504.4,404z M505.3,403.1c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.3-1.4,1.1-1.6
            c-0.2-0.2-0.7,0-1.7,1S505.1,402.9,505.3,403.1L505.3,403.1z"
              />
              <polygon
                class="st36"
                points="496.7,404.5 496.7,404.5 495.6,404.2 496.2,403.2 497.8,403.7 498.7,404.6 494.4,409 493.3,408 	"
              />
              <path
                class="st36"
                d="M501.5,407.2c0.6,0.6,0.8,1.6,0.1,2.3c-0.2,0.3-0.7,0.6-1.5,0.4l0,0c0.2,0.6,0.1,1.3-0.4,1.8
            c-0.9,0.9-2,0.7-2.7,0c-0.8-0.7-1-1.8-0.2-2.6c0.5-0.5,1.2-0.6,1.8-0.5l0,0c-0.1-0.6,0.1-1.1,0.4-1.5
            C499.7,406.3,500.7,406.4,501.5,407.2L501.5,407.2z M497.7,411c0.3,0.3,0.7,0,0.9-0.2c0.4-0.4,0.4-0.9,0.3-1.2
            c-0.3,0-0.6,0.1-1,0.4C497.6,410.3,497.4,410.7,497.7,411L497.7,411z M500.8,407.8c-0.2-0.2-0.6-0.1-0.8,0.2
            c-0.2,0.3-0.3,0.6-0.2,1c0.2,0.1,0.6-0.1,0.8-0.3C500.8,408.4,501,408,500.8,407.8L500.8,407.8z"
              />
              <polygon
                class="st36"
                points="489.3,412.1 489.3,412.1 488.2,411.7 488.8,410.8 490.4,411.3 491.3,412.2 487,416.6 485.9,415.6
            "
              />
              <path
                class="st36"
                d="M494.2,416.5c-0.1-0.1-0.3-0.2-0.4-0.3c-0.6-0.4-1.3-0.3-1.9,0.1l0,0c0.3,0,0.7,0,1,0.3
            c0.6,0.6,0.5,1.5-0.3,2.4c-0.7,0.7-2,1.2-2.9,0.3c-0.9-0.8-0.7-2.1,0.4-3.2c1-1,2-1.3,2.8-1.3c0.6,0,1.2,0.2,1.6,0.5
            c0.3,0.2,0.4,0.4,0.5,0.4L494.2,416.5z M490.3,418.5c0.3,0.3,0.7-0.1,1.2-0.6c0.2-0.3,0.5-0.7,0.3-0.9c-0.1-0.1-0.3-0.1-0.5,0
            c-0.1,0-0.2,0.2-0.5,0.4C490.4,417.8,490.1,418.3,490.3,418.5L490.3,418.5z"
              />
              <polygon
                class="st36"
                points="481.9,419.7 481.9,419.7 480.8,419.3 481.4,418.3 482.9,418.9 483.9,419.8 479.6,424.2 478.5,423.2
            "
              />
              <path
                class="st36"
                d="M482.3,426.8l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L482.3,426.8z
            M484.1,425l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L484.1,425z"
              />
              <polygon
                class="st36"
                points="474.5,427.3 474.5,427.3 473.4,426.9 474,425.9 475.6,426.4 476.5,427.3 472.2,431.7 471.1,430.7
            "
              />
              <path
                class="st36"
                d="M473.5,433l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L473.5,433z"
              />
              <polygon
                class="st36"
                points="467.1,434.9 467.1,434.8 466,434.5 466.6,433.5 468.2,434 469.1,434.9 464.8,439.3 463.7,438.3 	"
              />
              <path
                class="st36"
                d="M467.4,441.9c-1.1-1.1-0.2-2.6,0.8-3.6c1.1-1.2,2.6-1.9,3.6-0.9c1.2,1.1,0,2.6-0.8,3.5
            C469.4,442.6,468.1,442.7,467.4,441.9L467.4,441.9z M468.3,441.1c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.3-1.4,1.1-1.6
            c-0.2-0.2-0.7,0-1.7,1S468,440.8,468.3,441.1L468.3,441.1z"
              />
              <path
                class="st36"
                d="M462.5,444.1c0.6,0.6,0.8,1.6,0.1,2.3c-0.2,0.3-0.7,0.6-1.5,0.4l0,0c0.2,0.6,0.1,1.3-0.4,1.8
            c-0.9,0.9-2,0.7-2.7,0c-0.8-0.7-1-1.8-0.2-2.6c0.5-0.5,1.2-0.6,1.8-0.5l0,0c-0.1-0.6,0.1-1.1,0.4-1.5
            C460.7,443.3,461.8,443.4,462.5,444.1L462.5,444.1z M458.7,447.9c0.3,0.3,0.7,0.1,0.9-0.2c0.4-0.4,0.4-0.9,0.3-1.2
            c-0.3,0-0.6,0.1-1,0.4C458.6,447.2,458.5,447.7,458.7,447.9L458.7,447.9z M461.8,444.8c-0.2-0.2-0.6-0.1-0.8,0.2
            c-0.2,0.3-0.3,0.6-0.2,1c0.2,0.1,0.6-0.1,0.8-0.3C461.9,445.4,462.1,445,461.8,444.8L461.8,444.8z"
              />
              <path
                class="st36"
                d="M453.2,455c-0.1-0.1-0.2-0.3-0.4-0.4c-0.6-0.5-1.2-0.5-1.9-0.1l0,0c0.3,0,0.7,0.1,0.9,0.4
            c0.5,0.7,0.3,1.6-0.6,2.3c-0.8,0.7-2.1,1-2.9-0.1c-0.8-0.9-0.5-2.2,0.7-3.2c1.1-0.9,2.1-1.1,3-1c0.6,0.1,1.2,0.4,1.6,0.7
            c0.3,0.2,0.4,0.4,0.5,0.5L453.2,455z M449.2,456.5c0.3,0.3,0.8-0.1,1.2-0.4c0.3-0.2,0.6-0.6,0.4-0.9c-0.1-0.1-0.3-0.2-0.5-0.1
            c-0.1,0-0.3,0.1-0.5,0.3C449.3,455.8,449,456.3,449.2,456.5L449.2,456.5z"
              />
              <path
                class="st36"
                d="M163.3,336.1c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L163.3,336.1z"
              />
              <path
                class="st36"
                d="M151.3,317.9c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.9-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L151.3,317.9z"
              />
              <path
                class="st36"
                d="M167,332.6c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0
            c0,0.3-0.1,0.6-0.3,0.8c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.8,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9
            c0,0.5-0.2,1.1-0.6,1.6c-0.1,0.2-0.3,0.3-0.4,0.4L167,332.6z M165,328.8c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3
            c0.1-0.1,0.1-0.3,0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.6C165.6,328.8,165.2,328.6,165,328.8L165,328.8z"
              />
              <path
                class="st36"
                d="M170.9,343.4c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L170.9,343.4z"
              />
              <polygon
                class="st36"
                points="173.2,334.2 173.9,334.8 176.2,339.8 175.3,340.9 173.1,336.1 173,336.1 171.6,337.6 170.7,336.7
            "
              />
              <path
                class="st36"
                d="M178.6,350.9c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L178.6,350.9z"
              />
              <path
                class="st36"
                d="M181.6,342.8l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.9,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.8,0.6-1,0.7l-0.7-1c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.6-0.5-1.2-0.2-1.6,0.2c-0.1,0.1-0.2,0.2-0.3,0.3
            l-2.1-2.5l1.9-1.9L181.6,342.8z"
              />
              <path
                class="st36"
                d="M143.7,305.6l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.9,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.8,0.6-1,0.7l-0.7-1c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.6-0.5-1.2-0.2-1.6,0.2c-0.1,0.1-0.2,0.2-0.3,0.3
            l-2.1-2.5l1.9-1.9L143.7,305.6z"
              />
              <path
                class="st36"
                d="M186.1,358.1c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.9-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L186.1,358.1z"
              />
              <path
                class="st36"
                d="M189.3,354.8c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L189.3,354.8z"
              />
              <path
                class="st36"
                d="M193.8,365.6c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L193.8,365.6z"
              />
              <polygon
                class="st36"
                points="195.4,358.9 195.4,358.9 195,360.1 194.1,359.4 194.6,357.9 195.5,356.9 199.9,361.2 198.9,362.3
            "
              />
              <polygon
                class="st36"
                points="157.2,322.3 157.2,322.3 156.8,323.4 155.8,322.8 156.3,321.2 157.3,320.3 161.7,324.6 160.7,325.6
            "
              />
              <path
                class="st36"
                d="M202.2,374.1l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1.1,0c-0.3,0.3-0.4,0.6-0.4,0.9
            l-1-0.6c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L202.2,374.1z"
              />
              <path
                class="st36"
                d="M205,369.6c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0
            c0,0.3-0.1,0.6-0.3,0.8c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.9,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9
            c0,0.5-0.2,1.1-0.6,1.6c-0.1,0.2-0.3,0.3-0.4,0.4L205,369.6z M203.1,365.8c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3
            c0.1-0.1,0.1-0.3,0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.6C203.7,365.7,203.3,365.6,203.1,365.8L203.1,365.8z"
              />
              <path
                class="st36"
                d="M209.8,381.4l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L209.8,381.4z"
              />
              <polygon
                class="st36"
                points="211.2,371.1 211.9,371.8 214.3,376.8 213.3,377.8 211.1,373.1 211.1,373.1 209.7,374.5 208.7,373.6
            "
              />
              <path
                class="st36"
                d="M217.3,388.7l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L217.3,388.7z"
              />
              <path
                class="st36"
                d="M219.4,379.5l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.9,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.8,0.6-1,0.7l-0.7-1c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.6-0.5-1.2-0.2-1.6,0.2c-0.1,0.1-0.2,0.2-0.3,0.3
            l-2.1-2.5l1.9-1.9L219.4,379.5z"
              />
              <polygon
                class="st36"
                points="237.8,406.6 237.8,406.6 237.4,407.7 236.4,407.1 236.9,405.6 237.9,404.6 242.3,408.9 241.3,410
            "
              />
              <path
                class="st36"
                d="M243.1,406.5c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0
            c0,0.3-0.1,0.6-0.3,0.8c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.9,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9
            c0,0.5-0.2,1.1-0.6,1.6c-0.1,0.2-0.3,0.3-0.4,0.4L243.1,406.5z M241.1,402.7c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.4
            c0.1-0.1,0.1-0.3,0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.6C241.7,402.6,241.3,402.5,241.1,402.7L241.1,402.7z"
              />
              <polygon
                class="st36"
                points="260.6,428.3 260.5,428.3 260.2,429.4 259.2,428.8 259.7,427.2 260.6,426.3 265,430.6 264,431.6 	"
              />
              <path
                class="st36"
                d="M265.1,423.5l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.9,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.8,0.6-1,0.7l-0.7-1c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.6-0.5-1.2-0.2-1.6,0.2c-0.1,0.1-0.2,0.2-0.3,0.3
            l-2.1-2.5l1.9-1.9L265.1,423.5z"
              />
              <polygon
                class="st36"
                points="268.8,434.9 268.7,434.9 268.4,436 267.4,435.4 267.9,433.8 268.8,432.9 273.2,437.2 272.2,438.2
            "
              />
              <polygon
                class="st36"
                points="272,431.5 272,431.5 271.7,432.6 270.7,432 271.2,430.5 272.1,429.5 276.5,433.8 275.5,434.9 	"
              />
              <path
                class="st36"
                d="M279.6,444.7c0.2-0.2,0.3-0.3,0.4-0.5s0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0c0,0.3-0.1,0.6-0.3,0.8
            c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.9,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9c0,0.5-0.2,1.1-0.6,1.6
            c-0.1,0.2-0.3,0.3-0.4,0.4L279.6,444.7z M277.6,440.9c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3c0.1-0.1,0.1-0.3,0.1-0.4
            c-0.1-0.1-0.2-0.2-0.5-0.6C278.2,440.9,277.8,440.7,277.6,440.9L277.6,440.9z"
              />
              <polygon
                class="st36"
                points="286.4,446.9 287.1,447.6 289.5,452.6 288.5,453.6 286.3,448.9 286.3,448.9 284.9,450.3 283.9,449.4
            "
              />
              <path
                class="st36"
                d="M296.2,456.9l-1,1.2l0.6,0.6l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.6s1,0.1,1.4,0.5c0.9,0.8,1.2,2,0.3,3.2
            c-0.3,0.4-0.7,0.7-1,0.8l-0.8-0.9c0.2-0.1,0.5-0.3,0.7-0.6c0.4-0.5,0.3-0.9-0.1-1.3c-0.6-0.5-1.2-0.1-1.6,0.4
            c-0.1,0.1-0.2,0.2-0.3,0.3l-2.3-2.3l1.7-2.1L296.2,456.9z"
              />
              <path
                class="st36"
                d="M307.7,469.6c0.3-0.1,0.5-0.4,0.7-0.7c0.3-0.5,0.2-0.9-0.1-1.2c-0.5-0.3-1,0-1.3,0.5l-0.1,0.1l-0.9-0.6
            l0.1-0.1c0.2-0.4,0.4-0.9,0-1.2c-0.3-0.2-0.7-0.1-0.9,0.2c-0.1,0.2-0.2,0.5-0.2,0.8l-1-0.5c0-0.3,0.2-0.8,0.5-1.3
            c0.6-1,1.6-1.1,2.2-0.6c0.5,0.3,0.7,0.9,0.7,1.5l0,0c0.5-0.4,1.2-0.5,1.9,0c0.8,0.5,1.2,1.7,0.4,2.9c-0.3,0.5-0.6,0.8-0.9,0.9
            L307.7,469.6z"
              />
              <polygon
                class="st36"
                points="315.8,473.4 315.8,473.4 315.8,474.6 314.7,474.3 314.7,472.7 315.3,471.5 320.8,474.2 320.2,475.5
            "
              />
              <path
                class="st36"
                d="M438.5,464.5l1.1-0.8l-1.2-1.8l0.8-0.6l4.3-0.5l0.8,1.2l-3,2l0.3,0.5l-1,0.7l-0.3-0.5l-1.1,0.8L438.5,464.5z
            M440.6,463l0.9-0.6c0.2-0.2,0.5-0.3,0.8-0.5l0,0c-0.3,0.1-0.6,0.1-0.9,0.2l-1.2,0.1l0,0L440.6,463z"
              />
              <path
                class="st36"
                d="M425.7,469.6l0.9-0.5l1,0.2c1.3,0.2,2.2,0.4,2.9,0c0.4-0.2,0.5-0.6,0.3-1c-0.2-0.3-0.5-0.5-0.7-0.7l0.9-0.8
            c0.3,0.2,0.7,0.6,1,1.1c0.7,1.3,0.1,2.2-0.7,2.6c-1,0.6-2.1,0.3-3.1,0.1l-0.5-0.1l0,0l0.9,1.6l-1.1,0.6L425.7,469.6z"
              />
              <polygon
                class="st3"
                points="216.5,393.6 230.4,407.1 243,394.2 229.1,380.8 	"
              />
              <path
                class="st13"
                d="M230.4,407.4l-14.2-13.8l12.9-13.1l0.1,0.1l14,13.6l-0.1,0.1L230.4,407.4z M216.7,393.6l13.7,13.3l12.3-12.6
            l-13.6-13.2L216.7,393.6z"
              />
              <path
                class="st36"
                d="M228.8,399.3l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L228.8,399.3z"
              />
              <path
                class="st36"
                d="M231.2,394.9c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L231.2,394.9z"
              />
              <path
                class="st36"
                d="M555.5,352.5l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L555.5,352.5z"
              />
              <path
                class="st36"
                d="M562.4,338.8c-0.1,0.1-0.2,0.3-0.3,0.5c-0.4,0.7-0.2,1.3,0.2,1.9l0,0c-0.1-0.3,0-0.7,0.2-1
            c0.5-0.6,1.5-0.6,2.4,0.2c0.8,0.7,1.3,1.9,0.5,2.9c-0.8,0.9-2,0.9-3.2-0.1c-1.1-0.9-1.5-1.9-1.5-2.7c0-0.6,0.1-1.2,0.4-1.7
            c0.2-0.3,0.3-0.5,0.4-0.6L562.4,338.8z M564.6,342.4c0.3-0.3-0.2-0.7-0.6-1.1c-0.3-0.2-0.7-0.5-1-0.2c-0.1,0.1-0.1,0.3,0,0.5
            c0,0.1,0.2,0.2,0.4,0.4C563.9,342.5,564.4,342.7,564.6,342.4L564.6,342.4z"
              />
              <polygon
                class="st36"
                points="559.4,350 558.8,350.3 555,342.9 555.5,342.6 	"
              />
              <path
                class="st18"
                d="M418.3,462.4L412,447c-25.5,12.2-52.6,12.6-78.3,0.6l-6,15.8l-8.6,21.6c16.7,7,34.3,12.4,53.5,12.4
            c20.1,0,35.5-4.1,55.1-12.2L418.3,462.4z"
              />
              <path
                class="st29"
                d="M307.5,448.1c0.3-0.4,0.7-0.4,1-0.2c0.6,0.4,0.9,1.3,1.3,2.5l0.3,1l0.8,0.6l2-2.9l-1.1-0.7l-1,1.5l0,0
            l-0.1-0.5c-0.2-1-0.5-2-1.5-2.7c-0.7-0.5-1.8-0.7-2.6,0.6c-0.3,0.5-0.5,1-0.5,1.4l1.1,0.4C307.2,448.7,307.3,448.4,307.5,448.1"
              />
              <path
                class="st29"
                d="M311,446.4c1.2,0.8,2.8,1.4,3.6,0.2l0,0c0.6-0.8,0.2-2.1-1.6-3.3c-1-0.7-2.7-1.6-3.6-0.2
            C308.7,444.1,309.7,445.5,311,446.4 M310.5,443.7c0.2-0.3,0.7,0,1.8,0.7c1.1,0.8,1.5,1.1,1.4,1.4l0,0c-0.2,0.3-0.7,0.1-1.8-0.7
            C310.6,444.4,310.3,443.9,310.5,443.7"
              />
              <path
                class="st29"
                d="M314.1,441.9c0.4-0.5,0.9-1,1.5-0.5c0.4,0.3,0.5,0.8,0.2,1.3c-0.2,0.3-0.4,0.5-0.7,0.6l0.8,0.8
            c0.2-0.1,0.6-0.5,0.9-0.9c0.8-1.2,0.4-2.4-0.5-3.1c-0.5-0.3-1-0.5-1.5-0.4s-0.9,0.5-1,0.7l-0.1,0.1l-0.7-0.6l0.9-1.3l-1-0.7
            l-1.5,2.2l2.5,2.1C314,442.2,314,442,314.1,441.9"
              />
              <path
                class="st29"
                d="M325.4,457l-0.8,1.6l0,0l-0.2-0.5c-0.3-0.9-0.8-1.9-1.8-2.5c-0.8-0.4-1.8-0.4-2.5,0.9
            c-0.3,0.5-0.3,1.1-0.3,1.4l1.1,0.3c0-0.3,0-0.6,0.2-1s0.6-0.5,1-0.3c0.7,0.3,1.1,1.2,1.6,2.3l0.4,0.9l0.9,0.4l1.6-3.1L325.4,457z"
              />
              <path
                class="st29"
                d="M328,454.9c-0.7,1.3-2.4,0.9-3.6,0.3c-1.5-0.7-2.6-1.9-2-3.1c0.7-1.4,2.5-0.8,3.6-0.3
            C328,452.7,328.5,453.9,328,454.9L328,454.9z M326.9,454.3c0.1-0.3-0.3-0.6-1.5-1.2c-1.1-0.6-1.7-0.8-1.9-0.5
            c-0.1,0.3,0.2,0.6,1.5,1.3C326.2,454.5,326.7,454.6,326.9,454.3L326.9,454.3z"
              />
              <path
                class="st29"
                d="M328.1,451.6c0.3-0.2,0.5-0.4,0.6-0.7c0.3-0.5,0.1-0.9-0.3-1.1c-0.6-0.3-1,0.1-1.3,0.6l-0.1,0.2l-0.9-0.5
            l0.1-0.1c0.2-0.4,0.3-1-0.1-1.2c-0.3-0.2-0.7,0-0.8,0.3c-0.1,0.2-0.2,0.5-0.2,0.8l-1.1-0.3c0-0.3,0.1-0.9,0.3-1.3
            c0.5-1,1.4-1.2,2.1-0.9c0.5,0.3,0.8,0.8,0.8,1.4l0,0c0.5-0.4,1.2-0.6,1.8-0.2c0.8,0.4,1.3,1.5,0.7,2.8c-0.2,0.5-0.6,0.8-0.8,1
            L328.1,451.6z"
              />
              <path
                class="st29"
                d="M351.6,471.8c0.4-0.1,1-0.1,1.9-0.1s1.5,0.2,1.9,0.5s0.7,0.8,0.7,1.4s-0.2,1.1-0.6,1.5
            c-0.5,0.4-1.2,0.7-2,0.7c-0.2,0-0.4,0-0.5,0v2.2h-1.4V471.8z M353,474.6c0.1,0,0.3,0,0.5,0c0.8,0,1.2-0.4,1.2-1s-0.4-0.9-1.1-0.9
            c-0.3,0-0.5,0-0.6,0V474.6z"
              />
              <path
                class="st29"
                d="M357,471.8c0.5-0.1,1.1-0.1,1.9-0.1c0.9,0,1.6,0.1,2,0.5c0.4,0.3,0.6,0.7,0.6,1.3c0,0.8-0.6,1.3-1.1,1.5l0,0
            c0.4,0.2,0.7,0.6,0.8,1.2c0.2,0.7,0.4,1.5,0.5,1.8h-1.4c-0.1-0.2-0.2-0.7-0.4-1.5c-0.2-0.8-0.4-1-1-1h-0.5v2.4H357V471.8z
            M358.4,474.5h0.6c0.7,0,1.1-0.3,1.1-0.9s-0.4-0.9-1-0.9c-0.3,0-0.5,0-0.6,0v1.8H358.4z"
              />
              <polygon
                class="st29"
                points="366.2,475.3 363.9,475.3 363.9,476.8 366.5,476.8 366.5,477.9 362.5,477.9 362.5,471.7 366.3,471.7
            366.3,472.9 363.9,472.9 363.9,474.2 366.2,474.2 	"
              />
              <path
                class="st29"
                d="M367.5,476.5c0.4,0.2,1,0.4,1.6,0.4s1-0.3,1-0.7c0-0.4-0.3-0.6-1-0.9c-1-0.4-1.7-0.9-1.7-1.9
            c0-1.1,0.9-1.9,2.4-1.9c0.7,0,1.2,0.1,1.6,0.3l-0.3,1.1c-0.2-0.1-0.7-0.3-1.3-0.3c-0.6,0-0.9,0.3-0.9,0.6c0,0.4,0.3,0.6,1.2,0.9
            c1.1,0.4,1.6,1,1.6,1.9c0,1-0.8,1.9-2.5,1.9c-0.7,0-1.4-0.2-1.8-0.4L367.5,476.5z"
              />
              <path
                class="st29"
                d="M372.5,476.5c0.4,0.2,1,0.4,1.6,0.4s1-0.3,1-0.7c0-0.4-0.3-0.6-1-0.9c-1-0.4-1.7-0.9-1.7-1.9
            c0-1.1,0.9-1.9,2.4-1.9c0.7,0,1.2,0.1,1.6,0.3l-0.3,1.1c-0.2-0.1-0.7-0.3-1.3-0.3c-0.6,0-0.9,0.3-0.9,0.6c0,0.4,0.3,0.6,1.2,0.9
            c1.1,0.4,1.6,1,1.6,1.9c0,1-0.8,1.9-2.5,1.9c-0.7,0-1.4-0.2-1.8-0.4L372.5,476.5z"
              />
              <path
                class="st29"
                d="M379.3,471.8c0.4-0.1,1.1-0.1,1.8-0.1c0.9,0,1.4,0.1,1.8,0.3c0.4,0.2,0.7,0.7,0.7,1.2s-0.3,1.1-1,1.3l0,0
            c0.7,0.2,1.2,0.7,1.2,1.5c0,0.6-0.3,1-0.6,1.3c-0.5,0.4-1.2,0.6-2.5,0.6c-0.7,0-1.2,0-1.5-0.1v-6L379.3,471.8L379.3,471.8z
            M380.7,474.2h0.5c0.8,0,1.1-0.3,1.1-0.8s-0.4-0.7-1-0.7c-0.3,0-0.5,0-0.6,0V474.2z M380.7,476.9c0.1,0,0.3,0,0.5,0
            c0.6,0,1.2-0.2,1.2-0.9c0-0.6-0.6-0.9-1.3-0.9h-0.5L380.7,476.9L380.7,476.9z"
              />
              <path
                class="st29"
                d="M387.6,478c-1.8,0-2.9-1.4-2.9-3.2c0-1.9,1.2-3.3,3-3.3c1.9,0,3,1.4,3,3.1C390.6,476.8,389.4,478,387.6,478
            L387.6,478z M387.6,476.9c1,0,1.5-0.9,1.5-2.1c0-1.1-0.5-2.1-1.5-2.1s-1.5,0.9-1.5,2.1S386.7,476.9,387.6,476.9L387.6,476.9z"
              />
              <path
                class="st29"
                d="M394.5,477.9l-0.6-1.1c-0.2-0.4-0.4-0.8-0.6-1.1l0,0c-0.1,0.4-0.3,0.7-0.5,1.1l-0.5,1.1h-1.6l1.8-3.2
            l-1.7-3.1h1.6l0.5,1.1c0.2,0.4,0.3,0.7,0.5,1l0,0c0.1-0.4,0.3-0.7,0.4-1l0.5-1.1h1.6l-1.8,3l1.9,3.2h-1.5L394.5,477.9L394.5,477.9z
            "
              />
              <path
                class="st29"
                d="M432.7,440.5l-1-1.5l0,0l0.5,0.1c1,0.2,2.1,0.3,3-0.4c0.7-0.5,1.3-1.4,0.4-2.6c-0.3-0.5-0.8-0.8-1.1-1
            l-0.8,0.8c0.3,0.1,0.6,0.3,0.8,0.6c0.3,0.4,0.2,0.8-0.2,1c-0.6,0.4-1.5,0.4-2.8,0.3l-1-0.1l-0.8,0.6l2,2.9L432.7,440.5z"
              />
              <path
                class="st29"
                d="M433.3,443.8c0.6,0.9,1.9,1,3.7-0.2c1-0.7,2.4-1.9,1.5-3.3c-0.8-1.1-2.4-0.7-3.7,0.2
            C433.7,441.2,432.5,442.5,433.3,443.8L433.3,443.8z M435.7,441.6c1.2-0.8,1.7-0.9,1.8-0.7c0.2,0.3-0.3,0.7-1.4,1.4
            c-1.1,0.8-1.6,1-1.8,0.7l0,0C434.2,442.8,434.5,442.4,435.7,441.6"
              />
              <path
                class="st29"
                d="M438.9,448c1-0.6,1.3-1.5,0.8-2.2c-0.2-0.3-0.5-0.5-0.9-0.5l0,0c0.7-0.3,1.3-0.2,1.9,0.3
            c0.1,0.1,0.3,0.3,0.4,0.4l1-0.7c-0.1-0.1-0.2-0.3-0.4-0.5c-0.4-0.4-0.9-0.7-1.5-0.8c-0.8-0.2-1.9-0.1-3,0.7c-1.3,0.9-1.7,2.1-1,3.1
            C436.7,448.7,438,448.5,438.9,448 M437.5,446c0.3-0.2,0.5-0.3,0.5-0.3c0.2,0,0.4,0,0.5,0.1c0.2,0.3-0.2,0.7-0.4,0.9
            c-0.5,0.3-1,0.7-1.2,0.3l0,0C436.7,446.8,437,446.4,437.5,446"
              />
              <path
                class="st29"
                d="M415.2,447.1l0.9-0.4l1,0.2c1.3,0.3,2.1,0.5,2.8,0.2c0.4-0.2,0.5-0.6,0.3-1c-0.2-0.3-0.4-0.6-0.7-0.7l0.9-0.7
            c0.3,0.2,0.7,0.6,1,1.1c0.6,1.3,0,2.1-0.8,2.5c-1,0.5-2.1,0.2-3-0.1l-0.5-0.2l0,0l0.8,1.6l-1.2,0.6L415.2,447.1z"
              />
              <path
                class="st29"
                d="M418,453c-0.6-1.4,0.7-2.4,2-3c1.5-0.7,3.1-0.9,3.7,0.4c0.7,1.5-0.9,2.5-2,3C419.7,454.3,418.4,454,418,453
            L418,453z M419.1,452.5c0.1,0.3,0.6,0.1,1.9-0.5c1.1-0.5,1.7-0.9,1.6-1.2c-0.1-0.3-0.7-0.2-1.9,0.4
            C419.3,451.9,419,452.2,419.1,452.5L419.1,452.5z"
              />
              <path
                class="st29"
                d="M420.1,457.3l1.2-0.6l-0.9-1.9l0.9-0.4l4.3,0.2l0.6,1.3l-3.3,1.5l0.2,0.5l-1,0.5l-0.3-0.5l-1.2,0.6
            L420.1,457.3z M422.4,456.2l0.9-0.5c0.3-0.1,0.6-0.2,0.9-0.3l0,0c-0.3,0-0.6,0-1,0H422l0,0L422.4,456.2z"
              />
              <line class="st45" x1="140.6" y1="268.6" x2="128.2" y2="281.3" />
              <polygon
                class="st3"
                points="128,282.6 126.8,281.4 140.9,267.2 142.1,268.4 	"
              />
              <polygon
                class="st46"
                points="326.8,465.8 325.2,465.3 332.4,446.9 333.9,447.5 	"
              />
              <polygon
                class="st46"
                points="420.6,464.4 419.1,465 411.5,446.8 413,446.2 	"
              />
              <polygon
                class="st3"
                points="618.8,271.2 617.6,272.3 603.7,257.9 604.9,256.8 	"
              />
              <polygon
                class="st36"
                points="249.8,417.6 249.8,417.6 249.5,418.7 248.5,418.1 249,416.6 249.9,415.6 254.3,419.9 253.3,421 	"
              />
              <polygon
                class="st36"
                points="253.7,411.7 254.4,412.4 256.8,417.4 255.8,418.4 253.6,413.7 253.6,413.7 252.2,415.1 251.2,414.2
            "
              />
              <path
                class="st3"
                d="M406.8,470.2c0.1,0.3,5.5,18.4,5.7,18.8c4.2-1.4,8.7-2.9,12.8-4.8c-0.1-0.3-7-17.8-7.1-18.2
            C414.4,467.6,410.4,469.1,406.8,470.2"
              />
              <path
                class="st47"
                d="M406.8,470.2c0.1,0.3,5.5,18.4,5.7,18.8c4.2-1.4,8.7-2.9,12.8-4.8c-0.1-0.3-7-17.8-7.1-18.2
            C414.4,467.6,410.4,469.1,406.8,470.2"
              />
              <path
                class="st36"
                d="M158.2,328l-1-1l-1.6,1.6l-0.7-0.7l-1.4-4.2l1-1.1l2.7,2.6l0.4-0.4l0.9,0.8l-0.4,0.4l1,1L158.2,328z
            M156.3,326.2l-0.8-0.8c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.4,0.9l0.4,1.2l0,0L156.3,326.2z"
              />
              <path
                class="st36"
                d="M150.2,320.7l-1-1l-1.6,1.6l-0.7-0.7l-1.4-4.2l1-1.1l2.7,2.6l0.4-0.4l0.9,0.8l-0.4,0.4l1,1L150.2,320.7z
            M148.3,318.9l-0.8-0.8c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.4,0.9l0.4,1.2l0,0L148.3,318.9z"
              />
              <path
                class="st36"
                d="M143,313.3l-1-1l-1.6,1.6l-0.7-0.7l-1.4-4.2l1-1.1l2.7,2.6l0.4-0.4l0.9,0.8l-0.4,0.4l1,1L143,313.3z
            M141.1,311.4l-0.8-0.8c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.4,0.9l0.4,1.2l0,0L141.1,311.4z"
              />
              <path
                class="st38"
                d="M633,261.8c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C626.6,259.5,630.5,259.4,633,261.8z"
              />
              <path
                class="st37"
                d="M633,261.8c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C626.6,259.5,630.5,259.4,633,261.8"
              />
              <path
                class="st29"
                d="M628.6,272.5c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C631.9,271.9,630.3,272.5,628.6,272.5 M628.6,260.2c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            c2.4,2.3,6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5l0,0C631.7,260.8,630.2,260.2,628.6,260.2"
              />
              <path
                class="st39"
                d="M628.4,267.8L628.4,267.8l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L628.4,267.8z"
              />
              <path
                class="st39"
                d="M625.6,263.5c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3
            C624.6,263.2,625.2,263.2,625.6,263.5"
              />
              <path
                class="st39"
                d="M631.9,266.8l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C632.3,267.9,632.2,267.3,631.9,266.8
            C632,266.8,631.9,266.8,631.9,266.8"
              />
              <path
                class="st37"
                d="M119.7,270.8c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C113.3,268.5,117.3,268.4,119.7,270.8"
              />
              <path
                class="st29"
                d="M115.4,281.5c-1.7,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c1.2-1.2,2.8-1.9,4.5-1.9h0.1
            c1.7,0,3.2,0.6,4.4,1.8c1.2,1.2,1.9,2.8,1.9,4.4c0,1.7-0.6,3.3-1.8,4.5C118.8,280.8,117.2,281.5,115.4,281.5L115.4,281.5
            M115.4,269.2L115.4,269.2c-1.7,0-3.2,0.7-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5c1.1,1.1,2.6,1.7,4.2,1.7h0.1c1.6,0,3.1-0.7,4.2-1.8
            c1.1-1.1,1.7-2.7,1.7-4.3c0-1.6-0.7-3.1-1.8-4.2C118.5,269.8,117,269.2,115.4,269.2"
              />
              <path
                class="st38"
                d="M119.7,270.8c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C113.3,268.5,117.3,268.4,119.7,270.8z"
              />
              <path
                class="st39"
                d="M115.2,276.8L115.2,276.8l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.2H120l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9H117l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.4h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L115.2,276.8z"
              />
              <path
                class="st39"
                d="M112.3,272.5c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0s-0.4-0.9,0-1.3S112,272.1,112.3,272.5"
              />
              <path
                class="st39"
                d="M118.6,275.8l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1v-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C119,276.9,118.9,276.3,118.6,275.8
            C118.7,275.8,118.7,275.7,118.6,275.8"
              />
              <path
                class="st13"
                d="M605.3,311.5l-0.1-0.1l-13-12.6l0.1-0.1l14.5-15l0.1,0.1l13,12.6l-0.1,0.1L605.3,311.5z M592.6,298.8
            l12.7,12.2l14.2-14.6l-12.7-12.2L592.6,298.8z"
              />
              <text
                transform="matrix(0.7512 0.6607 -0.6627 0.7489 299.2814 30.9820)"
                class="st13 st14 st48"
              >
                THE
              </text>
              <text
                transform="matrix(0.7512 0.6607 -0.6627 0.7489 292.2814 32.0699)"
                class="st13 st14 st48"
              >
                DAIQUIRI
              </text>
              <text
                transform="matrix(0.7512 0.6607 -0.6627 0.7489 291.2814 39.1578)"
                class="st13 st14 st48"
              >
                DEC
              </text>
              <text
                transform="matrix(0.7512 0.6607 -0.6627 0.7489 297.5924 44.7078)"
                class="st13 st14 st48"
              >
                K
              </text>
              <text
                transform="matrix(-0.2103 -0.9748 0.9778 -0.2096 219.9419 227.2292)"
                class="st13 st14 st49"
              >
                SEMINOLE HARD ROCK TAMPA
              </text>
              <text
                transform="matrix(-0.2103 -0.9748 0.9778 -0.2096 220.7697 207.75)"
                class="st13 st14 st49"
              >
                162 LANDING
              </text>
              <polygon
                class="st3"
                points="487.8,272.5 531.1,314.5 532.2,313.3 488.9,271.4 	"
              />
              <text
                transform="matrix(0.7082 -0.706 0.7082 0.706 418.8414 37.8427)"
                class="st50 st14 st51"
              >
                R
              </text>
              <text
                transform="matrix(0.7082 -0.706 0.7082 0.706 420.8243 35.8662)"
                class="st50 st14 st51"
              >
                A
              </text>
              <text
                transform="matrix(0.7082 -0.706 0.7082 0.706 422.6656 34.0302)"
                class="st50 st14 st51"
              >
                YS
              </text>
              <text
                transform="matrix(0.7082 -0.706 0.7082 0.706 421.8785 42.9257)"
                class="st50 st14 st51"
              >
                TOUCH
              </text>
              <text
                transform="matrix(0.7082 -0.706 0.7082 0.706 421.899 51.0136)"
                class="st50 st14 st51"
              >
                EXPERIENCE
              </text>
              <!-- <path
                class="st50"
                d="M142.8,146.3c-0.5-0.2-1.2-0.2-1.4,0.4c-0.2,0.7,0.3,1.2,2,1.8c1.6,0.6,2.6,0.8,2.9,0c0.1-0.3,0-1-0.7-1.2
            c-0.3-0.1-0.4-0.1-0.7-0.2c-0.1,0.4-0.2,0.5-0.3,0.9c-0.4-0.1-0.6-0.2-1-0.3c0.3-0.9,0.5-1.3,0.8-2.2c1.4,0.5,2.1,0.8,3.5,1.3
            c-0.1,0.4-0.2,0.6-0.4,1c-0.2-0.1-0.4-0.1-0.6-0.2l0,0c0.4,0.5,0.5,1,0.2,1.7c-0.6,1.7-1.9,1.6-4.2,0.8c-2.2-0.8-3.2-1.7-2.5-3.5
            c0.5-1.5,1.5-1.9,2.9-1.4C143.1,145.6,143,145.8,142.8,146.3"
              /> -->
              <!-- <path
                class="st50"
                d="M143.3,139.3c0.4,0.2,0.6,0.3,1.1,0.4c-0.2,0.6-0.4,0.9-0.6,1.5c2.2,0.8,3.3,1.3,5.4,2.1
            c-0.2,0.5-0.3,0.8-0.5,1.3c-2.2-0.8-3.3-1.2-5.5-2.1c-0.2,0.6-0.3,0.9-0.6,1.5l-1.1-0.4C142.3,142,142.6,141.1,143.3,139.3"
              />
              <path
                class="st50"
                d="M145.1,135c0.4,0.2,0.6,0.3,1.1,0.5c-0.4,1-0.6,1.4-1,2.4c0.6,0.2,0.9,0.4,1.5,0.6c0.4-0.9,0.6-1.3,0.9-2.2
            c0.4,0.2,0.6,0.3,1.1,0.4c-0.4,0.9-0.6,1.3-0.9,2.2c0.7,0.3,1,0.4,1.7,0.7c0.4-1,0.6-1.5,1-2.4c0.4,0.2,0.6,0.3,1.1,0.5
            c-0.6,1.5-0.9,2.2-1.6,3.7c-2.6-1-3.9-1.6-6.5-2.6C144.1,137.2,144.5,136.5,145.1,135"
              />
              <path
                class="st50"
                d="M146.4,131.9c0.7-1.5,1-2.2,1.7-3.7c0.4,0.2,0.6,0.3,1,0.5c-0.4,0.9-0.7,1.4-1.1,2.4c0.6,0.3,0.9,0.4,1.5,0.7
            c0.4-0.9,0.6-1.3,1-2.2c0.4,0.2,0.6,0.3,1,0.5c-0.4,0.9-0.6,1.3-1,2.2c1.1,0.5,1.7,0.7,2.8,1.2c-0.2,0.5-0.4,0.8-0.6,1.3
            C150.2,133.6,149,133.1,146.4,131.9"
              /> -->
              <!-- <path
                class="st50"
                d="M154.7,130.5c-2.5-1.2-3.8-1.8-6.3-3c0.3-0.5,0.4-0.8,0.6-1.3c2.5,1.2,3.8,1.8,6.3,3
            C155.1,129.8,155,130,154.7,130.5"
              />
              <path
                class="st50"
                d="M150.3,123.7c2,0.2,3,0.3,5.1,0.6l0,0c-1.7-0.9-2.6-1.3-4.3-2.2c0.2-0.5,0.4-0.7,0.6-1.2
            c2.5,1.3,3.7,1.9,6.2,3.2c-0.3,0.6-0.4,0.9-0.7,1.4c-2.1-0.3-3.1-0.4-5.2-0.6l0,0c1.8,0.9,2.6,1.3,4.4,2.2
            c-0.2,0.5-0.3,0.7-0.6,1.2c-2.5-1.2-3.8-1.8-6.3-3C149.8,124.6,150,124.3,150.3,123.7"
              />
              <path
                class="st50"
                d="M152.8,118.8c0.3-0.6,0.5-1,0.9-1.6c2.8,0.6,4.2,1,7.1,1.7c-0.3,0.5-0.4,0.8-0.7,1.3
            c-0.6-0.2-0.9-0.2-1.5-0.4c-0.4,0.7-0.5,1-0.9,1.7c0.5,0.4,0.7,0.6,1.2,1c-0.3,0.5-0.4,0.8-0.7,1.3
            C156,121.7,154.9,120.7,152.8,118.8 M156.8,120.6c0.3-0.5,0.4-0.7,0.7-1.2c-1.2-0.4-1.9-0.5-3.1-0.9l0,0
            C155.3,119.4,155.8,119.8,156.8,120.6"
              />

              <path
                class="st50"
                d="M155.7,113.5c2,0.3,3,0.5,5,0.8l0,0c-1.7-1-2.5-1.4-4.2-2.4c0.3-0.5,0.4-0.7,0.7-1.2c2.4,1.4,3.6,2.1,6,3.5
            c-0.3,0.6-0.5,0.8-0.8,1.4c-2-0.4-3.1-0.5-5.1-0.9l0,0c1.7,1,2.6,1.4,4.3,2.4c-0.3,0.5-0.4,0.7-0.6,1.1c-2.4-1.4-3.7-2-6.1-3.4
            C155.2,114.4,155.4,114.1,155.7,113.5"
              />
              <path
                class="st50"
                d="M161.4,108.5c-0.9-0.5-1.4-0.6-1.7,0c-0.4,0.6,0.1,1.1,1.8,2.2c1.8,1.1,2.3,1,2.6,0.5c0.3-0.4,0.2-0.9-1-1.7
            c0.3-0.5,0.5-0.7,0.8-1.2c1.3,0.8,2.2,1.8,1.2,3.4c-1.1,1.8-2.5,1.3-4.4,0.2c-1.8-1.1-3-2.1-1.9-4c1.1-1.8,2.4-1.1,3.3-0.6
            C161.8,107.7,161.7,108,161.4,108.5"
              />
              <path
                class="st50"
                d="M166.6,108.9c-2.4-1.5-3.6-2.2-5.9-3.7c0.3-0.5,0.5-0.7,0.8-1.2c2.4,1.5,3.5,2.2,5.9,3.7
            C167,108.2,166.9,108.4,166.6,108.9"
              />
              <path
                class="st50"
                d="M162.8,101.8c0.4-0.6,0.6-0.9,1-1.5c2.8,0.9,4.1,1.4,6.9,2.3c-0.3,0.5-0.5,0.7-0.8,1.2
            c-0.6-0.2-0.8-0.3-1.4-0.5c-0.4,0.6-0.6,0.9-1,1.6c0.4,0.4,0.6,0.6,1.1,1.1c-0.3,0.5-0.5,0.7-0.8,1.2
            C165.7,105.1,164.7,104,162.8,101.8 M166.6,104c0.3-0.5,0.5-0.7,0.8-1.2c-1.2-0.5-1.8-0.7-3-1.1l0,0
            C165.2,102.7,165.7,103.1,166.6,104"
              />
              <path
                class="st50"
                d="M171,102.2c-2.3-1.6-3.5-2.4-5.8-3.9c0.3-0.5,0.5-0.7,0.8-1.2c1.9,1.3,2.9,2,4.8,3.3c0.6-0.8,0.9-1.2,1.5-2.1
            c0.4,0.3,0.6,0.4,0.9,0.7C172.3,100.3,171.8,100.9,171,102.2"
              />
              <path
                class="st50"
                d="M169.3,92.4c0.6-0.8,0.9-1.2,1.5-2.1c0.9-1.2,2-1,2.9-0.3c1.2,0.9,1.1,2,0.3,3.1c-0.2,0.2-0.3,0.4-0.5,0.6
            c0.9,0.7,1.3,1,2.2,1.7c-0.3,0.5-0.5,0.7-0.8,1.1C172.7,94.9,171.6,94.1,169.3,92.4 M172.7,93.1c0.2-0.2,0.2-0.3,0.4-0.5
            c0.3-0.5,0.3-1-0.3-1.4c-0.5-0.4-1-0.4-1.5,0.2c-0.1,0.2-0.2,0.3-0.4,0.5C171.7,92.4,172.1,92.6,172.7,93.1"
              />
              <path
                class="st50"
                d="M173,87.5c0.4-0.6,0.7-0.9,1.1-1.4c2.7,1.1,4,1.7,6.7,2.9c-0.4,0.5-0.6,0.7-0.9,1.2c-0.5-0.3-0.8-0.4-1.4-0.7
            c-0.5,0.6-0.7,0.9-1.2,1.5c0.4,0.5,0.6,0.7,1,1.2c-0.4,0.5-0.5,0.7-0.9,1.2C175.7,91,174.8,89.8,173,87.5 M176.6,90
            c0.3-0.4,0.5-0.7,0.9-1.1c-1.2-0.6-1.7-0.8-2.9-1.4l0,0C175.4,88.5,175.8,89,176.6,90"
              /> -->
              <!-- <path
                class="st50"
                d="M175.7,84.2c0.7-0.8,1-1.3,1.7-2.1c0.8-0.9,1.7-1.1,2.6-0.3c0.7,0.6,0.9,1.3,0.5,2l0,0
            c0.7-0.7,1.2-0.4,2.4,0.5c0.6,0.5,0.9,0.7,1.2,0.6l0,0c-0.4,0.5-0.6,0.7-1,1.2c-0.2,0-0.5-0.2-0.7-0.3c-0.4-0.3-0.6-0.5-1.1-0.8
            c-0.4-0.3-0.9-0.4-1.2,0.1c-0.2,0.2-0.3,0.4-0.5,0.6c0.9,0.7,1.4,1.1,2.3,1.9c-0.4,0.4-0.5,0.7-0.9,1.1
            C179,86.8,177.9,85.9,175.7,84.2 M179,85c0.2-0.2,0.2-0.3,0.4-0.5c0.4-0.5,0.5-1-0.1-1.5c-0.5-0.4-1-0.3-1.4,0.2
            c-0.2,0.2-0.3,0.3-0.4,0.5C178,84.2,178.4,84.5,179,85"
              />
              <path
                class="st50"
                d="M182,76.7c0.3,0.3,0.5,0.5,0.9,0.8c-0.4,0.5-0.6,0.7-1.1,1.2c1.8,1.5,2.6,2.3,4.4,3.8
            c-0.4,0.4-0.6,0.6-0.9,1.1c-1.8-1.5-2.7-2.3-4.4-3.8c-0.4,0.5-0.6,0.7-1,1.2c-0.4-0.3-0.5-0.4-0.9-0.7
            C180.2,78.8,180.8,78.1,182,76.7"
              />
              <path
                class="st50"
                d="M183.2,75.4c1.1,0.4,1.6,0.7,2.6,1.1l0,0c-0.5-1-0.8-1.5-1.3-2.6c0.4-0.5,0.6-0.7,1.1-1.2
            c0.7,1.7,1.1,2.6,1.8,4.2c0.8,0.7,1.2,1.1,2,1.9c-0.4,0.4-0.6,0.6-1,1.1c-0.8-0.7-1.2-1.1-2-1.8c-1.8-0.6-2.6-0.9-4.4-1.4
            C182.6,76.1,182.8,75.9,183.2,75.4"
              />
              <path
                class="st50"
                d="M187.8,70.5c0.7-0.7,1-1,1.7-1.7c1.4-1.5,2.7-0.8,4.1,0.7c1.7,1.8,2.1,2.9,0.8,4.3c-0.6,0.6-0.9,1-1.6,1.6
            C190.8,73.4,189.8,72.4,187.8,70.5 M193.1,73.6c0.2-0.2,0.3-0.3,0.4-0.5c0.7-0.7,0.4-1.3-0.9-2.6c-1.1-1.1-1.8-1.6-2.6-0.8
            c-0.2,0.2-0.3,0.3-0.4,0.4C191,71.5,191.7,72.2,193.1,73.6"
              />
              <path
                class="st50"
                d="M194.8,63.5c0.3,0.3,0.5,0.5,0.8,0.8c-0.8,0.7-1.1,1.1-1.9,1.8c0.5,0.5,0.7,0.7,1.1,1.2c0.7-0.7,1-1,1.8-1.7
            c0.3,0.3,0.5,0.5,0.8,0.8c-0.7,0.7-1.1,1-1.7,1.7c0.5,0.5,0.8,0.8,1.3,1.3c0.8-0.7,1.1-1.1,1.9-1.8c0.3,0.3,0.5,0.5,0.8,0.8
            c-1.2,1.1-1.8,1.7-2.9,2.8c-2-2-2.9-3-4.9-5C193,65.2,193.6,64.7,194.8,63.5"
              />
              <path
                class="st50"
                d="M199.3,62.6c-0.7-0.7-1.1-0.9-1.6-0.5c-0.5,0.5-0.2,1.1,1.2,2.6s1.9,1.6,2.4,1.2c0.4-0.4,0.5-0.8-0.5-1.9
            c0.4-0.4,0.6-0.6,1.1-1c1,1.1,1.6,2.3,0.2,3.6c-1.6,1.4-2.8,0.5-4.3-1s-2.3-2.8-0.7-4.3c1.6-1.4,2.7-0.4,3.4,0.3
            C200,62,199.8,62.2,199.3,62.6"
              />
              <path
                class="st50"
                d="M200.6,58.3c0.7,0.8,1.1,1.3,1.9,2.1l0,0c-0.2-1.3-0.3-2-0.4-3.3c0.5-0.4,0.7-0.6,1.2-1
            c0.2,1.4,0.3,2.1,0.4,3.6c1.7,0.6,2.6,1,4.3,1.6c-0.5,0.4-0.7,0.6-1.2,1c-1.2-0.5-1.8-0.7-3-1.2c0,0.4,0.1,0.6,0.1,0.9
            c0.5,0.6,0.8,0.9,1.4,1.6c-0.4,0.4-0.6,0.6-1.1,0.9c-1.9-2.1-2.8-3.1-4.7-5.2C200,58.8,200.2,58.6,200.6,58.3"
              /> -->
              <text
                transform="matrix(0.7025 -0.7116 0.7138 0.7003 203.1211 102.21)"
                class="st29 st14 st52"
              >
                VIVA VICTORY LEDGE
              </text>
              <!-- <text
                transform="matrix(0.7025 -0.7116 0.7138 0.7003 191.5015 101.2724)"
                class="st29 st14 st52"
              >
                LOUISIANA HOT SAUCE
              </text> -->
              <path
                class="st38"
                d="M523,287.9c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C516.6,285.6,520.6,285.6,523,287.9z"
              />
              <path
                class="st37"
                d="M523,287.9c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C516.6,285.6,520.6,285.6,523,287.9"
              />
              <path
                class="st29"
                d="M518.7,298.7c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C522,298,520.3,298.7,518.7,298.7 M518.7,286.4c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            c2.4,2.3,6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5C521.7,286.9,520.2,286.4,518.7,286.4"
              />
              <path
                class="st39"
                d="M518.5,293.9L518.5,293.9l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1L519,291h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L518.5,293.9z"
              />
              <path
                class="st39"
                d="M515.6,289.7c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3
            C514.7,289.3,515.3,289.3,515.6,289.7"
              />
              <path
                class="st39"
                d="M521.9,292.9l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C522.3,294,522.3,293.5,521.9,292.9C522,293,522,292.9,521.9,292.9"
              />
              <path
                class="st27"
                d="M479.5,253.7l-8.8,9l-4.1-9c0,0,13.1-5.2,13.2-5.1C480,248.7,479.5,253.7,479.5,253.7"
              />
              <path
                class="st53"
                d="M531.5,157.3l-7.1-7.2l-13.8,27.7c0,0,3.6,5.6,2.7,20.1c0,0-2,7.4-3.2,9.6c-2.5,4.4-12.9,15.3-12.9,15.3
            l15.1,14.6l26.9-29.4c0,0,4.5-11.9-5.3-52.2L531.5,157.3z"
              />
              <path
                class="st54"
                d="M512.3,237.9l-15.6-15.1l0.2-0.2c0.1-0.1,10.5-10.9,12.9-15.2c1.2-2.1,3.1-9.4,3.2-9.5
            c0.9-14.1-2.6-19.8-2.7-19.9l-0.1-0.2l0.1-0.2l14-28.1l7.2,7.3l2.6-1.6l0.1,0.4c9.7,40,5.5,51.9,5.3,52.4l-0.1,0.1L512.3,237.9z
            M497.6,222.7l14.7,14.2l26.7-29.1c0.3-0.9,3.9-13.5-5.3-51.5l-2.3,1.4l-7-7l-13.5,27.1c0.6,1,3.5,6.9,2.7,20.1
            c-0.1,0.4-2,7.5-3.2,9.7C508.1,211.7,499.2,221.1,497.6,222.7"
              />
              <text
                transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 529.5987 183.7313)"
                class="st55 st14 st56"
              >
                P
              </text>
              <text
                transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 529.0274 186.0164)"
                class="st55 st14 st56"
              >
                A
              </text>
              <text
                transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 528.3397 188.7476)"
                class="st55 st14 st56"
              >
                P
              </text>
              <text
                transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 527.7607 191.0313)"
                class="st55 st14 st56"
              >
                A JOHN’S
              </text>
              <text
                transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 523.8499 181.5823)"
                class="st55 st14 st56"
              >
                BULLPEN BOX
              </text>
              <path
                class="st26"
                d="M310.1,426.1c5,3,10.4,5.7,16,8c0.1-0.4,7.4-19.1,7.5-19.3c-0.2-0.2-4.2-4.3-4.2-4.3s2.3-6,2.5-6.4
            c-0.3-0.1-5.9-2.5-6.2-2.7C325.5,401.7,310.3,425.7,310.1,426.1"
              />
              <path
                class="st23"
                d="M326.2,434.3l-0.2-0.1c-5.6-2.3-11-5-16-8l-0.2-0.1l0.1-0.2c0.1-0.2,4.1-6.4,8-12.6c3.8-6,7.5-11.9,7.6-12
            l0.1-0.1l0.1,0.1c0.3,0.1,5.8,2.5,6.2,2.7l0.2,0.1l-2.5,6.4c0.6,0.6,4,4,4.1,4.2l0.1,0.1v0.1c-0.1,0.2-3.3,8.6-5.5,14.1
            c-1.1,2.9-1.9,5-2,5.2L326.2,434.3z M310.4,426c4.9,3,10.2,5.6,15.6,7.8c0.2-0.6,1-2.5,1.9-5c2-5.2,5-13,5.4-14
            c-0.6-0.6-4.1-4.2-4.1-4.2l-0.1-0.1l2.5-6.3c-0.9-0.4-5-2.2-5.9-2.5c-0.6,0.9-4,6.4-7.5,11.9C314.6,419.2,311,425,310.4,426"
              />
              <path
                class="st26"
                d="M331.9,410c0.2,0.2,4.2,4.2,4.2,4.2s-7.8,20.3-8,20.6c5.4,2.1,10.9,3.8,16.6,5.1c0.1-0.4,5.4-30,5.5-30.4
            c-5.6-1.1-11.1-2.7-16.4-4.7C333.7,405.2,331.9,409.8,331.9,410"
              />
              <path
                class="st23"
                d="M344.9,440.2h-0.2c-5.7-1.3-11.3-3-16.7-5.1l-0.2-0.1l0.1-0.2c0.1-0.4,7.3-18.9,7.9-20.5
            c-0.6-0.6-4-4-4.1-4.2l-0.1-0.1v-0.1c0.1-0.2,1.9-4.8,2-5.1l0.1-0.2l0.2,0.1c5.3,2,10.8,3.5,16.4,4.6h0.2v0.2c0,0.2-1.5,8.5-3,16.3
            c-1.3,7.1-2.5,13.8-2.5,14L344.9,440.2z M328.3,434.8c5.2,2,10.7,3.7,16.3,5c0.2-1.2,1.3-7.4,2.5-13.8c1.3-7.3,2.7-14.9,2.9-16.2
            c-5.5-1.1-10.9-2.6-16.1-4.6c-0.3,0.8-1.6,4.1-1.9,4.8c0.6,0.6,4.1,4.2,4.1,4.2l0.1,0.1v0.1C336.2,414.3,329.1,432.8,328.3,434.8"
              />
              <path
                class="st26"
                d="M361.1,442.4c4,0.3,8.2,0.5,12.3,0.4c0-0.4-0.3-23.1-0.3-23.1l-2.8-6c0,0,0-1.8,0-2.1c-2.4,0-5-0.1-7.5-0.3
            C362.7,411.6,361.1,442.1,361.1,442.4"
              />
              <path
                class="st23"
                d="M370.8,443c-3.3,0-6.5-0.1-9.8-0.4h-0.2v-0.2c0-0.2,0.6-10.9,1-19.7c0.3-6.1,0.6-11.4,0.6-11.5V411h0.2
            c2.6,0.2,5.1,0.3,7.5,0.3h0.2v0.2c0,0.3,0,1.8,0,2.1c0.7,1.5,2.3,5.1,2.7,5.9h0.1v0.3c0,0,0.3,22.7,0.3,23.1v0.2h-0.2
            C372.5,443,371.7,443,370.8,443 M361.3,442.3c3.9,0.3,8,0.4,11.9,0.4c0-2.2-0.3-22.9-0.3-22.9l0,0c-0.2-0.3-0.5-1.1-1.4-2.9
            l-1.4-3.1c0,0,0-1.4,0-2c-2.3,0-4.7-0.1-7.2-0.3c-0.1,1-0.3,5.8-0.6,11.4C361.9,431,361.4,440.8,361.3,442.3"
              />
              <path
                class="st26"
                d="M372.4,411.5c0,0.3,0,1.7,0,1.7l2.8,6c0,0,0.3,23.1,0.3,23.5c8.3-0.3,16.5-1.5,24.4-3.6
            c-0.1-0.4-6.2-20.9-6.2-20.9l-4.1-6.2c0,0-0.4-1.9-0.5-2.2C383.6,410.9,378,411.4,372.4,411.5"
              />
              <path
                class="st23"
                d="M375.4,442.9v-0.2c0-0.4-0.3-22.4-0.3-23.5c-0.7-1.5-2.4-5.3-2.7-5.9h-0.1v-0.1c0,0,0-1.4,0-1.7v-0.2h0.2
            c5.6-0.1,11.2-0.7,16.7-1.7h0.2l0.5,2.4c1.3,2,3.7,5.6,4.1,6.1l0,0v0.1c0.1,0.2,6.1,20.5,6.2,20.9l0.1,0.2h-0.2
            c-8,2-16.2,3.2-24.5,3.6L375.4,442.9z M372.6,413.2c0.2,0.4,0.8,1.7,2.7,6v0.1c0,0.2,0.3,21.1,0.3,23.3c8.1-0.3,16.2-1.5,24-3.5
            c-0.6-2.1-6.1-20.5-6.2-20.7l0,0c-0.3-0.4-1.1-1.6-4.1-6.2v-0.1l-0.4-2.1c-5.4,1-10.9,1.5-16.4,1.6
            C372.6,412.2,372.6,413.2,372.6,413.2L372.6,413.2z"
              />
              <path
                class="st26"
                d="M391.2,409.5c0,0.2,0.4,1.8,0.4,1.8l4.1,6.2c0,0,6.2,20.8,6.3,21.2c4.8-1.3,9.5-2.9,14.1-4.8
            c-0.1-0.3-8.7-20.8-8.7-20.8s2.9-1.5,3.2-1.6c-0.1-0.3-2.7-6.5-2.9-6.8C402.4,406.7,396.9,408.3,391.2,409.5"
              />
              <path
                class="st23"
                d="M401.9,438.9l-0.1-0.2l-6.3-21.2c-1.3-2-3.7-5.6-4-6.1l0,0v-0.1c0,0-0.3-1.6-0.4-1.8v-0.2h0.2
            c5.6-1.1,11.2-2.7,16.5-4.8l0.2-0.1l0.1,0.2c0.1,0.3,2.7,6.5,2.9,6.8l0.1,0.2l-0.2,0.1c-0.2,0.1-2.4,1.2-3,1.5
            c0.8,1.9,8.5,20.3,8.6,20.6l0.1,0.2l-0.2,0.1c-4.6,1.9-9.3,3.5-14.1,4.8H401.9z M391.8,411.2c0.3,0.4,1.1,1.6,4.1,6.1l0,0l6.3,21.1
            c4.7-1.3,9.3-2.9,13.7-4.7c-0.8-2-8.6-20.6-8.6-20.6l-0.1-0.2l0.2-0.1c0,0,2.4-1.2,3-1.5c-0.4-0.9-2.3-5.5-2.7-6.5
            c-5.2,2-10.7,3.6-16.2,4.7C391.5,410.1,391.8,411.2,391.8,411.2L391.8,411.2z"
              />
              <path
                class="st26"
                d="M409.8,403.9c0.1,0.3,3.6,8.6,3.6,8.6s-2.9,1.5-3.2,1.6c0.1,0.3,7.7,18.5,7.9,18.9c4.7-2.1,9.3-4.5,13.7-7.1
            c-0.2-0.3-16.2-24.2-16.4-24.5C415.1,401.5,410.1,403.7,409.8,403.9"
              />
              <path
                class="st23"
                d="M418,433.2l-0.1-0.2c-0.1-0.1-1.3-3-2.7-6.5c-2.2-5.4-5.1-12.2-5.2-12.4l-0.1-0.2l0.1-0.1
            c0.3-0.1,2.4-1.2,3-1.5c-0.5-1.1-3.4-8.2-3.6-8.5l-0.1-0.2l1.7-0.8c1.6-0.7,3.9-1.7,4.1-1.8l0.1-0.1l0.1,0.1
            c0.1,0.2,16.2,24.2,16.4,24.5l0.1,0.2l-0.2,0.1c-4.4,2.7-9.1,5.1-13.8,7.1L418,433.2z M410.5,414.2c0.4,1.1,3,7.2,5.1,12.2
            c1.3,3.1,2.4,5.7,2.7,6.4c4.6-2,9.1-4.3,13.4-6.9c-1.4-2-15-22.4-16.2-24.2c-0.6,0.2-2.5,1.1-3.9,1.7l-1.4,0.6
            c0.5,1.2,3.6,8.5,3.6,8.5l0.1,0.2l-0.2,0.1C413.5,412.7,411.1,413.8,410.5,414.2"
              />
              <path
                class="st26"
                d="M346.8,440.4c4.1,0.8,8.2,1.5,12.1,1.9c0-0.4,1.6-30.9,1.6-31.2c-2.7-0.3-5.5-0.6-8.3-1.1
            C352.3,410.3,346.9,440,346.8,440.4"
              />
              <path
                class="st23"
                d="M359.1,442.5h-0.2c-4-0.4-8.1-1-12.2-1.9h-0.2v-0.2c0.1-0.4,5.5-30.2,5.5-30.4v-0.2h0.2
            c2.7,0.5,5.5,0.9,8.2,1.1h0.2v0.2c0,0.2-0.5,8.8-0.9,17c-0.4,7.2-0.7,14-0.7,14.2L359.1,442.5z M347,440.3c4,0.8,7.9,1.4,11.8,1.8
            c0.1-1.2,0.4-7.4,0.7-14c0.4-7.5,0.8-15.5,0.9-16.8c-2.6-0.3-5.3-0.6-7.9-1.1C352,412.5,347.4,437.9,347,440.3"
              />
              <path
                class="st50"
                d="M321.7,428.1l1.2,0.8l-0.6,1.4l-5.9-4.3l0.8-1.8l7,1.7l-0.6,1.4l-1.4-0.4L321.7,428.1z M320.9,426.7l-1.3-0.4
            c-0.4-0.1-1.1-0.3-1.6-0.5l0,0c0.4,0.2,1.1,0.7,1.4,0.9l1.1,0.7L320.9,426.7z"
              />
              <path
                class="st50"
                d="M323.9,423.2l1.2,0.8l-0.6,1.4l-5.9-4.3l0.8-1.8l7,1.7l-0.6,1.4l-1.4-0.4L323.9,423.2z M323.2,421.7l-1.3-0.4
            c-0.4-0.1-1.1-0.3-1.6-0.5l0,0c0.4,0.2,1.1,0.7,1.4,0.9l1.1,0.7L323.2,421.7z"
              />
              <path
                class="st50"
                d="M326.1,418.2l1.2,0.8l-0.6,1.4l-5.9-4.3l0.8-1.8l7,1.7l-0.6,1.4l-1.4-0.4L326.1,418.2z M325.4,416.8l-1.3-0.4
            c-0.4-0.1-1.1-0.3-1.6-0.5l0,0c0.4,0.2,1.1,0.7,1.4,0.9l1.1,0.7L325.4,416.8z"
              />
              <path
                class="st50"
                d="M333.9,435.2c0-0.5,0.2-1.1,0.3-1.7c0.2-0.6,0.4-1.3,1-1.7c0.4-0.3,1-0.3,1.4-0.2c0.6,0.2,1.1,0.6,1.2,1.4
            l0,0c0.5-0.7,1.2-0.9,1.9-0.7c0.6,0.2,1,0.5,1.2,0.9c0.3,0.5,0.4,1.3,0,2.6c-0.1,0.5-0.3,1-0.5,1.3L333.9,435.2z M337,434.4
            l0.1-0.2c0.1-0.4-0.2-0.8-0.7-0.9c-0.4-0.1-0.8,0-1,0.4c0,0.1-0.1,0.2-0.1,0.3L337,434.4z M339.9,435.2c0-0.1,0.1-0.2,0.1-0.2
            c0.1-0.4,0-0.9-0.6-1.1s-1,0.1-1.1,0.6l-0.1,0.3L339.9,435.2z"
              />
              <path
                class="st50"
                d="M335.5,429.5c0-0.5,0.2-1.1,0.3-1.7c0.2-0.6,0.4-1.3,1-1.7c0.4-0.3,1-0.3,1.4-0.2c0.6,0.2,1.1,0.6,1.2,1.4
            l0,0c0.5-0.7,1.2-0.9,1.9-0.7c0.6,0.2,1,0.5,1.2,0.9c0.3,0.5,0.4,1.3,0,2.6c-0.1,0.5-0.3,1-0.5,1.3L335.5,429.5z M338.6,428.7
            l0.1-0.3c0.1-0.4-0.2-0.8-0.7-0.9c-0.4-0.1-0.8,0-1,0.4c0,0.1-0.1,0.2-0.1,0.3L338.6,428.7z M341.6,429.6c0-0.1,0.1-0.2,0.1-0.2
            c0.1-0.4,0-0.9-0.6-1.1s-1,0.1-1.1,0.6l-0.1,0.3L341.6,429.6z"
              />
              <path
                class="st50"
                d="M337.2,423.8c0-0.5,0.2-1.1,0.3-1.7c0.2-0.6,0.4-1.3,1-1.7c0.4-0.3,1-0.3,1.4-0.2c0.6,0.2,1.1,0.6,1.2,1.4
            l0,0c0.5-0.7,1.2-0.9,1.9-0.7c0.6,0.2,1,0.5,1.2,0.9c0.3,0.5,0.4,1.3,0,2.6c-0.1,0.5-0.3,1-0.5,1.3L337.2,423.8z M340.3,423.1
            l0.1-0.3c0.1-0.4-0.2-0.8-0.7-0.9c-0.4-0.1-0.8,0-1,0.4c0,0.1-0.1,0.2-0.1,0.3L340.3,423.1z M343.2,423.9c0-0.1,0.1-0.2,0.1-0.2
            c0.1-0.4,0-0.9-0.6-1.1s-1,0.1-1.1,0.6l-0.1,0.3L343.2,423.9z"
              />
              <path
                class="st50"
                d="M356.6,437.3c0.1,0.2,0.1,0.6,0,1.1c-0.3,2-2.1,2.5-3.9,2.2c-2.6-0.4-3.4-2.1-3.2-3.6c0.1-0.5,0.2-0.8,0.3-1
            l1.3,0.5c-0.1,0.1-0.2,0.3-0.2,0.6c-0.1,0.8,0.4,1.5,2,1.8c1.5,0.2,2.2-0.2,2.3-1c0-0.2,0-0.5,0-0.6H356.6z"
              />
              <path
                class="st50"
                d="M357.3,432.8c0.1,0.2,0.1,0.6,0,1.1c-0.3,2-2.1,2.5-3.9,2.2c-2.6-0.4-3.4-2.1-3.2-3.6c0.1-0.5,0.2-0.8,0.3-1
            l1.3,0.5c-0.1,0.1-0.2,0.3-0.2,0.6c-0.1,0.8,0.4,1.5,2,1.8c1.5,0.2,2.2-0.2,2.3-1c0-0.2,0-0.5,0-0.6H357.3z"
              />
              <path
                class="st50"
                d="M358.1,428.4c0.1,0.2,0.1,0.6,0,1.1c-0.3,2-2.1,2.5-3.9,2.2c-2.6-0.4-3.4-2.1-3.2-3.6c0.1-0.5,0.2-0.8,0.3-1
            l1.3,0.5c-0.1,0.1-0.2,0.3-0.2,0.6c-0.1,0.8,0.4,1.5,2,1.8c1.5,0.2,2.2-0.2,2.3-1c0-0.2,0-0.5,0-0.6H358.1z"
              />
              <path
                class="st50"
                d="M364,440.6c-0.1-0.4-0.1-0.9-0.1-1.5c0-1,0.3-1.6,0.7-2.1c0.6-0.6,1.6-0.9,2.9-0.8c1.4,0,2.4,0.4,3,1.1
            c0.4,0.5,0.6,1.2,0.6,2.3c0,0.5-0.1,1-0.1,1.2L364,440.6z M369.8,439.1c0,0,0-0.1,0-0.2c0-0.6-0.6-1-2.4-1.1c-1.3,0-2.2,0.2-2.2,1
            c0,0.1,0,0.2,0,0.2L369.8,439.1z"
              />
              <path
                class="st50"
                d="M364.2,434.7c-0.1-0.4-0.1-0.9-0.1-1.5c0-1,0.3-1.6,0.7-2.1c0.6-0.6,1.6-0.9,2.9-0.8c1.4,0,2.4,0.4,3,1.1
            c0.4,0.5,0.6,1.2,0.6,2.3c0,0.5-0.1,1-0.1,1.2L364.2,434.7z M369.9,433.2c0,0,0-0.1,0-0.2c0-0.6-0.6-1-2.4-1.1
            c-1.3,0-2.2,0.2-2.2,1c0,0.1,0,0.2,0,0.2L369.9,433.2z"
              />
              <path
                class="st50"
                d="M364.3,428.8c-0.1-0.4-0.1-0.9-0.1-1.5c0-1,0.3-1.6,0.7-2.1c0.6-0.6,1.6-0.9,2.9-0.8c1.4,0,2.4,0.4,3,1.1
            c0.4,0.5,0.6,1.2,0.6,2.3c0,0.5-0.1,1-0.1,1.2L364.3,428.8z M370.1,427.3c0,0,0-0.1,0-0.2c0-0.6-0.6-1-2.4-1.1
            c-1.3,0-2.2,0.2-2.2,0.9c0,0.1,0,0.2,0,0.2L370.1,427.3z"
              />
              <polygon
                class="st50"
                points="387.1,436.1 387.3,437.7 388.9,437.4 388.6,435.7 390,435.5 390.5,438.8 383.5,439.9 383,436.7
            384.4,436.5 384.7,438.1 386,437.9 385.7,436.3 	"
              />
              <polygon
                class="st50"
                points="386.3,431.3 386.5,432.9 388.1,432.6 387.8,430.9 389.2,430.7 389.8,434 382.8,435.1 382.2,431.9
            383.6,431.7 383.9,433.3 385.2,433.1 385,431.5 	"
              />
              <polygon
                class="st50"
                points="385.5,426.5 385.8,428.1 387.4,427.8 387.1,426.1 388.5,425.9 389,429.2 382,430.3 381.5,427.1
            382.9,426.9 383.1,428.5 384.4,428.3 384.2,426.8 	"
              />
              <polygon
                class="st50"
                points="404.8,435.2 403.7,432.1 405.1,431.7 405.6,433.2 407,432.7 406.6,431.3 407.8,430.8 408.3,432.3
            411,431.4 411.5,432.9 	"
              />
              <polygon
                class="st50"
                points="403.2,430.6 402.2,427.5 403.5,427.1 404,428.6 405.5,428.1 405,426.7 406.3,426.2 406.8,427.7
            409.4,426.8 410,428.3 	"
              />
              <polygon
                class="st50"
                points="401.7,426 400.6,422.9 401.9,422.5 402.5,424 403.9,423.5 403.4,422.1 404.7,421.6 405.2,423.1
            407.9,422.2 408.4,423.7 	"
              />
              <path
                class="st50"
                d="M424.9,423c0.3,0.2,0.7,0.8,1,1.2c0.4,0.8,0.5,1.5,0.3,2.1c-0.2,0.9-1,1.7-2.1,2.2c-2.2,1.2-3.9,0.4-4.7-1
            c-0.3-0.5-0.4-0.9-0.4-1.2l1.4-0.4c0,0.2,0.1,0.5,0.3,0.8c0.5,0.8,1.3,1.1,2.8,0.3c1.3-0.7,1.5-1.5,1.3-2c0-0.1-0.1-0.1-0.1-0.1
            l-1.3,0.7l0.2,0.5l-1.2,0.6l-1-1.7L424.9,423z"
              />
              <path
                class="st50"
                d="M422.2,418c0.2,0.2,0.7,0.8,1,1.2c0.4,0.8,0.5,1.5,0.3,2.1c-0.2,0.9-1,1.7-2.1,2.2c-2.2,1.2-3.9,0.4-4.7-1
            c-0.3-0.5-0.4-0.9-0.4-1.2l1.4-0.4c0,0.2,0.1,0.5,0.3,0.8c0.5,0.8,1.3,1.1,2.8,0.3c1.3-0.7,1.5-1.5,1.3-2c0-0.1-0.1-0.1-0.1-0.1
            l-1.3,0.7l0.2,0.4l-1.2,0.6l-1-1.8L422.2,418z"
              />
              <path
                class="st50"
                d="M419.4,413c0.2,0.2,0.7,0.8,1,1.2c0.4,0.8,0.5,1.5,0.3,2.1c-0.2,0.9-1,1.7-2.1,2.2c-2.2,1.2-3.9,0.4-4.7-1
            c-0.3-0.5-0.4-0.9-0.4-1.2l1.4-0.4c0,0.2,0.1,0.5,0.2,0.8c0.5,0.8,1.3,1.1,2.8,0.3c1.3-0.7,1.5-1.5,1.3-2c0-0.1-0.1-0.1-0.1-0.1
            l-1.3,0.7l0.2,0.5l-1.2,0.6l-1-1.7L419.4,413z"
              />
              <text
                transform="matrix(0.6871 -0.7263 0.7285 0.685 598.8329 303.9459)"
                class="st36 st14 st57"
              >
                PRESS LEVEL
              </text>
              <text
                transform="matrix(0.6871 -0.7263 0.7285 0.685 602.3661 306.4948)"
                class="st36 st14 st57"
              >
                P
              </text>
              <text
                transform="matrix(0.6871 -0.7263 0.7285 0.685 603.5344 305.2628)"
                class="st36 st14 st57"
              >
                A
              </text>
              <text
                transform="matrix(0.6871 -0.7263 0.7285 0.685 604.9074 303.8099)"
                class="st36 st14 st57"
              >
                R
              </text>
              <text
                transform="matrix(0.6871 -0.7263 0.7285 0.685 606.2825 302.3564)"
                class="st36 st14 st57"
              >
                TY
              </text>
              <text
                transform="matrix(0.6871 -0.7263 0.7285 0.685 608.757 299.7421)"
                class="st36 st14 st57"
              ></text>
              <text
                transform="matrix(0.6871 -0.7263 0.7285 0.685 609.2368 299.2321)"
                class="st36 st14 st57"
              >
                AREA
              </text>
              <text
                transform="matrix(0.9432 -0.3393 0.3403 0.9403 409.8433 474.7349)"
                class="st36 st14 st58"
              >
                PRESS
              </text>
              <text
                transform="matrix(0.9432 -0.3393 0.3403 0.9403 412.9514 478.2008)"
                class="st36 st14 st58"
              >
                B
              </text>
              <text
                transform="matrix(0.9432 -0.3393 0.3403 0.9403 414.838 477.5222)"
                class="st36 st14 st58"
              >
                O
              </text>
              <text
                transform="matrix(0.9432 -0.3393 0.3403 0.9403 416.6286 476.877)"
                class="st36 st14 st58"
              >
                X
              </text>
              <text
                transform="matrix(0.9432 -0.3393 0.3403 0.9403 413.3181 482.6519)"
                class="st36 st14 st58"
              >
                SUITE
              </text>
              <text
                transform="matrix(0.7348 0.6786 -0.6807 0.7326 266.767 383.9952)"
                class="st36 st14 st59"
              >
                REPUBLIC BANK DRAFT ROOM
              </text>
              <rect x="334.6" y="1.5" class="st24" width="51.2" height="30.5" />
              <path
                class="st27"
                d="M386,32.3h-51.8V1.2H386V32.3z M334.9,31.7h50.5V1.8h-50.5V31.7z"
              />

              <rect
                x="591.2"
                y="191.4"
                transform="matrix(0.9891 -0.1473 0.1473 0.9891 -22.285 90.4705)"
                class="st3"
                width="17"
                height="8.6"
              />
              <path
                class="st13"
                d="M607.3,190.4l1.2,8.1L592,201l-1.2-8.1L607.3,190.4z M607.6,190l-17.2,2.6l1.3,8.8l17.2-2.6L607.6,190z"
              />
              <polygon
                class="st3"
                points="593.5,211.7 610.3,209.1 611.4,216.5 594.6,219.1 	"
              />
              <path
                class="st13"
                d="M610.2,209.3l1.1,7.1l-16.5,2.5l-1.1-7.1L610.2,209.3z M610.4,208.9l-17.2,2.6l1.2,7.7l17.2-2.6L610.4,208.9z
            "
              />
              <polygon
                class="st3"
                points="592.1,202.5 608.9,200 610.1,207.8 593.3,210.3 	"
              />
              <path
                class="st13"
                d="M608.8,200.2l1.1,7.4l-16.5,2.5l-1.1-7.5L608.8,200.2z M609.1,199.8l-17.2,2.6l1.2,8.2l17.2-2.6L609.1,199.8z
            "
              />
              <polygon
                class="st3"
                points="594.8,220.4 611.6,217.8 613,226.7 596.1,229.2 	"
              />
              <path
                class="st13"
                d="M611.5,218l1.3,8.6l-16.5,2.5l-1.3-8.5L611.5,218z M611.8,217.6l-17.2,2.6l1.4,9.2l17.2-2.6L611.8,217.6z"
              />
              <path
                class="st36"
                d="M598.7,194l-1.5,0.2v0.8c0.1,0,0.1,0,0.2,0c0.2,0,0.7,0,1.1,0.3c0.4,0.3,0.6,0.7,0.7,1.2
            c0.2,1.1-0.4,2.2-1.8,2.4c-0.4,0.1-0.9,0-1.2-0.1v-1.1c0.2,0.1,0.5,0.1,0.9,0.1c0.6-0.1,0.8-0.5,0.7-0.9c-0.1-0.7-0.7-0.8-1.4-0.7
            c-0.1,0-0.3,0-0.4,0.1l-0.1-3l2.5-0.4L598.7,194z"
              />
              <path
                class="st36"
                d="M601.6,192.3c0.8-0.1,1.7,0.3,1.8,1.2c0,0.3,0,0.9-0.6,1.3l0,0c0.6,0.2,1,0.7,1.1,1.3c0.2,1.1-0.6,1.8-1.6,2
            c-1,0.1-1.9-0.3-2-1.3c-0.1-0.7,0.2-1.2,0.6-1.6l0,0c-0.5-0.2-0.8-0.7-0.9-1.1C599.9,193.1,600.6,192.4,601.6,192.3L601.6,192.3z
            M601.7,193.2c-0.3,0-0.4,0.4-0.3,0.7c0,0.3,0.3,0.6,0.6,0.7c0.2-0.1,0.3-0.5,0.2-0.8C602.1,193.5,602,193.1,601.7,193.2
            L601.7,193.2z M602.3,197.3c0.3-0.1,0.4-0.5,0.4-0.8c-0.1-0.5-0.4-0.8-0.7-0.9c-0.2,0.2-0.3,0.5-0.3,0.9S601.9,197.3,602.3,197.3
            L602.3,197.3z"
              />
              <path
                class="st36"
                d="M600.1,203.6l-1.5,0.2v0.8c0.1,0,0.1,0,0.2,0c0.2,0,0.7,0,1.1,0.3c0.4,0.3,0.6,0.7,0.7,1.2
            c0.2,1.1-0.4,2.2-1.8,2.4c-0.4,0.1-0.9,0-1.2-0.1v-1.1c0.2,0.1,0.5,0.1,0.9,0.1c0.6-0.1,0.8-0.5,0.7-0.9c-0.1-0.7-0.7-0.8-1.4-0.7
            c-0.1,0-0.3,0-0.4,0.1l-0.1-3l2.5-0.4L600.1,203.6z"
              />
              <path
                class="st36"
                d="M604.4,202.8c-0.1,0-0.3,0.1-0.5,0.1c-0.7,0.2-1,0.8-1,1.5l0,0c0.2-0.3,0.4-0.5,0.8-0.5
            c0.8-0.1,1.4,0.5,1.6,1.6c0.1,1-0.2,2.1-1.4,2.3c-1.1,0.2-2-0.6-2.2-2.1c-0.2-1.3,0.1-2.2,0.6-2.8c0.3-0.4,0.9-0.8,1.3-0.9
            c0.3-0.1,0.5-0.1,0.6-0.2L604.4,202.8z M603.7,206.8c0.4-0.1,0.3-0.6,0.2-1.2c-0.1-0.3-0.2-0.8-0.6-0.7c-0.1,0-0.3,0.1-0.3,0.3
            c0,0.1,0,0.3,0,0.6C603.2,206.3,603.4,206.8,603.7,206.8L603.7,206.8z"
              />
              <path
                class="st36"
                d="M601.4,212.4l-1.5,0.2v0.8c0.1,0,0.1,0,0.2,0c0.2,0,0.7,0,1.1,0.3c0.4,0.3,0.6,0.7,0.7,1.2
            c0.2,1.1-0.4,2.2-1.8,2.4c-0.4,0.1-0.9,0-1.2-0.1v-1.1c0.2,0.1,0.5,0.1,0.9,0.1c0.6-0.1,0.8-0.5,0.7-0.9c-0.1-0.7-0.7-0.8-1.4-0.7
            c-0.1,0-0.3,0-0.4,0.1l-0.1-3l2.5-0.4L601.4,212.4z"
              />
              <path
                class="st36"
                d="M605.2,216.5l-0.2-1.3l-2,0.3l-0.1-0.9l1.4-3.8l1.3-0.2l0.5,3.4l0.5-0.1l0.2,1.1l-0.5,0.1l0.2,1.3
            L605.2,216.5z M604.8,214.2l-0.1-1c0-0.3-0.1-0.6-0.1-0.9l0,0c-0.1,0.3-0.1,0.5-0.2,0.9l-0.4,1.1l0,0L604.8,214.2z"
              />
              <path
                class="st36"
                d="M602.8,221.8l-1.5,0.2v0.8c0.1,0,0.1,0,0.2,0c0.2,0,0.7,0,1.1,0.3c0.4,0.3,0.6,0.7,0.7,1.2
            c0.2,1.1-0.4,2.2-1.8,2.4c-0.4,0.1-0.9,0-1.2-0.1v-1.1c0.2,0.1,0.5,0.1,0.9,0.1c0.6-0.1,0.8-0.5,0.7-0.9c-0.1-0.7-0.7-0.8-1.4-0.7
            c-0.1,0-0.3,0-0.4,0.1l-0.1-3l2.5-0.4L602.8,221.8z"
              />
              <path
                class="st36"
                d="M604.7,226.1l-0.1-0.9l0.5-0.8c0.6-1.1,1-1.8,0.9-2.5c-0.1-0.4-0.3-0.6-0.8-0.6c-0.3,0-0.6,0.2-0.8,0.4
            l-0.4-1c0.3-0.2,0.8-0.5,1.3-0.5c1.4-0.2,1.9,0.6,2,1.4c0.2,1.1-0.4,1.9-0.9,2.7l-0.3,0.4l0,0l1.7-0.3l0.2,1.2L604.7,226.1z"
              />
              <polygon
                class="st3"
                points="121.8,236 126.8,188.7 145.4,190.4 140,239.2 	"
              />
              <path
                class="st13"
                d="M126.9,188.9l18.2,1.7l-5.3,48.4l-17.8-3.1L126.9,188.9z M126.6,188.5l-5,47.7l18.5,3.2l5.4-49.1L126.6,188.5
            z"
              />
              <path
                class="st36"
                d="M131.7,227.2L130,227l-0.2,0.9c0.1,0,0.1,0,0.2,0c0.2,0,0.8,0.2,1.1,0.6c0.3,0.4,0.5,0.9,0.4,1.5
            c-0.1,1.2-1,2.2-2.5,2c-0.5,0-1-0.2-1.2-0.4l0.3-1.2c0.2,0.1,0.6,0.3,0.9,0.3c0.6,0.1,1-0.3,1-0.8c0.1-0.8-0.6-1.1-1.3-1.1
            c-0.2,0-0.3,0-0.4,0l0.6-3.2l2.8,0.3L131.7,227.2L131.7,227.2z"
              />
              <path
                class="st36"
                d="M133,230.9c0.3,0.2,0.6,0.3,0.9,0.3c0.6,0,0.9-0.3,0.9-0.7c0-0.7-0.5-0.9-1.1-0.9h-0.2v-1.1h0.1
            c0.5,0,1-0.1,1.1-0.6c0-0.4-0.2-0.6-0.7-0.6c-0.3,0-0.6,0.1-0.8,0.2l-0.1-1.1c0.3-0.2,0.8-0.3,1.4-0.3c1.2,0,1.8,0.8,1.7,1.6
            c0,0.6-0.4,1.1-0.9,1.4l0,0c0.6,0.3,1,0.8,1,1.6c0,0.9-0.8,1.9-2.3,1.9c-0.6,0-1-0.2-1.3-0.3L133,230.9z"
              />
              <polygon
                class="st13"
                points="132.4,222.1 128.2,221.7 128.3,220.8 131.8,221.2 131.9,219.6 132.6,219.7 	"
              />
              <polygon
                class="st13"
                points="128.6,216.6 129.3,216.6 129.2,218.1 130.2,218.2 130.3,216.8 131,216.9 130.9,218.3 132,218.4
            132.2,216.8 132.9,216.9 132.6,219.3 128.4,218.9 	"
              />
              <polygon
                class="st13"
                points="128.7,216.1 128.9,213.7 129.6,213.7 129.5,215.3 130.5,215.4 130.6,213.9 131.3,214 131.2,215.4
            133,215.6 132.9,216.4 	"
              />
              <polygon
                class="st13"
                points="129.2,210.8 129.9,210.9 129.8,211.8 133.3,212.1 133.2,213 129.7,212.7 129.6,213.6 128.9,213.5
            "
              />
              <polygon
                class="st13"
                points="129.3,209 129.6,206.6 130.3,206.7 130.1,208.2 131.1,208.3 131.2,206.9 131.9,206.9 131.8,208.4
            133.6,208.5 133.6,209.4 	"
              />

              <rect
                x="131.3"
                y="203.9"
                transform="matrix(9.150732e-02 -0.9958 0.9958 9.150732e-02 -85.414 318.4047)"
                class="st13"
                width="0.9"
                height="4.2"
              />
              <polygon
                class="st13"
                points="130,202.3 130.7,202.4 130.5,203.9 131.5,204 131.6,202.6 132.3,202.6 132.2,204.1 133.3,204.2
            133.5,202.6 134.2,202.6 134,205.1 129.7,204.7 	"
              />
              <polygon
                class="st13"
                points="134.2,202.2 130,201.8 130.1,201 133.6,201.3 133.7,199.8 134.4,199.8 	"
              />
              <path
                class="st13"
                d="M130.3,199l0.1-1.4c0.1-1.2,0.9-1.3,2.2-1.2c1.5,0.1,2.1,0.5,2,1.7l-0.1,1.4L130.3,199z M133.9,198.5v-0.4
            c0.1-0.6-0.3-0.7-1.4-0.9c-1-0.1-1.5-0.1-1.5,0.6v0.4L133.9,198.5z"
              />
              <polygon
                class="st13"
                points="134.1,217.6 134.8,217.6 134.7,218.6 138.2,218.9 138.1,219.7 134.6,219.4 134.5,220.3 133.8,220.3
            "
              />
              <polygon
                class="st13"
                points="134.3,214.8 135,214.9 134.9,216.4 135.9,216.5 136,215 136.7,215.1 136.6,216.5 137.7,216.6
            137.8,215.1 138.5,215.1 138.3,217.6 134.1,217.2 	"
              />
              <path
                class="st13"
                d="M134.4,214.3l0.1-1.6c0.1-0.7,0.5-1.1,1.2-1c0.6,0.1,0.9,0.3,1,0.8l0,0c0.1-0.6,0.5-0.6,1.3-0.6
            c0.4,0,0.7,0,0.8-0.1l0,0l-0.1,0.9c-0.1,0.1-0.3,0.1-0.5,0.1l-0.8-0.1c-0.3,0-0.5,0.1-0.6,0.5v0.5l1.8,0.2l-0.1,0.9L134.4,214.3z
            M136.3,213.6v-0.4c0-0.4-0.1-0.7-0.6-0.7c-0.4,0-0.6,0.2-0.6,0.5v0.4L136.3,213.6z"
              />
              <path
                class="st13"
                d="M134.7,211l0.1-1.6c0.1-0.7,0.5-1.1,1.2-1c0.6,0.1,0.9,0.3,1,0.8l0,0c0.1-0.6,0.5-0.6,1.3-0.6
            c0.4,0,0.7,0,0.8-0.1l0,0l-0.1,0.9c-0.1,0.1-0.3,0.1-0.5,0.1l-0.8-0.1c-0.3,0-0.5,0.1-0.6,0.5v0.5l1.8,0.2l-0.1,0.9L134.7,211z
            M136.6,210.3v-0.4c0-0.4-0.1-0.7-0.6-0.7c-0.4,0-0.6,0.2-0.6,0.5v0.4L136.6,210.3z"
              />
              <path
                class="st13"
                d="M135,206.8l0.1-1.1l4.3-0.7l-0.1,0.9l-0.9,0.1l-0.1,1.1l0.9,0.3l-0.1,0.9L135,206.8z M137.7,207l0.1-0.8
            l-1.9,0.2l0,0L137.7,207z"
              />
              <path
                class="st13"
                d="M136.9,202.7c-0.6-0.1-0.9,0-0.9,0.4s0.4,0.6,1.6,0.7c1.3,0.1,1.5,0,1.6-0.4c0-0.3-0.1-0.6-1-0.6l0.1-0.9
            c0.9,0.1,1.7,0.4,1.6,1.5c-0.1,1.3-1,1.4-2.3,1.2c-1.3-0.1-2.2-0.4-2.1-1.7c0.1-1.2,1-1.2,1.6-1.2L136.9,202.7z"
              />
              <polygon
                class="st13"
                points="135.8,198.8 136.5,198.8 136.3,200.4 137.3,200.4 137.5,199 138.2,199.1 138,200.5 139.2,200.6
            139.3,199 140,199.1 139.8,201.5 135.6,201.2 	"
              />
              <path
                class="st60"
                d="M341.7,20.6h1.5c0.9,0,1.4,0,1.7,0.1c0.4,0.1,0.8,0.3,1.1,0.6c0.3,0.3,0.4,0.7,0.4,1.2s-0.1,0.9-0.4,1.2
            c-0.3,0.3-0.6,0.5-1.1,0.7c-0.3,0.1-1,0.1-1.9,0.1h-0.5V28h-0.8L341.7,20.6L341.7,20.6z M342.5,21.4v2.5h1.3c0.5,0,0.9,0,1.1-0.1
            s0.4-0.2,0.6-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.5-0.2-0.7s-0.3-0.4-0.5-0.4c-0.2-0.1-0.6-0.1-1.1-0.1
            C343.9,21.4,342.5,21.4,342.5,21.4z"
              />
              <path
                class="st60"
                d="M351.1,20.4c1.1,0,2.1,0.4,2.9,1.1c0.8,0.8,1.2,1.7,1.2,2.8c0,1.1-0.4,2-1.2,2.8c-0.8,0.8-1.7,1.1-2.8,1.1
            c-1.1,0-2.1-0.4-2.8-1.1c-0.8-0.8-1.2-1.7-1.2-2.8c0-0.7,0.2-1.4,0.5-2s0.8-1.1,1.4-1.4S350.4,20.4,351.1,20.4 M351.1,21.2
            c-0.6,0-1.1,0.1-1.6,0.4s-0.9,0.7-1.2,1.2c-0.3,0.5-0.4,1-0.4,1.6c0,0.9,0.3,1.6,0.9,2.3c0.6,0.6,1.4,0.9,2.2,0.9
            c0.6,0,1.1-0.1,1.6-0.4s0.9-0.7,1.2-1.2c0.3-0.5,0.4-1,0.4-1.6s-0.1-1.1-0.4-1.6s-0.7-0.9-1.2-1.2
            C352.2,21.3,351.7,21.2,351.1,21.2"
              />
              <path
                class="st60"
                d="M356.5,20.6h1.5c0.8,0,1.4,0,1.7,0.1c0.4,0.1,0.8,0.3,1.1,0.7c0.3,0.3,0.4,0.7,0.4,1.2c0,0.4-0.1,0.8-0.3,1.1
            c-0.2,0.3-0.5,0.5-0.8,0.7c-0.4,0.2-0.9,0.2-1.5,0.2l2.7,3.5h-0.9l-2.7-3.5h-0.4v3.5h-0.8L356.5,20.6L356.5,20.6z M357.2,21.4v2.5
            h1.3c0.5,0,0.9,0,1.1-0.1s0.4-0.2,0.6-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.5-0.2-0.7s-0.3-0.4-0.5-0.4
            c-0.2-0.1-0.6-0.1-1.1-0.1C358.6,21.4,357.2,21.4,357.2,21.4z"
              />
              <path
                class="st60"
                d="M369.6,22l-0.6,0.5c-0.3-0.4-0.7-0.7-1.2-1c-0.5-0.2-1-0.3-1.5-0.3c-0.6,0-1.2,0.1-1.7,0.4s-0.9,0.7-1.2,1.2
            c-0.3,0.5-0.4,1-0.4,1.6c0,0.9,0.3,1.7,0.9,2.3c0.6,0.6,1.4,0.9,2.4,0.9c1.1,0,1.9-0.4,2.6-1.2l0.6,0.4c-0.4,0.5-0.8,0.8-1.4,1.1
            c-0.6,0.3-1.2,0.4-1.9,0.4c-1.3,0-2.4-0.4-3.1-1.3c-0.6-0.7-1-1.6-1-2.7s0.4-2,1.2-2.8c0.8-0.7,1.7-1.1,2.9-1.1
            c0.7,0,1.3,0.1,1.9,0.4C368.8,21.1,369.2,21.5,369.6,22"
              />
              <polygon
                class="st60"
                points="371.1,20.6 371.9,20.6 371.9,23.8 375.7,23.8 375.7,20.6 376.4,20.6 376.4,28.1 375.7,28.1
            375.7,24.5 371.9,24.5 371.9,28.1 371.1,28.1 	"
              />
              <path
                class="st60"
                d="M368.5,10.7c0-0.2-0.2-0.4-0.3-0.4c-0.3,0-0.5,0.3-0.5,0.6c0,0.2,0.1,0.3,0.4,0.3
            C368.3,11.3,368.5,11,368.5,10.7"
              />
              <path
                class="st60"
                d="M374.3,19.5c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1
            c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3C374.5,19.5,374.4,19.5,374.3,19.5 M374.5,20.1
            c-0.1,0.1-0.1,0.1-0.2,0.1s-0.2,0-0.2-0.1C374,20,374,20,374,19.9s0-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1s0.2,0,0.2,0.1
            c0.1,0.1,0.1,0.1,0.1,0.2C374.6,19.9,374.5,20,374.5,20.1"
              />
              <path
                class="st60"
                d="M382.5,5.6l-23.1,4.5c-0.1,0.1-0.2,0.4-0.4,0.7l22.3-4.3l-4.5,6.8c-0.1,0.1-0.2,0.1-0.3,0.1
            c-0.1,0-0.1,0-0.2-0.1c0,0-0.1-0.1-0.1-0.2c0-0.3,0.3-0.7,0.6-0.8c0-0.2-0.1-0.3-0.4-0.3s-0.8,0.2-1.6,1.4c0.3-0.5,0.4-0.7,0.4-1
            c0-0.2-0.1-0.4-0.5-0.4c-0.6,0-0.9,0.5-1.7,1.5c-0.5,0.6-1.1,1.2-1.7,1.2c-0.2,0-0.3-0.1-0.3-0.3s0.1-0.5,0.2-0.7
            c0.8-0.1,1.9-0.7,1.9-1.4c0-0.3-0.2-0.4-0.5-0.4c-0.4,0-0.9,0.2-1.4,0.7s-1.4,1.3-1.8,1.6c0.2-0.3,0.3-0.6,0.3-1c0-0.3,0-0.6,0-0.9
            v-0.1c0.2,0,0.3-0.2,0.3-0.3s-0.1-0.2-0.3-0.2c-0.2,0-0.4,0.2-0.5,0.5c-0.3,0.3-0.7,0.7-1,1.1c-0.9,0.9-1.5,1.4-1.8,1.4
            c-0.1,0-0.1,0-0.1-0.1c0-0.2,0.3-0.6,0.5-1c0,0,0.2-0.4,0.9-1.5h-0.8c-0.1,0.1-0.3,0.4-0.3,0.5c-0.6,0.8-1.7,2.1-2.6,2.1
            c-0.3,0-0.4-0.1-0.4-0.3s0.1-0.4,0.2-0.6c1.1-0.2,1.9-0.9,1.9-1.4c0-0.3-0.2-0.4-0.5-0.4c-1,0-1.8,1-2.1,1.6
            c-0.2-0.1-0.4-0.2-0.5-0.4c0.3-0.5,0.5-1,0.5-1.1S363,12,362.9,12c-0.2,0-0.3,0.1-0.3,0.2c-0.1,0.2-0.2,0.5-0.2,0.9
            c-0.2,0.6-1.1,1.7-1.7,1.7c-0.1,0-0.2-0.1-0.2-0.1c0-0.2,0.2-0.6,0.6-1.2c0.1-0.1,0.5-0.9,0.8-1.2h-0.8c-0.2,0.3-0.4,0.6-0.6,0.9
            c-0.9,1.2-1.5,1.7-1.8,1.7c-0.1,0-0.1,0-0.1-0.1s0-0.2,0.1-0.3c0.3-0.5,0.9-1.4,1.4-2.1h-0.8c-0.1,0.1-0.4,0.5-0.5,0.7
            c-1.2,1.5-1.7,1.9-2,1.9c-0.1,0-0.1-0.1-0.1-0.1c0-0.2,0.3-0.7,0.8-1.6c0.1-0.2,1.3-2.2,2-3.2l-0.9,0.1c0,0-0.1,0.2-0.3,0.5
            c0,0,0,0.1-0.1,0.1l-11.9-4.5L344,9.9l0,0h-0.1c-1.4,0-2.3,0.6-2.3,1.5c0,0.7,0.6,1.1,1.7,1.1c0.8,0,1.4-0.2,1.8-0.5
            c-0.7,1-1.6,2.3-1.9,2.9c-0.2,0.3-0.3,0.5-0.3,0.7c0,0.3,0.3,0.5,0.7,0.5c0.5,0,0.9-0.3,1.3-1l0.2-0.2c0,0,0,0.1,0,0.2
            c0,0.5,0.3,0.9,1.3,0.9c1.3,0,2.6-0.7,3.8-1.9l0.3-0.2c-0.4,0.5-0.5,0.9-0.5,1.1c0,0.3,0.2,0.4,0.5,0.4c0.5,0,1-0.4,1.4-0.8
            l0.2-0.2c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.2,0.1,0.4,0.5,0.4c0.6,0,1.2-0.5,1.7-1c-0.1,0.2-0.1,0.4-0.1,0.5c0,0.3,0.2,0.5,0.6,0.5
            c0.5,0,0.9-0.2,1.4-0.8c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0.2-0.2,0.4-0.2,0.7s0.2,0.5,0.5,0.5c0.7,0,1.4-0.8,1.8-1.2
            c-0.2,0.3-0.3,0.5-0.3,0.8s0.2,0.5,0.5,0.5c0.6,0,1.2-0.6,1.7-1.1c-0.1,0.2-0.2,0.4-0.2,0.7s0.2,0.5,0.6,0.5c0.3,0,0.7-0.1,1.2-0.5
            c0.4-0.4,0.7-0.8,1-1.2c0.1,0.2,0.3,0.3,0.5,0.4c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.4,0.3,0.7,0.8,0.7c0.9,0,1.7-0.8,2.2-1.3
            c-0.2,0.4-0.3,0.7-0.3,0.9c0,0.3,0.2,0.5,0.5,0.5c0.6,0,1.3-0.6,1.8-1.2c0.2-0.2,0.7-0.6,1.3-1.3c0,0.2-0.1,0.5-0.1,0.7
            c-0.2,1.2-0.6,1.6-1,1.6s-0.3-0.4-0.6-0.4c-0.1,0-0.2,0.1-0.2,0.2c0,0.2,0.3,0.4,0.7,0.4c0.8,0,1.4-0.5,1.9-0.9
            c0.2-0.2,0.5-0.4,0.7-0.7c-0.2,0.3-0.3,0.6-0.3,0.9c0,0.4,0.2,0.7,0.8,0.7c1,0,1.8-0.9,2.2-1.5c0.6-0.7,1-1.3,1.3-1.3
            c0.1,0,0.1,0,0.1,0.1s-0.1,0.3-0.2,0.5c-0.5,0.9-1.2,1.9-1.3,2.1h0.8c0.4-0.6,1.5-2,2-2.5c-0.1,0.2-0.2,0.4-0.2,0.6
            c0,0.3,0.2,0.5,0.6,0.5c0.2,0,0.4,0,0.5-0.1l-0.1-0.2l0.2,0.1l0.1,0.3c-0.1,0.1-0.4,0.2-0.7,0.2l0,0l-3.7,5.7l-17.5-3.4l-16.9,2.7
            l4.2-6.5c-0.2,0-0.4-0.1-0.6-0.2l-4.9,7.5l18.1-2.9l17.8,3.5L382.5,5.6z M372.7,12.2c0.1,0,0.1,0.1,0.1,0.1c0,0.5-0.8,1.2-1.4,1.3
            C371.8,12.7,372.3,12.2,372.7,12.2 M365.1,12.2c0.1,0,0.1,0.1,0.1,0.1c0,0.5-0.8,1.2-1.4,1.3C364.2,12.9,364.7,12.2,365.1,12.2
            M343.4,11.7c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0l1.2-1.8c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.4,0l-1.1,1.7
            c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.7,0.8-1.2,2-1.2c0.9,0,1.7,0.2,2.2,0.4l-0.5,0.8
            C345.1,11,344.5,11.6,343.4,11.7 M344,15c-0.2,0.1-0.3,0.2-0.4,0.2s-0.1,0-0.1-0.1s0-0.2,0.2-0.4c0.2-0.3,2.8-4.1,3-4.4
            c0.2,0.1,0.4,0.2,0.5,0.3c-0.4,0.6-1,1.5-1.6,2.4C344.9,14,344.4,14.7,344,15 M347.1,12.1h0.3c0.7,0,0.8,0.4,0.8,0.8
            c0,0.9-0.9,2.4-2.3,2.4c-0.6,0-0.8-0.3-0.8-0.7c0-0.7,0.7-1.5,1.7-1.5v-0.2c-0.3,0-0.8,0.1-1.1,0.3c0.6-0.8,1.4-2.1,1.7-2.5
            c0.2,0.1,0.4,0.3,0.6,0.4l0.1-0.2c-0.1-0.1-0.3-0.3-0.6-0.4c0.3-0.4,0.8-1,1.4-1c0.4,0,0.5,0.2,0.5,0.5c0,0.4-0.4,1.2-1.1,1.6
            c-0.3,0.2-0.8,0.2-1.4,0.2l-0.2,0.3C346.9,12.1,347,12.1,347.1,12.1 M352.5,14.7c-0.1,0-0.1,0-0.1-0.1v-0.1
            c0.1-0.2,0.2-0.5,0.5-0.9c0,0,0.2-0.4,1-1.5l-0.9,0.1c0,0-0.7,1.1-1,1.4c-0.5,0.6-1.1,1.2-1.4,1.2c-0.1,0-0.1-0.1-0.1-0.1
            c0-0.1,0-0.2,0.2-0.4c0.2-0.4,1.4-2.1,1.4-2.1l-0.9,0.1c-0.1,0.1-0.3,0.4-0.4,0.5c-0.5,0.6-1.5,1.6-2.3,2c0.4-0.4,0.7-1,0.7-1.6
            c0-0.7-0.4-0.9-0.7-1c0.4-0.1,1-0.3,1.4-0.7c0.3-0.3,0.5-0.8,0.5-1.2c0-0.5-0.3-0.9-1.1-0.9c-0.7,0-1.3,0.4-1.9,1.1
            c-0.2-0.1-0.4-0.2-0.5-0.3c0.2-0.3,0.4-0.5,0.5-0.6h-1c-0.1,0.1-0.1,0.2-0.2,0.3c-0.4-0.1-0.8-0.3-1.3-0.3c-0.1,0-0.3,0-0.4-0.1
            l1.9-2.9l11.4,4.3l-0.1,0.1c-0.3,0.5-0.6,1-0.8,1.3c-0.1-0.2-0.3-0.3-0.6-0.3c-0.7,0-1.4,0.5-1.9,1.1
            C354,13.5,353.1,14.7,352.5,14.7 M355.5,14.1c-0.4,0.4-0.7,0.6-0.8,0.6c-0.2,0-0.2-0.1-0.2-0.2c0-0.3,0.4-1,0.8-1.5
            c0.4-0.6,0.8-0.8,1.1-0.8c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0.1,0,0.2C356.3,13.2,355.8,13.7,355.5,14.1"
              />
              <path
                class="st60"
                d="M374.5,19.8C374.5,19.7,374.4,19.7,374.5,19.8c-0.1-0.1-0.1-0.1-0.2-0.1h-0.2v0.4h0.1v-0.2h0.1l0.1,0.2h0.1
            l-0.1-0.2C374.4,19.9,374.5,19.8,374.5,19.8 M374.3,19.8L374.3,19.8l-0.1-0.1h0.1C374.3,19.7,374.4,19.7,374.3,19.8
            C374.4,19.8,374.3,19.8,374.3,19.8"
              />
              <polygon
                class="st60"
                points="340.4,7.5 340.7,7.5 340.7,8.8 340.9,8.8 340.9,7.5 341.2,7.5 341.2,7.3 340.4,7.3 	"
              />
              <polygon
                class="st60"
                points="342.2,7.9 341.5,7.9 341.5,7.3 341.3,7.3 341.3,8.8 341.5,8.8 341.5,8.1 342.2,8.1 342.2,8.8
            342.4,8.8 342.4,7.3 342.2,7.3 	"
              />
              <polygon
                class="st60"
                points="343.5,7.5 343.5,7.3 342.6,7.3 342.6,8.8 343.5,8.8 343.5,8.6 342.8,8.6 342.8,8.1 343.5,8.1
            343.5,7.9 342.8,7.9 342.8,7.5 	"
              />
              <rect x="303.4" y="4.4" class="st24" width="29.2" height="9.2" />
              <rect x="303.4" y="4.4" class="st61" width="29.2" height="9.2" />
              <path
                class="st62"
                d="M370.4,335.8c-0.1-0.2-0.2-0.3-0.2-0.3c-0.1,0-0.6-0.1-0.9-0.2v0.3C369.4,335.6,370.1,335.7,370.4,335.8"
              />
              <path
                class="st62"
                d="M372.3,343.2h-0.9h-3.9v0.3h4.2h0.8h2.1c0.2-0.1,0.5-0.2,0.8-0.3H372.3z"
              />
              <path
                class="st62"
                d="M373.5,335.4c0.3,0.5,0.8,1.6,1.2,2.2c0.1-0.1,0.1-0.2,0.2-0.3c-0.3-0.6-0.7-1.4-0.9-1.7
            c0.2-0.1,0.7-0.2,0.7-0.2v-0.9h-0.3v0.8C374.3,335.3,373.7,335.4,373.5,335.4"
              />
              <path
                class="st62"
                d="M375.3,335.3v0.3c0,0,0.2,0,0.4,0.1c0.1-0.1,0.1-0.2,0.1-0.2C375.7,335.4,375.5,335.4,375.3,335.3"
              />
              <path
                class="st62"
                d="M376.5,343.2l0.3,0.4l-0.2,0.2c-0.4,0.4-4.3,3.1-8.5,2.5c-1.9-0.2-3.5-1-5-2.4c1.5,1.6,3.2,2.5,5.2,2.7
            c4.3,0.5,8.1-2.2,8.5-2.6l0.2-0.2l-0.3-0.3h0.6v-1.1c0,0-0.1,0-0.3-0.1v0.8h-0.5L376.5,343.2L376.5,343.2z"
              />
              <path
                class="st62"
                d="M377.7,335.9c-0.6,1-2.1,3.4-2.1,3.6v2.4c0.1,0,0.2,0,0.3,0.1v-2.3c0.1-0.1,1-1.6,1.6-2.7
            C377.5,336.5,377.6,336.2,377.7,335.9"
              />
              <path
                class="st62"
                d="M381.5,340.7c-0.3-0.2-0.7-0.4-1.1-0.6l-0.6-0.3c-0.6-0.3-1-0.6-1.3-0.8c0.4,0.4,0.9,0.8,1.7,1.2l0.6,0.3
            c0.3,0.1,0.7,0.3,0.9,0.5C381.6,340.8,381.6,340.7,381.5,340.7"
              />
              <path
                class="st62"
                d="M379.6,341.7c-0.2-0.3-0.4-0.7-0.5-1.2v-0.3h-0.3C378.9,340.9,379.2,341.4,379.6,341.7"
              />
              <path
                class="st62"
                d="M382.8,337.3C382.8,337.3,382.9,337.4,382.8,337.3l0.1,0.3h1.3l-0.1-2.8l-0.2-0.1h-0.1l0.1,2.6H382.8z"
              />
              <path
                class="st62"
                d="M381.1,335.3c-0.5,0-1.1,0.2-1.1,0.7c0,0.3,0.1,0.5,0.4,0.7c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.5,0.6-0.7,1.1-0.7
            c0.7,0,1.1,0.3,1.4,1.6V337C382.6,335.9,382,335.3,381.1,335.3"
              />
              <path
                class="st62"
                d="M383.9,338.9c0.3,0.4,0.4,1,0.4,1.6c0,1.8-1.4,2.9-3.6,2.9c-1,0-1.9-0.2-2.7-0.6v0.2l0.2,0.1
            c0.9,0.4,1.8,0.6,2.8,0.6c2.2,0,3.6-1.1,3.6-2.9C384.6,340,384.4,339.3,383.9,338.9"
              />
              <path
                class="st62"
                d="M371.8,341.9c-0.4-1-2-5-2.6-6.7l0,0l-0.1-0.3l0,0c-0.1-0.3-0.2-0.5-0.2-0.5h-0.3c0.6,1.4,2.8,7.1,2.9,7.3
            C371.5,341.9,371.6,341.9,371.8,341.9"
              />
              <path
                class="st62"
                d="M366,341.2h2.1c0-0.1-0.1-0.2-0.1-0.3h-2.2c-0.1,0.2-0.2,0.5-0.3,0.8c0.2,0.2,0.4,0.4,0.6,0.6
            c-0.1-0.1-0.2-0.2-0.3-0.3C365.8,341.7,365.9,341.4,366,341.2"
              />
              <path
                class="st62"
                d="M366.2,339.5c0.2,0,0.3,0,0.5,0c0-0.1,0.1-0.2,0.1-0.2l0,0c0.1-0.3,0.2-0.6,0.4-1.1c-0.1-0.2-0.1-0.4-0.2-0.6
            C366.6,338.5,366.2,339.5,366.2,339.5"
              />
              <path
                class="st62"
                d="M364.4,336.2l-0.5,0.1c-0.3,0.4-0.6,0.8-1.1,1.1l0.3,0.4C363.6,337.4,364.1,336.8,364.4,336.2"
              />
              <path
                class="st62"
                d="M359,332.9c0.1,0,0.1,0,0.2,0c0.6,0,1.1,0.1,1.4,0.4c-0.4-0.5-0.9-0.7-1.7-0.7c-0.1,0-0.1,0-0.2,0v1.3
            l0.3,0.2L359,332.9L359,332.9z"
              />
              <path
                class="st62"
                d="M359.4,338.3l-0.1-0.1l0,0c-0.2-0.1-0.5-0.2-0.6-0.2v3.6c0.1,0,0.2,0,0.3,0.1v-3.3c0.1,0,0.3,0.1,0.4,0.1
            L359.4,338.3L359.4,338.3z"
              />
              <path
                class="st62"
                d="M354.1,343.2v0.3h6.6v-1.3c0,0-0.1,0-0.3-0.1v1h-6.3L354.1,343.2L354.1,343.2z"
              />
              <path
                class="st62"
                d="M364.1,335.7l0.4,0.1c0.1-0.3,0.2-0.7,0.2-1.1c0-1.1-0.4-1.8-1-2.3c0.4,0.5,0.6,1.1,0.6,2
            C364.4,334.8,364.3,335.3,364.1,335.7"
              />
              <path
                class="st62"
                d="M358.8,336.6l0.2-0.1v-2.2l-0.3-0.3v2.8c0,0,0.2,0,0.3,0v-0.2L358.8,336.6z"
              />
              <path
                class="st62"
                d="M364,339.9l-0.7-1.1c0,0-0.3-0.5-0.6-0.8h0.1l0.1-0.1l-0.4-0.3c0,0-0.1,0-0.1,0.1c0,0,0,0-0.1,0
            c0.2,0.3,0.6,0.8,0.6,0.8l0.7,1.1l0.1,0.1c0.1,0.2,0.2,0.3,0.3,0.5v-0.1C364,340,364,340,364,339.9C364,340,364,339.9,364,339.9"
              />
              <path
                class="st62"
                d="M355.3,332.8c-0.3,0-0.9-0.2-1.3-0.2v0.4c0,0,0.8,0.1,1.3,0.2V332.8z"
              />
              <path
                class="st29"
                d="M384.4,340.5c0-0.6-0.1-1.2-0.4-1.6c-0.1-0.2-0.2-0.3-0.4-0.4c-0.6-0.5-1.2-0.8-1.8-1.1l-0.4-0.2h-0.1
            c-0.4-0.2-0.7-0.3-0.9-0.5c-0.3-0.2-0.4-0.4-0.4-0.7c0-0.5,0.6-0.7,1.1-0.7c0.9,0,1.5,0.6,1.7,1.7v0.2v0.1l0,0h1l-0.1-2.6v-0.2
            l-0.2-0.1c-0.9-0.3-1.6-0.5-2.4-0.5c-0.6,0-1.1,0.1-1.5,0.2h-4.7v1.1c0,0,0.1,0,0.3,0.1c0.2,0,0.4,0.1,0.6,0.1
            c0,0.1-0.1,0.2-0.1,0.2c-0.3,0.5-0.7,1.1-1,1.7c-0.1,0.1-0.1,0.2-0.2,0.3c-0.3-0.6-0.9-1.7-1.2-2.2c0.3-0.1,0.8-0.2,0.8-0.2v-0.8
            v-0.3h-5.3v0.8l0,0v0.3h0.1c0.1,0,0.1,0,0.2,0c0.3,0.1,0.8,0.1,0.9,0.2c0,0,0.1,0.1,0.2,0.3c0.5,0.9,2.1,3.5,2.2,3.6v2.4
            c-0.2,0-0.5,0.1-0.7,0.1h-0.1c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.3-2.3-5.9-2.9-7.3c-0.1-0.2-0.1-0.3-0.1-0.3h-1.9l-0.7,1.8l0.3,0.1
            h-0.4l-1.6,3.9v0.1c-0.1-0.2-0.2-0.3-0.3-0.5l-0.1-0.1l-0.7-1.1c0,0-0.3-0.5-0.6-0.8h0.1c0,0,0.1,0,0.1-0.1l-0.3-0.2
            c-0.1,0.1-0.2,0.1-0.3,0.1h-0.1c0.6,0.8,1.1,1.6,1.5,2.3c0.2,0.3,0.5,0.7,0.8,1l2.6-6.2h1.5l3,7.6l0.7,0.2l1.1-0.2v-2.8l-2.5-4.2
            h-1v-0.5h4.6v0.5l-1,0.2l1.7,3.2l1.8-3.2l-1.1-0.2v-0.5h3.5h0.9c0.4-0.1,0.9-0.2,1.4-0.2c0.7,0,1.5,0.2,2.3,0.4l0.1,2.2h-0.4
            c-0.3-1.3-1-2-2-2c-0.8,0-1.4,0.4-1.4,1.1c0,0.8,0.6,1.1,1.6,1.5c0.6,0.3,1.4,0.6,2.1,1.1c0.5,0.4,0.7,1,0.7,1.8
            c0,1.5-1.1,2.5-3.2,2.5c-1,0-1.9-0.2-2.7-0.6l-0.1-2.2h0.4c0.2,1.4,1,2.2,2.2,2.2c0.9,0,1.4-0.5,1.4-1.1c0-0.3-0.1-0.6-0.4-0.8
            c-0.5-0.4-1.1-0.6-1.7-0.9c-1.4-0.7-2.1-1.4-2.1-2.6c0-0.8,0.3-1.4,0.8-1.9l-1,0.1l-2.5,4.2v2.8l1.5,0.2v0.5H372h-0.1h-4.2v-0.5
            l1.1-0.2l-0.6-1.6h-2.8l-0.5,1.2c0,0,0,0,0.1,0.1c2.2,2.4,5.2,4.3,11,1.4l0.3,0.3c-0.7,0.7-9.7,6.6-15.1-2.5
            c-0.1-0.1-0.2-0.3-0.2-0.4v0.2v-0.3c-0.5-0.8-0.9-1.6-1.3-2.3c0,0,0-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1l-0.8-0.3v-0.1v-0.3
            c0.1,0,0.3,0,0.4,0c0.4,0,0.8-0.1,1.1-0.2l0,0c0,0,0.1,0,0.3-0.2l0,0l0,0l0,0c0.1-0.1,0.2-0.1,0.2-0.2l0.2,2l0.4-2.2l0.7,0.5
            l-0.5-0.8l1.9-0.2l-1.9-0.4l0.3-0.7l-0.6,0.4c0-0.1,0-0.3,0-0.4l0,0l0,0l0,0v-0.1l0,0l0,0l0,0c0-1.7-0.9-2.5-2.5-2.5
            c-0.2,0-0.4,0-0.5,0v1.4l0.3,0.2v-1.3c0.1,0,0.1,0,0.2,0c0.8,0,1.4,0.2,1.7,0.7c0.2,0.3,0.4,0.8,0.4,1.4l0.2,0.3l0,0
            c-0.6,0.5-0.7,1.2-0.7,1.6h-0.1c-0.3,0.2-0.7,0.3-1.3,0.3c0,0,0,0-0.1,0s-0.3,0-0.3,0V334l-0.3-0.4v8.2l1.7,0.3v0.7H354v-0.7
            l1.6-0.3v-9.4l-1.6-0.3v-0.7h4.3h1.3l0,0c2.9,0,4.3,0.8,4.3,2.9c0,0.5-0.1,0.9-0.2,1.3l0.3,0.1c0.2-0.4,0.2-0.9,0.2-1.3
            c0-0.9-0.2-1.5-0.6-2c-0.9-1.1-2.6-1.3-4-1.3h-6v1.3c0,0,0.1,0,0.3,0.1c0.4,0.1,1,0.2,1.3,0.2v0.4v8.4c-0.4,0.1-1.6,0.3-1.6,0.3
            v1.3h0.3h6.3v-1v-0.3c0,0-0.8-0.1-1.3-0.2c-0.1,0-0.3,0-0.3-0.1V338c0.1,0,0.4,0.2,0.6,0.2l0,0l0.1,0.1l0,0v0.1l0.5,0.9
            c0.3,0.6,0.7,1.3,1.1,1.9c0.6,1.1,1.4,2,2.1,2.7c1.4,1.4,3.1,2.2,5,2.4c4.3,0.5,8.1-2.1,8.5-2.5l0.2-0.2l-0.3-0.4h0.6v-0.8V342
            c0,0-0.7-0.1-1.1-0.2c-0.1,0-0.3,0-0.3-0.1v-2.4c0.1-0.1,1.5-2.6,2.1-3.6c-0.1,0.3-0.2,0.7-0.2,1l0,0c0,0.8,0.3,1.5,1,2.1
            c0.3,0.3,0.8,0.6,1.3,0.8l0.6,0.3c0.4,0.2,0.8,0.3,1.1,0.6c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.5-0.4,0.8-1.1,0.8
            c-0.4,0-0.8-0.1-1.1-0.3c-0.4-0.3-0.7-0.8-0.8-1.5l0,0v-0.3h-1.1l0.1,2.8l0.2,0.1c0,0,0.1,0,0.1,0.1c0.8,0.4,1.7,0.6,2.7,0.6
            C383,343.3,384.4,342.2,384.4,340.5 M369.3,344.2c-1.4-0.3-2.5-1.1-3.3-1.9c-0.2-0.2-0.4-0.4-0.6-0.6c0.1-0.3,0.2-0.6,0.3-0.8h2.2
            c0,0.1,0.1,0.2,0.1,0.3c0.1,0.2,0.1,0.4,0.2,0.6c-0.3,0.1-1,0.2-1,0.2v1.1h0.3h3.9h0.8h3.2c-0.3,0.1-0.5,0.2-0.8,0.3
            C372.6,344.3,370.8,344.6,369.3,344.2"
              />
              <path
                class="st29"
                d="M366.9,336.6l-1,2.7l-0.2,0.5h2.3L366.9,336.6z M367.1,338.3c0.2,0.5,0.3,0.9,0.4,1.3c-0.3,0-0.6,0-0.8,0
            c-0.2,0-0.3,0-0.5,0c0,0,0.4-1,0.7-1.8C366.9,337.9,367,338.1,367.1,338.3"
              />
              <path
                class="st29"
                d="M363.9,336.2h-0.4c-0.2,0.3-0.5,0.6-0.8,0.8l0.2,0.3C363.2,337.1,363.6,336.7,363.9,336.2"
              />
              <path
                class="st63"
                d="M361.6,336.9l-0.6,3.7c0.1,0.1,0.2,0.3,0.2,0.4c5.4,9.1,14.4,3.3,15.1,2.5l-0.3-0.3c-5.9,3-8.8,1-11-1.4
            c0,0,0,0-0.1-0.1l0.5-1.2h2.7l0.6,1.6l-1.1,0.2v0.5h4.2h0.1h4.8v-0.5l-1.5-0.2v-2.8l2.5-4.2l1-0.1c-0.5,0.4-0.8,1.1-0.8,1.9
            c0,1.2,0.7,1.9,2.1,2.6c0.6,0.3,1.2,0.5,1.7,0.9c0.3,0.2,0.4,0.5,0.4,0.8c0,0.6-0.5,1.1-1.4,1.1c-1.2,0-2-0.7-2.2-2.2h-0.4l0.1,2.2
            c0.8,0.4,1.7,0.6,2.7,0.6c2.1,0,3.2-1,3.2-2.5c0-0.8-0.2-1.4-0.7-1.8c-0.6-0.6-1.4-0.9-2.1-1.1c-1-0.4-1.6-0.7-1.6-1.5
            c0-0.6,0.6-1.1,1.4-1.1c1.1,0,1.8,0.7,2,2h0.4l-0.1-2.2c-0.8-0.3-1.5-0.4-2.3-0.4c-0.5,0-1,0.1-1.4,0.2h-0.9h-3.5v0.5l1.1,0.2
            l-1.8,3.2l-1.7-3.2l1-0.2v-0.5h-4.5v0.5l1.1,0.2l2.5,4.2v2.8l-1.1,0.2l-0.7-0.2l-3-7.6h-1.5l-2.6,6.2c-0.3-0.3-0.5-0.7-0.8-1
            c-0.5-0.6-1-1.4-1.5-2.3h0.1c0.1,0,0.2-0.1,0.3-0.1L361.6,336.9z M367.9,339.9h-2.3l0.2-0.5l1-2.7L367.9,339.9z"
              />
              <path
                class="st63"
                d="M363.4,336.3l-1.3,0.1l0.5,0.7C362.9,336.9,363.2,336.6,363.4,336.3"
              />
              <path
                class="st63"
                d="M362.9,333.3l-0.7,2l1.6,0.3c0.2-0.4,0.2-0.8,0.2-1.3c0-2-1.4-2.9-4.3-2.9l0,0h-1.3h-4.3v0.7l1.6,0.3v9.4
            l-1.6,0.3v0.7h5.9v-0.7l-1.7-0.3v-8.2l-0.2-0.2l0.2,0.1v-1.4c0.2,0,0.4,0,0.5,0c1.6,0,2.5,0.9,2.5,2.5l0,0l0,0l0,0v0.1l0,0l0,0
            L362.9,333.3z"
              />
              <path
                class="st63"
                d="M360.6,336.8L360.6,336.8L360.6,336.8c-0.2,0.1-0.3,0.2-0.3,0.2l0,0c-0.3,0.1-0.7,0.2-1.1,0.2
            c-0.1,0-0.3,0-0.4,0v0.3v0.1l0.8,0.3c0,0,0,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.1,0.2c0.4,0.7,0.8,1.5,1.3,2.3L360.6,336.8z"
              />
              <path
                class="st64"
                d="M364.1,335.7l-0.3-0.1l-1.6-0.3l0.7-2l-1.5,1.5l0,0c0,0.1,0,0.2,0,0.4l0.6-0.4l-0.3,0.7l1.9,0.4l-1.9,0.2
            l0.5,0.8l-0.7-0.5l-0.4,2.2l-0.2-2c-0.1,0.1-0.2,0.1-0.2,0.2l0,0l0.4,3.7v0.3v-0.2l0.6-3.7l0.6,0.4l0.3,0.2l0.4,0.3l0.6,0.5
            l-0.4-0.6l-0.3-0.4l-0.2-0.3l-0.5-0.7l1.3-0.1h0.4l0.5-0.1l1.3-0.1h0.4l-0.3-0.1l-1.2-0.2L364.1,335.7z"
              />
              <path
                class="st64"
                d="M358.2,333.5l0.2,0.2l0.3,0.4l0.3,0.3l1.5,1.5l-1.5,0.6l-0.2,0.1h0.2l1.4-0.1h0.1c0-0.4,0.1-1,0.7-1.6l0,0
            l-0.2-0.3l-0.4-0.8l0.3,1.4L359,334l-0.3-0.2l-0.3-0.2L358.2,333.5z"
              />
              <polygon
                class="st63"
                points="384.6,342.2 384.8,342.2 384.8,342.7 385,342.7 385,342.2 385.2,342.2 385.2,342.1 384.6,342.1 	"
              />
              <polygon
                class="st63"
                points="385.8,342.1 385.6,342.5 385.6,342.5 385.5,342.1 385.3,342.1 385.3,342.7 385.4,342.7 385.4,342.2
            385.4,342.2 385.6,342.7 385.7,342.7 385.9,342.2 385.9,342.2 385.9,342.7 386,342.7 386,342.1 	"
              />
              <path
                class="st29"
                d="M240.1,5.3c0,0.3,0,0.5,0.2,0.8c0.2,0.4,0.6,0.4,1,0.2c0.6-0.3,0.5-0.8,0.3-1.2L241.5,5l0.9-0.5v0.1
            c0.2,0.3,0.5,0.6,1,0.4c0.3-0.2,0.4-0.5,0.3-0.8c-0.1-0.2-0.3-0.3-0.5-0.4l0.9-0.7c0.2,0.1,0.6,0.4,0.8,0.8c0.5,0.8,0,1.6-0.6,2
            c-0.5,0.3-1.1,0.3-1.5,0.1l0,0c0,0.5-0.3,1.1-0.9,1.5c-0.8,0.4-1.9,0.4-2.5-0.6c-0.2-0.4-0.3-0.7-0.3-1L240.1,5.3z"
              />
              <path
                class="st29"
                d="M246.1,8.7l-0.7-1.1L244.6,8c0,0,0,0.1,0.1,0.1c0.1,0.2,0.2,0.6,0,1s-0.5,0.8-1,1.1c-1,0.6-2.2,0.5-2.8-0.5
            c-0.2-0.3-0.3-0.7-0.3-1l1.1-0.4c0,0.2,0,0.5,0.2,0.7c0.2,0.4,0.7,0.5,1.1,0.2c0.7-0.4,0.6-0.9,0.3-1.4c-0.1-0.1-0.1-0.2-0.2-0.3
            l2.9-1.3l1.1,1.9L246.1,8.7z"
              />
              <path
                class="st29"
                d="M247.7,11.5l-0.6-1.1l-0.8,0.4c0,0,0,0.1,0.1,0.1c0.1,0.2,0.2,0.6,0,1c-0.1,0.4-0.5,0.8-1,1.1
            c-1,0.6-2.2,0.5-2.8-0.5c-0.2-0.3-0.3-0.7-0.3-1l1.1-0.4c0,0.2,0,0.5,0.2,0.7c0.2,0.4,0.7,0.5,1.1,0.2c0.7-0.4,0.6-0.9,0.3-1.4
            c-0.1-0.1-0.1-0.2-0.2-0.3l2.9-1.3l1.1,1.9L247.7,11.5z"
              />
              <path
                class="st29"
                d="M223.5,17.2c0,0.3,0.1,0.6,0.2,0.8c0.2,0.4,0.7,0.4,1,0.2c0.5-0.3,0.5-0.8,0.3-1.2l-0.1-0.1l0.9-0.6v0.1
            c0.2,0.3,0.5,0.6,1,0.3c0.3-0.2,0.4-0.5,0.2-0.8c-0.1-0.2-0.3-0.3-0.5-0.4l0.9-0.7c0.2,0.1,0.6,0.4,0.8,0.7c0.5,0.8,0.1,1.6-0.6,2
            c-0.5,0.3-1.1,0.3-1.5,0.1l0,0c0.1,0.5-0.2,1.1-0.9,1.5c-0.8,0.5-1.9,0.5-2.5-0.5c-0.2-0.4-0.3-0.7-0.3-1L223.5,17.2z"
              />
              <path
                class="st29"
                d="M229.5,20.3l-0.7-1.1l-0.8,0.4c0,0,0,0.1,0.1,0.1c0.1,0.2,0.2,0.6,0.1,1c-0.1,0.4-0.5,0.8-1,1.1
            c-1,0.6-2.2,0.6-2.8-0.4c-0.2-0.3-0.3-0.7-0.3-0.9l1.1-0.5c0,0.2,0.1,0.5,0.2,0.7c0.3,0.4,0.7,0.5,1.1,0.2c0.7-0.4,0.6-0.9,0.3-1.4
            c-0.1-0.1-0.1-0.2-0.2-0.3l2.9-1.4l1.1,1.8L229.5,20.3z"
              />
              <path
                class="st29"
                d="M226.9,22.8c0,0.3,0.1,0.5,0.2,0.8c0.2,0.4,0.7,0.4,1,0.2c0.5-0.3,0.5-0.8,0.3-1.2l-0.1-0.1l0.9-0.6V22
            c0.2,0.3,0.5,0.6,1,0.3c0.3-0.2,0.4-0.5,0.2-0.8c-0.1-0.2-0.3-0.3-0.5-0.4l0.9-0.7c0.2,0.1,0.6,0.4,0.8,0.7c0.5,0.8,0.1,1.6-0.6,2
            c-0.5,0.3-1.1,0.3-1.5,0.1l0,0c0.1,0.5-0.2,1.1-0.9,1.5c-0.8,0.5-1.9,0.5-2.5-0.5c-0.2-0.4-0.3-0.7-0.3-1L226.9,22.8z"
              />
              <path
                class="st29"
                d="M200,31.3c0,0.3,0.1,0.5,0.3,0.7c0.3,0.4,0.7,0.3,1,0.1c0.5-0.4,0.4-0.9,0.1-1.2l-0.1-0.1l0.8-0.7l0.1,0.1
            c0.2,0.3,0.6,0.5,1,0.2c0.3-0.2,0.3-0.5,0.1-0.8c-0.1-0.2-0.3-0.3-0.6-0.3l0.7-0.8c0.3,0.1,0.7,0.3,0.9,0.6c0.6,0.7,0.3,1.5-0.2,2
            c-0.5,0.4-1,0.5-1.5,0.3l0,0c0.1,0.5-0.1,1.1-0.6,1.6c-0.7,0.6-1.8,0.8-2.6-0.1c-0.3-0.3-0.4-0.7-0.5-0.9L200,31.3z"
              />
              <path
                class="st29"
                d="M206.5,33.5l-0.8-1L205,33l0.1,0.1c0.1,0.1,0.3,0.6,0.2,1s-0.3,0.8-0.8,1.2c-0.9,0.8-2.1,0.9-2.9,0.1
            c-0.2-0.3-0.4-0.7-0.4-0.9l1-0.6c0,0.2,0.1,0.5,0.3,0.7c0.3,0.4,0.8,0.3,1.2,0c0.6-0.5,0.4-1,0.1-1.4c-0.1-0.1-0.2-0.2-0.2-0.2
            l2.6-1.9l1.4,1.6L206.5,33.5z"
              />
              <polygon
                class="st29"
                points="207.6,34.8 207.6,34.8 206.6,34.5 207.4,33.6 208.7,34.1 209.4,34.8 204.7,38.8 203.9,37.9 	"
              />
              <path
                class="st29"
                d="M178.1,54.3c0,0.3,0.2,0.5,0.4,0.7c0.3,0.3,0.7,0.2,1,0c0.4-0.5,0.3-0.9-0.1-1.2l-0.1-0.1l0.7-0.8l0.1,0.1
            c0.3,0.2,0.7,0.5,1,0.1c0.3-0.3,0.3-0.6,0-0.8c-0.2-0.1-0.4-0.2-0.6-0.3l0.7-0.9c0.3,0,0.7,0.2,1,0.5c0.7,0.7,0.5,1.5-0.1,2.1
            c-0.4,0.4-1,0.6-1.4,0.5l0,0c0.2,0.5,0.1,1.1-0.5,1.7c-0.6,0.7-1.7,0.9-2.6,0.1c-0.3-0.3-0.5-0.6-0.5-0.9L178.1,54.3z"
              />
              <path
                class="st29"
                d="M180.6,58.6l1-1l-1.2-1.2l0.7-0.7l3.8-1.6l0.8,0.8l-2.5,2.6l0.3,0.3l-0.8,0.8l-0.3-0.3l-1,1L180.6,58.6z
            M182.3,56.7l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.5,0.3-0.8,0.4l-1.1,0.5l0,0L182.3,56.7z"
              />
              <path
                class="st29"
                d="M182.9,59.2c0.2,0.2,0.2,0.2,0.4,0.3c0.1,0.1,0.4,0.2,0.6,0.1c0.3,0,0.7-0.2,1-0.4l0,0c-0.2,0-0.5,0-0.7-0.2
            c-0.5-0.5-0.4-1.3,0.4-2.2c0.7-0.7,1.9-1.2,2.6-0.5s0.3,1.7-0.7,2.9c-1,1.1-2,1.5-2.7,1.6c-0.5,0.1-1-0.1-1.4-0.4
            c-0.1-0.1-0.2-0.2-0.4-0.3L182.9,59.2z M186.5,57.1c-0.2-0.2-0.5,0.1-1,0.5c-0.3,0.3-0.6,0.8-0.4,1c0.1,0.1,0.3,0.1,0.4,0
            c0.1-0.1,0.2-0.2,0.6-0.5C186.4,57.6,186.6,57.2,186.5,57.1L186.5,57.1z"
              />
              <path
                class="st29"
                d="M153.8,78.6c0.1,0.2,0.3,0.5,0.5,0.6c0.4,0.3,0.8,0.1,1-0.2c0.4-0.5,0.1-0.9-0.2-1.2l-0.1-0.1l0.6-0.9
            l0.1,0.1c0.3,0.2,0.7,0.3,1-0.1c0.2-0.3,0.2-0.6-0.1-0.8c-0.2-0.1-0.4-0.2-0.6-0.2l0.5-1c0.3,0,0.7,0.1,1.1,0.4
            c0.8,0.5,0.7,1.4,0.3,2c-0.5,0.6-1,0.9-1.5,0.8l0,0c0.3,0.5,0.2,1.1-0.2,1.7c-0.5,0.7-1.6,1.2-2.5,0.5c-0.4-0.2-0.6-0.6-0.7-0.8
            L153.8,78.6z"
              />
              <path
                class="st29"
                d="M156.9,82.5l0.8-1.1l-1.4-1l0.6-0.8l3.5-2.1l0.9,0.6l-2.1,2.9l0.4,0.3l-0.7,0.9l-0.4-0.3l-0.8,1.1L156.9,82.5
            z M158.4,80.4l0.6-0.9c0.2-0.2,0.4-0.5,0.6-0.7l0,0c-0.2,0.2-0.5,0.3-0.8,0.5l-1,0.6l0,0L158.4,80.4z"
              />
              <polygon
                class="st29"
                points="164.3,80.1 163.7,80.9 159.5,84.3 158.5,83.6 162.6,80.5 162.6,80.5 161.2,79.6 162,78.5 	"
              />
              <path
                class="st29"
                d="M139.2,107c0.1,0.2,0.3,0.4,0.5,0.6c0.4,0.2,0.8,0,1-0.3c0.3-0.6,0-0.9-0.4-1.2l-0.1-0.1l0.5-0.9h0.1
            c0.3,0.2,0.8,0.2,1-0.2c0.2-0.3,0.1-0.6-0.2-0.8c-0.2-0.1-0.4-0.1-0.7-0.1l0.4-1c0.3,0,0.7,0,1.1,0.2c0.8,0.4,0.9,1.3,0.5,2
            c-0.3,0.5-0.8,0.8-1.3,0.9l0,0c0.3,0.4,0.4,1.1,0,1.7c-0.4,0.8-1.4,1.4-2.4,0.8c-0.4-0.2-0.6-0.5-0.8-0.7L139.2,107z"
              />
              <path
                class="st29"
                d="M142.8,110.4l0.6-1.2l-1.5-0.8l0.5-0.9l3.2-2.6l1,0.5l-1.7,3.2l0.4,0.2l-0.5,1l-0.4-0.2l-0.6,1.2L142.8,110.4
            z M143.9,108.2l0.5-0.9c0.1-0.2,0.3-0.5,0.5-0.8l0,0c-0.2,0.2-0.4,0.4-0.7,0.6l-0.9,0.7l0,0L143.9,108.2z"
              />
              <path
                class="st29"
                d="M148.9,108.2l-1.1-0.6l-0.5,0.7c0,0,0.1,0,0.1,0.1c0.2,0.1,0.5,0.4,0.6,0.8s0,0.9-0.3,1.5
            c-0.6,1-1.6,1.6-2.6,1.1c-0.3-0.2-0.6-0.5-0.7-0.7l0.7-0.9c0.1,0.2,0.3,0.4,0.5,0.5c0.4,0.2,0.8,0,1.1-0.4c0.4-0.7,0-1.1-0.5-1.4
            c-0.1-0.1-0.2-0.1-0.3-0.1l1.7-2.7l1.9,1L148.9,108.2z"
              />
              <path
                class="st29"
                d="M121.5,138.4c0.1,0.2,0.4,0.4,0.6,0.5c0.4,0.2,0.8,0,0.9-0.4c0.3-0.6-0.1-0.9-0.5-1.1l-0.1-0.1l0.4-1h0.1
            c0.3,0.1,0.8,0.2,1-0.3c0.1-0.3,0.1-0.6-0.2-0.8c-0.2-0.1-0.4-0.1-0.7-0.1l0.3-1.1c0.3-0.1,0.7,0,1.1,0.2c0.9,0.4,1,1.2,0.7,1.9
            c-0.3,0.6-0.7,0.9-1.2,1l0,0c0.4,0.4,0.4,1,0.1,1.7c-0.4,0.8-1.3,1.5-2.4,1c-0.4-0.2-0.7-0.4-0.8-0.7L121.5,138.4z"
              />
              <path
                class="st29"
                d="M125.3,141.6l0.6-1.3l-1.6-0.7l0.4-0.9l3-2.8l1,0.5l-1.5,3.3l0.4,0.2l-0.5,1.1l-0.4-0.2l-0.6,1.2L125.3,141.6
            z M126.3,139.3l0.4-1c0.1-0.3,0.3-0.6,0.4-0.8l0,0c-0.2,0.2-0.4,0.4-0.6,0.7l-0.9,0.8l0,0L126.3,139.3z"
              />
              <path
                class="st29"
                d="M127.5,141.1c0.1,0.2,0.4,0.4,0.6,0.5c0.4,0.2,0.8,0,0.9-0.4c0.3-0.6-0.1-0.9-0.5-1.1l-0.1-0.1l0.4-1h0.1
            c0.3,0.1,0.8,0.2,1-0.3c0.2-0.3,0.1-0.6-0.2-0.8c-0.2-0.1-0.4-0.1-0.7-0.1l0.3-1.1c0.3-0.1,0.7,0,1.1,0.1c0.9,0.4,1,1.2,0.7,1.9
            c-0.3,0.6-0.7,0.9-1.2,1l0,0c0.4,0.4,0.4,1,0.1,1.7c-0.4,0.8-1.3,1.5-2.4,1c-0.4-0.2-0.7-0.4-0.8-0.7L127.5,141.1z"
              />
              <path
                class="st29"
                d="M115.9,168.1c0.2,0.2,0.4,0.3,0.7,0.4c0.5,0.1,0.8-0.2,0.9-0.6c0.1-0.6-0.2-0.9-0.7-1h-0.1l0.2-1h0.1
            c0.4,0.1,0.8,0,0.9-0.5c0.1-0.4-0.1-0.6-0.4-0.7c-0.2,0-0.4,0-0.7,0.1l0.1-1.1c0.2-0.1,0.7-0.2,1.1-0.1c0.9,0.2,1.2,1,1,1.8
            c-0.1,0.6-0.5,1-1,1.2l0,0c0.4,0.3,0.6,0.9,0.5,1.7c-0.2,0.9-1,1.7-2.1,1.4c-0.4-0.1-0.7-0.3-0.9-0.5L115.9,168.1z"
              />
              <path
                class="st29"
                d="M120.2,170.5l0.3-1.3l-1.7-0.4l0.2-1l2.4-3.3l1.1,0.2l-0.8,3.5l0.5,0.1l-0.3,1.1l-0.5-0.1l-0.3,1.3
            L120.2,170.5z M120.8,168l0.2-1c0.1-0.3,0.2-0.6,0.3-0.9l0,0c-0.1,0.2-0.3,0.5-0.5,0.8l-0.7,1l0,0L120.8,168z"
              />
              <polygon
                class="st29"
                points="124.1,166.4 124.1,166.4 123.1,166.7 123.2,165.6 124.5,165.1 125.5,165.3 124.2,171.3 123,171.1
            "
              />
              <path
                class="st29"
                d="M219.8,364.6c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0v-0.5
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.6,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C219.4,365.1,219.6,364.8,219.8,364.6"
              />
              <polygon
                class="st29"
                points="223.3,361.3 223.4,361.2 226.8,364.6 227.8,363.5 223.4,359.3 222.5,360.2 222,361.7 223,362.4 	"
              />
              <path
                class="st29"
                d="M226.2,358c0.3-0.3,0.6-0.3,0.9-0.1c0.4,0.4,0.1,0.8-0.2,1.2l-0.1,0.1l0.8,0.7l0.1-0.1
            c0.4-0.4,0.9-0.6,1.4-0.2c0.3,0.3,0.3,0.7-0.1,1.1c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,0.9c0.3-0.1,0.7-0.3,1.1-0.7c1-1,0.8-2.2,0.2-2.9
            c-0.6-0.5-1.2-0.6-1.8-0.3l0,0c0.2-0.5,0.1-1.1-0.4-1.6c-0.6-0.5-1.5-0.6-2.3,0.2c-0.4,0.4-0.6,0.9-0.7,1.2l0.9,0.6
            C225.9,358.4,226.1,358.1,226.2,358"
              />
              <path
                class="st29"
                d="M241.6,387.2c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0V389
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.6,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C241.3,387.8,241.4,387.5,241.6,387.2"
              />
              <polygon
                class="st29"
                points="245.2,383.9 245.2,383.9 248.6,387.2 249.6,386.2 245.2,381.9 244.3,382.9 243.8,384.4 244.8,385
            "
              />
              <polygon
                class="st29"
                points="248.4,380.6 248.4,380.6 251.9,383.9 252.9,382.9 248.5,378.6 247.6,379.5 247.1,381.1 248,381.7
            "
              />
              <path
                class="st29"
                d="M265.3,408.9c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0v-0.5
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.6,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C264.9,409.5,265,409.2,265.3,408.9"
              />
              <path
                class="st29"
                d="M272.6,408.7L272.6,408.7c0.7-0.7,0.6-2-1-3.6c-0.9-0.9-2.4-2-3.5-0.8c-1,1-0.2,2.5,0.9,3.6
            C270.1,408.8,271.6,409.7,272.6,408.7 M269,405.1c0.2-0.2,0.7,0.2,1.6,1c1,1,1.3,1.4,1.1,1.6l0,0c-0.2,0.2-0.7,0-1.7-1
            C269.1,405.8,268.8,405.3,269,405.1"
              />
              <path
                class="st29"
                d="M274,404c0.3-0.3,0.3-0.5,0.3-0.8l0,0c0.2,0.4,0.4,0.8,0.4,1.1c0,0.3-0.1,0.5-0.2,0.7s-0.2,0.3-0.4,0.5
            l0.9,0.8c0.1-0.1,0.3-0.3,0.4-0.4c0.4-0.5,0.6-1.1,0.6-1.6c0-0.8-0.3-1.9-1.4-2.9c-1.1-1.1-2.3-1.3-3.1-0.5
            c-0.9,0.9-0.5,2.2,0.2,2.9C272.4,404.6,273.4,404.6,274,404 M272.1,401.7L272.1,401.7c0.2-0.2,0.6,0,1,0.4c0.4,0.3,0.5,0.5,0.5,0.6
            s0,0.3-0.1,0.4c-0.2,0.2-0.7,0-1-0.3C272.1,402.3,271.9,401.9,272.1,401.7"
              />
              <path
                class="st29"
                d="M286.1,427.3c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0v-0.5
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.6,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C285.7,427.9,285.8,427.6,286.1,427.3"
              />
              <path
                class="st29"
                d="M293.4,427.1L293.4,427.1c0.7-0.7,0.6-2-1-3.6c-0.9-0.9-2.4-2-3.5-0.8c-1,1-0.2,2.5,0.9,3.6
            C290.8,427.2,292.3,428.2,293.4,427.1 M289.8,423.5c0.2-0.2,0.7,0.2,1.6,1c1,1,1.3,1.4,1.1,1.6l0,0c-0.2,0.2-0.7,0-1.7-1
            C289.8,424.2,289.6,423.8,289.8,423.5"
              />
              <polygon
                class="st29"
                points="293.3,420.1 293.3,420.1 295.5,424.8 296.5,423.8 294.1,418.8 293.4,418.1 291,420.6 291.9,421.5
            "
              />
              <path
                class="st29"
                d="M137,286.2l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0c-0.2,0.3-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.6-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L137,286.2z"
              />
              <path
                class="st29"
                d="M140.3,282.9l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.6-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L140.3,282.9z"
              />
              <polygon
                class="st29"
                points="141.1,275.2 141.1,275.2 140.7,276.3 139.8,275.7 140.3,274.1 141.2,273.2 145.6,277.5 144.6,278.5
            "
              />
              <path
                class="st29"
                d="M154.6,302.8l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.6-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L154.6,302.8z"
              />
              <polygon
                class="st29"
                points="155.4,295.1 155.4,295.1 155.1,296.2 154.1,295.6 154.6,294 155.5,293.1 159.9,297.4 158.9,298.4
            "
              />
              <path
                class="st29"
                d="M160.7,295c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0
            c0,0.3-0.1,0.5-0.3,0.8c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.8,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9
            c0,0.5-0.2,1.1-0.6,1.6c-0.1,0.2-0.3,0.3-0.4,0.4L160.7,295z M158.7,291.2c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3
            c0.1-0.1,0.1-0.3,0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.6C159.3,291.2,158.9,291,158.7,291.2L158.7,291.2z"
              />
              <path
                class="st29"
                d="M174.2,320.7c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0v-0.5
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.6,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C173.8,321.3,173.9,321,174.2,320.7"
              />
              <polygon
                class="st29"
                points="177.7,317.4 177.7,317.5 177.3,318.6 176.3,317.9 176.8,316.4 177.7,315.5 182.1,319.7 181.1,320.8
            "
              />
              <polygon
                class="st29"
                points="181.6,311.6 182.2,312.2 184.6,317.2 183.6,318.2 181.5,313.5 181.4,313.5 180,315 179.1,314.1 	"
              />
              <path
                class="st29"
                d="M122.5,271.4l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.6-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L122.5,271.4z"
              />
              <path
                class="st29"
                d="M125.7,268.1l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.6-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L125.7,268.1z"
              />
              <path
                class="st29"
                d="M126.4,260.6c0.3-0.3,0.6-0.3,0.9-0.1c0.4,0.4,0.1,0.8-0.2,1.2l-0.1,0.1l0.8,0.7l0.1-0.1
            c0.4-0.4,0.9-0.6,1.4-0.2c0.3,0.3,0.3,0.7-0.1,1.1c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,0.9c0.3-0.1,0.7-0.3,1.1-0.7c1-1,0.8-2.2,0.2-2.9
            c-0.5-0.5-1.2-0.6-1.8-0.3l0,0c0.2-0.5,0.1-1.1-0.4-1.6c-0.6-0.5-1.5-0.6-2.3,0.2c-0.4,0.4-0.6,0.9-0.7,1.2l0.9,0.6
            C126,261,126.2,260.8,126.4,260.6"
              />
              <path
                class="st29"
                d="M197.2,342.8c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0v-0.5
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.6,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C196.8,343.3,196.9,343,197.2,342.8"
              />
              <polygon
                class="st29"
                points="200.7,339.5 200.7,339.4 204.1,342.8 205.2,341.7 200.7,337.5 199.8,338.4 199.3,339.9 200.3,340.6
            "
              />
              <path
                class="st29"
                d="M204.8,337.8c0.5-0.5,1.1-0.8,1.6-0.2c0.4,0.4,0.4,0.9,0,1.3c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,0.9
            c0.3-0.1,0.7-0.4,1-0.7c1-1,0.8-2.3,0-3.1c-0.4-0.4-0.9-0.6-1.4-0.6s-1,0.3-1.1,0.5l-0.1,0.1l-0.6-0.7l1.1-1.2l-0.9-0.9l-1.9,1.9
            l2.1,2.4C204.6,338.1,204.7,338,204.8,337.8"
              />
              <path
                class="st29"
                d="M519.1,356.2l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L519.1,356.2z"
              />
              <polygon
                class="st29"
                points="521.1,359.9 525.4,355.5 524.4,354.6 522.9,354.1 522.3,355.1 523.4,355.5 523.4,355.5 520,358.9
            "
              />
              <path
                class="st29"
                d="M523.8,362.5l0.9,0.9l1-1l0.4,0.4l0.8-0.8l-0.4-0.4l2.5-2.6l-1-1l-4.1,1.3l-0.7,0.7l1.5,1.5L523.8,362.5z
            M524.9,360.1l1.2-0.4c0.3-0.1,0.6-0.2,0.9-0.3l0,0c-0.2,0.2-0.5,0.4-0.7,0.6l-0.7,0.8L524.9,360.1L524.9,360.1z"
              />
              <path
                class="st29"
                d="M540.4,332.3l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L540.4,332.3z"
              />
              <polygon
                class="st29"
                points="542.4,336 546.7,331.6 545.8,330.7 544.2,330.2 543.6,331.2 544.7,331.6 544.7,331.6 541.4,335 	"
              />
              <path
                class="st29"
                d="M547.9,338.4c0.8-0.8,0.9-1.8,0.3-2.3c-0.3-0.3-0.6-0.4-1-0.3l0,0c0.6-0.4,1.3-0.5,1.9-0.1
            c0.2,0.1,0.3,0.2,0.4,0.3l0.8-0.8c-0.1-0.1-0.3-0.2-0.5-0.4c-0.4-0.3-1-0.5-1.6-0.5c-0.8,0-1.8,0.3-2.8,1.3
            c-1.1,1.1-1.2,2.4-0.4,3.2C546,339.6,547.2,339.1,547.9,338.4 M546.2,336.8c0.2-0.2,0.4-0.4,0.5-0.4c0.2-0.1,0.4-0.1,0.5,0
            c0.3,0.3,0,0.7-0.3,0.9c-0.4,0.4-0.9,0.8-1.1,0.6l0,0C545.5,337.7,545.8,337.2,546.2,336.8"
              />
              <path
                class="st29"
                d="M558.9,309.9l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.9c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,1-2.9,1H561l0,0l1.3,1.2l-0.9,0.9L558.9,309.9z"
              />
              <polygon
                class="st29"
                points="564.4,315.1 568.6,310.6 567.7,309.8 566.1,309.3 565.5,310.3 566.6,310.6 566.7,310.6 563.4,314.1
            "
              />
              <path
                class="st29"
                d="M569.7,317.7c0.5-0.5,0.6-1.2,0.4-1.8l0,0c0.8,0.2,1.2-0.2,1.5-0.4c0.7-0.7,0.5-1.7-0.2-2.3l0,0
            c-0.7-0.7-1.8-0.8-2.5-0.1c-0.3,0.3-0.5,0.9-0.4,1.5l0,0c-0.6-0.1-1.2,0-1.7,0.5c-0.8,0.8-0.6,1.8,0.2,2.6
            C567.8,318.4,568.9,318.5,569.7,317.7 M569.9,314c0.2-0.2,0.5-0.4,0.8-0.2l0,0c0.2,0.2,0,0.6-0.2,0.8c-0.2,0.2-0.6,0.4-0.8,0.3
            C569.6,314.6,569.7,314.3,569.9,314 M567.9,316c0.3-0.3,0.7-0.4,1-0.4c0.1,0.3,0.1,0.8-0.2,1.2c-0.3,0.3-0.7,0.5-0.9,0.3l0,0
            C567.4,316.7,567.6,316.3,567.9,316"
              />
              <path
                class="st29"
                d="M580.1,287.1l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.9c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,1-2.9,1h-0.5l0,0l1.3,1.2l-0.9,0.9L580.1,287.1z"
              />
              <path
                class="st29"
                d="M583.5,290.3l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.9c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,1-2.9,1h-0.5l0,0l1.3,1.2l-0.9,0.9L583.5,290.3z"
              />
              <path
                class="st29"
                d="M588.3,294.8c-1.1-1-0.2-2.5,0.8-3.6c1.1-1.2,2.6-1.9,3.6-1c1.2,1.1,0.1,2.6-0.8,3.5
            C590.3,295.4,589,295.5,588.3,294.8L588.3,294.8z M589.2,293.9c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.2-1.4,1-1.6s-0.7,0-1.6,1.1
            C589.1,293.2,588.9,293.7,589.2,293.9L589.2,293.9z"
              />
              <path
                class="st29"
                d="M597.3,269.8l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.9c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,1-2.9,1h-0.5l0,0l1.3,1.2l-0.9,0.9L597.3,269.8z"
              />
              <path
                class="st29"
                d="M600.8,273l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.9c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,1-2.9,1h-0.5l0,0l1.3,1.2l-0.9,0.9L600.8,273z"
              />
              <path
                class="st29"
                d="M604.2,276.2l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.9c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,1-2.9,1h-0.5l0,0l1.3,1.2l-0.9,0.9L604.2,276.2z"
              />
              <path
                class="st29"
                d="M613,253.8l0.7-0.7l1-0.1c1.3-0.1,2.2-0.2,2.7-0.8c0.3-0.3,0.3-0.7,0-1c-0.2-0.3-0.6-0.4-0.9-0.5l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.8c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,0.9h-0.5l0,0l1.3,1.3l-0.9,0.9L613,253.8z"
              />
              <path
                class="st29"
                d="M616.2,256.9l0.7-0.7l1-0.1c1.3-0.1,2.2-0.2,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.5l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.8c1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,0.9h-0.5l0,0l1.3,1.3l-0.9,0.9L616.2,256.9z"
              />
              <path
                class="st29"
                d="M621,261.1l0.9,0.9l1-1l0.4,0.4l0.8-0.8l-0.4-0.4l2.5-2.6l-1-1l-4.1,1.3l-0.7,0.7l1.5,1.5L621,261.1z
            M622.1,258.6l1.2-0.4c0.3-0.1,0.6-0.2,0.9-0.3l0,0c-0.2,0.2-0.5,0.4-0.7,0.6l-0.7,0.8L622.1,258.6L622.1,258.6z"
              />
              <path
                class="st29"
                d="M452.1,423.9l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L452.1,423.9z"
              />
              <path
                class="st29"
                d="M453.4,427c0.7,0.7,2,0.6,3.6-1c0.9-0.9,2-2.4,0.8-3.5c-1-1-2.5-0.2-3.6,0.9C453.2,424.5,452.3,426,453.4,427
            L453.4,427z M455.2,424.5c1-1,1.4-1.2,1.7-1c0.2,0.2-0.2,0.7-1,1.6c-1,1-1.4,1.3-1.6,1.1l0,0C454,425.9,454.2,425.5,455.2,424.5"
              />
              <path
                class="st29"
                d="M459.4,430.3c0.5-0.5,0.6-1.2,0.4-1.8l0,0c0.8,0.2,1.2-0.1,1.5-0.4c0.7-0.7,0.5-1.7-0.1-2.3l0,0
            c-0.7-0.7-1.8-0.8-2.5-0.1c-0.3,0.3-0.5,0.8-0.4,1.4l0,0c-0.6-0.1-1.2,0-1.7,0.5c-0.8,0.8-0.6,1.8,0.2,2.6
            C457.4,431,458.5,431.2,459.4,430.3 M459.6,426.6c0.2-0.2,0.6-0.4,0.8-0.2l0,0c0.2,0.2,0,0.6-0.2,0.8c-0.2,0.2-0.6,0.4-0.8,0.3
            C459.3,427.2,459.4,426.9,459.6,426.6 M457.6,428.6c0.3-0.3,0.7-0.4,1-0.4c0.1,0.3,0.1,0.8-0.3,1.2c-0.3,0.3-0.7,0.5-0.9,0.2l0,0
            C457.1,429.3,457.3,428.9,457.6,428.6"
              />
              <path
                class="st29"
                d="M474,401.4l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L474,401.4z"
              />
              <polygon
                class="st29"
                points="476,405.1 480.3,400.7 479.3,399.8 477.8,399.3 477.2,400.3 478.3,400.7 478.3,400.7 474.9,404.1
            "
              />
              <path
                class="st29"
                d="M478.6,407.8c0.7,0.7,2,0.6,3.6-1c0.9-0.9,2-2.4,0.8-3.5c-1-1-2.5-0.2-3.6,0.9
            C478.4,405.2,477.5,406.7,478.6,407.8L478.6,407.8z M480.4,405.2c1-1,1.4-1.2,1.7-1c0.2,0.2-0.2,0.7-1,1.6c-1,1-1.4,1.3-1.6,1.1
            l0,0C479.2,406.6,479.4,406.2,480.4,405.2"
              />
              <path
                class="st29"
                d="M496.6,378.9l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L496.6,378.9z"
              />
              <polygon
                class="st29"
                points="498.6,382.6 502.9,378.2 502,377.3 500.4,376.8 499.8,377.8 500.9,378.2 500.9,378.2 497.6,381.6
            "
              />
              <path
                class="st29"
                d="M503.3,385.4l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L503.3,385.4z"
              />
              <path
                class="st20"
                d="M267.8,545.6l-3.4-2.6c0.7,0.6,1.8,1.6,3.3,2.7L267.8,545.6z"
              />
            </g>
            <g id="fieldside-box">
              <path
                class="st12"
                d="M437.4,323.7l-9.5-9.2c-3.1,3.2-6.1,6.2-8.9,9.1l9.5,9.2C431.4,329.9,434.4,326.9,437.4,323.7"
              />
              <path
                class="st12"
                d="M391.1,334.9l18.1,17.6c2.3-2.3,5.1-5.2,8.3-8.5l-18.1-17.6C396.2,329.7,393.4,332.6,391.1,334.9"
              />
              <path
                class="st12"
                d="M341.4,327.1l-17.1,17.5c3.4,3.3,6.4,6.2,8.8,8.5l17.1-17.5C347.7,333.3,344.8,330.4,341.4,327.1"
              />
              <path
                class="st12"
                d="M322,323.9c-2.9-2.8-5.9-5.7-9-8.8l-9.2,9.5c3.1,3,6.2,6,9,8.8L322,323.9z"
              />
              <path
                class="st12"
                d="M323.1,325l-9.3,9.5c3.3,3.2,6.4,6.3,9.3,9l9.3-9.5C329.5,331.3,326.4,328.2,323.1,325"
              />
              <path
                class="st12"
                d="M292.5,295.4l-9.3,9.5c3.1,3,6.1,5.9,9.1,8.8l9.3-9.5C298.6,301.3,295.6,298.3,292.5,295.4"
              />
              <path
                class="st12"
                d="M290.9,276.8L273.1,295c3,2.9,6,5.8,9,8.8l17.7-18.2C296.9,282.6,293.9,279.7,290.9,276.8"
              />
              <path
                class="st12"
                d="M302.7,305.3l-9.3,9.5c3.1,3,6.1,5.9,9,8.8l9.3-9.5C308.8,311.2,305.8,308.3,302.7,305.3"
              />
              <path
                class="st12"
                d="M447.5,313.4l-9.5-9.2c-3,3.1-6,6.2-8.9,9.2l9.5,9.2C441.4,319.6,444.4,316.5,447.5,313.4"
              />
              <path
                class="st12"
                d="M417.9,324.7c-3.1,3.2-6.1,6.2-8.7,8.9l9.5,9.2c2.7-2.7,5.6-5.7,8.7-8.9L417.9,324.7z"
              />
              <path
                class="st12"
                d="M440.5,284.4l18.1,17.6c3-3.1,6-6.1,9-9.2l-18.2-17.6C446.4,278.3,443.5,281.3,440.5,284.4"
              />
              <path
                class="st12"
                d="M450.6,274.2l18.1,17.6c3-3.1,6-6.1,29.3-29.5l-18.2-17.6C456.5,268.1,453.6,271.1,450.6,274.2"
              />
              <path
                class="st12"
                d="M439.1,303l9.5,9.2c2.9-3,5.9-6,8.9-9.1l-9.5-9.2C445,297,442,300,439.1,303"
              />
              <path
                class="st12"
                d="M351.7,362.7c-0.6,1.4-1.1,2.9-1.7,4.4c2.8,1.5,5.6,2.6,8.6,3.4l0.9-4.7C356.9,365,354.3,364,351.7,362.7z"
              />
              <path
                class="st12"
                d="M280.8,266.8l-9.2,9.5c3,2.9,6,5.8,9,8.8l9.2-9.5C286.8,272.6,283.8,269.7,280.8,266.8"
              />
              <path
                class="st12"
                d="M270.7,256.9l-8.2,8.7c2.9,2.8,6,5.8,9,8.8l8.2-8.7C276.6,262.7,273.6,259.7,270.7,256.9"
              />
              <path
                class="st12"
                d="M260.5,247l-8.2,8.5c2.9,2.8,5.9,5.7,9,8.8l8.2-8.5C266.4,252.7,263.4,249.8,260.5,247"
              />
              <path
                class="st12"
                d="M405.5,351.1c-0.8,0.8-3.2,3-6.7,5.5l2.6,3.9c0.6-0.5,1.1-1,1.6-1.6l0,0c0.1-0.1,2-2,5.1-5.2L405.5,351.1z"
              />
              <path
                class="st12"
                d="M390.6,361.6l2.1,5.1c2.6-1.4,5.2-3.2,7.5-5.2l-2.7-4C395.5,358.8,393.2,360.3,390.6,361.6z"
              />
              <path
                class="st12"
                d="M381.3,365.3c0.4,1.8,0.8,3.6,1.1,5.4c3-0.8,6-1.9,8.8-3.3c-0.7-1.7-1.4-3.4-2.2-5.1
            C386.7,363.4,384.1,364.5,381.3,365.3z"
              />
              <path
                class="st12"
                d="M371.8,367c0,1.7,0,3.4,0.1,5.2c3-0.1,6.1-0.4,9.1-1.1l-1.1-5.4C377.2,366.4,374.6,366.8,371.8,367z"
              />
              <path
                class="st12"
                d="M361,366.1l-0.9,4.8c3.3,0.8,6.7,1.3,10.2,1.3l-0.1-5.1C367.2,367.1,364.1,366.8,361,366.1z"
              />
              <path
                class="st12"
                d="M343.2,356.9l-2.3,3.7h0.1c2.4,2.2,5,4,7.7,5.6l1.7-4.3C347.9,360.6,345.5,358.9,343.2,356.9z"
              />
              <path
                class="st12"
                d="M337.2,351.2l-3,3.1c2.8,2.7,4.7,4.6,5.5,5.3l2.3-3.7C340.4,354.5,338.8,352.9,337.2,351.2z"
              />
              <text
                transform="matrix(0.6893 -0.7248 0.7225 0.6913 465.8401 281.4472)"
                class="st13 st14 st15"
              >
                CHALK BOX
              </text>
            </g>
          </svg>
        </b-col>
        <b-col lg="5" md="12">
          <h2>Select your Flexible Membership Level</h2>
          <p>
            Select your Flexible Membership Level to view available seat
            locations. Please note, each Membership Level provides access to
            purchase tickets in different seat locations, subject to
            availability. Increase your Membership Level to gain access to
            additional locations.
          </p>
          <select v-model="selected">
            <option disabled value="">Please select one</option>
            <option value="$750">$750</option>
            <option value="$2,000">$2,000</option>
            <option value="$4,000">$4,000</option>
            <option value="$8,000">$8,000</option>
            <option value="$12,000">$12,000</option>
            <option value="$20,000">$20,000</option>
          </select>
          <div class="total">
            <p>
              Discount Tier:
              <span v-show="selected === ''"></span>
              <span v-show="selected === '$750'">Bronze</span>
              <span v-show="selected === '$2,000'">Bronze</span>
              <span v-show="selected === '$4,000'">Silver</span>
              <span v-show="selected === '$8,000'">Gold</span>
              <span v-show="selected === '$12,000'">Gold</span>
              <span v-show="selected === '$20,000'">Platinum</span>
            </p>
          </div>
          <div class="renewBtn yellow">
            <a
              href="https://www.mlb.com/rays/tickets/season-tickets/season-membership/flexible-seating"
              target="_blank"
              class="btn btn-scondary"
            >
              Buy Now
            </a>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center">
          <!-- <p class="smallPrint">Discounts, estimated to be between 0 – 30%, will vary depending on games selected and membership tier. Gold discounted ticket pricing will be the largest discount, followed by Silver, then Bronze.</p> -->
          <!-- <p class="note" v-if="traditionalOrFlex === 'Traditional'">
            Please note, all seat locations, game availability and access to
            benefits are subject to change. Seating capacity may be restricted
            and/or vary throughout the 2023 season.
          </p> -->
          <p class="note">
            Membership levels are subject to change each season
          </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// import { seatingData } from "@/data/seatingData";
// import { TweenLite } from "gsap/dist/gsap";

export default {
  name: "Seating",
  data() {
    return {
      currentPackageMapping: {
        " $750 Membership": "$750",
        " $2k Membership": "$2,000",
        " $4k Membership": "$4,000",
        " $8k Membership": "$8,000",
        " $12k Membership": "$12,000",
        " $20k Membership": "$20,000",
      },
      selected: "",
      // accordionData: seatingData(),
      selectedCategory: "",
      activeItemKey: "",
    };
  },
  watch: {
    selected() {
      var partyDeck = document.getElementById("party-deck");
      var pressLevel = document.getElementById("press-level");
      var preferredLevel = document.getElementById("preferred-level");
      var lowerReserved = document.getElementById("lower-reserved");
      var lowerBox = document.getElementById("lower-box");
      var lowerBoxPreferred = document.getElementById("lower-box-preferred");
      var lowerInfieldBox = document.getElementById("lower-infield-box");
      var chalkBox = document.getElementById("chalk-box");
      var fieldsideBox = document.getElementById("fieldside-box");
      var fieldsideBoxGrey = document.getElementById("fieldside-box-grey");
      var raysClub = document.getElementById("rays-club");
      var dexHomePlate = document.getElementById("dex-home-plate");
      var dexHomePlateGrey = document.getElementById("dex-home-plate-grey");
      var leftFieldLedge = document.getElementById("hotSauce");
      var thirdLevelBases = document.getElementById("third-level-bases");
      var upperHomePlate = document.getElementById("upper-home-plate");

      if (this.selected === "$750") {
        partyDeck.classList.add("showSeats") &
          partyDeck.classList.remove("hideSeats");
        pressLevel.classList.remove("showSeats") &
          pressLevel.classList.add("hideSeats");
        preferredLevel.classList.remove("showSeats") &
          preferredLevel.classList.add("hideSeats");
        lowerReserved.classList.add("showSeats") &
          lowerReserved.classList.remove("hideSeats");
        lowerBox.classList.remove("showSeats") &
          lowerBox.classList.add("hideSeats");
        lowerBoxPreferred.classList.remove("showSeats") &
          lowerBoxPreferred.classList.add("hideSeats");
        leftFieldLedge.classList.remove("showSeats") &
          leftFieldLedge.classList.add("hideSeats");
        lowerInfieldBox.classList.remove("showSeats") &
          lowerInfieldBox.classList.add("hideSeats");
        chalkBox.classList.remove("showSeats") &
          chalkBox.classList.add("hideSeats");
        fieldsideBox.classList.remove("showSeats") &
          fieldsideBox.classList.add("hideSeats");
        // fieldsideBoxGrey.classList.add("showSeats") &
        //   fieldsideBoxGrey.classList.remove("hideSeats");
        raysClub.classList.remove("showSeats") &
          raysClub.classList.add("hideSeats");
        dexHomePlate.classList.remove("showSeats") &
          dexHomePlate.classList.add("hideSeats");
        // dexHomePlateGrey.classList.add("showSeats") &
        //   dexHomePlateGrey.classList.remove("hideSeats");
        // thirdLevelBases.classList.add("showSeats") &
        //   thirdLevelBases.classList.remove("hideSeats");
        // upperHomePlate.classList.remove("showSeats") &
        //   upperHomePlate.classList.add("hideSeats");
      }
      if (this.selected === "$2,000") {
        partyDeck.classList.add("showSeats") &
          partyDeck.classList.remove("hideSeats");
        pressLevel.classList.add("showSeats") &
          pressLevel.classList.remove("hideSeats");
        preferredLevel.classList.add("showSeats") &
          preferredLevel.classList.remove("hideSeats");
        lowerReserved.classList.add("showSeats") &
          lowerReserved.classList.remove("hideSeats");
        lowerBox.classList.remove("showSeats") &
          lowerBox.classList.add("hideSeats");
        lowerBoxPreferred.classList.remove("showSeats") &
          lowerBoxPreferred.classList.add("hideSeats");
        leftFieldLedge.classList.remove("showSeats") &
          leftFieldLedge.classList.add("hideSeats");
        lowerInfieldBox.classList.remove("showSeats") &
          lowerInfieldBox.classList.add("hideSeats");
        chalkBox.classList.remove("showSeats") &
          chalkBox.classList.add("hideSeats");
        fieldsideBox.classList.remove("showSeats") &
          fieldsideBox.classList.add("hideSeats");
        // fieldsideBoxGrey.classList.add("showSeats") &
        //   fieldsideBoxGrey.classList.remove("hideSeats");
        raysClub.classList.remove("showSeats") &
          raysClub.classList.add("hideSeats");
        dexHomePlate.classList.remove("showSeats") &
          dexHomePlate.classList.add("hideSeats");
        // dexHomePlateGrey.classList.add("showSeats") &
        //   dexHomePlateGrey.classList.remove("hideSeats");
        // thirdLevelBases.classList.add("showSeats") &
        //   thirdLevelBases.classList.remove("hideSeats");
        // upperHomePlate.classList.add("showSeats") &
        //   upperHomePlate.classList.remove("hideSeats");
      }
      if (this.selected === "$4,000") {
        partyDeck.classList.add("showSeats") &
          partyDeck.classList.remove("hideSeats");
        pressLevel.classList.add("showSeats") &
          pressLevel.classList.remove("hideSeats");
        preferredLevel.classList.add("showSeats") &
          preferredLevel.classList.remove("hideSeats");
        lowerReserved.classList.add("showSeats") &
          lowerReserved.classList.remove("hideSeats");
        lowerBox.classList.add("showSeats") &
          lowerBox.classList.remove("hideSeats");
        lowerBoxPreferred.classList.add("showSeats") &
          lowerBoxPreferred.classList.remove("hideSeats");
        leftFieldLedge.classList.add("showSeats") &
          leftFieldLedge.classList.remove("hideSeats");
        lowerInfieldBox.classList.remove("showSeats") &
          lowerInfieldBox.classList.add("hideSeats");
        chalkBox.classList.remove("showSeats") &
          chalkBox.classList.add("hideSeats");
        fieldsideBox.classList.remove("showSeats") &
          fieldsideBox.classList.add("hideSeats");
        // fieldsideBoxGrey.classList.add("showSeats") &
        //   fieldsideBoxGrey.classList.remove("hideSeats");
        raysClub.classList.remove("showSeats") &
          raysClub.classList.add("hideSeats");
        dexHomePlate.classList.remove("showSeats") &
          dexHomePlate.classList.add("hideSeats");
        // dexHomePlateGrey.classList.add("showSeats") &
        //   dexHomePlateGrey.classList.remove("hideSeats");
        // thirdLevelBases.classList.add("showSeats") &
        //   thirdLevelBases.classList.remove("hideSeats");
        // upperHomePlate.classList.add("showSeats") &
        //   upperHomePlate.classList.remove("hideSeats");
      }
      if (this.selected === "$8,000") {
        partyDeck.classList.add("showSeats") &
          partyDeck.classList.remove("hideSeats");
        pressLevel.classList.add("showSeats") &
          pressLevel.classList.remove("hideSeats");
        preferredLevel.classList.add("showSeats") &
          preferredLevel.classList.remove("hideSeats");
        lowerReserved.classList.add("showSeats") &
          lowerReserved.classList.remove("hideSeats");
        lowerBox.classList.add("showSeats") &
          lowerBox.classList.remove("hideSeats");
        lowerBoxPreferred.classList.add("showSeats") &
          lowerBoxPreferred.classList.remove("hideSeats");
        leftFieldLedge.classList.add("showSeats") &
          leftFieldLedge.classList.remove("hideSeats");
        lowerInfieldBox.classList.add("showSeats") &
          lowerInfieldBox.classList.remove("hideSeats");
        chalkBox.classList.remove("showSeats") &
          chalkBox.classList.add("hideSeats");
        fieldsideBox.classList.remove("showSeats") &
          fieldsideBox.classList.add("hideSeats");
        // fieldsideBoxGrey.classList.add("showSeats") &
        //   fieldsideBoxGrey.classList.remove("hideSeats");
        raysClub.classList.remove("showSeats") &
          raysClub.classList.add("hideSeats");
        dexHomePlate.classList.remove("showSeats") &
          dexHomePlate.classList.add("hideSeats");
        // dexHomePlateGrey.classList.add("showSeats") &
        //   dexHomePlateGrey.classList.remove("hideSeats");
        // thirdLevelBases.classList.add("showSeats") &
        //   thirdLevelBases.classList.remove("hideSeats");
        // upperHomePlate.classList.add("showSeats") &
        //   upperHomePlate.classList.remove("hideSeats");
      }
      if (this.selected === "$12,000") {
        partyDeck.classList.add("showSeats") &
          partyDeck.classList.remove("hideSeats");
        pressLevel.classList.add("showSeats") &
          pressLevel.classList.remove("hideSeats");
        preferredLevel.classList.add("showSeats") &
          preferredLevel.classList.remove("hideSeats");
        lowerReserved.classList.add("showSeats") &
          lowerReserved.classList.remove("hideSeats");
        lowerBox.classList.add("showSeats") &
          lowerBox.classList.remove("hideSeats");
        lowerBoxPreferred.classList.add("showSeats") &
          lowerBoxPreferred.classList.remove("hideSeats");
        leftFieldLedge.classList.add("showSeats") &
          leftFieldLedge.classList.remove("hideSeats");
        lowerInfieldBox.classList.add("showSeats") &
          lowerInfieldBox.classList.remove("hideSeats");
        chalkBox.classList.add("showSeats") &
          chalkBox.classList.remove("hideSeats");
        fieldsideBox.classList.add("showSeats") &
          fieldsideBox.classList.remove("hideSeats");
        // fieldsideBoxGrey.classList.remove("showSeats") &
        //   fieldsideBoxGrey.classList.add("hideSeats");
        raysClub.classList.add("showSeats") &
          raysClub.classList.remove("hideSeats");
        dexHomePlate.classList.remove("showSeats") &
          dexHomePlate.classList.add("hideSeats");
        // dexHomePlateGrey.classList.add("showSeats") &
        //   dexHomePlateGrey.classList.remove("hideSeats");
        // thirdLevelBases.classList.add("showSeats") &
        //   thirdLevelBases.classList.remove("hideSeats");
        // upperHomePlate.classList.add("showSeats") &
        //   upperHomePlate.classList.remove("hideSeats");
      }
      if (this.selected === "$20,000") {
        partyDeck.classList.add("showSeats") &
          partyDeck.classList.remove("hideSeats");
        pressLevel.classList.add("showSeats") &
          pressLevel.classList.remove("hideSeats");
        preferredLevel.classList.add("showSeats") &
          preferredLevel.classList.remove("hideSeats");
        lowerReserved.classList.add("showSeats") &
          lowerReserved.classList.remove("hideSeats");
        lowerBox.classList.add("showSeats") &
          lowerBox.classList.remove("hideSeats");
        lowerBoxPreferred.classList.add("showSeats") &
          lowerBoxPreferred.classList.remove("hideSeats");
        leftFieldLedge.classList.add("showSeats") &
          leftFieldLedge.classList.remove("hideSeats");
        lowerInfieldBox.classList.add("showSeats") &
          lowerInfieldBox.classList.remove("hideSeats");
        chalkBox.classList.add("showSeats") &
          chalkBox.classList.remove("hideSeats");
        fieldsideBox.classList.add("showSeats") &
          fieldsideBox.classList.remove("hideSeats");
        // fieldsideBoxGrey.classList.remove("showSeats") &
        //   fieldsideBoxGrey.classList.add("hideSeats");
        raysClub.classList.add("showSeats") &
          raysClub.classList.remove("hideSeats");
        dexHomePlate.classList.remove("showSeats") &
          dexHomePlate.classList.add("hideSeats");
        // dexHomePlateGrey.classList.remove("showSeats") &
        //   dexHomePlateGrey.classList.add("hideSeats");
        // thirdLevelBases.classList.add("showSeats") &
        //   thirdLevelBases.classList.remove("hideSeats");
        // upperHomePlate.classList.add("showSeats") &
        //   upperHomePlate.classList.remove("hideSeats");
      }
    },
  },
  //   computed: {
  //     currentPackage() {
  //           let userInfo = this.$store.state.global.userInfo;
  // this.selected = this.currentPackageMapping[userInfo.Current_Package]
  // // switch (userInfo.Current_Package) {
  // //   case "$500 Membership":
  // //     return
  // //     break;

  // //   default:
  // //     break;
  // // }
  //     // },
  //   },
  mounted() {
    var partyDeck = document.getElementById("party-deck");
    var pressLevel = document.getElementById("press-level");
    var preferredLevel = document.getElementById("preferred-level");
    var lowerReserved = document.getElementById("lower-reserved");
    var lowerBox = document.getElementById("lower-box");
    var lowerBoxPreferred = document.getElementById("lower-box-preferred");
    var lowerInfieldBox = document.getElementById("lower-infield-box");
    var chalkBox = document.getElementById("chalk-box");
    var fieldsideBox = document.getElementById("fieldside-box");
    var fieldsideBoxGrey = document.getElementById("fieldside-box-grey");
    var raysClub = document.getElementById("rays-club");
    var dexHomePlate = document.getElementById("dex-home-plate");
    var dexHomePlateGrey = document.getElementById("dex-home-plate-grey");
    var leftFieldLedge = document.getElementById("hotSauce");
    var thirdLevelBases = document.getElementById("third-level-bases");
    var upperHomePlate = document.getElementById("upper-home-plate");
    partyDeck.classList.remove("showSeats") &
      partyDeck.classList.add("hideSeats");
    pressLevel.classList.remove("showSeats") &
      pressLevel.classList.add("hideSeats");
    preferredLevel.classList.remove("showSeats") &
      preferredLevel.classList.add("hideSeats");
    lowerReserved.classList.remove("showSeats") &
      lowerReserved.classList.add("hideSeats");
    lowerBox.classList.remove("showSeats") &
      lowerBox.classList.add("hideSeats");
    lowerBoxPreferred.classList.remove("showSeats") &
      lowerBoxPreferred.classList.add("hideSeats");
    leftFieldLedge.classList.remove("showSeats") &
      leftFieldLedge.classList.add("hideSeats");
    lowerInfieldBox.classList.remove("showSeats") &
      lowerInfieldBox.classList.add("hideSeats");
    chalkBox.classList.remove("showSeats") &
      chalkBox.classList.add("hideSeats");
    fieldsideBox.classList.remove("showSeats") &
      fieldsideBox.classList.add("hideSeats");
    // fieldsideBoxGrey.classList.remove("showSeats") &
    //   fieldsideBoxGrey.classList.add("hideSeats");
    raysClub.classList.remove("showSeats") &
      raysClub.classList.add("hideSeats");
    dexHomePlate.classList.remove("showSeats") &
      dexHomePlate.classList.add("hideSeats");
    // dexHomePlateGrey.classList.remove("showSeats") &
    //   dexHomePlateGrey.classList.add("hideSeats");
    // thirdLevelBases.classList.remove("showSeats") &
    //   thirdLevelBases.classList.add("hideSeats");
    // upperHomePlate.classList.remove("showSeats") &
    //   upperHomePlate.classList.add("hideSeats");
  },
  created() {
    let userInfo = this.$store.state.global.userInfo;
    this.traditionalOrFlex = userInfo.Traditional_Flex;
    // this.selected = this.currentPackageMapping[userInfo.Current_Package];
  },
};
</script>

<style lang="scss" scoped>
#Seating {
  // padding: 0 0 100px 0;
  padding-block: 70px;
  .seatingMain {
    /* padding: 0 7%; */

    .note {
      font-family: "Futura";
      font-style: italic;
      font-weight: 500;
      font-size: 14px;
      line-height: 145%;
      color: #161e26;
      margin-top: 20px;
    }
    .map {
      background: #c4c4c4;
      height: 520px;
      margin-bottom: 20px;
      @media only screen and (max-width: $xl) {
        height: 450px;
      }
      @media only screen and (max-width: $lg) {
        height: 600px;
      }
      @media only screen and (max-width: $md) {
        height: 400px;
      }
      overflow: hidden;
      position: relative;
      svg {
        transform: translateX(-50%);
        left: 50%;
        top: 30px;
        position: absolute;
        width: 100%;
        @media only screen and (max-width: $md) {
          width: 420px;
          height: 420px;
        }
      }

      .st0 {
        fill: #d1d2d3;
      }
      .st1 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #d1d2d3;
      }
      .st2 {
        fill: #00275d;
      }
      .st3 {
        fill: #bdbfc1;
      }
      .st4 {
        fill: #03532f;
      }
      .st5 {
        fill: #055330;
      }
      .st6 {
        fill: #79bce7;
      }
      .st7 {
        fill: #0d5330;
      }
      .st8 {
        fill: #79bde9;
      }
      .st9 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #79bde9;
      }
      .st10 {
        fill: #f78f1e;
      }
      .st11 {
        fill: #72c06c;
      }
      .st12 {
        fill: #fcd20b;
      }
      .st13 {
        fill: #271f10;
      }
      .st14 {
        font-family: "HelveticaNeue-CondensedBold";
      }
      .st15 {
        font-size: 7.0947px;
      }
      .st16 {
        fill: #050707;
      }
      .st17 {
        fill: #e7e7e8;
      }
      .st18 {
        fill: #929497;
      }
      .st19 {
        fill: #e6e7e7;
      }
      .st20 {
        fill: #1d2d5c;
      }
      .st21 {
        fill: none;
        stroke: #282011;
        stroke-width: 0.5;
      }
      .st22 {
        fill: none;
        stroke: #d1d3d4;
      }
      .st23 {
        fill: #282011;
      }
      .st24 {
        fill: #dbdcdd;
      }
      .st25 {
        fill: #bfbdb6;
      }
      .st26 {
        fill: #bdc0c1;
      }
      .st27 {
        fill: #a8a8a8;
      }
      .st28 {
        fill: #d1d3d4;
      }
      .st29 {
        fill: #ffffff;
      }
      .st30 {
        fill: none;
        stroke: #bdbfc1;
        stroke-width: 0.696;
      }
      .st31 {
        fill: none;
        stroke: #bdbfc1;
        stroke-width: 0.696;
        stroke-miterlimit: 4.0016;
      }
      .st32 {
        fill: none;
        stroke: #bdbfc1;
        stroke-width: 0.696;
        stroke-miterlimit: 4;
      }
      .st33 {
        fill: #c8503b;
      }
      .st34 {
        fill: #838383;
      }
      .st35 {
        fill: #005f35;
      }
      .st36 {
        fill: #221f1f;
      }
      .st37 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #0155a3;
      }
      .st38 {
        fill: none;
        stroke: #ffffff;
        stroke-width: 0.238;
      }
      .st39 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #ffffff;
      }
      .st40 {
        fill: none;
      }
      .st41 {
        font-size: 5.1819px;
      }
      .st42 {
        font-size: 5.1818px;
      }
      .st43 {
        font-size: 7.0965px;
      }
      .st44 {
        font-size: 4.9736px;
      }
      .st45 {
        fill: none;
        stroke: #bdbfc1;
        stroke-width: 0.798;
      }
      .st46 {
        fill: #bec0c1;
      }
      .st47 {
        fill: none;
        stroke: #221f1f;
        stroke-width: 0.25;
        stroke-linecap: square;
        stroke-miterlimit: 10;
      }
      .st48 {
        font-size: 5.1044px;
      }
      .st49 {
        font-size: 5.1124px;
      }
      .st50 {
        fill: #231f20;
      }
      .st51 {
        font-size: 5.1053px;
      }
      .st52 {
        font-size: 8.9321px;
      }
      .st53 {
        fill: #bcbfc1;
      }
      .st54 {
        fill: #e7e6e6;
      }
      .st55 {
        fill: #272013;
      }
      .st56 {
        font-size: 5.0802px;
      }
      .st57 {
        font-size: 3.599px;
      }
      .st58 {
        font-size: 3.5952px;
      }
      .st59 {
        font-size: 4.2889px;
      }
      .st60 {
        fill: #ce0e2d;
      }
      .st61 {
        fill: none;
        stroke: #a8a8a8;
        stroke-width: 0.25;
        stroke-miterlimit: 10;
      }
      .st62 {
        fill: #79bde8;
      }
      .st63 {
        fill: #00285d;
      }
      .st64 {
        fill: #ffd200;
      }
      .st65 {
        fill: #d1d2d3;
      }

      #hotSauce {
        fill: #bdbfc1;
        transition: all 0.25s ease-in-out;
        &.showSeats {
          fill: $dark-blue;
        }
      }
    }
    h2 {
      font-family: "Antique Olive";
      font-style: normal;
      font-weight: 700;
      font-size: 19px;
      line-height: 29px;
      text-transform: uppercase;
      color: #00285e;
      margin-bottom: 20px;
    }

    p {
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 145%;
      color: #161e26;
    }
    .line {
      background-color: $yellow;
      width: 190px;
      height: 3px;
      margin: 10px 0 20px 0;
    }
    select {
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      color: #00285e;
      padding: 15px 6px;
      width: 100%;
      background: #c4c4c4;
      margin: 20px 0;
      /* border-block-width: 2px;
      border-style: dotted;
      border-color: $light-blue; */
      border: none;
      outline: 2px dotted $light-blue;

      @media only screen and (max-width: $sm) {
        width: 100%;
      }
      option {
        color: $dark-blue;
        &:disabled {
          color: $grey-blue;
        }
      }
    }
    .total {
      margin-bottom: 15px;
      p {
        font-family: "Futura";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 145%;
        text-transform: uppercase;
        color: #00285e;
        span {
          font-family: "Futura";
          font-weight: 700;
        }
      }
    }

    .seatingRow {
      height: 40px;
      .box {
        width: 25px;
        height: 25px;
        border: 1px solid #000;
        float: left;
        margin-top: -2px;
        &.white {
          background-color: #fff;
        }
        &.purple {
          background-color: #9d4d9f;
        }
        &.pink {
          background-color: #f48798;
        }
        &.black {
          background-color: #000;
        }
        &.lightBlue {
          background-color: #a0ccee;
        }
        &.blue {
          background-color: #00afdb;
        }
        &.yellow {
          background-color: #fed302;
        }
        &.darkGreen {
          background-color: #01532b;
        }
        &.green {
          background-color: #d3e6a8;
        }
        &.peach {
          background-color: #e1ceac;
        }
        &.orange {
          background-color: #f69418;
        }
      }
      p {
        font-family: "Futura";
        font-size: 16px;
        color: #000;
        margin-left: 40px;
      }
    }
    .renewBtn {
      text-align: center;
      margin-top: 10px;
      &.yellow button {
        background: #ffd200;
        border: none;
        padding: 14px 92px;
      }
      button {
        font-family: "Futura";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 145%;
        display: flex;
        align-items: center;
        text-align: center;
        text-transform: uppercase;
        color: #00285e;
        width: auto;
        margin-inline: auto;
        border: 2px solid #00285e;
        border-radius: 50px;
        padding: 10px 92px;
        margin-top: 50px;
        background: transparent;
        &:hover {
          text-decoration: none;
        }
        @media only screen and (max-width: $sm) {
          padding: 8px 4px;
        }
      }
    }
  }
  #party-deck {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #press-level {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #preferred-level {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #lower-reserved {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #lower-box {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #lower-box-preferred {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #lower-infield-box {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #chalk-box {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #fieldside-box {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #fieldside-box-grey {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #rays-club {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #dex-home-plate {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #dex-home-plate-grey {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #third-level-bases {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #upper-home-plate {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
}
</style>
